/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CognitoUserSession = {
  __typename: "CognitoUserSession",
  sessionid?: number | null,
  cognitousername?: string | null,
  logintimestamp?: string | null,
  logouttimestamp?: string | null,
  linkedsessionid?: string | null,
  deviceinfo?: string | null,
  ipaddress?: string | null,
};

export type CreatePartyTransactionInput = {
  partymaster?: Array< PartyMasterTransactionInput | null > | null,
  partyaddressentity?: Array< PartyAddressEntityTransactionInput | null > | null,
  partycontact?: Array< PartyContactTransactionInput | null > | null,
  partycreditdetails?: Array< PartyCreditDetailsTransactionInput | null > | null,
  partygstdetails?: Array< PartyGSTDetailsTransactionInput | null > | null,
  partyimages?: Array< PartyImagesTransactionInput | null > | null,
  bankdetails?: Array< PartyBankDetailsTransactionInput | null > | null,
  accountsid?: number | null,
  accountgroupid?: number | null,
};

export type PartyMasterTransactionInput = {
  partytypecd: string,
  partydisplayname: string,
  partylegalname: string,
  groupaccountid: number,
  gstcategory: string,
  placeofsupply: string,
  entity: string,
  email: string,
  contactnumber: string,
  whatsappnumber: string,
  is_active: number,
  msmetype: string,
  deliveryconsigneename: string,
  deliveryconsigneegstin: string,
  tdspercentage: number,
  udhyamregno: string,
  sameaddressflag: number,
  comments: string,
  tdssection: string,
  contactcountry?: string | null,
  whatsappcountry?: string | null,
  entityname?: string | null,
};

export type PartyAddressEntityTransactionInput = {
  objecttype: string,
  line1: string,
  line2: string,
  line3: string,
  city: string,
  statecode: number,
  pincode: string,
  countrycode: string,
  district: string,
  godownname?: string | null,
  gstin?: string | null,
  phone?: string | null,
  email?: string | null,
  personincharge?: string | null,
  consigneename?: string | null,
  consigneegstin?: string | null,
  foreignstate?: string | null,
  foreigndistrict?: string | null,
  defaultflag?: number | null,
  addresstitle?: string | null,
  addressindex?: number | null,
};

export type PartyContactTransactionInput = {
  contacttypename: string,
  contactdesignationname: string,
  contactorder: number,
  email: string,
  phonenumber: string,
  whatsappnumber: string,
  contactcountry?: string | null,
  whatsappcountry?: string | null,
};

export type PartyCreditDetailsTransactionInput = {
  creditperiodduration: number,
  billingcurrency: number,
  creditlimitcd: number,
  creditlimitamount: number,
  billwiseflag: number,
  notes: string,
};

export type PartyGSTDetailsTransactionInput = {
  pannumber: string,
  gstin: string,
  partyaddressid: number,
};

export type PartyImagesTransactionInput = {
  type: string,
  documentname: string,
  imagename: string,
  imageurl: string,
};

export type PartyBankDetailsTransactionInput = {
  objecttype: string,
  bankname: string,
  bankaccountnumber: string,
  ifsccode: string,
  branch: string,
  notes: string,
  ledgeraccount: string,
  bankaccounttype: string,
  accountgroupid: number,
  cash: number,
  swiftcode: string,
  upi: string,
};

export type PartyCreation = {
  __typename: "PartyCreation",
  partyid?: number | null,
  accountid?: number | null,
  companyid?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreateItemTransactionInput = {
  itemmaster?: Array< ItemMasterTransactionInput | null > | null,
  itemamountdetails?: Array< ItemAmountDetailsTransactionInput | null > | null,
  itemimages?: Array< ItemImagesTransactionInput | null > | null,
};

export type ItemMasterTransactionInput = {
  itemcode: string,
  serialnumber: string,
  itemname: string,
  salesinvoiceflag: number,
  purchaseinvoiceflag: number,
  itemcategorycd: number,
  measurementcd: number,
  currencycd: number,
  salesaccountid: number,
  purchaseaccountid: number,
  taxabilitycd: string,
  reversechargeflag: number,
  itemtype: string,
  hsnid: string,
  is_active: number,
  description: string,
  cessexist: number,
  barcode?: string | null,
};

export type ItemAmountDetailsTransactionInput = {
  amount: number,
  effectivedate: number,
  expireddate: number,
  hsnid: string,
  gstcompensationtype: number,
  gstcompensationvalue: number,
  gstrate: number,
  discounttype: number,
  discountvalue: number,
  invoicetype: number,
  pricetype: string,
  isactive: number,
  isdefault: number,
  pricetypeid: number,
};

export type ItemImagesTransactionInput = {
  imagename: string,
  imageurl: string,
  documentname: string,
  type: string,
};

export type itemmasterv2 = {
  __typename: "itemmasterv2",
  itemid?: number | null,
  itemcode?: string | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  itemname?: string | null,
  salesinvoiceflag?: number | null,
  purchaseinvoiceflag?: number | null,
  itemcategorycd?: string | null,
  measurementcd?: string | null,
  currencycd?: string | null,
  salesaccountid?: number | null,
  purchaseaccountid?: number | null,
  taxabilitycd?: string | null,
  reversechargeflag?: number | null,
  itemtype?: string | null,
  hsnid?: string | null,
  is_active?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  lastupdatedby?: string | null,
  itemamountenteredtimestamp?: number | null,
  itemamountexpiredtimestamp?: number | null,
  amount?: number | null,
  effectivedate?: number | null,
  expireddate?: number | null,
  sellinghsnid?: string | null,
  purchasehsnid?: string | null,
  gstcompensationtype?: string | null,
  gstcompensationvalue?: number | null,
  gstrate?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  imagename?: string | null,
  imageurl?: string | null,
  serialnumber?: string | null,
  isdefault?: number | null,
  invoicetype?: number | null,
  defaultsellingprice?: number | null,
  defaultpurchaseprice?: number | null,
  codetext?: string | null,
  itemcategory?: string | null,
  sellinggstcompensationtype?: string | null,
  purchasegstcompensationtype?: string | null,
  sellinggstcompensationvalue?: number | null,
  purchasegstcompensationvalue?: number | null,
  sellinggstrate?: number | null,
  purchasegstrate?: number | null,
  sellingdiscounttype?: number | null,
  purchasediscounttype?: number | null,
  sellingdiscountvalue?: number | null,
  purchasediscountvalue?: number | null,
  purchaseaccountname?: string | null,
  salesaccountname?: string | null,
  defaultnetsellingprice?: number | null,
  defaultnetpurchaseprice?: number | null,
  description?: string | null,
  hsnsacid?: number | null,
  hsncodetype?: string | null,
  hsnsaccode?: string | null,
  hsndescription?: string | null,
  cessexist?: number | null,
  barcode?: string | null,
};

export type CreateSalesInvoiceInput = {
  invoicetransactionmaster?: Array< InvoiceTransactionMasterTransactionInput | null > | null,
  transactiondetails?: Array< TransactionDetailsTransactionInput | null > | null,
  invoicelineitems?: Array< InvoiceLineItemsTransactionInput | null > | null,
  invoicelinenonitems?: Array< InvoiceLineNonItemsTransactionInput | null > | null,
  denominations?: Array< DenominationsTransactionInput | null > | null,
  invoicetcsdetails?: Array< InvoiceTCSDetailsTransactionInput | null > | null,
  invoicedispatch?: Array< InvoiceDispatchTransactionInput | null > | null,
  partyaddressentity?: Array< PartyAddressEntityTransactionInput | null > | null,
  invoicelinegst?: Array< InvoiceLineGSTTransactionInput | null > | null,
  invoicelinenongst?: Array< InvoiceLineNonGSTTransactionInput | null > | null,
  invoiceattachment?: Array< InvoiceAttachmentTransactionInput | null > | null,
};

export type InvoiceTransactionMasterTransactionInput = {
  invoicetypecd: string,
  partyid: number,
  paymentaccountid: number,
  invoicedate: number,
  invoicenumber: string,
  customerordernumber: string,
  customerorderdate: number,
  invoiceamount: number,
  paymenttype: string,
  creditduration: number,
  invoicebillingaddressid: number,
  invoicedeliveryaddressid: number,
  invoicetaxabletypecd: string,
  receipturl: string,
  invoicelinetypecd: string,
  invoicecurrencycd: string,
  exchangerate: number,
  comments: string,
  receivedamount: number,
  adjustmentamount: number,
  placeofsupply: string,
  balancedueamount: number,
  reversechargeflag: number,
  transactiontypecd: string,
  entrydate: number,
  bankreferencenumber: string,
  tcsapplicableflag: number,
  serialnumber: string,
  serialflag: number,
  consigneename: string,
  consigneegstin: string,
  companystate: string,
  roundoffamount: number,
  discounttype: number,
  discountvalue: number,
  currencycode: string,
  currencyrate: number,
  invoicepdf: string,
  bankaccountid: number,
  bankamount: number,
  taxability?: number | null,
  cessexist?: number | null,
};

export type TransactionDetailsTransactionInput = {
  transactiontypecd: string,
  accountid: number,
  creditamount: number,
  debitamount: number,
  comments: string,
};

export type InvoiceLineItemsTransactionInput = {
  invoiceitemid: number,
  lineitemnumber: number,
  invoicelineitemtype: string,
  itemid: number,
  quantity: number,
  unittypecd: string,
  itemrate: number,
  itemamount: number,
  itemdiscount: number,
  discounttype?: string | null,
  discountrate?: number | null,
  netamount: number,
  hsnsaccode: string,
  taxability: string,
  pricetype: string,
  manualdiscount: number,
  manualcess: number,
  pricetypeid: number,
  itemtype?: string | null,
  manualgst?: number | null,
  description?: string | null,
};

export type InvoiceLineNonItemsTransactionInput = {
  invoiceitemid: number,
  invoicelineitemtype: string,
  incomeaccountid: number,
  hsnsaccode: string,
  taxability: string,
  itemdescription: string,
  taxableamount: number,
  netamount: number,
  manualgst?: number | null,
  manualcess?: number | null,
};

export type DenominationsTransactionInput = {
  denomination?: number | null,
  no_of_notes?: number | null,
  typecd?: string | null,
};

export type InvoiceTCSDetailsTransactionInput = {
  tcsapplicablecd: string,
  totaltaxableamount: number,
  ineligibletcflag: number,
  reversechargeflag: number,
  gstcesstotal: number,
  tcsamount: number,
  adjustmentamount: number,
  tcssection: string,
  tcspercentage: number,
  tcsmanual: number,
};

export type InvoiceDispatchTransactionInput = {
  dispatchid: number,
  transportationcd: string,
  vehiclenumber: string,
  dispatchdate: number,
  ewaybillnumber: string,
};

export type InvoiceLineGSTTransactionInput = {
  invoiceitemid: number,
  gstrate: number,
  gsttypecd: string,
  gstamount: number,
  cessamount: number,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type InvoiceLineNonGSTTransactionInput = {
  invoiceitemid: number,
  gstrate: number,
  gsttypecd: string,
  gstamount: number,
  cessamount: number,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type InvoiceAttachmentTransactionInput = {
  type: string,
  documentname: string,
  attachmenturl: string,
};

export type SalesInvoiceTransaction = {
  __typename: "SalesInvoiceTransaction",
  invoiceid?: number | null,
  companyid?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  invoicenumber?: string | null,
};

export type CreateSalesPosInvoiceInputTemp = {
  invoicetransactionmaster?: Array< InvoiceTransactionMasterTransactionInput | null > | null,
  transactiondetails?: Array< TransactionDetailsTransactionInput | null > | null,
  invoicelineitems?: Array< InvoiceLineItemsTransactionInput | null > | null,
  invoicelinenonitems?: Array< InvoiceLineNonItemsTransactionInput | null > | null,
  denominations?: Array< DenominationsTransactionInput | null > | null,
  invoicetcsdetails?: Array< InvoiceTCSDetailsTransactionInput | null > | null,
  invoicedispatch?: Array< InvoiceDispatchTransactionInput | null > | null,
  partyaddressentity?: Array< PartyAddressEntityTransactionInput | null > | null,
  invoicelinegst?: Array< InvoiceLineGSTTransactionInput | null > | null,
  invoicelinenongst?: Array< InvoiceLineNonGSTTransactionInput | null > | null,
  invoiceattachment?: Array< InvoiceAttachmentTransactionInput | null > | null,
  posphonecontacts?: Array< CreatePosPhoneContactsInput | null > | null,
  posparty?: Array< CreatePOSPartyTransactionInput | null > | null,
};

export type CreatePosPhoneContactsInput = {
  callallowed?: string | null,
  countrycode?: string | null,
  objecttype?: string | null,
  id?: number | null,
  objectid?: number | null,
  phonenumber?: string | null,
  promotionssignup?: string | null,
  smsallowed?: string | null,
  verifieddatetime?: number | null,
  whatsappallowed?: string | null,
  expiredtimestamp?: number | null,
};

export type CreatePOSPartyTransactionInput = {
  partyname?: string | null,
};

export type CreateCompanyFYInputv2 = {
  companyname: string,
  startdate: number,
  enddate: number,
  startyear: string,
  endyear: string,
  comments: string,
  aliasname: string,
  companyactive: number,
  companyshort: string,
  lutbondtodate: number,
  invoicedetailapplicablefromdate: number,
  tdsapplicable: number,
  gstcategory: string,
  financialyearstartandendmonth: number,
  websiteurl: string,
  currencycd: number,
  accountinventoryflag: number,
  pannumber: string,
  tdstcsnumber: string,
  cinregistrationnumber: string,
  registrationtype: number,
  gstrperiod: string,
  lut: string,
  lutbondvalidfrom: number,
  ewaybillflag: number,
  gstapplicablefrom: number,
  thresholdlimitcd: number,
  thresholdlimitamount: number,
  companylogourl: string,
  msmetype: string,
  udhyamregno: string,
  udhyamdocs: string,
  ewaybillstartdate: number,
  minamountewayinter: number,
  minamountewayintra: number,
  einvoiceflag: number,
  einvoicestartingdate: number,
  gstcompensationcessflag: number,
  tradelicensenumber: string,
  tradelicensestartdate: number,
  tradelicenseenddate: number,
  cinregistrationdate: number,
  line1: string,
  statecode: number,
  countrycode: string,
  emailaddress: string,
  phonenumber: string,
  gstin: string,
  pincode: string,
};

export type Company = {
  __typename: "Company",
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  companyname?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  relatedcompanydetailsnew?:  Array<CompanyDetails | null > | null,
  relatedcompanyentity?:  Array<CompanyEntity | null > | null,
  relatedemailcontacts?:  Array<EmailContacts | null > | null,
  relatedphonecontacts?:  Array<PhoneContacts | null > | null,
  relatedaddressentity?:  Array<AddressEntity | null > | null,
  lastupdatedby?: string | null,
  addressentityid?: number | null,
  objecttype?: string | null,
  line1?: string | null,
  line2?: string | null,
  line3?: string | null,
  city?: string | null,
  statecode?: string | null,
  statename?: string | null,
  pincode?: string | null,
  countrycode?: string | null,
  district?: string | null,
  financialyearid?: number | null,
  einvoiceusername?: string | null,
  companydeletiontime?: number | null,
  ewaybillusername?: string | null,
};

export type CompanyDetails = {
  __typename: "CompanyDetails",
  companyid: number,
  enteredtimestamp: number,
  expiredtimestamp?: number | null,
  websiteurl?: string | null,
  currencycd?: number | null,
  accountinventoryflag?: number | null,
  pannumber?: string | null,
  tdstcsnumber?: string | null,
  cinregistrationnumber?: string | null,
  registrationtype?: number | null,
  comppercentage?: number | null,
  gstrperiod?: string | null,
  lut?: string | null,
  lutbondvalidfrom?: number | null,
  ewaybillflag?: number | null,
  gstapplicablefrom?: number | null,
  thresholdlimitcd?: number | null,
  thresholdlimitamount?: number | null,
  companylegalname?: string | null,
  companyshort?: string | null,
  lutbondtodate?: number | null,
  invoicedetailapplicablefromdate?: number | null,
  tdsapplicable?: number | null,
  gstcategory?: string | null,
  financialyearstartandendmonth?: number | null,
  companylogourl?: string | null,
  msmetype?: string | null,
  udhyamregno?: string | null,
  udhyamdocs?: string | null,
  ewaybillstartdate?: number | null,
  minamountewayinter?: number | null,
  minamountewayintra?: number | null,
  einvoiceflag?: number | null,
  einvoicestartingdate?: number | null,
  gstcompensationcessflag?: number | null,
  tradelicensenumber?: string | null,
  tradelicensestartdate?: number | null,
  tradelicenseenddate?: number | null,
  lastupdatedby?: string | null,
  cinregistrationdate?: number | null,
  einvoiceconnect?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  activeflag?: number | null,
  relatedfinancialyeardata?:  Array<FinancialYear | null > | null,
  financialyearid?: number | null,
  lastupdatedtimestamp?: number | null,
  companydeletiontime?: number | null,
  ewaybillconnect?: number | null,
  stepscompleted?: Array< string | null > | null,
  disablegstcompensation?: number | null,
  businesstypeid?: Array< number | null > | null,
  industrytypeid?: Array< number | null > | null,
};

export type FinancialYear = {
  __typename: "FinancialYear",
  financialyearid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  startdate?: number | null,
  enddate?: number | null,
  startyear?: string | null,
  endyear?: string | null,
  comments?: string | null,
  userid?: string | null,
  aliasname?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  freezestatus?: number | null,
  transferdate?: number | null,
  freezedate?: number | null,
  stepscompleted?: Array< string | null > | null,
};

export type CompanyEntity = {
  __typename: "CompanyEntity",
  id?: number | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  legalname?: string | null,
  gstin?: string | null,
  financialyearcode?: string | null,
  companyentitytype?: string | null,
  startdate?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  lastupdatedby?: string | null,
  financialyearid?: number | null,
};

export type EmailContacts = {
  __typename: "EmailContacts",
  id: number,
  objecttype: string,
  objectid: string,
  enteredtimestamp: number,
  expiredtimestamp: number,
  emailaddress: string,
  verifieddatetime?: number | null,
  promotionssignup?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  lastupdatedby?: string | null,
};

export type PhoneContacts = {
  __typename: "PhoneContacts",
  id?: number | null,
  objecttype?: string | null,
  objectid?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  countrycode?: string | null,
  phonenumber?: string | null,
  verifieddatetime?: number | null,
  promotionssignup?: string | null,
  smsallowed?: string | null,
  callallowed?: string | null,
  whatsappallowed?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type AddressEntity = {
  __typename: "AddressEntity",
  id?: number | null,
  objecttype?: string | null,
  objectid?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  line1?: string | null,
  line2?: string | null,
  line3?: string | null,
  city?: string | null,
  statecode?: string | null,
  statename?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  pincode?: string | null,
  countrycode?: string | null,
  codevalue?: string | null,
  district?: string | null,
  lastupdatedby?: string | null,
  godownname?: string | null,
  gstin?: string | null,
  phone?: string | null,
  email?: string | null,
  personincharge?: string | null,
  consigneename?: string | null,
  consigneegstin?: string | null,
  foreignstate?: string | null,
  foreigndistrict?: string | null,
  defaultflag?: number | null,
  addresstitle?: string | null,
  addressindex?: number | null,
};

export type CreatePurchaseInvoiceInput = {
  purchasetransactionmaster?: Array< PurchaseTransactionMasterTransactionInput | null > | null,
  transactiondetails?: Array< TransactionDetailsTransactionInput | null > | null,
  purchasetdsdetails?: Array< PurchaseTDSDetailsTransactionInput | null > | null,
  purchasetcsdetails?: Array< PurchaseTCSDetailsTransactionInput | null > | null,
  purchaselineitems?: Array< PurchaseLineItemsTransactionInput | null > | null,
  purchaselinenonitems?: Array< PurchaseLineNonItemsTransactionInput | null > | null,
  partyaddressentity?: Array< PartyAddressEntityTransactionInput | null > | null,
  purchaselinegst?: Array< PurchaseLineGSTTransactionInput | null > | null,
  purchaselinenongst?: Array< PurchaseLineNonGSTTransactionInput | null > | null,
  purchaseattachment?: Array< PurchaseAttachmentTransactionInput | null > | null,
};

export type PurchaseTransactionMasterTransactionInput = {
  purchasegsttypecd: string,
  supplierid: number,
  entrydate: number,
  vouchernumber: string,
  supplierinvoicedate: number,
  supplierinvoicenumber: string,
  supplieraddressid: number,
  paymenttypecd: string,
  paidamount: number,
  creditduration: number,
  paymentaccountid: number,
  comments: string,
  tdsapplicableflag: number,
  granttotalamount: number,
  balancedueamount: number,
  paymentclearedflag: number,
  placeofsupply: string,
  companystate: string,
  roundoffamount: number,
  discounttype: number,
  discountvalue: number,
  adjustmentamount: number,
  serialnumber: string,
  currencycode: string,
  currencyrate: number,
  reversechargeflag: number,
  partyregistrationtype: string,
  purchaseinvoicepdf: string,
  consigneename: string,
  consigneegstin: string,
  transactiontypecd: string,
  bankreferencenumber: string,
  itcflag?: number | null,
  cessexist?: number | null,
};

export type PurchaseTDSDetailsTransactionInput = {
  tdsapplicablecd: string,
  totaltaxableamount: number,
  ineligibletcflag: number,
  reversechargeflag: number,
  gstcesstotal: number,
  tdsamount: number,
  adjustmentamount: number,
  tdssection: string,
  tdspercentage: number,
  tdsmanual: number,
};

export type PurchaseTCSDetailsTransactionInput = {
  tcsapplicablecd: string,
  totaltaxableamount: number,
  ineligibletcflag: number,
  reversechargeflag: number,
  gstcesstotal: number,
  tcsamount: number,
  adjustmentamount: number,
  tcssection: string,
  tcspercentage: number,
  tcsmanual: number,
};

export type PurchaseLineItemsTransactionInput = {
  purchaseitemid: number,
  itemnumber: number,
  itemid: number,
  purchaseaccountid: number,
  hsncode: string,
  itemquantity: number,
  unittypecd: string,
  itemrate: number,
  itemamount: number,
  itemdiscount: number,
  discounttype?: string | null,
  discountrate?: number | null,
  netamount: number,
  taxability: string,
  pricetype: string,
  manualdiscount: number,
  manualcess: number,
  pricetypeid: number,
  itemtype?: string | null,
  manualgst?: number | null,
};

export type PurchaseLineNonItemsTransactionInput = {
  purchaseitemid: number,
  purchaselineitemtype: string,
  purchaseaccountid: number,
  hsnsaccode?: string | null,
  itemdescription: string,
  taxableamount: number,
  netamount: number,
  taxability: string,
  manualgst?: number | null,
  manualcess?: number | null,
};

export type PurchaseLineGSTTransactionInput = {
  purchaseitemid: number,
  gstrate: number,
  cessamount: number,
  gstamount: number,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type PurchaseLineNonGSTTransactionInput = {
  purchaseitemid: number,
  gstrate: number,
  cessamount: number,
  gstamount: number,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type PurchaseAttachmentTransactionInput = {
  attachmentname: string,
  attachmenturl: string,
  documentname: string,
  type: string,
};

export type PurchaseInvoice = {
  __typename: "PurchaseInvoice",
  purchaseid?: number | null,
  companyid?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type TransactionSpecificTime = {
  __typename: "TransactionSpecificTime",
  transactionid?: number | null,
  companyid?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreateCrDrNoteTransactionsArrayInput = {
  crdrnotetransactionmaster?: Array< CrDrNoteTransactionMasterTransactionInput | null > | null,
  transactiondetails?: Array< TransactionDetailsTransactionInput | null > | null,
  crdrnotelineitems?: Array< CrDrNoteLineItemsTransactionInput | null > | null,
  crdrnotelinenonitems?: Array< CrDrNoteLineNonItemsTransactionInput | null > | null,
  crdrnotetcsdetails?: Array< CrDrNoteTCSDetailsTransactionInput | null > | null,
  crdrnotetdsdetails?: Array< CrDrNoteTDSDetailsTransactionInput | null > | null,
  crdrnotedetails?: Array< CrDrNoteDetailsTransactionInput | null > | null,
  crdrnoteinvoices?: Array< CrDrNoteInvoicesTransactionInput | null > | null,
  crdrnotedispatch?: Array< CrDrNoteDispatchTransactionInput | null > | null,
  crdrattachment?: Array< CrDrAttachmentTransactionInput | null > | null,
  partyaddressentity?: Array< PartyAddressEntityTransactionInput | null > | null,
};

export type CrDrNoteTransactionMasterTransactionInput = {
  crdrnotetypecd: string,
  crdrnotedate: number,
  crdrnotenumber: string,
  invoicetypecd: string,
  gsttypecd: string,
  partyid: number,
  deliveryaddressid: number,
  paymenttype: string,
  grandtotalamount: number,
  creditduration: number,
  psflag: number,
  reversechargeflag: number,
  balancedueamount: number,
  consigneename: string,
  consigneegstin: string,
  companystate: string,
  placeofsupply: string,
  cancelflag: number,
  cancelremark: string,
  roundoffamount: number,
  discounttype: number,
  discountvalue: number,
  adjustmentamount: number,
  serialnumber: string,
  currencycode: string,
  currencyrate: number,
  originalinvoicenumber: string,
  partyinvoicenumber: string,
  crdrnotepdf: string,
  partyregistrationtype: string,
  itcflag?: number | null,
  cessexist?: number | null,
};

export type CrDrNoteLineItemsTransactionInput = {
  crdrnoteitemid: number,
  lineitemnumber: number,
  lineitemtype: string,
  itemid: number,
  quantity: number,
  unittypecd: string,
  itemrate: number,
  itemamount: number,
  itemdiscount: number,
  discounttype?: string | null,
  discountrate?: number | null,
  gstrate: number,
  gsttypecd: string,
  gstamount: number,
  gstcess: number,
  hsnsaccode: string,
  netamount: number,
  taxability: string,
  reason: string,
  pricetype: string,
  manualdiscount: number,
  manualcess: number,
  pricetypeid: number,
  itemtype?: string | null,
  manualgst?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type CrDrNoteLineNonItemsTransactionInput = {
  crdrnoteitemid: number,
  lineitemtype: string,
  ledgeraccountid: number,
  hsnsaccode: string,
  itemdescription: string,
  taxableamount: number,
  gstrate: number,
  gsttypecd: string,
  gstamount: number,
  gstcess: number,
  netamount: number,
  taxability: string,
  reason: string,
  manualgst?: number | null,
  manualcess?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type CrDrNoteTCSDetailsTransactionInput = {
  tcsapplicablecd: string,
  totaltaxableamount: number,
  ineligibletcflag: number,
  reversechargeflag: number,
  gstcesstotal: number,
  tcsamount: number,
  adjustmentamount: number,
  tcssection: string,
  tcspercentage: number,
  tcsmanual: number,
};

export type CrDrNoteTDSDetailsTransactionInput = {
  tdsapplicablecd: string,
  totaltaxableamount: number,
  ineligibletcflag: number,
  reversechargeflag: number,
  gstcesstotal: number,
  tdsamount: number,
  adjustmentamount: number,
  tdssection: string,
  tdspercentage: number,
  tdsmanual: number,
};

export type CrDrNoteDetailsTransactionInput = {
  totaltaxableamount: number,
  totalgst: number,
  totalgstcess: number,
  totaladjustments: number,
  comments: string,
  accountid: number,
  partamount: number,
  transportationcd: string,
  vehiclenumber: string,
  dispatchdate: number,
  ewaybillnumber: string,
};

export type CrDrNoteInvoicesTransactionInput = {
  invoiceid: number,
};

export type CrDrNoteDispatchTransactionInput = {
  dispatchid: number,
  transportationcd: string,
  vehiclenumber: string,
  dispatchdate: number,
  ewaybillnumber: string,
};

export type CrDrAttachmentTransactionInput = {
  attachmentname: string,
  attachmenturl: string,
  documentname: string,
  type: string,
};

export type CrDrNoteInvoiceTransaction = {
  __typename: "CrDrNoteInvoiceTransaction",
  crdrnoteid?: number | null,
  companyid?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreateAccountOpeningBalancesArrayInput = {
  openingbalancedate?: number | null,
  transactionmaster?: string | null,
  transactiondetails?: string | null,
};

export type AccountOpeningBalanceResponse = {
  __typename: "AccountOpeningBalanceResponse",
  companyid?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreateItemCategorymasterInput = {
  itemcategoryid: number,
  expiredtimestamp: number,
  category: string,
  itemcategorygroupid: number,
  maincategory: string,
};

export type ItemCategoryMaster = {
  __typename: "ItemCategoryMaster",
  itemcategoryid?: number | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  category?: string | null,
  itemcategorygroupid?: number | null,
  maincategory?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  lastupdatedby?: string | null,
};

export type CreateCompanyCodeTranslationInput = {
  expiredtimestamp: number,
  codetype: string,
  codevalue: string,
  language?: string | null,
  codetext: string,
  codeorder?: number | null,
  uqc: string,
  is_active?: string | null,
  section?: string | null,
};

export type CompanyCodeTranslation = {
  __typename: "CompanyCodeTranslation",
  id?: number | null,
  companyid?: number | null,
  codetype?: string | null,
  codevalue?: string | null,
  language?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  codetext?: string | null,
  codeorder?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  lastupdatedby?: string | null,
  uqc?: string | null,
  is_active?: string | null,
  section?: string | null,
};

export type PriceType = {
  __typename: "PriceType",
  id?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  pricetype?: string | null,
  userid?: string | null,
  is_default?: number | null,
  is_active?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  tabletype?: number | null,
};

export type CreateAccountGroupMasterInput = {
  accounttypecd: string,
  accountgroupname: string,
  accountparentgroupid: number,
};

export type AccountGroupMaster = {
  __typename: "AccountGroupMaster",
  accountgroupid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  accounttypecd?: string | null,
  accountgroupname?: string | null,
  accountparentgroupid?: number | null,
  displayordernumber?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  restrictedflag?: number | null,
  is_active?: number | null,
  relatedaccounts?:  Array<AccountMaster | null > | null,
  path?: string | null,
};

export type AccountMaster = {
  __typename: "AccountMaster",
  accountsid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  accountname?: string | null,
  accounttypecd?: string | null,
  accountgroupid?: number | null,
  hsnsaccode?: string | null,
  displayordernumber?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  restrictedflag?: number | null,
  is_active?: number | null,
  accounttypeflag?: number | null,
  relatedaccountgstdetails?:  Array<AccountGSTDetails | null > | null,
  relatedaccountopeningbalance?:  Array<AccountOpeningBalance | null > | null,
  relatedaccountgroupmaster?:  Array<AccountGroupMasterNew | null > | null,
  relatedaccountbalance?:  Array<AccountBalanceNew | null > | null,
  path?: string | null,
};

export type AccountGSTDetails = {
  __typename: "AccountGSTDetails",
  accountid?: number | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  effectivedate?: number | null,
  expireddate?: number | null,
  hsnid?: string | null,
  gstcompensationtype?: string | null,
  gstrate?: number | null,
  cessamount?: number | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  hsnsaccode?: string | null,
  codetype?: string | null,
  description?: string | null,
  taxability?: string | null,
};

export type AccountOpeningBalance = {
  __typename: "AccountOpeningBalance",
  accountsid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  financialyearid?: number | null,
  startdate?: number | null,
  creditamount?: number | null,
  debitamount?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type AccountGroupMasterNew = {
  __typename: "AccountGroupMasterNew",
  accountgroupid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  accounttypecd?: string | null,
  accountgroupname?: string | null,
  accountparentgroupid?: number | null,
  displayordernumber?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  is_active?: number | null,
  restrictedflag?: number | null,
  path?: string | null,
};

export type AccountBalanceNew = {
  __typename: "AccountBalanceNew",
  accountid?: number | null,
  accountbalance?: number | null,
  actualbalance?: number | null,
};

export type InvoiceSettingsInput = {
  expiredtimestamp: number,
  typecd: string,
  invoiceheading: string,
  signaturetext: string,
  declarationatfooter: string,
  termsandcondition: string,
  declarationatfooterflag: number,
  termsandconditionsflag: number,
  companyname: number,
  companycin: number,
  invoicenumber: number,
  companyaddress: number,
  companylogo: number,
  invoicedate: number,
  companycontactnumber: number,
  companyemail: number,
  paymentmode: number,
  companygstin: number,
  companywebsite: number,
  creditperiod: number,
  companypan: number,
  companybankdetails: number,
  paymentduedate: number,
  customerlegalname: number,
  customergstin: number,
  lutbonddetails: number,
  customerdisplayname: number,
  placeofsupply: number,
  dispatchdetails: number,
  customerbillingaddress: number,
  customercontactperson: number,
  customercontactnumber: number,
  customername: number,
  ewaybilldetails: number,
  customershippingaddress: number,
  customerordernoanddate: number,
  einvoicedetails: number,
  itemwisediscount: number,
  hsnsacode: number,
  showroundoff: number,
  hsnsasummarytable: number,
  invoicedescription: number,
  regularinvoicesignaturefilename: string,
  posinvoicesignaturefilename: string,
  defaultsetting: number,
  bankdetails: string,
  upi_id: string,
  acknowledgement: string,
  acknowledgementflag: number,
  bosinvoiceheading: string,
  bank_name?: string | null,
  branch?: string | null,
  ac_name?: string | null,
  ac_no?: string | null,
  ifsc?: string | null,
  swift_code?: string | null,
};

export type InvoiceSettings = {
  __typename: "InvoiceSettings",
  invoicesettingsid?: number | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  typecd?: string | null,
  invoiceheading?: string | null,
  signaturetext?: string | null,
  declarationatfooter?: string | null,
  termsandcondition?: string | null,
  declarationatfooterflag?: number | null,
  termsandconditionsflag?: number | null,
  companyname?: number | null,
  companycin?: number | null,
  invoicenumber?: number | null,
  companyaddress?: number | null,
  companylogo?: number | null,
  invoicedate?: number | null,
  companycontactnumber?: number | null,
  companyemail?: number | null,
  paymentmode?: number | null,
  companygstin?: number | null,
  companywebsite?: number | null,
  creditperiod?: number | null,
  companypan?: number | null,
  companybankdetails?: number | null,
  paymentduedate?: number | null,
  customerlegalname?: number | null,
  customergstin?: number | null,
  lutbonddetails?: number | null,
  customerdisplayname?: number | null,
  placeofsupply?: number | null,
  dispatchdetails?: number | null,
  customerbillingaddress?: number | null,
  customercontactperson?: number | null,
  customercontactnumber?: number | null,
  customername?: number | null,
  ewaybilldetails?: number | null,
  customershippingaddress?: number | null,
  customerordernoanddate?: number | null,
  einvoicedetails?: number | null,
  itemwisediscount?: number | null,
  hsnsacode?: number | null,
  showroundoff?: number | null,
  hsnsasummarytable?: number | null,
  invoicedescription?: number | null,
  regularinvoicesignaturefilename?: string | null,
  last_updated_by?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  posinvoicesignaturefilename?: string | null,
  defaultsetting?: number | null,
  bankdetails?: string | null,
  upi_id?: string | null,
  acknowledgement?: string | null,
  acknowledgementflag?: number | null,
  bosinvoiceheading?: string | null,
  bank_name?: string | null,
  branch?: string | null,
  ac_name?: string | null,
  ac_no?: string | null,
  ifsc?: string | null,
  swift_code?: string | null,
};

export type CreateAccountMasterInput = {
  accountname?: string | null,
  accounttypecd?: string | null,
  accountgroupid?: number | null,
  hsnsaccode?: string | null,
};

export type CreateCompanyDetailsInput = {
  companyshort: string,
  companylegalname: string,
  lutbondtodate: number,
  invoicedetailapplicablefromdate: number,
  tdsapplicable: number,
  gstcategory: string,
  financialyearstartandendmonth: number,
  expiredtimestamp: number,
  websiteurl: string,
  currencycd: number,
  accountinventoryflag: number,
  pannumber: string,
  tdstcsnumber: string,
  cinregistrationnumber: string,
  registrationtype: number,
  comppercentage: number,
  gstrperiod: string,
  lut: string,
  lutbondvalidfrom: number,
  ewaybillflag: number,
  gstapplicablefrom: number,
  thresholdlimitcd: number,
  thresholdlimitamount: number,
  companylogourl: string,
  msmetype: string,
  udhyamregno: string,
  udhyamdocs: string,
  ewaybillstartdate: number,
  minamountewayinter: number,
  minamountewayintra: number,
  einvoiceflag: number,
  einvoicestartingdate: number,
  gstcompensationcessflag: number,
  tradelicensenumber: string,
  tradelicensestartdate: number,
  tradelicenseenddate: number,
  cinregistrationdate: number,
  lastupdatedtimestamp: number,
  einvoiceconnect: number,
  ewaybillconnect: number,
  financialyearid: number,
  stepscompleted?: string | null,
  emailaddress: string,
  phonenumber: string,
  businesstypeid?: Array< number | null > | null,
  industrytypeid?: Array< number | null > | null,
};

export type CreatecompanyentityInput = {
  expiredtimestamp: number,
  legalname: string,
  gstin: string,
  financialyearcode: string,
  companyentitytype: string,
  startdate: number,
  financialyearid: number,
};

export type CreateAccountGSTDetailsInput = {
  accountid: number,
  effectivedate: number,
  expireddate: number,
  hsnid?: string | null,
  cessamount?: number | null,
  gstcompensationtype?: string | null,
  gstrate?: number | null,
  taxability?: string | null,
};

export type CreateHSNSACMasterInput = {
  codetype: string,
  hsnsaccode: string,
  description: string,
};

export type hsnsacmaster = {
  __typename: "hsnsacmaster",
  hsnsacid?: number | null,
  codetype?: string | null,
  hsnsaccode?: string | null,
  description?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  companyid?: number | null,
};

export type CreatePartyCreditDetailsInput = {
  partyid: number,
  creditperiodduration: string,
  billingcurrency: string,
  creditlimitcd: number,
  creditlimitamount: number,
  billwiseflag: number,
  notes: string,
};

export type PartyCreditDetails = {
  __typename: "PartyCreditDetails",
  partyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  creditperiodduration?: string | null,
  billingcurrency?: string | null,
  creditlimitcd?: number | null,
  creditlimitamount?: number | null,
  billwiseflag?: number | null,
  notes?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreatePartyGSTDetailsInput = {
  partyid: number,
  pannumber: string,
  gstin: string,
  partyaddressid: number,
};

export type PartyGSTDetails = {
  __typename: "PartyGSTDetails",
  partyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  pannumber?: string | null,
  gstin?: string | null,
  partyaddressid?: number | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type BusinessTypeInputs = {
  businesstypeid?: number | null,
  companyid: number,
  expiredtimestamp: number,
  businesstype: string,
  lastupdatedby: string,
  restrictedflag: number,
  isactive: number,
};

export type BusinessType = {
  __typename: "BusinessType",
  businesstypeid?: number | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  businesstype?: string | null,
  lastupdatedby?: string | null,
  restrictedflag?: number | null,
  isactive?: number | null,
};

export type IndustryTypeInputs = {
  industrytypeid?: number | null,
  companyid: number,
  expiredtimestamp: number,
  industrytype: string,
  lastupdatedby: string,
  restrictedflag: number,
  isactive: number,
};

export type IndustryType = {
  __typename: "IndustryType",
  industrytypeid?: number | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  industrytype?: string | null,
  lastupdatedby?: string | null,
  restrictedflag?: number | null,
  isactive?: number | null,
};

export type CreateBankDetailsInput = {
  bankdetailsid: number,
  companybranchid: number,
  objecttype: string,
  expiredtimestamp: number,
  objectid: string,
  bankname: string,
  bankaccountnumber: string,
  ifsccode: string,
  branch: string,
  notes: string,
  ledgeraccount: string,
  bankaccounttype: string,
  upi: string,
  cash: number,
  swiftcode: string,
};

export type BankDetails = {
  __typename: "BankDetails",
  bankdetailsid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  objecttype?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  objectid?: string | null,
  userid?: string | null,
  bankname?: string | null,
  bankaccountnumber?: string | null,
  ifsccode?: string | null,
  branch?: string | null,
  notes?: string | null,
  ledgeraccount?: string | null,
  bankaccounttype?: string | null,
  cash?: number | null,
  swiftcode?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  relatedaccountdetails?:  Array<AccountMaster | null > | null,
  upi?: string | null,
};

export type CreateFinancialYearInput = {
  companyid: number,
  startdate?: number | null,
  enddate?: number | null,
  startyear?: string | null,
  endyear?: string | null,
  comments?: string | null,
  aliasname?: string | null,
};

export type CreateUserPreferenceInput = {
  attributetypecd?: string | null,
  attributevalue?: number | null,
  additionalvalue?: string | null,
};

export type UserPreference = {
  __typename: "UserPreference",
  userid?: string | null,
  attributetypecd?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  attributevalue?: number | null,
  additionalvalue?: string | null,
};

export type CreateCompanyPreferenceInput = {
  attributetypecd: string,
  attributevalue: number,
  additionalvalue: string,
};

export type CompanyPreference = {
  __typename: "CompanyPreference",
  companyid?: number | null,
  attributetypecd?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  attributevalue?: number | null,
  additionalvalue?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type SwitchCompany = {
  __typename: "SwitchCompany",
  companyid?: number | null,
  financialyearid?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type PaymentSettingsInput = {
  enable_itemwiseentry: number,
  enable_creditperiod: number,
  enable_creditlimit: number,
  enable_autopayreminder: number,
  enable_autoreminderdays: number,
  expiredtimestamp: number,
};

export type PaymentSettings = {
  __typename: "PaymentSettings",
  enable_itemwiseentry?: number | null,
  enable_creditperiod?: number | null,
  enable_creditlimit?: number | null,
  enable_autopayreminder?: number | null,
  enable_autoreminderdays?: number | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  lastupdatedby?: string | null,
};

export type CreateTransactionMasterInput = {
  transactiontypecd: string,
  entrydate: number,
  bankreferencenumber: string,
  comments: string,
  vouchercode?: string | null,
  serialnumber?: string | null,
};

export type TransactionMaster = {
  __typename: "TransactionMaster",
  transactionid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  transactiontypecd?: string | null,
  vouchernumber?: string | null,
  entrydate?: number | null,
  bankreferencenumber?: string | null,
  comments?: string | null,
  relatedtransactiondetails?:  Array<TransactionDetailsCustom | null > | null,
  relatedtransactionattachment?:  Array<TransactionAttachment | null > | null,
  relatedtransactiontdsdetails?:  Array<TransactionTDSDetails | null > | null,
  relatedpurchasemaster?:  Array<PurchaseMasterNew | null > | null,
  relatedinvoicemaster?:  Array<Invoicemasternew | null > | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  cancelflag?: number | null,
  cancelremark?: string | null,
  serialnumber?: string | null,
  pdflink?: string | null,
  towards?: string | null,
  isvouchereditable?: number | null,
};

export type TransactionDetailsCustom = {
  __typename: "TransactionDetailsCustom",
  transactionid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  transactiontypecd?: string | null,
  accountid?: number | null,
  creditamount?: number | null,
  debitamount?: number | null,
  comments?: string | null,
  entryordernumber?: number | null,
  transactionbalance?: number | null,
  openingbalance?: number | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  financialyearid?: number | null,
};

export type TransactionAttachment = {
  __typename: "TransactionAttachment",
  transactionid: number,
  attachmentid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  attachmentname: string,
  attachmenturl: string,
  lastupdatedby?: string | null,
  documentname: string,
  statuscode?: string | null,
  statusmessage?: string | null,
  type?: string | null,
};

export type TransactionTDSDetails = {
  __typename: "TransactionTDSDetails",
  transactionid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  tdsapplicablecd: string,
  tdsamount: number,
  tdsmanual?: number | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  tdspercentage?: number | null,
};

export type PurchaseMasterNew = {
  __typename: "PurchaseMasterNew",
  purchaseid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  purchasegsttypecd: string,
  supplierid: number,
  entrydate: number,
  vouchernumber: string,
  supplierinvoicedate: number,
  supplierinvoicenumber: string,
  supplieraddressid: number,
  paymenttypecd: string,
  paidamount: number,
  creditduration: number,
  paymentaccountid: number,
  comments: string,
  tdsapplicableflag: number,
  granttotalamount?: number | null,
  balancedueamount?: number | null,
  paymentclearedflag?: number | null,
  placeofsupply?: string | null,
  companystate?: string | null,
  relatedpurchasetdsdetails?:  Array<PurchaseTDSDetails | null > | null,
  relatedpurchaselineitems?:  Array<PurchaseLineItems | null > | null,
  relatedpurchaselinenonitems?:  Array<PurchaseLineNonItems | null > | null,
  relatedpurchaselinegst?:  Array<PurchaseLineGST | null > | null,
  relatedpurchaseattachment?:  Array<PurchaseAttachment | null > | null,
  relatedpurchasetransactiondetails?:  Array<TransactionMaster | null > | null,
  relatedpurchasetransactionrelation?:  Array<TransactionRelation | null > | null,
  lastupdatedby?: string | null,
  cancelflag?: number | null,
  roundoffamount?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  adjustmentamount?: number | null,
  serialnumber?: string | null,
  currencycode?: string | null,
  currencyrate?: number | null,
  reversechargeflag?: number | null,
  paymentstatus?: number | null,
  partyregistrationtype?: string | null,
  partygstcategory?: string | null,
  itcflag?: number | null,
};

export type PurchaseTDSDetails = {
  __typename: "PurchaseTDSDetails",
  purchaseid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  tdsapplicablecd?: number | null,
  totaltaxableamount?: number | null,
  ineligibletcflag?: number | null,
  reversechargeflag?: number | null,
  gstcesstotal?: number | null,
  tdsamount?: number | null,
  adjustmentamount?: number | null,
  tdssection?: string | null,
  tdspercentage?: number | null,
  tdsmanual?: number | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type PurchaseLineItems = {
  __typename: "PurchaseLineItems",
  purchaseid: number,
  purchaseitemid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  itemnumber: number,
  itemid: number,
  purchaseaccountid: number,
  hsncode: string,
  itemquantity: number,
  unittypecd: string,
  itemrate: number,
  itemamount: number,
  itemdiscount: number,
  discounttype?: string | null,
  discountrate?: number | null,
  netamount: number,
  relatedpurchaselinegst?:  Array<PurchaseLineGST | null > | null,
  relateditemmaster?:  Array<itemmaster | null > | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  taxability?: string | null,
  pricetype?: string | null,
  lotid?: string | null,
  hsnid?: string | null,
  hsncodetype?: string | null,
  hsndescription?: string | null,
  gstrate?: number | null,
  gstamount?: number | null,
  cessamount?: number | null,
  unit?: string | null,
  uqc?: string | null,
  purchaseaccountname?: string | null,
  itemname?: string | null,
  itemcode?: string | null,
  itemtype?: string | null,
  manualdiscount?: number | null,
  manualcess?: number | null,
  pricetypeid?: number | null,
  manualgst?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type PurchaseLineGST = {
  __typename: "PurchaseLineGST",
  purchaseid: number,
  purchaseitemid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  gstrate: number,
  cessamount: number,
  gstamount: number,
  cessrate?: number | null,
  cesstype?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type itemmaster = {
  __typename: "itemmaster",
  itemid?: number | null,
  itemcode?: string | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  itemname?: string | null,
  salesinvoiceflag?: number | null,
  purchaseinvoiceflag?: number | null,
  itemcategorycd?: string | null,
  measurementcd?: string | null,
  currencycd?: string | null,
  salesaccountid?: number | null,
  purchaseaccountid?: number | null,
  taxabilitycd?: string | null,
  reversechargeflag?: number | null,
  itemtype?: string | null,
  hsnid?: string | null,
  is_active?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  relateditemamountdetails?:  Array<ItemAmountDetails | null > | null,
  relateditemgstdetails?:  Array<ItemGstDetails | null > | null,
  relateditemimages?:  Array<ItemImages | null > | null,
  lastupdatedby?: string | null,
  serialnumber?: string | null,
  financialyearid?: number | null,
  description?: string | null,
  hsnsacid?: number | null,
  hsncodetype?: string | null,
  hsncodevalue?: string | null,
  hsndescription?: string | null,
  cessexist?: number | null,
  barcode?: string | null,
};

export type ItemAmountDetails = {
  __typename: "ItemAmountDetails",
  id?: number | null,
  itemid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  amount?: number | null,
  effectivedate?: number | null,
  expireddate?: number | null,
  hsnid?: string | null,
  gstcompensationtype?: string | null,
  gstcompensationvalue?: number | null,
  gstrate?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  lastupdatedby?: string | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  invoicetype?: number | null,
  pricetype?: string | null,
  isactive?: number | null,
  isdefault?: number | null,
  pricetypeid?: number | null,
  tabletype?: number | null,
};

export type ItemGstDetails = {
  __typename: "ItemGstDetails",
  itemid: number,
  companyid: number,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  hsnid: string,
  gstcesstype: string,
  gstcompensationvalue: number,
  effectivedate?: number | null,
  expireddate?: number | null,
  gstcessvalue?: number | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type ItemImages = {
  __typename: "ItemImages",
  attachmentid?: number | null,
  itemid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  imagename?: string | null,
  imageurl?: string | null,
  documentname?: string | null,
  type?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type PurchaseLineNonItems = {
  __typename: "PurchaseLineNonItems",
  purchaseid: number,
  purchaseitemid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  purchaselineitemtype: string,
  purchaseaccountid: number,
  hsnsaccode: string,
  itemdescription: string,
  taxableamount: number,
  netamount: number,
  relatedpurchaselinenongst?:  Array<PurchaseLineNonGST | null > | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  taxability?: string | null,
  hsnsacid?: number | null,
  hsncodetype?: string | null,
  hsncodevalue?: string | null,
  hsndescription?: string | null,
  gstrate?: number | null,
  gstamount?: number | null,
  cessamount?: number | null,
  purchaseaccountname?: string | null,
  manualgst?: number | null,
  manualcess?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type PurchaseLineNonGST = {
  __typename: "PurchaseLineNonGST",
  purchaseid: number,
  purchaseitemid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  gstrate: number,
  cessamount: number,
  gstamount: number,
  cessrate?: number | null,
  cesstype?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type PurchaseAttachment = {
  __typename: "PurchaseAttachment",
  purchaseid: number,
  attachmentid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  attachmentname: string,
  attachmenturl: string,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  documentname?: string | null,
  type?: string | null,
};

export type TransactionRelation = {
  __typename: "TransactionRelation",
  transactionid?: number | null,
  transactiontypecd?: string | null,
  objecttype?: string | null,
  objectid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  linkedamount?: number | null,
  objectattribute?: string | null,
  isdirect?: number | null,
  lastupdatedby?: string | null,
  accountid?: number | null,
  paymentvouchernumber?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type Invoicemasternew = {
  __typename: "Invoicemasternew",
  invoiceid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  invoicetypecd: string,
  partyid: number,
  paymentaccountid: number,
  invoicedate: number,
  invoicenumber: string,
  customerordernumber: string,
  customerorderdate?: number | null,
  invoiceamount: number,
  paymenttype: string,
  creditduration: number,
  invoicebillingaddressid: number,
  invoicedeliveryaddressid: number,
  invoicetaxabletypecd: string,
  receipturl: string,
  invoicelinetypecd: string,
  invoicecurrencycd: string,
  exchangerate: number,
  comments: string,
  receivedamount: number,
  adjustmentamount: number,
  placeofsupply?: string | null,
  balancedueamount?: number | null,
  reversechargeflag?: number | null,
  tcsapplicableflag?: number | null,
  relatedinvoicelineitems?:  Array<InvoiceLineItems | null > | null,
  relatedinvoicelinenonitems?:  Array<InvoiceLineNonItems | null > | null,
  relatedinvoiceattachment?:  Array<InvoiceAttachment | null > | null,
  relatedinvoicedispatch?:  Array<InvoiceDispatch | null > | null,
  relatedinvoiceposdetails?:  Array<InvoicePOSDetails | null > | null,
  relatedinvoicelinegst?:  Array<InvoiceLineGST | null > | null,
  relatedinvoicenumbertracker?:  Array<InvoiceNumberTracker | null > | null,
  relatedinvoicetransactiondetails?:  Array<TransactionMaster | null > | null,
  lastupdatedby?: string | null,
  cancelflag?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  consigneename?: string | null,
  consigneegstin?: string | null,
  companystate?: string | null,
  cancelremark?: string | null,
  deleteremark?: string | null,
  roundoffamount?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  serialnumber?: string | null,
  currencycode?: string | null,
  currencyrate?: number | null,
  paymentstatus?: number | null,
  ackno?: string | null,
  ackdt?: number | null,
  irn?: string | null,
  signedqrcode?: string | null,
  itcflag?: number | null,
};

export type InvoiceLineItems = {
  __typename: "InvoiceLineItems",
  invoiceid?: number | null,
  invoiceitemid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  lineitemnumber?: number | null,
  invoicelineitemtype?: string | null,
  itemid?: number | null,
  quantity?: number | null,
  unittypecd?: string | null,
  itemrate?: number | null,
  itemamount?: number | null,
  itemdiscount?: number | null,
  discounttype?: string | null,
  discountrate?: number | null,
  netamount?: number | null,
  hsnsaccode?: string | null,
  taxability?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  pricetype?: string | null,
  lotid?: string | null,
  hsnsacid?: number | null,
  hsncodetype?: string | null,
  hsncodevalue?: string | null,
  hsndescription?: string | null,
  gstrate?: number | null,
  gsttypecd?: string | null,
  gstamount?: number | null,
  cessamount?: number | null,
  unit?: string | null,
  uqc?: string | null,
  salesaccountname?: string | null,
  salesaccountid?: number | null,
  itemname?: string | null,
  itemcode?: string | null,
  itemtype?: string | null,
  manualdiscount?: number | null,
  manualcess?: number | null,
  itemmaster_timestamp?: number | null,
  description?: string | null,
  relatedinvoicelinegst?:  Array<InvoiceLineGST | null > | null,
  relateditemmaster?:  Array<itemmaster | null > | null,
  pricetypeid?: number | null,
  manualgst?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type InvoiceLineGST = {
  __typename: "InvoiceLineGST",
  invoiceid: number,
  invoiceitemid: number,
  companyid: number,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  gstrate?: number | null,
  gsttypecd?: string | null,
  gstamount?: number | null,
  cessamount?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type InvoiceLineNonItems = {
  __typename: "InvoiceLineNonItems",
  invoiceid?: number | null,
  invoiceitemid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  invoicelineitemtype?: string | null,
  incomeaccountid?: number | null,
  hsnsaccode?: string | null,
  taxability?: string | null,
  itemdescription?: string | null,
  taxableamount?: number | null,
  netamount?: number | null,
  relatedaccounts?:  Array<AccountMaster | null > | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  hsnsacid?: number | null,
  hsncodetype?: string | null,
  hsncodevalue?: string | null,
  hsndescription?: string | null,
  gstrate?: number | null,
  gsttypecd?: string | null,
  gstamount?: number | null,
  cessamount?: number | null,
  incomeaccountname?: string | null,
  manualgst?: number | null,
  manualcess?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type InvoiceAttachment = {
  __typename: "InvoiceAttachment",
  invoiceid?: number | null,
  attachmentid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  attachmentname?: string | null,
  attachmenturl?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  documentname?: string | null,
  type?: string | null,
};

export type InvoiceDispatch = {
  __typename: "InvoiceDispatch",
  invoiceid: number,
  dispatchid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  transportationcd: string,
  vehiclenumber: string,
  dispatchdate: number,
  ewaybillnumber: string,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type InvoicePOSDetails = {
  __typename: "InvoicePOSDetails",
  posid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  partyposid: number,
  lastupdatedby?: string | null,
  relatedposparty?:  Array<POSParty | null > | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type POSParty = {
  __typename: "POSParty",
  pospartyid?: number | null,
  companyid?: number | null,
  partyname?: string | null,
  partycontactnumberid?: number | null,
  lastupdatedby?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  relatedphonecontacts?:  Array<PhoneContacts | null > | null,
};

export type InvoiceNumberTracker = {
  __typename: "InvoiceNumberTracker",
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  nextinvoicenumber: string,
  lastupdatedby?: string | null,
};

export type TransactionDetails = {
  __typename: "TransactionDetails",
  transactionid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  transactiontypecd?: string | null,
  accountid?: number | null,
  creditamount?: number | null,
  debitamount?: number | null,
  comments?: string | null,
  entryordernumber?: number | null,
  transactionbalance?: number | null,
  openingbalance?: number | null,
  relatedaccounts?:  Array<AccountMaster | null > | null,
  relatedaccountstransaction?:  Array<RelatedAccountsTransactionDetails | null > | null,
  lastupdatedby?: string | null,
  financialyearid?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type RelatedAccountsTransactionDetails = {
  __typename: "RelatedAccountsTransactionDetails",
  transactionid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  transactiontypecd?: string | null,
  accountid?: number | null,
  creditamount: number,
  debitamount: number,
  comments?: string | null,
  entryordernumber?: number | null,
  transactionbalance?: number | null,
  openingbalance?: number | null,
  vouchernumber?: string | null,
  transactionmastertypecd?: string | null,
  relatedaccounts?:  Array<AccountMaster | null > | null,
  financialyearid?: number | null,
};

export type CreateTransactionRelationInput = {
  transactionid?: number | null,
  transactiontypecd?: string | null,
  objecttype?: string | null,
  objectid?: number | null,
  linkedamount?: number | null,
  objectattribute?: string | null,
  isdirect?: number | null,
  accountid?: number | null,
  paymentvouchernumber?: string | null,
};

export type SetOffResponse = {
  __typename: "SetOffResponse",
  success: boolean,
  message?: string | null,
};

export type SetOffItemInput = {
  sourceinvoiceid: number,
  sourcetransactiontype: string,
  setoffamount: number,
};

export type CreateInvoicePOSDetailsInput = {
  posid: number,
  expiredtimestamp: number,
  partyposid: number,
};

export type CreatePOSPartyInput = {
  pospartyid: number,
  partyname: string,
  partycontactnumberid: number,
  expiredtimestamp: number,
};

export type CreatePhoneContactsInput = {
  id: number,
  objectid: number,
  objecttype: string,
  expiredtimestamp: number,
  countrycode: string,
  phonenumber: string,
  verifieddatetime: number,
  promotionssignup: string,
  smsallowed: string,
  callallowed: string,
  whatsappallowed: string,
  financialyearid: number,
};

export type CreateNumberTrackerInput = {
  financialyearid: number,
  companyid: number,
  entrytypecd: string,
  nextinvoicenumber: number,
  prefix?: string | null,
  suffix?: string | null,
  serialnumber?: string | null,
  serialisactive?: number | null,
  serialisused?: number | null,
  serialflag?: number | null,
  startinvoicenumber: number,
  taxability?: number | null,
  restrictedflag?: number | null,
};

export type NumberTracker = {
  __typename: "NumberTracker",
  id?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  financialyearid?: number | null,
  entrytypecd?: string | null,
  serialnumber?: string | null,
  serialisactive?: number | null,
  serialisused?: number | null,
  nextinvoicenumber?: number | null,
  prefix?: string | null,
  suffix?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  serialflag?: number | null,
  startinvoicenumber?: number | null,
  taxability?: number | null,
  lastused?: number | null,
  secondlastused?: number | null,
  restrictedflag?: number | null,
};

export type CreatePartyAddressEntityInput = {
  objecttype: string,
  objectid: number,
  expiredtimestamp: number,
  line1: string,
  line2: string,
  line3: string,
  city: string,
  statecode: number,
  pincode: string,
  countrycode: string,
  district: string,
  financialyearid: number,
  godownname?: string | null,
  gstin?: string | null,
  phone?: string | null,
  email?: string | null,
  personincharge?: string | null,
  consigneename?: string | null,
  consigneegstin?: string | null,
  foreignstate?: string | null,
  foreigndistrict?: string | null,
  defaultflag?: number | null,
  addresstitle?: string | null,
  addressindex?: number | null,
};

export type CreateCompanyDocumentsInput = {
  id: number,
  partyid: number,
  documenttype: string,
  expiredtimestamp: number,
  imagename: string,
  imageurl: string,
  isactive: number,
  type: string,
  documentname: string,
};

export type CompanyDocuments = {
  __typename: "CompanyDocuments",
  id?: number | null,
  companyid?: number | null,
  partyid?: number | null,
  documenttype?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  imagename?: string | null,
  imageurl?: string | null,
  lastupdatedby?: string | null,
  isactive?: number | null,
  type?: string | null,
  documentname?: string | null,
};

export type CreateEmailContactsInput = {
  objecttype: string,
  objectid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  emailaddress: string,
  verifieddatetime: number,
  promotionssignup: number,
  lastupdatedby: string,
  financialyearid: number,
};

export type TestInput = {
  name: string,
  value: number,
};

export type TestEntry = {
  __typename: "TestEntry",
  id: string,
  name: string,
  value: number,
};

export type eInvoiceMasterInput = {
  invoiceid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  ackno: string,
  ackdt: number,
  irn: string,
  signedqrcode: string,
  lastupdatedby: string,
  is_cancelled: number,
  cancel_reason?: string | null,
  cancel_remarks?: string | null,
};

export type eInvoiceMaster = {
  __typename: "eInvoiceMaster",
  id?: number | null,
  invoiceid?: number | null,
  invoicetype: string,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  ackno?: string | null,
  ackdt?: number | null,
  irn?: string | null,
  signedqrcode?: string | null,
  lastupdatedby?: string | null,
  is_cancelled?: number | null,
  cancel_reason?: string | null,
  cancel_remarks?: string | null,
};

export type EInvoiceUsersInput = {
  companyid: number,
  username: string,
  password: string,
  enteredtimestamp: number,
  expiredtimestamp: number,
  is_active: number,
  lastupdatedby: string,
};

export type EInvoiceUsers = {
  __typename: "EInvoiceUsers",
  id?: number | null,
  companyid?: number | null,
  username?: string | null,
  password?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  is_active?: number | null,
  lastupdatedby?: string | null,
};

export type CreateItemMasterInput = {
  itemid: number,
  itemcode: string,
  companyid: number,
  expiredtimestamp: number,
  itemname: string,
  salesinvoiceflag: number,
  purchaseinvoiceflag: number,
  itemcategorycd: number,
  measurementcd: number,
  currencycd: string,
  salesaccountid: number,
  purchaseaccountid: number,
  taxabilitycd: string,
  reversechargeflag: number,
  itemtype: string,
  hsnid: string,
  lastupdatedby: string,
  is_active: number,
  serialnumber: string,
  financialyearid: number,
  description: string,
  cessexist: number,
  barcode?: string | null,
};

export type CreateItemAmountDetailsInput = {
  id: number,
  itemid: number,
  companybranchid: number,
  expiredtimestamp: number,
  amount: number,
  effectivedate: number,
  expireddate: number,
  hsnid: string,
  gstcompensationtype: string,
  gstcompensationvalue: number,
  gstrate: number,
  discounttype: number,
  discountvalue: number,
  invoicetype: number,
  pricetype: string,
  isactive: number,
  isdefault: number,
  pricetypeid: number,
};

export type CreateItemImagesInput = {
  attachmentid: number,
  itemid: number,
  companybranchid: number,
  expiredtimestamp: number,
  imagename: string,
  imageurl: string,
  documentname: string,
  type: string,
};

export type CreatePartyMasterInput = {
  partyid: number,
  companybranchid: number,
  expiredtimestamp: number,
  partytypecd: string,
  partydisplayname: string,
  partylegalname: string,
  groupaccountid: number,
  gstcategory: string,
  placeofsupply: string,
  entity: string,
  email: string,
  contactnumber: string,
  whatsappnumber: string,
  accountsid: number,
  deliveryconsigneename: string,
  deliveryconsigneegstin: string,
  lastupdatedby: string,
  is_active: number,
  msmetype: string,
  tdspercentage: number,
  udhyamregno: string,
  sameaddressflag: number,
  comments: string,
  tdssection: string,
  financialyearid: number,
  contactcountry?: string | null,
  whatsappcountry?: string | null,
  entityname?: string | null,
};

export type partymaster = {
  __typename: "partymaster",
  partyid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  partytypecd?: string | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  groupaccountid?: number | null,
  gstcategory?: string | null,
  placeofsupply?: string | null,
  entity?: string | null,
  email?: string | null,
  contactnumber?: string | null,
  whatsappnumber?: string | null,
  accountsid?: number | null,
  is_active?: number | null,
  msmetype?: string | null,
  deliveryconsigneename?: string | null,
  deliveryconsigneegstin?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  relatedpartygstdetails?:  Array<PartyGSTDetails | null > | null,
  relatedpartycreditdetails?:  Array<PartyCreditDetails | null > | null,
  relatedpartycontact?:  Array<PartyContact | null > | null,
  relatedpartyimages?:  Array<PartyImages | null > | null,
  lastupdatedby?: string | null,
  tdspercentage?: number | null,
  udhyamregno?: string | null,
  sameaddressflag?: number | null,
  comments?: string | null,
  tdssection?: string | null,
  accountname?: string | null,
  deliverystatecode?: number | null,
  deliverystatename?: string | null,
  contactcountry?: string | null,
  whatsappcountry?: string | null,
  entityname?: string | null,
};

export type PartyContact = {
  __typename: "PartyContact",
  partyid: number,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  contacttypename: string,
  contactdesignationname: string,
  contactorder: number,
  email: string,
  phonenumber?: string | null,
  whatsappnumber?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  contactcountry?: string | null,
  whatsappcountry?: string | null,
};

export type PartyImages = {
  __typename: "PartyImages",
  attachmentid?: number | null,
  partyid: number,
  companyid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  type: string,
  documentname: string,
  imagename: string,
  imageurl: string,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreatePartyContactInput = {
  partyid: number,
  expiredtimestamp: number,
  contacttypename: string,
  contactdesignationname: string,
  contactorder: number,
  email: string,
  phonenumber?: string | null,
  whatsappnumber?: string | null,
  contactcountry?: string | null,
  whatsappcountry?: string | null,
};

export type CreatePartyImagesInput = {
  attachmentid: number,
  partyid: number,
  expiredtimestamp: number,
  type: string,
  documentname: string,
  imagename: string,
  imageurl: string,
};

export type CreateInvoiceMasterInput = {
  invoiceid: number,
  expiredtimestamp: number,
  invoicetypecd: string,
  partyid: number,
  paymentaccountid: number,
  invoicedate: number,
  invoicenumber: string,
  customerordernumber: string,
  customerorderdate: number,
  invoiceamount: number,
  paymenttype: string,
  creditduration: number,
  invoicebillingaddressid: number,
  invoicedeliveryaddressid: number,
  invoicetaxabletypecd: string,
  receipturl: string,
  invoicelinetyped: string,
  invoicecurrencycd: string,
  exchangerate: number,
  comments: string,
  receivedamount: number,
  adjustmentamount: number,
  placeofsupply: string,
  balancedueamount: number,
  reversechargeflag: number,
  cancelflag: number,
  consigneename: string,
  consigneegstin: string,
  tcsapplicableflag: number,
  companystate: string,
  cancelremark: string,
  deleteremark: string,
  financialyearid: number,
  roundoffamount: number,
  discounttype: number,
  discountvalue: number,
  serialnumber: string,
  serialflag: number,
  currencycode: string,
  currencyrate: number,
  paymentstatus: number,
  invoicepdf?: string | null,
  bankaccountid?: number | null,
  bankamount?: number | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  taxability?: number | null,
  cessexist?: number | null,
};

export type Invoicemaster = {
  __typename: "Invoicemaster",
  invoiceid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  invoicetypecd?: string | null,
  partyid?: number | null,
  paymentaccountid?: number | null,
  invoicedate?: number | null,
  invoicenumber?: string | null,
  customerordernumber?: string | null,
  customerorderdate?: number | null,
  invoiceamount?: number | null,
  paymenttype?: string | null,
  creditduration?: number | null,
  invoicebillingaddressid?: number | null,
  invoicedeliveryaddressid?: number | null,
  invoicetaxabletypecd?: string | null,
  receipturl?: string | null,
  invoicelinetypecd?: string | null,
  invoicecurrencycd?: string | null,
  exchangerate?: number | null,
  comments?: string | null,
  receivedamount?: number | null,
  adjustmentamount?: number | null,
  placeofsupply?: string | null,
  balancedueamount?: number | null,
  reversechargeflag?: number | null,
  tcsapplicableflag?: number | null,
  relatedinvoicetcsdetails?:  Array<InvoiceTCSDetails | null > | null,
  relatedinvoicelineitems?:  Array<InvoiceLineItems | null > | null,
  relatedinvoicelinenonitems?:  Array<InvoiceLineNonItems | null > | null,
  relatedinvoiceattachment?:  Array<InvoiceAttachment | null > | null,
  relatedinvoicedispatch?:  Array<InvoiceDispatch | null > | null,
  relatedinvoiceposdetails?:  Array<InvoicePOSDetails | null > | null,
  relatedinvoicelinegst?:  Array<InvoiceLineGST | null > | null,
  relatedinvoicelinenongst?:  Array<InvoiceLineNonGST | null > | null,
  relatedinvoicenumbertracker?:  Array<InvoiceNumberTracker | null > | null,
  relatedinvoicetransactiondetails?:  Array<TransactionMaster | null > | null,
  relatedpartymaster?:  Array<partymaster | null > | null,
  relatedpaymentaccountdetails?:  Array<AccountMaster | null > | null,
  relatedinvoiceaddressdetails?:  Array<AddressEntity | null > | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  cancelflag?: number | null,
  consigneename?: string | null,
  consigneegstin?: string | null,
  companystate?: string | null,
  cancelremark?: string | null,
  deleteremark?: string | null,
  roundoffamount?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  serialnumber?: string | null,
  serialflag?: number | null,
  currencycode?: string | null,
  currencyrate?: number | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  partyaccountid?: number | null,
  paymentstatus?: number | null,
  ackno?: string | null,
  ackdt?: number | null,
  irn?: string | null,
  signedqrcode?: string | null,
  partyemail?: string | null,
  invoicepdf?: string | null,
  partygstin?: string | null,
  partytypecd?: string | null,
  partygstcategory?: string | null,
  is_cancelled?: number | null,
  cancel_reason?: string | null,
  cancel_remarks?: string | null,
  phonenumber?: string | null,
  bankaccountid?: number | null,
  bankamount?: number | null,
  ewaybillno?: number | null,
  validupto?: number | null,
  ewaybill_validupto?: number | null,
  ewaybill_is_cancelled?: number | null,
  ewaybill_cancel_remarks?: string | null,
  ewaybill_cancel_rsn_code?: string | null,
  cancel_rsn_code?: string | null,
  einvoiceenteredtimestamp?: number | null,
  ewaybillenteredtimestamp?: number | null,
  ewaybillid?: number | null,
  ewaybillpdf?: string | null,
  ewaybillstatus?: string | null,
  invoicetype?: string | null,
  accountname?: string | null,
  partyisactive?: number | null,
  goods_exist?: number | null,
  overduedays?: number | null,
  duedatetimestamp?: number | null,
  isvouchereditable?: number | null,
  itcflag?: number | null,
  taxability?: number | null,
  linkedamount?: number | null,
  cessexist?: number | null,
  partyamount?: number | null,
};

export type InvoiceTCSDetails = {
  __typename: "InvoiceTCSDetails",
  invoiceid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  tcsapplicablecd?: number | null,
  totaltaxableamount?: number | null,
  ineligibletcflag?: number | null,
  reversechargeflag?: number | null,
  gstcesstotal?: number | null,
  tcsamount?: number | null,
  adjustmentamount?: number | null,
  tcssection?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  tcspercentage?: number | null,
  tcsmanual?: number | null,
};

export type InvoiceLineNonGST = {
  __typename: "InvoiceLineNonGST",
  invoiceid: number,
  invoiceitemid: number,
  companyid: number,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  gstrate?: number | null,
  gsttypecd?: string | null,
  gstamount?: number | null,
  cessamount?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreateInvoiceAttachmentInput = {
  attachmentid: number,
  invoiceid: number,
  companybranchid: number,
  expiredtimestamp: number,
  attachmentname: string,
  attachmenturl: string,
  documentname: string,
  type: string,
};

export type CreateInvoiceDispatchInput = {
  invoiceid: number,
  dispatchid: number,
  companybranchid: number,
  expiredtimestamp: number,
  transportationcd: string,
  vehiclenumber: string,
  dispatchdate: number,
  ewaybillnumber: string,
};

export type CreateInvoiceLineGSTInput = {
  invoiceid: number,
  invoiceitemid: number,
  companybranchid: number,
  expiredtimestamp: number,
  gstrate: number,
  gsttypecd: string,
  gstamount: number,
  cessamount: number,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type CreateInvoiceLineItemsInput = {
  invoiceid: number,
  invoiceitemid: number,
  companybranchid: number,
  expiredtimestamp: number,
  lineitemnumber: number,
  invoicelineitemtype: string,
  itemid: number,
  quantity: number,
  unittypecd: string,
  itemrate: number,
  itemamount: number,
  itemdiscount: number,
  discounttype?: string | null,
  discountrate?: number | null,
  netamount: number,
  hsnsaccode: string,
  taxability: string,
  pricetype: string,
  lotid: number,
  manualdiscount?: number | null,
  manualcess?: number | null,
  itemname?: string | null,
  pricetypeid?: number | null,
  invoicedate?: number | null,
  itemtype?: string | null,
  manualgst?: number | null,
  description?: string | null,
};

export type CreateInvoiceLineNonGSTInput = {
  invoiceid: number,
  invoiceitemid: number,
  companybranchid: number,
  expiredtimestamp: number,
  gstrate: number,
  gsttypecd: string,
  gstamount: number,
  cessamount: number,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type CreateInvoiceLineNonItemsInput = {
  invoiceid: number,
  invoiceitemid: number,
  companybranchid: number,
  expiredtimestamp: number,
  invoicelineitemtype: string,
  incomeaccountid: number,
  hsnsaccode: string,
  itemdescription: string,
  taxableamount: number,
  netamount: number,
  taxability: string,
  manualgst?: number | null,
  manualcess?: number | null,
};

export type CreateCompanyCodeTranslationArrayInput = {
  id: number,
  expiredtimestamp: number,
  codetype: string,
  codevalue: string,
  language?: string | null,
  codetext: string,
  codeorder?: number | null,
  uqc: string,
  is_active?: number | null,
};

export type CreateInvoiceTCSDetailsInput = {
  invoiceid: number,
  companybranchid: number,
  expiredtimestamp: number,
  tcsapplicablecd: number,
  totaltaxableamount: number,
  ineligibletcflag: number,
  reversechargeflag: number,
  gstcesstotal: number,
  tcsamount: number,
  adjustmentamount: number,
  tcssection?: string | null,
  tcspercentage?: number | null,
  tcsmanual: number,
};

export type CreatePurchaseLineGSTInput = {
  purchaseid: number,
  purchaseitemid: number,
  companybranchid: number,
  expiredtimestamp: number,
  gstrate: number,
  cessamount: number,
  gstamount: number,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type CreatePurchaseAttachmentInput = {
  attachmentid: number,
  purchaseid: number,
  companybranchid: number,
  expiredtimestamp: number,
  attachmentname: string,
  attachmenturl: string,
  documentname: string,
  type: string,
};

export type CreatePurchaseLineItemsInput = {
  purchaseid: number,
  purchaseitemid: number,
  companybranchid: number,
  expiredtimestamp: number,
  itemnumber: number,
  itemid: number,
  purchaseaccountid: number,
  hsncode: string,
  itemquantity: number,
  unittypecd: string,
  itemrate: number,
  itemamount: number,
  itemdiscount: number,
  discounttype?: string | null,
  discountrate?: number | null,
  netamount: number,
  taxability: string,
  pricetype: string,
  lotid: string,
  manualdiscount?: number | null,
  manualcess?: number | null,
  itemname?: string | null,
  pricetypeid?: number | null,
  entrydate?: number | null,
  itemtype?: string | null,
  manualgst?: number | null,
};

export type CreatePurchaseLineNonGSTInput = {
  purchaseid: number,
  purchaseitemid: number,
  companybranchid: number,
  expiredtimestamp: number,
  gstrate: number,
  cessamount: number,
  gstamount: number,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type CreatePurchaseLineNonItemsInput = {
  purchaseid: number,
  purchaseitemid: number,
  companybranchid: number,
  expiredtimestamp: number,
  purchaselineitemtype: string,
  purchaseaccountid: number,
  hsnsaccode: string,
  itemdescription: string,
  taxableamount: number,
  netamount: number,
  taxability?: string | null,
  manualgst?: number | null,
  manualcess?: number | null,
};

export type CreatePurchaseTCSDetailsInput = {
  purchaseid: number,
  companybranchid: number,
  expiredtimestamp: number,
  tcsapplicablecd: number,
  totaltaxableamount: number,
  ineligibletcflag: number,
  reversechargeflag: number,
  gstcesstotal: number,
  tcsamount: number,
  adjustmentamount: number,
  tcssection: string,
  tcspercentage: number,
  tcsmanual: number,
};

export type PurchaseTCSDetails = {
  __typename: "PurchaseTCSDetails",
  purchaseid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  tcsapplicablecd?: number | null,
  totaltaxableamount?: number | null,
  ineligibletcflag?: number | null,
  reversechargeflag?: number | null,
  gstcesstotal?: number | null,
  tcsamount?: number | null,
  adjustmentamount?: number | null,
  tcssection?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  tcspercentage?: number | null,
  tcsmanual?: number | null,
};

export type CreatePurchaseTDSDetailsInput = {
  purchaseid: number,
  companybranchid: number,
  expiredtimestamp: number,
  tdsapplicablecd: number,
  totaltaxableamount: number,
  ineligibletcflag: number,
  reversechargeflag: number,
  gstcesstotal: number,
  tdsamount: number,
  adjustmentamount: number,
  tdssection?: string | null,
  tdspercentage?: number | null,
  tdsmanual: number,
};

export type CreatePurchaseMasterInput = {
  purchaseid: number,
  companybranchid: number,
  expiredtimestamp: number,
  purchasegsttypecd: string,
  supplierid: number,
  entrydate: number,
  vouchernumber: string,
  supplierinvoicedate: number,
  supplierinvoicenumber: string,
  supplieraddressid: number,
  paymenttypecd: string,
  paidamount: number,
  creditduration: number,
  paymentaccountid: number,
  comments: string,
  tdsapplicableflag: number,
  granttotalamount: number,
  balancedueamount: number,
  paymentclearedflag: number,
  placeofsupply: string,
  cancelflag: number,
  companystate: string,
  financialyearid: number,
  cancelremark: string,
  deleteremark: string,
  roundoffamount: number,
  discounttype: number,
  discountvalue: number,
  adjustmentamount: number,
  serialnumber: string,
  currencycode: string,
  currencyrate: number,
  reversechargeflag: number,
  paymentstatus: number,
  partyregistrationtype: string,
  purchaseinvoicepdf?: string | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  consigneename?: string | null,
  consigneegstin?: string | null,
  itcflag?: number | null,
  cessexist?: number | null,
};

export type PurchaseMaster = {
  __typename: "PurchaseMaster",
  purchaseid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  purchasegsttypecd?: string | null,
  supplierid?: number | null,
  entrydate?: number | null,
  vouchernumber?: string | null,
  supplierinvoicedate?: number | null,
  supplierinvoicenumber?: string | null,
  supplieraddressid?: number | null,
  paymenttypecd?: string | null,
  paidamount?: number | null,
  creditduration?: number | null,
  paymentaccountid?: number | null,
  comments?: string | null,
  tdsapplicableflag?: number | null,
  granttotalamount?: number | null,
  balancedueamount?: number | null,
  paymentclearedflag?: number | null,
  placeofsupply?: string | null,
  companystate?: string | null,
  relatedpurchasetdsdetails?:  Array<PurchaseTDSDetails | null > | null,
  relatedpurchasetcsdetails?:  Array<PurchaseTCSDetails | null > | null,
  relatedpurchaselineitems?:  Array<PurchaseLineItems | null > | null,
  relatedpurchaselinenonitems?:  Array<PurchaseLineNonItems | null > | null,
  relatedpurchaselinegst?:  Array<PurchaseLineGST | null > | null,
  relatedpurchaselinenongst?:  Array<PurchaseLineNonGST | null > | null,
  relatedpurchaseattachment?:  Array<PurchaseAttachment | null > | null,
  relatedpurchasetransactiondetails?:  Array<TransactionMaster | null > | null,
  relatedpartymaster?:  Array<partymaster | null > | null,
  relatedpartyaddressdetails?:  Array<AddressEntity | null > | null,
  relatedpaymentaccountdetails?:  Array<AccountMaster | null > | null,
  relatedpurchaseaddressdetails?:  Array<AddressEntity | null > | null,
  lastupdatedby?: string | null,
  cancelflag?: number | null,
  roundoffamount?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  adjustmentamount?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  serialnumber?: string | null,
  currencycode?: string | null,
  currencyrate?: number | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  partyaccountid?: number | null,
  reversechargeflag?: number | null,
  overduedays?: number | null,
  paymentstatus?: number | null,
  partyregistrationtype?: string | null,
  purchaseinvoicepdf?: string | null,
  partygstcategory?: string | null,
  partyemail?: string | null,
  partygstin?: string | null,
  partytypecd?: string | null,
  ewaybillno?: number | null,
  validupto?: number | null,
  ewaybill_is_cancelled?: number | null,
  ewaybill_cancel_remarks?: string | null,
  cancel_rsn_code?: string | null,
  einvoiceenteredtimestamp?: number | null,
  ewaybillenteredtimestamp?: number | null,
  ewaybillid?: number | null,
  accountname?: string | null,
  duedatetimestamp?: number | null,
  partyisactive?: number | null,
  consigneename?: string | null,
  consigneegstin?: string | null,
  ewaybillpdf?: string | null,
  ewaybillstatus?: string | null,
  isvouchereditable?: number | null,
  goods_exist?: number | null,
  itcflag?: number | null,
  linkedamount?: number | null,
  cessexist?: number | null,
  partyamount?: number | null,
  totalgstamount?: number | null,
  tdsamount?: number | null,
  tcsamount?: number | null,
  taxableamount?: number | null,
  igstamount?: number | null,
  cgstamount?: number | null,
  sgstamount?: number | null,
  cessamount?: number | null,
  sourceofsupply?: string | null,
  taxabilitylabel?: string | null,
  additionaldiscount?: number | null,
  netinvoiceamount?: number | null,
};

export type CreateCrDrAttachmentInput = {
  attachmentid: number,
  crdrnoteid?: number | null,
  companybranchid: number,
  expiredtimestamp: number,
  attachmentname: string,
  attachmenturl: string,
  documentname: string,
  type: string,
};

export type CrDrAttachment = {
  __typename: "CrDrAttachment",
  crdrnoteid?: number | null,
  attachmentid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  attachmentname?: string | null,
  attachmenturl?: string | null,
  userid?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  documentname?: string | null,
  type?: string | null,
};

export type CreateCrDrNoteDetailsInput = {
  crdrnoteid: number,
  companybranchid: number,
  expiredtimestamp: number,
  totaltaxableamount: number,
  totalgst: number,
  totalgstcess: number,
  totaladjustments: number,
  comments: string,
  accountid: number,
  partamount: number,
  transportationcd: string,
  vehiclenumber: string,
  dispatchdate: number,
  ewaybillnumber: string,
};

export type CrDrNoteDetails = {
  __typename: "CrDrNoteDetails",
  crdrnoteid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  totaltaxableamount?: number | null,
  totalgst?: number | null,
  totalgstcess?: number | null,
  totaladjustments?: number | null,
  comments?: string | null,
  accountid?: number | null,
  partamount?: number | null,
  transportationcd?: string | null,
  vehiclenumber?: string | null,
  dispatchdate?: number | null,
  ewaybillnumber?: string | null,
  userid?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreateCrDrNoteDispatchInput = {
  crdrnoteid: number,
  dispatchid: number,
  companybranchid: number,
  expiredtimestamp: number,
  transportationcd: string,
  vehiclenumber: string,
  dispatchdate: number,
  ewaybillnumber: string,
};

export type CrDrNoteDispatch = {
  __typename: "CrDrNoteDispatch",
  crdrnoteid: number,
  dispatchid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  transportationcd: string,
  vehiclenumber: string,
  dispatchdate: number,
  ewaybillnumber: string,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreateCrDrNoteInvoicesInput = {
  crdrnoteid: number,
  companybranchid: number,
  expiredtimestamp: number,
  invoiceid: number,
};

export type CrDrNoteInvoices = {
  __typename: "CrDrNoteInvoices",
  crdrnoteid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  invoiceid?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  lastupdatedby?: string | null,
};

export type CreateCrDrNoteLineItemsInput = {
  crdrnoteid: number,
  crdrnoteitemid?: number | null,
  companybranchid: number,
  expiredtimestamp: number,
  lineitemnumber: number,
  lineitemtype: string,
  itemid: number,
  quantity: number,
  unittypecd: string,
  itemrate: number,
  itemamount: number,
  itemdiscount: number,
  discounttype?: string | null,
  discountrate?: number | null,
  gstrate: number,
  gsttypecd: string,
  gstamount: number,
  gstcess: number,
  netamount: number,
  hsnsaccode: string,
  taxability: string,
  reason: string,
  pricetype: string,
  lotid: string,
  manualdiscount?: number | null,
  manualcess?: number | null,
  itemname?: string | null,
  pricetypeid?: number | null,
  crdrnotedate?: number | null,
  itemtype?: string | null,
  manualgst?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type CrDrNoteLineItems = {
  __typename: "CrDrNoteLineItems",
  crdrnoteid?: number | null,
  crdrnoteitemid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  lineitemnumber?: number | null,
  lineitemtype?: string | null,
  itemid?: number | null,
  quantity?: number | null,
  unittypecd?: string | null,
  itemrate?: number | null,
  itemamount?: number | null,
  itemdiscount?: number | null,
  discounttype?: string | null,
  discountrate?: number | null,
  gstrate?: number | null,
  gsttypecd?: string | null,
  gstamount?: number | null,
  gstcess?: number | null,
  hsnsaccode?: string | null,
  netamount?: number | null,
  userid?: string | null,
  taxability?: string | null,
  reason?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  pricetype?: string | null,
  hsnsacid?: number | null,
  hsncodetype?: string | null,
  hsncodevalue?: string | null,
  hsndescription?: string | null,
  unit?: string | null,
  uqc?: string | null,
  salesaccountname?: string | null,
  purchaseaccountname?: string | null,
  salesaccountid?: number | null,
  purchaseaccountid?: number | null,
  itemname?: string | null,
  itemcode?: string | null,
  itemtype?: string | null,
  manualdiscount?: number | null,
  manualcess?: number | null,
  pricetypeid?: number | null,
  manualgst?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type CreateCrDrNoteLineNonItemsInput = {
  crdrnoteid: number,
  crdrnoteitemid: number,
  companybranchid: number,
  expiredtimestamp: number,
  lineitemtype: string,
  ledgeraccountid: number,
  hsnsaccode: string,
  itemdescription: string,
  taxableamount: number,
  gstrate: number,
  gsttypecd: string,
  gstamount: number,
  gstcess: number,
  netamount: number,
  taxability: string,
  reason: string,
  manualgst?: number | null,
  manualcess?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type CrDrNoteLineNonItems = {
  __typename: "CrDrNoteLineNonItems",
  crdrnoteid?: number | null,
  crdrnoteitemid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  lineitemtype?: string | null,
  ledgeraccountid?: number | null,
  hsnsaccode?: string | null,
  itemdescription?: string | null,
  taxableamount?: number | null,
  gstrate?: number | null,
  gsttypecd?: string | null,
  gstamount?: number | null,
  gstcess?: number | null,
  netamount?: number | null,
  userid?: string | null,
  taxability?: string | null,
  reason?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  hsnsacid?: number | null,
  hsncodetype?: string | null,
  hsncodevalue?: string | null,
  hsndescription?: string | null,
  ledgeraccountname?: string | null,
  manualgst?: number | null,
  manualcess?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
};

export type CreateCrDrNoteTCSDetailsInput = {
  crdrnoteid: number,
  companybranchid: number,
  expiredtimestamp: number,
  tcsapplicablecd: string,
  totaltaxableamount: number,
  ineligibletcflag: number,
  reversechargeflag: number,
  gstcesstotal: number,
  tcsamount: number,
  adjustmentamount: number,
  tcssection: string,
  tcspercentage: number,
  tcsmanual: number,
};

export type CrDrNoteTCSDetails = {
  __typename: "CrDrNoteTCSDetails",
  crdrnoteid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  tcsapplicablecd?: number | null,
  totaltaxableamount?: number | null,
  ineligibletcflag?: number | null,
  reversechargeflag?: number | null,
  gstcesstotal?: number | null,
  tcsamount?: number | null,
  adjustmentamount?: number | null,
  tcssection?: string | null,
  tcsmanual?: number | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  tcspercentage?: number | null,
};

export type CreateCrDrNoteTDSDetailsInput = {
  crdrnoteid: number,
  companybranchid: number,
  expiredtimestamp: number,
  tdsapplicablecd: string,
  totaltaxableamount: number,
  ineligibletcflag: number,
  reversechargeflag: number,
  gstcesstotal: number,
  tdsamount: number,
  adjustmentamount: number,
  tdssection: string,
  tdspercentage: number,
  tdsmanual: number,
};

export type CrDrNoteTDSDetails = {
  __typename: "CrDrNoteTDSDetails",
  crdrnoteid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  tdsapplicablecd: number,
  totaltaxableamount: number,
  ineligibletcflag: number,
  reversechargeflag: number,
  gstcesstotal: number,
  tdsamount: number,
  adjustmentamount: number,
  tdssection?: string | null,
  tdspercentage?: number | null,
  tcsmanual?: number | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreateCrDrNoteMasterInput = {
  companybranchid: number,
  crdrnoteid: number,
  expiredtimestamp: number,
  crdrnotetypecd: string,
  crdrnotedate: number,
  crdrnotenumber: string,
  invoicetypecd: string,
  gsttypecd: string,
  partyid: number,
  deliveryaddressid: number,
  paymenttype: string,
  grandtotalamount: number,
  transactionid: number,
  creditduration: number,
  psflag: number,
  reversechargeflag: number,
  balancedueamount: number,
  consigneename: string,
  consigneegstin: string,
  companystate: string,
  placeofsupply: string,
  cancelflag: number,
  cancelremark: string,
  roundoffamount: number,
  discounttype: number,
  discountvalue: number,
  adjustmentamount: number,
  currencycode: string,
  currencyrate: number,
  originalinvoicenumber: string,
  partyinvoicenumber?: string | null,
  serialnumber: string,
  crdrnotepdf?: string | null,
  partyregistrationtype?: string | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  itcflag?: number | null,
  cessexist?: number | null,
  partyjeamount?: number | null,
};

export type CrDrNoteMaster = {
  __typename: "CrDrNoteMaster",
  crdrnoteid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  crdrnotetypecd?: string | null,
  crdrnotedate?: number | null,
  crdrnotenumber?: string | null,
  invoicetypecd?: string | null,
  gsttypecd?: string | null,
  partyid?: number | null,
  deliveryaddressid?: number | null,
  paymenttype?: string | null,
  grandtotalamount?: number | null,
  transactionid?: number | null,
  userid?: string | null,
  creditduration?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  psflag?: number | null,
  reversechargeflag?: number | null,
  balancedueamount?: number | null,
  consigneename?: string | null,
  consigneegstin?: string | null,
  companystate?: string | null,
  placeofsupply?: string | null,
  cancelflag?: number | null,
  cancelremark?: string | null,
  roundoffamount?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  adjustmentamount?: number | null,
  relatedcrdrnoteinvoices?:  Array<CrDrNoteInvoices | null > | null,
  relatedcrdrattachment?:  Array<CrDrAttachment | null > | null,
  relatedcrdrnotedetails?:  Array<CrDrNoteDetails | null > | null,
  relatedcrdrnotelineitems?:  Array<CrDrNoteLineItems | null > | null,
  relatedcrdrnotelinenonitems?:  Array<CrDrNoteLineNonItems | null > | null,
  relatedcrdrnotetcsdetails?:  Array<CrDrNoteTCSDetails | null > | null,
  relatedcrdrnotetdsdetails?:  Array<CrDrNoteTDSDetails | null > | null,
  relatedcrdrnotedispatch?:  Array<CrDrNoteDispatch | null > | null,
  serialnumber?: string | null,
  currencycode?: string | null,
  currencyrate?: number | null,
  partamount?: number | null,
  originalinvoicenumber?: string | null,
  partyinvoicenumber?: string | null,
  totalgst?: number | null,
  totalgstcess?: number | null,
  totaltaxableamount?: number | null,
  totaladjustments?: number | null,
  comments?: string | null,
  accountid?: number | null,
  transportationcd?: string | null,
  vehiclenumber?: string | null,
  dispatchdate?: number | null,
  ewaybillnumber?: string | null,
  paymentstatus?: number | null,
  crdrnotepdf?: string | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  partyaccountid?: number | null,
  partygstcategory?: string | null,
  partyemail?: string | null,
  partytypecd?: string | null,
  partygstin?: string | null,
  accountname?: string | null,
  partyregistrationtype?: string | null,
  duedatetimestamp?: number | null,
  overduedays?: number | null,
  partyisactive?: number | null,
  isvouchereditable?: number | null,
  itcflag?: number | null,
  cessexist?: number | null,
};

export type UpdateAccountMasterInput = {
  accountsid: number,
  companybranchid: number,
  accountname: string,
  accounttypecd: string,
  accountgroupid: number,
  hsnsaccode: string,
  is_active: number,
  accounttypeflag: number,
};

export type UpdateAccountGroupMasterInput = {
  accountgroupid: number,
  companybranchid: number,
  accounttypecd: string,
  accountgroupname: string,
  accountparentgroupid: number,
  is_active: number,
};

export type DeleteNumberTrackerInput = {
  entrytypecd: string,
};

export type UpdateNumberTrackerInput = {
  id: number,
  entrytypecd: string,
  nextinvoicenumber: number,
  prefix: string,
  suffix: string,
  serialnumber: string,
  serialisactive: number,
  serialisused: number,
  financialyearid: number,
  companyid: number,
  serialflag?: number | null,
  startinvoicenumber: number,
  taxability?: number | null,
  restrictedflag?: number | null,
};

export type UpdateAccountGSTDetailsInput = {
  accountid: number,
  enteredtimestamp: number,
  effectivedate: number,
  expireddate: number,
  hsnid: string,
  cessamount: number,
  gstcompensationtype: string,
  gstrate: number,
  taxability?: string | null,
};

export type DeleteNumberTrackerByTypeInput = {
  entrytypecd?: string | null,
  mode?: string | null,
  financialyearid?: number | null,
};

export type DeleteNumberTrackerAutoByTypeInput = {
  id?: number | null,
};

export type Success = {
  __typename: "Success",
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type FinancialYearTransfer = {
  __typename: "FinancialYearTransfer",
  statuscode?: string | null,
  statusmessage?: string | null,
  financialyearid?: number | null,
};

export type DeleteInvoiceStatus = {
  __typename: "DeleteInvoiceStatus",
  newid?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type UserIssueInput = {
  name?: string | null,
  email?: string | null,
  phone?: string | null,
  issuetype?: string | null,
  status?: string | null,
  description?: string | null,
  filename?: string | null,
  pageurl?: string | null,
  personalname?: string | null,
  shortdescription?: string | null,
};

export type UserIssue = {
  __typename: "UserIssue",
  statusmessage?: string | null,
  statuscode?: string | null,
  id?: number | null,
  name?: string | null,
  email?: string | null,
  phone?: string | null,
  issuetype?: string | null,
  status?: string | null,
  description?: string | null,
  filename?: string | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  lastupdatedby?: string | null,
  pageurl?: string | null,
  personalname?: string | null,
  shortdescription?: string | null,
};

export type TransporterMasterInput = {
  transporterid: number,
  transportername: string,
  transportergstin: string,
  expiredtimestamp: number,
};

export type TransporterMaster = {
  __typename: "TransporterMaster",
  transporterid: number,
  transportername: string,
  companyid: number,
  enteredtimestamp: number,
  lastupdatedby: string,
  expiredtimestamp: number,
  transportergstin: string,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreateEwayBillInput = {
  id: number,
  invoiceid: number,
  expiredtimestamp: number,
  ewaybillno: number,
  expirydate: number,
  is_cancelled: number,
  cancel_remarks?: string | null,
};

export type EwayBill = {
  __typename: "EwayBill",
  id: number,
  invoiceid?: number | null,
  invoicetype?: string | null,
  companyid?: number | null,
  enteredtimestamp: number,
  expiredtimestamp: number,
  ewaybillno?: number | null,
  expirydate?: number | null,
  is_cancelled?: number | null,
  cancel_remarks?: string | null,
  lastupdatedby?: string | null,
  cancel_rsn_code?: string | null,
  ewaybilldate?: number | null,
  supplytype?: string | null,
  subtype?: string | null,
  partyid?: number | null,
  transporterid?: number | null,
  modeoftransport?: string | null,
  vehicleno?: string | null,
  distance?: number | null,
  invoiceno?: string | null,
  invoicedate?: number | null,
  fromgstin?: string | null,
  togstin?: string | null,
  fromstate?: string | null,
  tostate?: string | null,
  frompincode?: number | null,
  topincode?: number | null,
  billingstate?: string | null,
  billingpincode?: string | null,
  transportername?: string | null,
  transportergstin?: string | null,
  validupto?: number | null,
  total_items_count?: number | null,
  gstrate?: number | null,
  gstamount?: number | null,
  cessamount?: number | null,
  ewbrejecteddate?: number | null,
  totalitemamount?: number | null,
  totalinvoiceamount?: number | null,
  fromtradename?: string | null,
  totradename?: string | null,
  transactiontype?: string | null,
  doctype?: string | null,
  status?: string | null,
  transdocno?: string | null,
  transdocdate?: number | null,
  vehicletype?: string | null,
  ewaybillpdf?: string | null,
  addresses?:  Array<EwayBillAddress | null > | null,
};

export type EwayBillAddress = {
  __typename: "EwayBillAddress",
  objectid?: number | null,
  objecttype?: string | null,
  statecode?: number | null,
  statename?: string | null,
  pincode?: string | null,
  line1?: string | null,
  line2?: string | null,
  line3?: string | null,
  city?: string | null,
  countrycode?: string | null,
  district?: string | null,
};

export type AppVersion = {
  __typename: "AppVersion",
  id: number,
  version_number: string,
  release_notes?: string | null,
  release_date?: string | null,
  is_mandatory: boolean,
};

export type CreateTransactionAttachmentInput = {
  attachmentid: number,
  transactionid: number,
  expiredtimestamp: number,
  attachmentname: string,
  attachmenturl: string,
  type: string,
  documentname: string,
};

export type CreateItemOpeningStockInput = {
  openingstockdate?: number | null,
  items?: Array< openingstockitemsInput | null > | null,
};

export type openingstockitemsInput = {
  itemid: number,
  purchaseprice: number,
  quantity: number,
};

export type ItemOpeningStockResponse = {
  __typename: "ItemOpeningStockResponse",
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CreateUserInvitationInput = {
  id: number,
  email: string,
  companyid: number,
  invitedby: string,
  status: string,
  invitationtoken: string,
  invitationsource: string,
  acceptedtimestamp?: number | null,
  enteredtimestamp: number,
  expiredtimestamp?: number | null,
};

export type UserInvitation = {
  __typename: "UserInvitation",
  id: number,
  email: string,
  companyid: number,
  invitedby: string,
  status: string,
  invitationtoken: string,
  invitationsource: string,
  acceptedtimestamp?: number | null,
  enteredtimestamp: number,
  expiredtimestamp?: number | null,
};

export type CreateTransactionWithSpecificTimeInput = {
  transactionmaster?: Array< TransactionMasterSpecificTransactionInput | null > | null,
  transactiondetails?: Array< TransactionDetailsSpecificTransactionInput | null > | null,
  transactionrelation?: Array< TransactionRelationSpecificTransactionInput | null > | null,
  transactionattachment?: Array< TransactionAttachmentSpecificTransactionInput | null > | null,
  transactiontcsdetails?: Array< TransactionTCSDetailsSpecificTransactionInput | null > | null,
  transactiontdsdetails?: Array< TransactionTDSDetailsSpecificTransactionInput | null > | null,
  mode: number,
};

export type TransactionMasterSpecificTransactionInput = {
  transactiontypecd: string,
  entrydate: number,
  bankreferencenumber: string,
  comments: string,
  vouchercode: string,
  serialnumber: string,
  pdflink: string,
  towards: string,
  transactionid?: number | null,
  cancelremark?: string | null,
  cancelflag?: number | null,
};

export type TransactionDetailsSpecificTransactionInput = {
  transactiontypecd: string,
  accountid: number,
  creditamount: number,
  debitamount: number,
  comments: string,
  transactionid?: number | null,
  enteredtimestamp?: number | null,
  cancelflag?: number | null,
};

export type TransactionRelationSpecificTransactionInput = {
  transactiontypecd: string,
  objecttype: string,
  objectid: number,
  linkedamount: number,
  objectattribute: string,
  isdirect: number,
  accountid: number,
  paymentvouchernumber: string,
  transactionid?: number | null,
  expiredtimestamp?: number | null,
};

export type TransactionAttachmentSpecificTransactionInput = {
  attachmentname: string,
  attachmenturl: string,
  documentname: string,
  type: string,
  transactionid?: number | null,
};

export type TransactionTCSDetailsSpecificTransactionInput = {
  tcsapplicablecd: string,
  tcsamount: number,
  tcspercentage: number,
  tcsmanual: number,
  transactionid?: number | null,
};

export type TransactionTDSDetailsSpecificTransactionInput = {
  tdsapplicablecd: string,
  tdsamount: number,
  tdspercentage: number,
  tdsmanual: number,
  transactionid?: number | null,
};

export type UpdatefinancialyearstepsInput = {
  financialyearid: number,
  stepscompleted: string,
};

export type Stepscompleted = {
  __typename: "Stepscompleted",
  financialyearid: number,
  stepscompleted: string,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type SaveTablePreferenceInput = {
  table_key: string,
  column_settings: string,
  table_configs?: string | null,
};

export type BatchPreferenceResponse = {
  __typename: "BatchPreferenceResponse",
  statuscode?: string | null,
  statusmessage?: string | null,
  table_key?: string | null,
  column_settings?: string | null,
  table_configs?: string | null,
};

export type AccountMasterv2 = {
  __typename: "AccountMasterv2",
  accountsid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  accountname?: string | null,
  accounttypecd?: string | null,
  accountgroupid?: number | null,
  hsnsaccode?: string | null,
  displayordernumber?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  restrictedflag?: number | null,
  is_active?: number | null,
  accountgroupenteredtimestamp?: number | null,
  accountgroupexpiredtimestamp?: number | null,
  accountgrouptypecd?: string | null,
  accountgroupname?: string | null,
  accountparentgroupid?: number | null,
  accountgroupdisplayordernumber?: number | null,
  accountgrouprestrictedflag?: number | null,
  accountgroupis_active?: number | null,
  accountgstenteredtimestamp?: number | null,
  accountgstexpiredtimestamp?: number | null,
  accountgsteffectivedate?: number | null,
  accountgstexpireddate?: number | null,
  hsnid?: string | null,
  gstcompensationtype?: string | null,
  gstrate?: number | null,
  cessamount?: number | null,
  accounttypeflag?: number | null,
  partyid?: number | null,
  tdspercentage?: number | null,
  tdssection?: string | null,
  path?: string | null,
  tax_type?: number | null,
  balancesign?: number | null,
  accountcreationdate?: number | null,
};

export type OTPDetails = {
  __typename: "OTPDetails",
  id?: number | null,
  purpose?: string | null,
  otpcode?: number | null,
  enteredtimestamp?: number | null,
  active?: number | null,
  userid?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CodeTranslation = {
  __typename: "CodeTranslation",
  id?: number | null,
  companyid?: number | null,
  codetype?: string | null,
  codevalue?: string | null,
  language?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  codetext?: string | null,
  statecode?: number | null,
  codeorder?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  lastupdatedby?: string | null,
  uqc?: string | null,
  is_active?: string | null,
};

export type PurchaseInvoiceList = {
  __typename: "PurchaseInvoiceList",
  invoiceid?: number | null,
  purchaseid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  invoicetypecd?: string | null,
  purchasegsttypecd?: string | null,
  partyid?: number | null,
  supplierid?: number | null,
  paymentaccountid?: number | null,
  invoicedate?: number | null,
  entrydate?: number | null,
  invoicenumber?: string | null,
  vouchernumber?: string | null,
  customerordernumber?: string | null,
  supplierinvoicenumber?: string | null,
  customerorderdate?: number | null,
  invoiceamount?: number | null,
  granttotalamount?: number | null,
  paymenttype?: string | null,
  creditduration?: number | null,
  invoicebillingaddressid?: number | null,
  supplieraddressid?: number | null,
  invoicedeliveryaddressid?: number | null,
  invoicetaxabletypecd?: string | null,
  receipturl?: string | null,
  invoicelinetypecd?: string | null,
  invoicecurrencycd?: string | null,
  paymenttypecd?: string | null,
  exchangerate?: number | null,
  currencyrate?: number | null,
  comments?: string | null,
  receivedamount?: number | null,
  adjustmentamount?: number | null,
  placeofsupply?: string | null,
  statename?: string | null,
  balancedueamount?: number | null,
  reversechargeflag?: number | null,
  lastupdatedby?: string | null,
  cancelflag?: number | null,
  consigneename?: string | null,
  consigneegstin?: string | null,
  tcsapplicableflag?: number | null,
  tdsapplicableflag?: number | null,
  companystate?: string | null,
  cancelremark?: string | null,
  deleteremark?: string | null,
  financialyearid?: number | null,
  roundoffamount?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  serialnumber?: string | null,
  paymentclearedflag?: number | null,
  paymentstatus?: string | null,
  partyregistrationtype?: string | null,
  currencycode?: string | null,
};

export type EmailTemplateMaster = {
  __typename: "EmailTemplateMaster",
  templateid?: number | null,
  templatename?: string | null,
  valueid?: number | null,
  fieldname?: string | null,
};

export type EmailSettings = {
  __typename: "EmailSettings",
  email?: string | null,
  templateid?: number | null,
  emailbody?: string | null,
  smtp_port?: number | null,
  smtp_hostname?: string | null,
  username?: string | null,
  password?: string | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  lastupdatedby?: string | null,
};

export type TransactionMasterv2 = {
  __typename: "TransactionMasterv2",
  transactionid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  transactiontypecd?: string | null,
  vouchernumber?: string | null,
  entrydate?: number | null,
  bankreferencenumber?: string | null,
  comments?: string | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  cancelflag?: number | null,
  cancelremark?: string | null,
  serialnumber?: string | null,
  paidfrom?: string | null,
  paidto?: string | null,
  paidfromamount?: string | null,
  paidtoamount?: string | null,
  paidfromaccountid?: string | null,
  paidtoaccountid?: string | null,
  paidfromemail?: string | null,
  paidtoemail?: string | null,
  paidfrompartyid?: string | null,
  paidtopartyid?: string | null,
  paidfrompartytypecd?: string | null,
  paidtopartytypecd?: string | null,
  paidfromcomments?: string | null,
  paidtocomments?: string | null,
  pdflink?: string | null,
  tds_payable_amount?: number | null,
  tds_receivable_amount?: number | null,
  tcs_payable_amount?: number | null,
  tcs_receivable_amount?: number | null,
  receiptamount?: number | null,
  paymentamount?: number | null,
  totalamount?: number | null,
  lastpaidtoaccountid?: number | null,
  lastpaidfromaccountid?: number | null,
  towards?: string | null,
};

export type LinkedReceipts = {
  __typename: "LinkedReceipts",
  transactionid?: number | null,
  transactiontypecd?: string | null,
  objecttype?: string | null,
  objectid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  linkedamount?: number | null,
  invoicenumber?: string | null,
  invoicedate?: number | null,
  receiptvouchernumber?: string | null,
  grandtotalamount?: number | null,
  balancedueamount?: number | null,
};

export type Location = {
  __typename: "Location",
  pincode: string,
  state: string,
  district: string,
  city?: Array< string | null > | null,
};

export type ReceiptDetails = {
  __typename: "ReceiptDetails",
  id?: number | null,
  transactionid?: number | null,
  companyid?: number | null,
  financialyearid?: number | null,
  lastupdatedby?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  tan?: string | null,
  partyname?: string | null,
};

export type ThemeColor = {
  __typename: "ThemeColor",
  themecolorid?: number | null,
  color?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
};

export type AccountBalancev2 = {
  __typename: "AccountBalancev2",
  accountid?: number | null,
  accountbalance?: number | null,
  actualbalance?: number | null,
};

export type SetOffDetails = {
  __typename: "SetOffDetails",
  invoiceid?: number | null,
  invoicenumber?: string | null,
  invoicedate?: number | null,
  invoiceamount_converted?: number | null,
  partyid?: number | null,
  companyid?: number | null,
  transactiontype?: string | null,
  transactiontypedesc?: string | null,
  net_adjustments?: number | null,
  payments_receipts?: number | null,
  setoff_balance?: number | null,
  setoff_status?: string | null,
  available_amount?: number | null,
  linked_to_target?: number | null,
  can_setoff?: number | null,
  setoff_priority?: number | null,
};

export type UserThemePreference = {
  __typename: "UserThemePreference",
  userid?: string | null,
  attributetypecd?: string | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  attributevalue?: number | null,
  additionalvalue?: string | null,
  relatedthemecolor?:  Array<ThemeColor | null > | null,
};

export type AccountGroupMasterv2 = {
  __typename: "AccountGroupMasterv2",
  accountgroupid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  accounttypecd?: string | null,
  accountgroupname?: string | null,
  accountparentgroupid?: number | null,
  displayordernumber?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  restrictedflag?: number | null,
  is_active?: number | null,
  path?: string | null,
};

export type partymasterv2 = {
  __typename: "partymasterv2",
  partyid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  partytypecd?: string | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  groupaccountid?: number | null,
  gstcategory?: string | null,
  placeofsupply?: string | null,
  entity?: string | null,
  email?: string | null,
  contactnumber?: string | null,
  whatsappnumber?: string | null,
  accountsid?: number | null,
  is_active?: number | null,
  msmetype?: string | null,
  deliveryconsigneename?: string | null,
  deliveryconsigneegstin?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  lastupdatedby?: string | null,
  tdspercentage?: number | null,
  udhyamregno?: string | null,
  partygstenteredtimestamp?: number | null,
  partygstexpiredtimestamp?: number | null,
  pannumber?: string | null,
  gstin?: string | null,
  partyaddressid?: number | null,
  contacttypename?: string | null,
  contactdesignationname?: string | null,
  contactorder?: number | null,
  partycontactemail?: string | null,
  phonenumber?: string | null,
  partycontactwhatsappnumber?: string | null,
  creditperiodduration?: number | null,
  billingcurrency?: number | null,
  creditlimitcd?: number | null,
  creditlimitamount?: number | null,
  billwiseflag?: number | null,
  notes?: string | null,
  sameaddressflag?: number | null,
  comments?: string | null,
  accountbalance?: number | null,
  tdssection?: string | null,
  accounttypeflag?: number | null,
  accountgroup?: string | null,
  contactcountry?: string | null,
  whatsappcountry?: string | null,
};

export type PartyMasterListCount = {
  __typename: "PartyMasterListCount",
  partycount?: number | null,
  minbalancedue?: number | null,
  maxbalancedue?: number | null,
  totalpartybalance?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type OutstandingInvoicemaster = {
  __typename: "OutstandingInvoicemaster",
  invoiceid?: number | null,
  invoicetype?: string | null,
  invoicenumber?: string | null,
  invoicedate?: number | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  invoiceamount?: number | null,
  receivedamount?: number | null,
  balancedueamount?: string | null,
  creditduration?: number | null,
  overduedays?: number | null,
  duedate?: number | null,
  recordcount?: number | null,
  total_balancedueamount?: string | null,
  partyid?: number | null,
  partyaccountid?: number | null,
  adjustment_details?:  Array<AdjustmentDetail | null > | null,
  adjustment_summary?: AdjustmentSummary | null,
};

export type AdjustmentDetail = {
  __typename: "AdjustmentDetail",
  transactionid?: number | null,
  transactiontypecd?: string | null,
  vouchernumber?: string | null,
  linkedamount?: number | null,
  linkeddate?: string | null,
  isdirect?: number | null,
  paymentvouchernumber?: string | null,
  objectattribute?: string | null,
  transactiondate?: string | null,
  description?: string | null,
};

export type AdjustmentSummary = {
  __typename: "AdjustmentSummary",
  total_receipts?: number | null,
  total_credit_notes?: number | null,
  total_debit_notes?: number | null,
  total_payments?: number | null,
  adjustment_count?: number | null,
};

export type OutstandingPurchasemaster = {
  __typename: "OutstandingPurchasemaster",
  purchaseid?: number | null,
  invoicetype?: string | null,
  purchaseinvoicenumber?: string | null,
  purchaseinvoicedate?: number | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  granttotalamount?: number | null,
  receivedamount?: number | null,
  balancedueamount?: string | null,
  creditduration?: number | null,
  overduedays?: number | null,
  duedate?: number | null,
  recordcount?: number | null,
  total_balancedueamount?: string | null,
  partyid?: number | null,
  partyaccountid?: number | null,
};

export type LUTBondMaster = {
  __typename: "LUTBondMaster",
  id?: number | null,
  lutno?: string | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  validfrom?: number | null,
  validto?: number | null,
  financialyearid?: number | null,
};

export type LineItemsList = {
  __typename: "LineItemsList",
  type?: string | null,
  invoiceid?: number | null,
  purchaseid?: number | null,
  itemid?: number | null,
  quantity?: number | null,
  unittypecd?: string | null,
  itemrate?: number | null,
  itemamount?: number | null,
  itemdiscount?: number | null,
  itemdiscounttype?: string | null,
  itemdiscountrate?: number | null,
  netamount?: number | null,
  lineitemnumber?: number | null,
  invoicelineitemtype?: string | null,
  hsnsaccode?: string | null,
  taxability?: string | null,
  pricetype?: string | null,
  lotid?: string | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  vouchernumber?: string | null,
  invoicelinetypecd?: string | null,
  comments?: string | null,
  balancedueamount?: number | null,
  reversechargeflag?: number | null,
  cancelflag?: number | null,
  invoiceitemid?: number | null,
  purchaseitemid?: number | null,
  gstrate?: number | null,
  gstamount?: number | null,
  cessamount?: number | null,
  itemquantity?: number | null,
  hsncode?: string | null,
  itemname?: string | null,
  salesaccountid?: number | null,
  purchaseaccountid?: number | null,
  hsndescription?: string | null,
  itemcode?: string | null,
  itemtype?: string | null,
  hsnsacid?: number | null,
  hsncodetype?: string | null,
  hsnmastercode?: string | null,
  pricetypeid?: number | null,
  manualgst?: number | null,
  manualdiscount?: number | null,
  manualcess?: number | null,
  cessrate?: number | null,
  cesstype?: string | null,
  placeofsupply?: string | null,
  statename?: string | null,
};

export type ItemTablePreference = {
  __typename: "ItemTablePreference",
  id?: number | null,
  companyid?: number | null,
  type?: number | null,
  itemcode?: number | null,
  itemname?: number | null,
  category?: number | null,
  unit?: number | null,
  showitemin?: number | null,
  purchaseac?: number | null,
  salesac?: number | null,
  hsnSAC?: number | null,
  taxability?: number | null,
  purchaseamount?: number | null,
  sellingprice?: number | null,
  updateprice?: number | null,
  totalsellingprice?: number | null,
  effectivefrom?: number | null,
  effectiveto?: number | null,
  actions?: number | null,
  userid?: string | null,
};

export type ItemMasterListCount = {
  __typename: "ItemMasterListCount",
  itemcount?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type ItemLotDetails = {
  __typename: "ItemLotDetails",
  lotid?: number | null,
  itemid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  lotnumber?: number | null,
  lotquantity?: number | null,
  itemrate?: number | null,
  typecd?: string | null,
  balance?: number | null,
};

export type Invoicemasterv2 = {
  __typename: "Invoicemasterv2",
  invoiceid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  invoicetypecd?: string | null,
  partyid?: number | null,
  paymentaccountid?: number | null,
  invoicedate?: number | null,
  invoicenumber?: string | null,
  customerordernumber?: string | null,
  customerorderdate?: number | null,
  invoiceamount?: number | null,
  paymenttype?: string | null,
  creditduration?: number | null,
  invoicebillingaddressid?: number | null,
  invoicedeliveryaddressid?: number | null,
  invoicetaxabletypecd?: string | null,
  receipturl?: string | null,
  invoicelinetypecd?: string | null,
  invoicecurrencycd?: string | null,
  exchangerate?: number | null,
  comments?: string | null,
  receivedamount?: number | null,
  adjustmentamount?: number | null,
  placeofsupply?: string | null,
  balancedueamount?: number | null,
  reversechargeflag?: number | null,
  tcsapplicableflag?: number | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  cancelflag?: number | null,
  consigneename?: string | null,
  consigneegstin?: string | null,
  companystate?: string | null,
  cancelremark?: string | null,
  deleteremark?: string | null,
  roundoffamount?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  serialnumber?: string | null,
  currencycode?: string | null,
  currencyrate?: number | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  partyaccountid?: number | null,
  paymentstatus?: number | null,
  ackno?: string | null,
  ackdt?: number | null,
  irn?: string | null,
  signedqrcode?: string | null,
  partyemail?: string | null,
  invoicepdf?: string | null,
};

export type InvoiceMasterListCount = {
  __typename: "InvoiceMasterListCount",
  invoicemasterlistcount?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type Denomination = {
  __typename: "Denomination",
  invoiceid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  denomination?: number | null,
  number_of_notes?: number | null,
  typecd?: string | null,
  last_updated_by?: string | null,
};

export type FinancialYearTransferHistory = {
  __typename: "FinancialYearTransferHistory",
  id?: number | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  financialyearidfrom?: number | null,
  financialyearidto?: number | null,
  transferdate?: string | null,
  ledgertransferdate?: string | null,
  ledgercbtransferdate?: string | null,
  partyledgertransferdate?: string | null,
  partycbtransferdate?: string | null,
  itemtransferdate?: string | null,
  itemcbtransferdate?: string | null,
};

export type FinancialYearStatus = {
  __typename: "FinancialYearStatus",
  financialyearid?: number | null,
  statustypecd?: string | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  statusvalue?: string | null,
  userid?: string | null,
};

export type DeletedTransactionMaster = {
  __typename: "DeletedTransactionMaster",
  transactionid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp: number,
  transactiontypecd: string,
  vouchernumber: string,
  entrydate: number,
  bankreferencenumber?: string | null,
  comments?: string | null,
  relatedtransactiondetails?:  Array<TransactionDetailsCustomDeleted | null > | null,
  relatedtransactionattachment?:  Array<TransactionAttachment | null > | null,
  relatedtransactiontdsdetails?:  Array<TransactionTDSDetails | null > | null,
  relatedpurchasemaster?:  Array<PurchaseMasterNew | null > | null,
  relatedinvoicemaster?:  Array<Invoicemasternew | null > | null,
  lastupdatedby?: string | null,
};

export type TransactionDetailsCustomDeleted = {
  __typename: "TransactionDetailsCustomDeleted",
  transactionid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  transactiontypecd?: string | null,
  accountid?: number | null,
  creditamount?: number | null,
  debitamount?: number | null,
  comments?: string | null,
  entryordernumber?: number | null,
  transactionbalance?: number | null,
  openingbalance?: number | null,
  relatedaccounts?:  Array<AccountMaster | null > | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  financialyearid?: number | null,
};

export type partymasterDeleted = {
  __typename: "partymasterDeleted",
  partyid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  partytypecd?: string | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  groupaccountid?: number | null,
  gstcategory?: string | null,
  placeofsupply?: string | null,
  entity?: string | null,
  email?: string | null,
  contactnumber?: string | null,
  whatsappnumber?: string | null,
  accountsid?: number | null,
  is_active?: number | null,
  msmetype?: string | null,
  deliveryconsigneename?: string | null,
  deliveryconsigneegstin?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  relatedpartygstdetails?:  Array<PartyGSTDetails | null > | null,
  relatedpartycreditdetails?:  Array<PartyCreditDetails | null > | null,
  relatedpartycontact?:  Array<PartyContact | null > | null,
  relatedpartyimages?:  Array<PartyImages | null > | null,
  relatedpurchasemaster?:  Array<PurchaseMasterNew | null > | null,
  relatedinvoicemaster?:  Array<Invoicemasternew | null > | null,
  lastupdatedby?: string | null,
  tdspercentage?: number | null,
  udhyamregno?: string | null,
  sameaddressflag?: number | null,
  comments?: string | null,
  tdssection?: string | null,
};

export type itemmasterDeleted = {
  __typename: "itemmasterDeleted",
  itemid?: number | null,
  itemcode?: string | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  itemname?: string | null,
  salesinvoiceflag?: number | null,
  purchaseinvoiceflag?: number | null,
  itemcategorycd?: string | null,
  measurementcd?: string | null,
  currencycd?: string | null,
  salesaccountid?: number | null,
  purchaseaccountid?: number | null,
  taxabilitycd?: string | null,
  reversechargeflag?: number | null,
  itemtype?: string | null,
  hsnid?: string | null,
  is_active?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  relateditemamountdetails?:  Array<ItemAmountDetailsDeleted | null > | null,
  relateditemgstdetails?:  Array<ItemGstDetails | null > | null,
  relateditemimages?:  Array<ItemImages | null > | null,
  lastupdatedby?: string | null,
  serialnumber?: string | null,
};

export type ItemAmountDetailsDeleted = {
  __typename: "ItemAmountDetailsDeleted",
  itemid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  amount?: number | null,
  effectivedate?: number | null,
  expireddate?: number | null,
  hsnid?: string | null,
  gstcompensationtype?: string | null,
  gstcompensationvalue?: number | null,
  gstrate?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  lastupdatedby?: string | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  invoicetype?: number | null,
  pricetype?: string | null,
  isactive?: number | null,
  isdefault?: number | null,
};

export type PurchaseMasterDeleted = {
  __typename: "PurchaseMasterDeleted",
  purchaseid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  purchasegsttypecd?: string | null,
  supplierid?: number | null,
  entrydate?: number | null,
  vouchernumber?: string | null,
  supplierinvoicedate?: number | null,
  supplierinvoicenumber?: string | null,
  supplieraddressid?: number | null,
  paymenttypecd?: string | null,
  paidamount?: number | null,
  creditduration?: number | null,
  paymentaccountid?: number | null,
  comments?: string | null,
  tdsapplicableflag?: number | null,
  granttotalamount?: number | null,
  balancedueamount?: number | null,
  paymentclearedflag?: number | null,
  placeofsupply?: string | null,
  companystate?: string | null,
  relatedpurchasetdsdetails?:  Array<PurchaseTDSDetails | null > | null,
  relatedpurchaselineitems?:  Array<PurchaseLineItems | null > | null,
  relatedpurchaselinenonitems?:  Array<PurchaseLineNonItems | null > | null,
  relatedpurchaselinegst?:  Array<PurchaseLineGST | null > | null,
  relatedpurchaseattachment?:  Array<PurchaseAttachment | null > | null,
  relatedpurchasetransactiondetails?:  Array<TransactionMaster | null > | null,
  relatedpartymaster?:  Array<partymaster | null > | null,
  relatedpartyaddressdetails?:  Array<AddressEntity | null > | null,
  relatedpaymentaccountdetails?:  Array<AccountMaster | null > | null,
  lastupdatedby?: string | null,
  cancelflag?: number | null,
  roundoffamount?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  adjustmentamount?: number | null,
  serialnumber?: string | null,
  currencycode?: string | null,
  currencyrate?: number | null,
  reversechargeflag?: number | null,
  paymentstatus?: number | null,
  partyregistrationtype?: string | null,
  partygstcategory?: string | null,
};

export type InvoicemasterDeleted = {
  __typename: "InvoicemasterDeleted",
  invoiceid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  invoicetypecd?: string | null,
  partyid?: number | null,
  paymentaccountid?: number | null,
  invoicedate?: number | null,
  invoicenumber?: string | null,
  customerordernumber?: string | null,
  customerorderdate?: number | null,
  invoiceamount?: number | null,
  paymenttype?: string | null,
  creditduration?: number | null,
  invoicebillingaddressid?: number | null,
  invoicedeliveryaddressid?: number | null,
  invoicetaxabletypecd?: string | null,
  receipturl?: string | null,
  invoicelinetypecd?: string | null,
  invoicecurrencycd?: string | null,
  exchangerate?: number | null,
  comments?: string | null,
  receivedamount?: number | null,
  adjustmentamount?: number | null,
  placeofsupply?: string | null,
  balancedueamount?: number | null,
  reversechargeflag?: number | null,
  tcsapplicableflag?: number | null,
  relatedinvoicelineitems?:  Array<InvoiceLineItems | null > | null,
  relatedinvoicelinonitems?:  Array<InvoiceLineNonItems | null > | null,
  relatedinvoiceattachment?:  Array<InvoiceAttachment | null > | null,
  relatedinvoicedispatch?:  Array<InvoiceDispatch | null > | null,
  relatedinvoiceposdetails?:  Array<InvoicePOSDetails | null > | null,
  relatedinvoicelinegst?:  Array<InvoiceLineGST | null > | null,
  relatedinvoicenumbertracker?:  Array<InvoiceNumberTracker | null > | null,
  relatedinvoicetransactiondetails?:  Array<TransactionMaster | null > | null,
  relatedpartymaster?:  Array<partymaster | null > | null,
  relatedpartybillingaddressdetails?:  Array<AddressEntity | null > | null,
  relatedpartydeliveryaddressdetails?:  Array<AddressEntity | null > | null,
  relatedpaymentaccountdetails?:  Array<AccountMaster | null > | null,
  lastupdatedby?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  cancelflag?: number | null,
  consigneename?: string | null,
  consigneeGSTIN?: string | null,
  companystate?: string | null,
  roundoffamount?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  serialnumber?: string | null,
  currencycode?: string | null,
  currencyrate?: number | null,
  paymentstatus?: number | null,
  ackno?: string | null,
  ackdt?: number | null,
  irn?: string | null,
  signedqrcode?: string | null,
};

export type AccountGroupMasterDeleted = {
  __typename: "AccountGroupMasterDeleted",
  AccountGroupID?: number | null,
  CompanyID?: number | null,
  CompanyBranchID?: number | null,
  EnteredTimeStamp?: number | null,
  ExpiredTimeStamp?: number | null,
  AccountTypeCD?: string | null,
  AccountGroupName?: string | null,
  AccountParentGroupID?: number | null,
  DisplayOrderNumber?: number | null,
  StatusCode?: string | null,
  StatusMessage?: string | null,
  Restrictedflag?: number | null,
  Is_Active?: number | null,
  RelatedAccounts?:  Array<AccountMaster | null > | null,
  path?: string | null,
};

export type CrDrNoteMasterDeleted = {
  __typename: "CrDrNoteMasterDeleted",
  crdrnoteid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  crdrnotetypecd?: string | null,
  crdrnotedate?: number | null,
  crdrnotenumber?: string | null,
  invoicetypecd?: string | null,
  gsttypecd?: string | null,
  partyid?: number | null,
  deliveryaddressid?: number | null,
  paymenttype?: string | null,
  grandtotalamount?: number | null,
  transactionid?: number | null,
  userid?: string | null,
  creditduration?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  psflag?: number | null,
  reversechargeflag?: number | null,
  balancedueamount?: number | null,
  consigneeName?: string | null,
  consigneeGstin?: string | null,
  companystate?: string | null,
  placeofsupply?: string | null,
  relatedcrdrnoteinvoices?:  Array<CrDrNoteInvoices | null > | null,
  relatedcrdrattachment?:  Array<CrDrAttachment | null > | null,
  relatedcrdrnotedetails?:  Array<CrDrNoteDetails | null > | null,
  relatedcrdrnotelineitems?:  Array<CrDrNoteLineItems | null > | null,
  relatedcrdrnotelinnonitems?:  Array<CrDrNoteLineNonItems | null > | null,
  serialnumber?: string | null,
  currencycode?: string | null,
  currencyrate?: number | null,
  originalinvoicenumber?: string | null,
  partyinvoicenumber?: string | null,
  paymentstatus?: number | null,
  partyregistrationtype?: string | null,
};

export type AccountMasterDeleted = {
  __typename: "AccountMasterDeleted",
  accountid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  accountname?: string | null,
  accounttypecd?: string | null,
  accountgroupid?: number | null,
  hsnsaccode?: string | null,
  displayordernumber?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  restrictedflag?: number | null,
  relatedaccountgstdetails?:  Array<AccountGSTDetails | null > | null,
  relatedaccountopeningbalance?:  Array<AccountOpeningBalance | null > | null,
  relatedaccountgroupmaster?:  Array<AccountGroupMasterNew | null > | null,
  relatedaccountbalance?:  Array<AccountBalanceNew | null > | null,
  path?: string | null,
};

export type PlaceOfSupply = {
  __typename: "PlaceOfSupply",
  id?: number | null,
  statename?: string | null,
  statecode?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  isactive?: number | null,
};

export type AccountTransactionCount = {
  __typename: "AccountTransactionCount",
  transactioncount?: number | null,
};

export type DayBookTransactionDetails = {
  __typename: "DayBookTransactionDetails",
  transactionid: number,
  companyid: number,
  companybranchid: number,
  enteredtimestamp: number,
  expiredtimestamp?: number | null,
  transactiontypecd: string,
  accountid: number,
  accountname: string,
  balancesign: number,
  totalcreditamount: number,
  totaldebitamount: number,
  comments?: string | null,
  entryordernumber: number,
  financialyearid: number,
  cancelflag?: number | null,
  balance: number,
  transactiontype?: string | null,
  vouchernumber?: string | null,
  voucherid?: number | null,
};

export type AccountOpeningBalancev2 = {
  __typename: "AccountOpeningBalancev2",
  accountid?: number | null,
  accountname?: string | null,
  accounttypecd?: string | null,
  displayordernumber?: number | null,
  path?: string | null,
  accountgroupid?: number | null,
  accountgroupname?: string | null,
  accountparentgroupid?: number | null,
  companyid?: number | null,
  financialyearid?: number | null,
  creditamount?: number | null,
  debitamount?: number | null,
  enteredtimestamp?: number | null,
  restrictedflag?: number | null,
  is_active?: number | null,
  root_group_id?: number | null,
  root_group_name?: string | null,
  balancesign?: number | null,
  balance?: number | null,
  type?: string | null,
};

export type TransactionDetailsv3 = {
  __typename: "TransactionDetailsv3",
  transactionid?: number | null,
  companyid?: number | null,
  enteredtimestamp?: number | null,
  financialyearid?: number | null,
  invoiceid?: number | null,
  purchaseid?: number | null,
  crdrnoteid?: number | null,
  vouchertype?: string | null,
  vouchernumber?: string | null,
  accountid?: number | null,
  accountname?: string | null,
  accounttypecd?: string | null,
  balancesign?: number | null,
  accountgroupname?: string | null,
  transactiontype?: string | null,
  entryordernumber?: number | null,
  totaldebitamount?: number | null,
  totalcreditamount?: number | null,
  balance?: number | null,
  oppositeaccountid?: number | null,
  oppositeaccountname?: string | null,
  comments?: string | null,
  setoffremarks?: string | null,
  setoffbalance?: number | null,
  accounttypeflag?: number | null,
};

export type TransactionMasterCount = {
  __typename: "TransactionMasterCount",
  transactionmasterlistcount?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  min_paymentamount?: number | null,
  max_paymentamount?: number | null,
  min_receiptamount?: number | null,
  max_receiptamount?: number | null,
  min_tds_payable_amount?: number | null,
  max_tds_payable_amount?: number | null,
  min_tds_receivable_amount?: number | null,
  max_tds_receivable_amount?: number | null,
  min_totalamount?: number | null,
  max_totalamount?: number | null,
};

export type PurchaseMasterv2 = {
  __typename: "PurchaseMasterv2",
  purchaseid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  purchasegsttypecd?: string | null,
  supplierid?: number | null,
  entrydate?: number | null,
  vouchernumber?: string | null,
  supplierinvoicedate?: number | null,
  supplierinvoicenumber?: string | null,
  supplieraddressid?: number | null,
  paymenttypecd?: string | null,
  paidamount?: number | null,
  creditduration?: number | null,
  paymentaccountid?: number | null,
  comments?: string | null,
  tdsapplicableflag?: number | null,
  granttotalamount?: number | null,
  balancedueamount?: number | null,
  paymentclearedflag?: number | null,
  placeofsupply?: string | null,
  companystate?: string | null,
  lastupdatedby?: string | null,
  cancelflag?: number | null,
  roundoffamount?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  adjustmentamount?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  serialnumber?: string | null,
  currencycode?: string | null,
  currencyrate?: number | null,
  partyaccountid?: number | null,
  reversechargeflag?: number | null,
  paymentstatus?: number | null,
  partyregistrationtype?: string | null,
  partygstcategory?: string | null,
};

export type PurchaseMasterListCount = {
  __typename: "PurchaseMasterListCount",
  purchasemasterlistcount?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type PartyInvoicePurchases = {
  __typename: "PartyInvoicePurchases",
  partyid?: number | null,
  companyid?: number | null,
  partytypecd?: string | null,
  partydisplayname?: string | null,
  partylegalname?: string | null,
  groupaccountid?: number | null,
  gstcategory?: string | null,
  placeofsupply?: string | null,
  entity?: string | null,
  email?: string | null,
  contactnumber?: string | null,
  whatsappnumber?: string | null,
  accountsid?: number | null,
  is_active?: number | null,
  msmetype?: string | null,
  deliveryconsigneename?: string | null,
  deliveryconsigneegstin?: string | null,
  lastupdatedby?: string | null,
  tdspercentage?: number | null,
  udhyamregno?: string | null,
  sameaddressflag?: number | null,
  invoiceid?: number | null,
  invoicetypecd?: string | null,
  invoicepaymentaccountid?: number | null,
  invoicedate?: number | null,
  invoicenumber?: string | null,
  customerordernumber?: string | null,
  customerorderdate?: number | null,
  invoiceamount?: number | null,
  paymenttype?: string | null,
  invoicecreditduration?: number | null,
  invoicebillingaddressid?: number | null,
  invoicedeliveryaddressid?: number | null,
  invoicetaxabletypecd?: string | null,
  receipturl?: string | null,
  invoicelinetypecd?: string | null,
  invoicecurrencycd?: string | null,
  invoiceexchangerate?: number | null,
  invoicecomments?: string | null,
  receivedamount?: number | null,
  invoiceadjustmentamount?: number | null,
  invoiceplaceofsupply?: string | null,
  invoicebalancedueamount?: number | null,
  invoicereversechargeflag?: number | null,
  invoicetcsapplicableflag?: number | null,
  invoicelastupdatedby?: string | null,
  invoicestatuscode?: string | null,
  invoicestatusmessage?: string | null,
  invoicecancelflag?: number | null,
  consigneename?: string | null,
  consigneegstin?: string | null,
  invoicecompanystate?: string | null,
  cancelremark?: string | null,
  deleteremark?: string | null,
  invoiceroundoffamount?: number | null,
  invoicediscounttype?: number | null,
  invoicediscountvalue?: number | null,
  invoiceserialnumber?: string | null,
  invoicecurrencycode?: string | null,
  invoicecurrencyrate?: number | null,
  invoicepartydisplayname?: string | null,
  invoicepartylegalname?: string | null,
  invoicepartyaccountid?: number | null,
  purchaseid?: number | null,
  purchasegsttypecd?: string | null,
  supplierid?: number | null,
  entrydate?: number | null,
  vouchernumber?: string | null,
  supplierinvoicedate?: number | null,
  supplierinvoicenumber?: string | null,
  supplieraddressid?: number | null,
  paymenttypecd?: string | null,
  paidamount?: number | null,
  purchasecreditduration?: number | null,
  purchasepaymentaccountid?: number | null,
  purchasecomments?: string | null,
  tdsapplicableflag?: number | null,
  granttotalamount?: number | null,
  purchasebalancedueamount?: number | null,
  paymentclearedflag?: number | null,
  purchaseplaceofsupply?: string | null,
  purchasecompanystate?: string | null,
  purchaselastupdatedby?: string | null,
  purchasecancelflag?: number | null,
  purchaseroundoffamount?: number | null,
  purchasediscounttype?: number | null,
  purchasediscountvalue?: number | null,
  purchaseadjustmentamount?: number | null,
  purchasestatuscode?: string | null,
  purchasestatusmessage?: string | null,
  purchaseserialnumber?: string | null,
  purchasecurrencycode?: string | null,
  purchasecurrencyrate?: number | null,
  purchasepartydisplayname?: string | null,
  purchasepartylegalname?: string | null,
  purchasepartyaccountid?: number | null,
  purchasereversechargeflag?: number | null,
  crdrnoteid?: number | null,
  crdrnotetypecd?: string | null,
  crdrnotedate?: number | null,
  crdrnotenumber?: string | null,
  crdrinvoicetypecd?: string | null,
  crdrgsttypecd?: string | null,
  crdrpartyid?: number | null,
  crdrdeliveryaddressid?: number | null,
  crdrpaymenttype?: string | null,
  crdrgrandtotalamount?: number | null,
  crdrtransactionid?: number | null,
  crdruserid?: string | null,
  crdrcreditduration?: number | null,
  crdrpsflag?: number | null,
  crdrreversechargeflag?: number | null,
  crdrbalancedueamount?: number | null,
  crdrconsigneename?: string | null,
  crdrconsigneegstin?: string | null,
  crdrplaceofsupply?: string | null,
  crdrcancelflag?: number | null,
  crdrcancelremark?: string | null,
  crdrroundoffamount?: number | null,
  crdrdiscounttype?: number | null,
  crdrdiscountvalue?: number | null,
  crdradjustmentamount?: number | null,
  crdrserialnumber?: string | null,
  crdrcurrencycode?: string | null,
  crdrcurrencyrate?: number | null,
  crdroriginalinvoicenumber?: string | null,
  crdrpaymentstatus?: number | null,
};

export type CrDrNoteMasterv2 = {
  __typename: "CrDrNoteMasterv2",
  crdrnoteid?: number | null,
  companyid?: number | null,
  companybranchid?: number | null,
  enteredtimestamp?: number | null,
  expiredtimestamp?: number | null,
  crdrnotetypecd?: string | null,
  crdrnotedate?: number | null,
  crdrnotenumber?: string | null,
  invoicetypecd?: string | null,
  gsttypecd?: string | null,
  partyid?: number | null,
  deliveryaddressid?: number | null,
  paymenttype?: string | null,
  grandtotalamount?: number | null,
  transactionid?: number | null,
  userid?: string | null,
  creditduration?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  psflag?: number | null,
  reversechargeflag?: number | null,
  balancedueamount?: number | null,
  consigneename?: string | null,
  consignegstin?: string | null,
  companystate?: string | null,
  placeofsupply?: string | null,
  cancelflag?: number | null,
  cancelremark?: string | null,
  roundoffamount?: number | null,
  discounttype?: number | null,
  discountvalue?: number | null,
  adjustmentamount?: number | null,
  serialnumber?: string | null,
  currencycode?: string | null,
  currencyrate?: number | null,
  partamount?: number | null,
  partydisplayname?: string | null,
  partyaccountid?: number | null,
  partytypecd?: string | null,
  originalinvoicenumber?: string | null,
  partyinvoicenumber?: string | null,
  paymentstatus?: number | null,
  crdrnotepdf?: string | null,
  receivedamount?: number | null,
  partyregistrationtype?: string | null,
  duedatetimestamp?: number | null,
  overduedays?: number | null,
  cessexist?: number | null,
  partyamount?: number | null,
};

export type CrDrNoteMasterListCount = {
  __typename: "CrDrNoteMasterListCount",
  crdrnotemasterlistcount?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CompanyFullDetails = {
  __typename: "CompanyFullDetails",
  companyid: number,
  enteredtimestamp: number,
  expiredtimestamp?: number | null,
  websiteurl?: string | null,
  currencycd?: number | null,
  accountinventoryflag?: number | null,
  pannumber?: string | null,
  tdstcsnumber?: string | null,
  cinregistrationnumber?: string | null,
  registrationtype?: number | null,
  gstrperiod?: string | null,
  lut?: string | null,
  lutbondvalidfrom?: number | null,
  ewaybillflag?: number | null,
  gstapplicablefrom?: number | null,
  thresholdlimitcd?: number | null,
  thresholdlimitamount?: number | null,
  companyshort?: string | null,
  lutbondtodate?: number | null,
  invoicedetailapplicablefromdate?: number | null,
  tdsapplicable?: number | null,
  gstcategory?: string | null,
  financialyearstartandendmonth?: number | null,
  companylogourl?: string | null,
  msmetype?: string | null,
  udhyamregno?: string | null,
  udhyamdocs?: string | null,
  ewaybillstartdate?: number | null,
  minamountewayinter?: number | null,
  minamountewayintra?: number | null,
  einvoiceflag?: number | null,
  einvoicestartingdate?: number | null,
  gstcompensationcessflag?: number | null,
  tradelicensenumber?: string | null,
  tradelicensestartdate?: number | null,
  tradelicenseenddate?: number | null,
  lastupdatedby?: string | null,
  cinregistrationdate?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
  activeflag?: number | null,
};

export type AccountBalance = {
  __typename: "AccountBalance",
  accountid?: number | null,
  accountbalance?: number | null,
  actualbalance?: number | null,
  balancesign?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type RelatedPaymentDetails = {
  __typename: "RelatedPaymentDetails",
  id?: number | null,
  serialnumber?: string | null,
  paymenttransactionid?: number | null,
  paymentvouchernumber?: string | null,
  transactiontypecd?: string | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type DashboardBalances = {
  __typename: "DashboardBalances",
  companyid?: number | null,
  expiredtimestamp?: number | null,
  financialyearid?: number | null,
  type?: string | null,
  accountid?: number | null,
  accountname?: string | null,
  immediate_parent_group_id?: number | null,
  immediate_parent_group_name?: string | null,
  root_group_id?: number | null,
  root_group_name?: string | null,
  accounttypecd?: string | null,
  restrictedflag?: number | null,
  creditamount?: number | null,
  debitamount?: number | null,
  balance?: number | null,
  is_active?: number | null,
  group_path?: string | null,
  balancesign?: number | null,
  accounttypeflag?: number | null,
};

export type BusinessOverview = {
  __typename: "BusinessOverview",
  companyid?: number | null,
  expiredtimestamp?: number | null,
  financialyearid?: number | null,
  group_name?: string | null,
  level?: number | null,
  group_path?: string | null,
  balance?: number | null,
  closingstockamt?: number | null,
  openingstockamt?: number | null,
};

export type Top5Expense = {
  __typename: "Top5Expense",
  companyid: number,
  financialyearid: number,
  account_id: number,
  account_name: string,
  balance: number,
  type: string,
};

export type MinMaxInvoiceDate = {
  __typename: "MinMaxInvoiceDate",
  previnvoicedate?: string | null,
  nextinvoicedate?: string | null,
  latestinvoicedate?: string | null,
  openingbalancedate?: string | null,
};

export type TransactionDetailsModalTotals = {
  __typename: "TransactionDetailsModalTotals",
  totalcredit: number,
  totaldebit: number,
  balancesign: number,
  closingbalance: number,
  transactioncount: number,
};

export type LambdaAIResponse = {
  __typename: "LambdaAIResponse",
  statusCode?: number | null,
  body?: string | null,
};

export type PosPartyDetails = {
  __typename: "PosPartyDetails",
  pospartyid: number,
  companyid: number,
  partyname?: string | null,
  partycontactnumberid: number,
  financialyearid?: number | null,
  id: number,
  objecttype: string,
  objectid: number,
  countrycode: string,
  phonenumber: string,
  verifieddatetime?: number | null,
  promotionssignup?: string | null,
  smsallowed?: string | null,
  callallowed?: string | null,
  whatsappallowed?: string | null,
};

export type TDSTCSReport = {
  __typename: "TDSTCSReport",
  id: number,
  invoicedate: number,
  vouchernumber?: string | null,
  vouchertype?: string | null,
  suppliername?: string | null,
  legalentity?: string | null,
  pan_number?: string | null,
  deductedamount?: number | null,
  tdsamount?: number | null,
  amountaftertds?: number | null,
  tdspercentage?: number | null,
  tdssection?: string | null,
  tdsdetails?: string | null,
  totalcount?: number | null,
  transactiontype?: string | null,
};

export type JournalDetails = {
  __typename: "JournalDetails",
  transactionid: number,
  accountsid: number,
  accountname: string,
  creditamount: number,
  debitamount: number,
  transactiontypecd: string,
};

export type FirstTransaction = {
  __typename: "FirstTransaction",
  transactiontimestamp: number,
  transactioncount: number,
};

export type EwayBillListCount = {
  __typename: "EwayBillListCount",
  ewaybillcount?: number | null,
  mintotalinvoiceamount?: number | null,
  maxtotalinvoiceamount?: number | null,
  maxtotalitemamount?: number | null,
  maxtotalitemscount?: number | null,
  maxgstcess?: number | null,
  maxdistance?: number | null,
  statuscode?: string | null,
  statusmessage?: string | null,
};

export type CheckItemPartyAdded = {
  __typename: "CheckItemPartyAdded",
  count: number,
};

export type ListStockSummaryInput = {
  starttimestamp: number,
  endtimestamp: number,
  openingbalance?: number | null,
  limit?: number | null,
  offset?: number | null,
};

export type StockSummary = {
  __typename: "StockSummary",
  slno: number,
  itemid?: number | null,
  itemcode: string,
  itemname: string,
  unit: string,
  hsn: string,
  taxability?: string | null,
  gstrate: number,
  openingamt: number,
  openingqty: number,
  purchaseamt: number,
  purchaseqty: number,
  salesamt: number,
  salesqty: number,
  closingamt: number,
  closingqty: number,
  total_count: number,
};

export type ListItemwiseStockSummaryInput = {
  starttimestamp: number,
  endtimestamp: number,
  itemid: number,
  limit?: number | null,
  cursortimestamp?: number | null,
  cursortransactionid?: number | null,
  openingbalance?: number | null,
};

export type ItemWiseStockSummary = {
  __typename: "ItemWiseStockSummary",
  itemid?: number | null,
  date?: number | null,
  particular?: string | null,
  voucher_no?: string | null,
  qty?: number | null,
  cost_item?: number | null,
  total_cost?: number | null,
  closing_stock?: number | null,
  closing_stock_amount?: number | null,
  invoiceid?: number | null,
  next_cursor_timestamp?: number | null,
  next_cursor_transactionid?: number | null,
  total_count?: number | null,
  remark?: string | null,
};

export type ItemFinancialYearSummaryInput = {
  itemid: number,
  financialyearid: number,
  openingbalance?: number | null,
  starttimestamp: number,
  endtimestamp: number,
};

export type ItemFinancialYearSummary = {
  __typename: "ItemFinancialYearSummary",
  itemid: number,
  financialyearid: number,
  openingqty: number,
  openingamt: number,
  purchaseqty: number,
  purchaseamt: number,
  closingqty: number,
  closingamt: number,
};

export type ItemOpeningStockDetails = {
  __typename: "ItemOpeningStockDetails",
  itemid: number,
  itemcode: string,
  itemname: string,
  units?: string | null,
  stockquantity?: number | null,
  rate_unit?: number | null,
  openingbalance?: number | null,
};

export type ItemDashboardData = {
  __typename: "ItemDashboardData",
  itemid: number,
  itemcode: string,
  itemname: string,
  itemtype?: string | null,
  itemcategoryid?: number | null,
  is_active?: boolean | null,
  closing_amount?: number | null,
  closing_quantity?: number | null,
  unit?: string | null,
};

export type TotalClosingStock = {
  __typename: "TotalClosingStock",
  total_closing_quantity?: number | null,
  total_closing_amount?: number | null,
};

export type PartyEmailAddress = {
  __typename: "PartyEmailAddress",
  partyid: number,
  email: string,
  is_active: number,
  partydisplayname?: string | null,
  partylegalname?: string | null,
};

export type TotalOpeningStock = {
  __typename: "TotalOpeningStock",
  total_opening_quantity?: number | null,
  total_opening_amount?: number | null,
};

export enum TransactionType {
  payment = "payment",
  receipt = "receipt",
}


export type LastUsedAccount = {
  __typename: "LastUsedAccount",
  bankpaidtoaccountid?: string | null,
  cashpaidtoaccountid?: string | null,
  bankpaidtoaccountname?: string | null,
  cashpaidtoaccountname?: string | null,
  paymentmethodlastused?: string | null,
};

export type TDSTCSReportTotals = {
  __typename: "TDSTCSReportTotals",
  totaltaxableamount?: number | null,
  totaltdsamount?: number | null,
  totalamountaftertds?: number | null,
  totalrecords?: number | null,
  transactiontype?: string | null,
};

export type LoginCognitoUserMutationVariables = {
  LinkedSessionID?: string | null,
};

export type LoginCognitoUserMutation = {
  loginCognitoUser?:  {
    __typename: "CognitoUserSession",
    sessionid?: number | null,
    cognitousername?: string | null,
    logintimestamp?: string | null,
    logouttimestamp?: string | null,
    linkedsessionid?: string | null,
    deviceinfo?: string | null,
    ipaddress?: string | null,
  } | null,
};

export type LogoutCognitoUserMutationVariables = {
};

export type LogoutCognitoUserMutation = {
  logoutCognitoUser?:  {
    __typename: "CognitoUserSession",
    sessionid?: number | null,
    cognitousername?: string | null,
    logintimestamp?: string | null,
    logouttimestamp?: string | null,
    linkedsessionid?: string | null,
    deviceinfo?: string | null,
    ipaddress?: string | null,
  } | null,
};

export type LogoutCognitoUserv2MutationVariables = {
};

export type LogoutCognitoUserv2Mutation = {
  logoutCognitoUserv2?:  {
    __typename: "CognitoUserSession",
    sessionid?: number | null,
    cognitousername?: string | null,
    logintimestamp?: string | null,
    logouttimestamp?: string | null,
    linkedsessionid?: string | null,
    deviceinfo?: string | null,
    ipaddress?: string | null,
  } | null,
};

export type CreatePartyTransactionMutationVariables = {
  createPartyTransactionInput: CreatePartyTransactionInput,
};

export type CreatePartyTransactionMutation = {
  createPartyTransaction?:  {
    __typename: "PartyCreation",
    partyid?: number | null,
    accountid?: number | null,
    companyid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreateItemTransactionMutationVariables = {
  createItemTransactionInput: CreateItemTransactionInput,
};

export type CreateItemTransactionMutation = {
  createItemTransaction?:  {
    __typename: "itemmasterv2",
    itemid?: number | null,
    itemcode?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    itemname?: string | null,
    salesinvoiceflag?: number | null,
    purchaseinvoiceflag?: number | null,
    itemcategorycd?: string | null,
    measurementcd?: string | null,
    currencycd?: string | null,
    salesaccountid?: number | null,
    purchaseaccountid?: number | null,
    taxabilitycd?: string | null,
    reversechargeflag?: number | null,
    itemtype?: string | null,
    hsnid?: string | null,
    is_active?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
    itemamountenteredtimestamp?: number | null,
    itemamountexpiredtimestamp?: number | null,
    amount?: number | null,
    effectivedate?: number | null,
    expireddate?: number | null,
    sellinghsnid?: string | null,
    purchasehsnid?: string | null,
    gstcompensationtype?: string | null,
    gstcompensationvalue?: number | null,
    gstrate?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    imagename?: string | null,
    imageurl?: string | null,
    serialnumber?: string | null,
    isdefault?: number | null,
    invoicetype?: number | null,
    defaultsellingprice?: number | null,
    defaultpurchaseprice?: number | null,
    codetext?: string | null,
    itemcategory?: string | null,
    sellinggstcompensationtype?: string | null,
    purchasegstcompensationtype?: string | null,
    sellinggstcompensationvalue?: number | null,
    purchasegstcompensationvalue?: number | null,
    sellinggstrate?: number | null,
    purchasegstrate?: number | null,
    sellingdiscounttype?: number | null,
    purchasediscounttype?: number | null,
    sellingdiscountvalue?: number | null,
    purchasediscountvalue?: number | null,
    purchaseaccountname?: string | null,
    salesaccountname?: string | null,
    defaultnetsellingprice?: number | null,
    defaultnetpurchaseprice?: number | null,
    description?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsnsaccode?: string | null,
    hsndescription?: string | null,
    cessexist?: number | null,
    barcode?: string | null,
  } | null,
};

export type CreateSalesInvoiceMutationVariables = {
  createSalesInvoiceInput: CreateSalesInvoiceInput,
};

export type CreateSalesInvoiceMutation = {
  createSalesInvoice?:  {
    __typename: "SalesInvoiceTransaction",
    invoiceid?: number | null,
    companyid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    invoicenumber?: string | null,
  } | null,
};

export type CreateSalesPosInvoiceTempMutationVariables = {
  createSalesInvoiceInput: CreateSalesPosInvoiceInputTemp,
};

export type CreateSalesPosInvoiceTempMutation = {
  createSalesPosInvoiceTemp?:  {
    __typename: "SalesInvoiceTransaction",
    invoiceid?: number | null,
    companyid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    invoicenumber?: string | null,
  } | null,
};

export type CreateCompanyFYv2MutationVariables = {
  createCompanyFYInput: CreateCompanyFYInputv2,
};

export type CreateCompanyFYv2Mutation = {
  createCompanyFYv2?:  {
    __typename: "Company",
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    companyname?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedcompanydetailsnew?:  Array< {
      __typename: "CompanyDetails",
      companyid: number,
      enteredtimestamp: number,
      expiredtimestamp?: number | null,
      websiteurl?: string | null,
      currencycd?: number | null,
      accountinventoryflag?: number | null,
      pannumber?: string | null,
      tdstcsnumber?: string | null,
      cinregistrationnumber?: string | null,
      registrationtype?: number | null,
      comppercentage?: number | null,
      gstrperiod?: string | null,
      lut?: string | null,
      lutbondvalidfrom?: number | null,
      ewaybillflag?: number | null,
      gstapplicablefrom?: number | null,
      thresholdlimitcd?: number | null,
      thresholdlimitamount?: number | null,
      companylegalname?: string | null,
      companyshort?: string | null,
      lutbondtodate?: number | null,
      invoicedetailapplicablefromdate?: number | null,
      tdsapplicable?: number | null,
      gstcategory?: string | null,
      financialyearstartandendmonth?: number | null,
      companylogourl?: string | null,
      msmetype?: string | null,
      udhyamregno?: string | null,
      udhyamdocs?: string | null,
      ewaybillstartdate?: number | null,
      minamountewayinter?: number | null,
      minamountewayintra?: number | null,
      einvoiceflag?: number | null,
      einvoicestartingdate?: number | null,
      gstcompensationcessflag?: number | null,
      tradelicensenumber?: string | null,
      tradelicensestartdate?: number | null,
      tradelicenseenddate?: number | null,
      lastupdatedby?: string | null,
      cinregistrationdate?: number | null,
      einvoiceconnect?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      activeflag?: number | null,
      relatedfinancialyeardata?:  Array< {
        __typename: "FinancialYear",
        financialyearid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        startdate?: number | null,
        enddate?: number | null,
        startyear?: string | null,
        endyear?: string | null,
        comments?: string | null,
        userid?: string | null,
        aliasname?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        freezestatus?: number | null,
        transferdate?: number | null,
        freezedate?: number | null,
        stepscompleted?: Array< string | null > | null,
      } | null > | null,
      financialyearid?: number | null,
      lastupdatedtimestamp?: number | null,
      companydeletiontime?: number | null,
      ewaybillconnect?: number | null,
      stepscompleted?: Array< string | null > | null,
      disablegstcompensation?: number | null,
      businesstypeid?: Array< number | null > | null,
      industrytypeid?: Array< number | null > | null,
    } | null > | null,
    relatedcompanyentity?:  Array< {
      __typename: "CompanyEntity",
      id?: number | null,
      companyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      legalname?: string | null,
      gstin?: string | null,
      financialyearcode?: string | null,
      companyentitytype?: string | null,
      startdate?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
      financialyearid?: number | null,
    } | null > | null,
    relatedemailcontacts?:  Array< {
      __typename: "EmailContacts",
      id: number,
      objecttype: string,
      objectid: string,
      enteredtimestamp: number,
      expiredtimestamp: number,
      emailaddress: string,
      verifieddatetime?: number | null,
      promotionssignup?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedphonecontacts?:  Array< {
      __typename: "PhoneContacts",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      countrycode?: string | null,
      phonenumber?: string | null,
      verifieddatetime?: number | null,
      promotionssignup?: string | null,
      smsallowed?: string | null,
      callallowed?: string | null,
      whatsappallowed?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedaddressentity?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    addressentityid?: number | null,
    objecttype?: string | null,
    line1?: string | null,
    line2?: string | null,
    line3?: string | null,
    city?: string | null,
    statecode?: string | null,
    statename?: string | null,
    pincode?: string | null,
    countrycode?: string | null,
    district?: string | null,
    financialyearid?: number | null,
    einvoiceusername?: string | null,
    companydeletiontime?: number | null,
    ewaybillusername?: string | null,
  } | null,
};

export type CreatePurchaseInvoiceMutationVariables = {
  createPurchaseInvoiceInput: CreatePurchaseInvoiceInput,
};

export type CreatePurchaseInvoiceMutation = {
  createPurchaseInvoice?:  {
    __typename: "PurchaseInvoice",
    purchaseid?: number | null,
    companyid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreateTransactionWithSpecificTimeMutationVariables = {
  transactionmaster: string,
  transactiondetails: string,
  transactionrelation: string,
  transactionattachment: string,
  transactiontcsdetails: string,
  transactiontdsdetails: string,
  mode: number,
};

export type CreateTransactionWithSpecificTimeMutation = {
  createTransactionWithSpecificTime?:  {
    __typename: "TransactionSpecificTime",
    transactionid?: number | null,
    companyid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreateCrDrNoteTransactionsArrayMutationVariables = {
  createCrDrNoteTransactionsArrayInput: CreateCrDrNoteTransactionsArrayInput,
};

export type CreateCrDrNoteTransactionsArrayMutation = {
  createCrDrNoteTransactionsArray?:  {
    __typename: "CrDrNoteInvoiceTransaction",
    crdrnoteid?: number | null,
    companyid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreateAccountOpeningBalancesTransactionMutationVariables = {
  createAccountOpeningBalancesArrayInput: CreateAccountOpeningBalancesArrayInput,
};

export type CreateAccountOpeningBalancesTransactionMutation = {
  createAccountOpeningBalancesTransaction?:  {
    __typename: "AccountOpeningBalanceResponse",
    companyid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreateItemCategorymasterMutationVariables = {
  createItemCategorymasterInput: CreateItemCategorymasterInput,
};

export type CreateItemCategorymasterMutation = {
  createItemCategorymaster?:  {
    __typename: "ItemCategoryMaster",
    itemcategoryid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    category?: string | null,
    itemcategorygroupid?: number | null,
    maincategory?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
  } | null,
};

export type CreateCompanyCodeTranslationMutationVariables = {
  createCompanyCodeTranslationInput: CreateCompanyCodeTranslationInput,
};

export type CreateCompanyCodeTranslationMutation = {
  createCompanyCodeTranslation?:  {
    __typename: "CompanyCodeTranslation",
    id?: number | null,
    companyid?: number | null,
    codetype?: string | null,
    codevalue?: string | null,
    language?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    codetext?: string | null,
    codeorder?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
    uqc?: string | null,
    is_active?: string | null,
    section?: string | null,
  } | null,
};

export type CreatePriceTypeMutationVariables = {
  pricetype?: string | null,
};

export type CreatePriceTypeMutation = {
  createPriceType?:  {
    __typename: "PriceType",
    id?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    pricetype?: string | null,
    userid?: string | null,
    is_default?: number | null,
    is_active?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    tabletype?: number | null,
  } | null,
};

export type CreateAccountGroupMasterMutationVariables = {
  createAccountGroupMasterInput: CreateAccountGroupMasterInput,
};

export type CreateAccountGroupMasterMutation = {
  createAccountGroupMaster?:  {
    __typename: "AccountGroupMaster",
    accountgroupid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accounttypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    relatedaccounts?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    path?: string | null,
  } | null,
};

export type CreateInvoiceSettingsMutationVariables = {
  invoiceSettingsInput: Array< InvoiceSettingsInput >,
};

export type CreateInvoiceSettingsMutation = {
  createInvoiceSettings:  Array< {
    __typename: "InvoiceSettings",
    invoicesettingsid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    typecd?: string | null,
    invoiceheading?: string | null,
    signaturetext?: string | null,
    declarationatfooter?: string | null,
    termsandcondition?: string | null,
    declarationatfooterflag?: number | null,
    termsandconditionsflag?: number | null,
    companyname?: number | null,
    companycin?: number | null,
    invoicenumber?: number | null,
    companyaddress?: number | null,
    companylogo?: number | null,
    invoicedate?: number | null,
    companycontactnumber?: number | null,
    companyemail?: number | null,
    paymentmode?: number | null,
    companygstin?: number | null,
    companywebsite?: number | null,
    creditperiod?: number | null,
    companypan?: number | null,
    companybankdetails?: number | null,
    paymentduedate?: number | null,
    customerlegalname?: number | null,
    customergstin?: number | null,
    lutbonddetails?: number | null,
    customerdisplayname?: number | null,
    placeofsupply?: number | null,
    dispatchdetails?: number | null,
    customerbillingaddress?: number | null,
    customercontactperson?: number | null,
    customercontactnumber?: number | null,
    customername?: number | null,
    ewaybilldetails?: number | null,
    customershippingaddress?: number | null,
    customerordernoanddate?: number | null,
    einvoicedetails?: number | null,
    itemwisediscount?: number | null,
    hsnsacode?: number | null,
    showroundoff?: number | null,
    hsnsasummarytable?: number | null,
    invoicedescription?: number | null,
    regularinvoicesignaturefilename?: string | null,
    last_updated_by?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    posinvoicesignaturefilename?: string | null,
    defaultsetting?: number | null,
    bankdetails?: string | null,
    upi_id?: string | null,
    acknowledgement?: string | null,
    acknowledgementflag?: number | null,
    bosinvoiceheading?: string | null,
    bank_name?: string | null,
    branch?: string | null,
    ac_name?: string | null,
    ac_no?: string | null,
    ifsc?: string | null,
    swift_code?: string | null,
  } >,
};

export type CreateAccountMasterMutationVariables = {
  createAccountMasterInput: CreateAccountMasterInput,
};

export type CreateAccountMasterMutation = {
  createAccountMaster?:  {
    __typename: "AccountMaster",
    accountsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    accountgroupid?: number | null,
    hsnsaccode?: string | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    accounttypeflag?: number | null,
    relatedaccountgstdetails?:  Array< {
      __typename: "AccountGSTDetails",
      accountid?: number | null,
      companyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstrate?: number | null,
      cessamount?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsaccode?: string | null,
      codetype?: string | null,
      description?: string | null,
      taxability?: string | null,
    } | null > | null,
    relatedaccountopeningbalance?:  Array< {
      __typename: "AccountOpeningBalance",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      financialyearid?: number | null,
      startdate?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedaccountgroupmaster?:  Array< {
      __typename: "AccountGroupMasterNew",
      accountgroupid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accounttypecd?: string | null,
      accountgroupname?: string | null,
      accountparentgroupid?: number | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      is_active?: number | null,
      restrictedflag?: number | null,
      path?: string | null,
    } | null > | null,
    relatedaccountbalance?:  Array< {
      __typename: "AccountBalanceNew",
      accountid?: number | null,
      accountbalance?: number | null,
      actualbalance?: number | null,
    } | null > | null,
    path?: string | null,
  } | null,
};

export type CreatecompanydetailsMutationVariables = {
  createCompanyDetailsInput: Array< CreateCompanyDetailsInput >,
};

export type CreatecompanydetailsMutation = {
  createcompanydetails:  Array< {
    __typename: "CompanyDetails",
    companyid: number,
    enteredtimestamp: number,
    expiredtimestamp?: number | null,
    websiteurl?: string | null,
    currencycd?: number | null,
    accountinventoryflag?: number | null,
    pannumber?: string | null,
    tdstcsnumber?: string | null,
    cinregistrationnumber?: string | null,
    registrationtype?: number | null,
    comppercentage?: number | null,
    gstrperiod?: string | null,
    lut?: string | null,
    lutbondvalidfrom?: number | null,
    ewaybillflag?: number | null,
    gstapplicablefrom?: number | null,
    thresholdlimitcd?: number | null,
    thresholdlimitamount?: number | null,
    companylegalname?: string | null,
    companyshort?: string | null,
    lutbondtodate?: number | null,
    invoicedetailapplicablefromdate?: number | null,
    tdsapplicable?: number | null,
    gstcategory?: string | null,
    financialyearstartandendmonth?: number | null,
    companylogourl?: string | null,
    msmetype?: string | null,
    udhyamregno?: string | null,
    udhyamdocs?: string | null,
    ewaybillstartdate?: number | null,
    minamountewayinter?: number | null,
    minamountewayintra?: number | null,
    einvoiceflag?: number | null,
    einvoicestartingdate?: number | null,
    gstcompensationcessflag?: number | null,
    tradelicensenumber?: string | null,
    tradelicensestartdate?: number | null,
    tradelicenseenddate?: number | null,
    lastupdatedby?: string | null,
    cinregistrationdate?: number | null,
    einvoiceconnect?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    activeflag?: number | null,
    relatedfinancialyeardata?:  Array< {
      __typename: "FinancialYear",
      financialyearid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      startdate?: number | null,
      enddate?: number | null,
      startyear?: string | null,
      endyear?: string | null,
      comments?: string | null,
      userid?: string | null,
      aliasname?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      freezestatus?: number | null,
      transferdate?: number | null,
      freezedate?: number | null,
      stepscompleted?: Array< string | null > | null,
    } | null > | null,
    financialyearid?: number | null,
    lastupdatedtimestamp?: number | null,
    companydeletiontime?: number | null,
    ewaybillconnect?: number | null,
    stepscompleted?: Array< string | null > | null,
    disablegstcompensation?: number | null,
    businesstypeid?: Array< number | null > | null,
    industrytypeid?: Array< number | null > | null,
  } >,
};

export type CreatecompanyentityMutationVariables = {
  createcompanyentityInput: Array< CreatecompanyentityInput >,
};

export type CreatecompanyentityMutation = {
  createcompanyentity:  Array< {
    __typename: "CompanyEntity",
    id?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    legalname?: string | null,
    gstin?: string | null,
    financialyearcode?: string | null,
    companyentitytype?: string | null,
    startdate?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
    financialyearid?: number | null,
  } >,
};

export type CreateAccountGSTDetailsMutationVariables = {
  createAccountGSTDetailsInput: CreateAccountGSTDetailsInput,
};

export type CreateAccountGSTDetailsMutation = {
  createAccountGSTDetails?:  {
    __typename: "AccountGSTDetails",
    accountid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    effectivedate?: number | null,
    expireddate?: number | null,
    hsnid?: string | null,
    gstcompensationtype?: string | null,
    gstrate?: number | null,
    cessamount?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    hsnsaccode?: string | null,
    codetype?: string | null,
    description?: string | null,
    taxability?: string | null,
  } | null,
};

export type CreateHSNSACMasterMutationVariables = {
  createHSNSACMasterInput: CreateHSNSACMasterInput,
};

export type CreateHSNSACMasterMutation = {
  createHSNSACMaster?:  {
    __typename: "hsnsacmaster",
    hsnsacid?: number | null,
    codetype?: string | null,
    hsnsaccode?: string | null,
    description?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    companyid?: number | null,
  } | null,
};

export type CreatePartyCreditDetailsMutationVariables = {
  createPartyCreditDetailsInput: CreatePartyCreditDetailsInput,
};

export type CreatePartyCreditDetailsMutation = {
  createPartyCreditDetails?:  {
    __typename: "PartyCreditDetails",
    partyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    creditperiodduration?: string | null,
    billingcurrency?: string | null,
    creditlimitcd?: number | null,
    creditlimitamount?: number | null,
    billwiseflag?: number | null,
    notes?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreatePartyGSTDetailsMutationVariables = {
  createPartyGSTDetailsInput: CreatePartyGSTDetailsInput,
};

export type CreatePartyGSTDetailsMutation = {
  createPartyGSTDetails?:  {
    __typename: "PartyGSTDetails",
    partyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    pannumber?: string | null,
    gstin?: string | null,
    partyaddressid?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreatebusinessTypeMutationVariables = {
  businessTypeInputs: Array< BusinessTypeInputs >,
};

export type CreatebusinessTypeMutation = {
  createbusinessType?:  Array< {
    __typename: "BusinessType",
    businesstypeid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    businesstype?: string | null,
    lastupdatedby?: string | null,
    restrictedflag?: number | null,
    isactive?: number | null,
  } | null > | null,
};

export type CreateindustryTypeMutationVariables = {
  industryTypeInputs: Array< IndustryTypeInputs >,
};

export type CreateindustryTypeMutation = {
  createindustryType?:  Array< {
    __typename: "IndustryType",
    industrytypeid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    industrytype?: string | null,
    lastupdatedby?: string | null,
    restrictedflag?: number | null,
    isactive?: number | null,
  } | null > | null,
};

export type CreateBankDetailsMutationVariables = {
  createBankDetailsInput: Array< CreateBankDetailsInput >,
};

export type CreateBankDetailsMutation = {
  createBankDetails:  Array< {
    __typename: "BankDetails",
    bankdetailsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    objecttype?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    objectid?: string | null,
    userid?: string | null,
    bankname?: string | null,
    bankaccountnumber?: string | null,
    ifsccode?: string | null,
    branch?: string | null,
    notes?: string | null,
    ledgeraccount?: string | null,
    bankaccounttype?: string | null,
    cash?: number | null,
    swiftcode?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    upi?: string | null,
  } >,
};

export type CreateFinancialYearMutationVariables = {
  createFinancialYearInput: CreateFinancialYearInput,
};

export type CreateFinancialYearMutation = {
  createFinancialYear?:  {
    __typename: "FinancialYear",
    financialyearid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    startdate?: number | null,
    enddate?: number | null,
    startyear?: string | null,
    endyear?: string | null,
    comments?: string | null,
    userid?: string | null,
    aliasname?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    freezestatus?: number | null,
    transferdate?: number | null,
    freezedate?: number | null,
    stepscompleted?: Array< string | null > | null,
  } | null,
};

export type CreateUserPreferenceMutationVariables = {
  createUserPreferenceInput: CreateUserPreferenceInput,
};

export type CreateUserPreferenceMutation = {
  createUserPreference?:  {
    __typename: "UserPreference",
    userid?: string | null,
    attributetypecd?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    attributevalue?: number | null,
    additionalvalue?: string | null,
  } | null,
};

export type CreateCompanyPreferenceMutationVariables = {
  createCompanyPreferenceInput: CreateCompanyPreferenceInput,
};

export type CreateCompanyPreferenceMutation = {
  createCompanyPreference?:  {
    __typename: "CompanyPreference",
    companyid?: number | null,
    attributetypecd?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    attributevalue?: number | null,
    additionalvalue?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type SwitchCompanyMutationVariables = {
  companyid: number,
  financialyearid: number,
};

export type SwitchCompanyMutation = {
  switchCompany?:  Array< {
    __typename: "SwitchCompany",
    companyid?: number | null,
    financialyearid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreatePaymentSettingsMutationVariables = {
  paymentSettingsInput: Array< PaymentSettingsInput >,
};

export type CreatePaymentSettingsMutation = {
  createPaymentSettings:  Array< {
    __typename: "PaymentSettings",
    enable_itemwiseentry?: number | null,
    enable_creditperiod?: number | null,
    enable_creditlimit?: number | null,
    enable_autopayreminder?: number | null,
    enable_autoreminderdays?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    lastupdatedby?: string | null,
  } >,
};

export type CreateTransactionMasterMutationVariables = {
  createTransactionMasterInput: CreateTransactionMasterInput,
};

export type CreateTransactionMasterMutation = {
  createTransactionMaster?:  {
    __typename: "TransactionMaster",
    transactionid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    transactiontypecd?: string | null,
    vouchernumber?: string | null,
    entrydate?: number | null,
    bankreferencenumber?: string | null,
    comments?: string | null,
    relatedtransactiondetails?:  Array< {
      __typename: "TransactionDetailsCustom",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      accountid?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      comments?: string | null,
      entryordernumber?: number | null,
      transactionbalance?: number | null,
      openingbalance?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      financialyearid?: number | null,
    } | null > | null,
    relatedtransactionattachment?:  Array< {
      __typename: "TransactionAttachment",
      transactionid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      documentname: string,
      statuscode?: string | null,
      statusmessage?: string | null,
      type?: string | null,
    } | null > | null,
    relatedtransactiontdsdetails?:  Array< {
      __typename: "TransactionTDSDetails",
      transactionid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      tdsapplicablecd: string,
      tdsamount: number,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tdspercentage?: number | null,
    } | null > | null,
    relatedpurchasemaster?:  Array< {
      __typename: "PurchaseMasterNew",
      purchaseid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchasegsttypecd: string,
      supplierid: number,
      entrydate: number,
      vouchernumber: string,
      supplierinvoicedate: number,
      supplierinvoicenumber: string,
      supplieraddressid: number,
      paymenttypecd: string,
      paidamount: number,
      creditduration: number,
      paymentaccountid: number,
      comments: string,
      tdsapplicableflag: number,
      granttotalamount?: number | null,
      balancedueamount?: number | null,
      paymentclearedflag?: number | null,
      placeofsupply?: string | null,
      companystate?: string | null,
      relatedpurchasetdsdetails?:  Array< {
        __typename: "PurchaseTDSDetails",
        purchaseid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        tdsapplicablecd?: number | null,
        totaltaxableamount?: number | null,
        ineligibletcflag?: number | null,
        reversechargeflag?: number | null,
        gstcesstotal?: number | null,
        tdsamount?: number | null,
        adjustmentamount?: number | null,
        tdssection?: string | null,
        tdspercentage?: number | null,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaselineitems?:  Array< {
        __typename: "PurchaseLineItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        itemnumber: number,
        itemid: number,
        purchaseaccountid: number,
        hsncode: string,
        itemquantity: number,
        unittypecd: string,
        itemrate: number,
        itemamount: number,
        itemdiscount: number,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount: number,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnid?: string | null,
        hsncodetype?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        purchaseaccountname?: string | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinenonitems?:  Array< {
        __typename: "PurchaseLineNonItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchaselineitemtype: string,
        purchaseaccountid: number,
        hsnsaccode: string,
        itemdescription: string,
        taxableamount: number,
        netamount: number,
        relatedpurchaselinenongst?:  Array< {
          __typename: "PurchaseLineNonGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        purchaseaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaseattachment?:  Array< {
        __typename: "PurchaseAttachment",
        purchaseid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedpurchasetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      relatedpurchasetransactionrelation?:  Array< {
        __typename: "TransactionRelation",
        transactionid?: number | null,
        transactiontypecd?: string | null,
        objecttype?: string | null,
        objectid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        linkedamount?: number | null,
        objectattribute?: string | null,
        isdirect?: number | null,
        lastupdatedby?: string | null,
        accountid?: number | null,
        paymentvouchernumber?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      adjustmentamount?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      reversechargeflag?: number | null,
      paymentstatus?: number | null,
      partyregistrationtype?: string | null,
      partygstcategory?: string | null,
      itcflag?: number | null,
    } | null > | null,
    relatedinvoicemaster?:  Array< {
      __typename: "Invoicemasternew",
      invoiceid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      invoicetypecd: string,
      partyid: number,
      paymentaccountid: number,
      invoicedate: number,
      invoicenumber: string,
      customerordernumber: string,
      customerorderdate?: number | null,
      invoiceamount: number,
      paymenttype: string,
      creditduration: number,
      invoicebillingaddressid: number,
      invoicedeliveryaddressid: number,
      invoicetaxabletypecd: string,
      receipturl: string,
      invoicelinetypecd: string,
      invoicecurrencycd: string,
      exchangerate: number,
      comments: string,
      receivedamount: number,
      adjustmentamount: number,
      placeofsupply?: string | null,
      balancedueamount?: number | null,
      reversechargeflag?: number | null,
      tcsapplicableflag?: number | null,
      relatedinvoicelineitems?:  Array< {
        __typename: "InvoiceLineItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        lineitemnumber?: number | null,
        invoicelineitemtype?: string | null,
        itemid?: number | null,
        quantity?: number | null,
        unittypecd?: string | null,
        itemrate?: number | null,
        itemamount?: number | null,
        itemdiscount?: number | null,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        salesaccountname?: string | null,
        salesaccountid?: number | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        itemmaster_timestamp?: number | null,
        description?: string | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoicelinenonitems?:  Array< {
        __typename: "InvoiceLineNonItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        invoicelineitemtype?: string | null,
        incomeaccountid?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        itemdescription?: string | null,
        taxableamount?: number | null,
        netamount?: number | null,
        relatedaccounts?:  Array< {
          __typename: "AccountMaster",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accountname?: string | null,
          accounttypecd?: string | null,
          accountgroupid?: number | null,
          hsnsaccode?: string | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          restrictedflag?: number | null,
          is_active?: number | null,
          accounttypeflag?: number | null,
          relatedaccountgstdetails?:  Array< {
            __typename: "AccountGSTDetails",
            accountid?: number | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstrate?: number | null,
            cessamount?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsaccode?: string | null,
            codetype?: string | null,
            description?: string | null,
            taxability?: string | null,
          } | null > | null,
          relatedaccountopeningbalance?:  Array< {
            __typename: "AccountOpeningBalance",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            financialyearid?: number | null,
            startdate?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedaccountgroupmaster?:  Array< {
            __typename: "AccountGroupMasterNew",
            accountgroupid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accounttypecd?: string | null,
            accountgroupname?: string | null,
            accountparentgroupid?: number | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            is_active?: number | null,
            restrictedflag?: number | null,
            path?: string | null,
          } | null > | null,
          relatedaccountbalance?:  Array< {
            __typename: "AccountBalanceNew",
            accountid?: number | null,
            accountbalance?: number | null,
            actualbalance?: number | null,
          } | null > | null,
          path?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        incomeaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoiceattachment?:  Array< {
        __typename: "InvoiceAttachment",
        invoiceid?: number | null,
        attachmentid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        attachmentname?: string | null,
        attachmenturl?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedinvoicedispatch?:  Array< {
        __typename: "InvoiceDispatch",
        invoiceid: number,
        dispatchid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        transportationcd: string,
        vehiclenumber: string,
        dispatchdate: number,
        ewaybillnumber: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoiceposdetails?:  Array< {
        __typename: "InvoicePOSDetails",
        posid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        partyposid: number,
        lastupdatedby?: string | null,
        relatedposparty?:  Array< {
          __typename: "POSParty",
          pospartyid?: number | null,
          companyid?: number | null,
          partyname?: string | null,
          partycontactnumberid?: number | null,
          lastupdatedby?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          relatedphonecontacts?:  Array< {
            __typename: "PhoneContacts",
            id?: number | null,
            objecttype?: string | null,
            objectid?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            countrycode?: string | null,
            phonenumber?: string | null,
            verifieddatetime?: number | null,
            promotionssignup?: string | null,
            smsallowed?: string | null,
            callallowed?: string | null,
            whatsappallowed?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
        } | null > | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicenumbertracker?:  Array< {
        __typename: "InvoiceNumberTracker",
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        nextinvoicenumber: string,
        lastupdatedby?: string | null,
      } | null > | null,
      relatedinvoicetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      companystate?: string | null,
      cancelremark?: string | null,
      deleteremark?: string | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      paymentstatus?: number | null,
      ackno?: string | null,
      ackdt?: number | null,
      irn?: string | null,
      signedqrcode?: string | null,
      itcflag?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    cancelremark?: string | null,
    serialnumber?: string | null,
    pdflink?: string | null,
    towards?: string | null,
    isvouchereditable?: number | null,
  } | null,
};

export type CreateTransactionDetailsArrayMutationVariables = {
  createTransactionDetailsArrayInput: string,
};

export type CreateTransactionDetailsArrayMutation = {
  createTransactionDetailsArray?:  Array< {
    __typename: "TransactionDetails",
    transactionid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    transactiontypecd?: string | null,
    accountid?: number | null,
    creditamount?: number | null,
    debitamount?: number | null,
    comments?: string | null,
    entryordernumber?: number | null,
    transactionbalance?: number | null,
    openingbalance?: number | null,
    relatedaccounts?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedaccountstransaction?:  Array< {
      __typename: "RelatedAccountsTransactionDetails",
      transactionid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transactiontypecd?: string | null,
      accountid?: number | null,
      creditamount: number,
      debitamount: number,
      comments?: string | null,
      entryordernumber?: number | null,
      transactionbalance?: number | null,
      openingbalance?: number | null,
      vouchernumber?: string | null,
      transactionmastertypecd?: string | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      financialyearid?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    financialyearid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreateTransactionRelationMutationVariables = {
  createTransactionRelationInput: CreateTransactionRelationInput,
};

export type CreateTransactionRelationMutation = {
  createTransactionRelation?:  {
    __typename: "TransactionRelation",
    transactionid?: number | null,
    transactiontypecd?: string | null,
    objecttype?: string | null,
    objectid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    linkedamount?: number | null,
    objectattribute?: string | null,
    isdirect?: number | null,
    lastupdatedby?: string | null,
    accountid?: number | null,
    paymentvouchernumber?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreateSetOffMutationVariables = {
  sourceinvoiceid: number,
  sourcetransactiontype: string,
  targetinvoiceid: number,
  targettransactiontype: string,
  setoffamount: number,
};

export type CreateSetOffMutation = {
  createSetOff?:  {
    __typename: "SetOffResponse",
    success: boolean,
    message?: string | null,
  } | null,
};

export type CreateSetOffBatchMutationVariables = {
  targetaccountid: number,
  targetinvoiceid: number,
  targettransactiontype: string,
  setoffitems: Array< SetOffItemInput >,
};

export type CreateSetOffBatchMutation = {
  createSetOffBatch?:  Array< {
    __typename: "SetOffResponse",
    success: boolean,
    message?: string | null,
  } | null > | null,
};

export type CreateInvoicePOSDetailsMutationVariables = {
  createInvoicePOSDetailsInput: CreateInvoicePOSDetailsInput,
};

export type CreateInvoicePOSDetailsMutation = {
  createInvoicePOSDetails?:  {
    __typename: "InvoicePOSDetails",
    posid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    partyposid: number,
    lastupdatedby?: string | null,
    relatedposparty?:  Array< {
      __typename: "POSParty",
      pospartyid?: number | null,
      companyid?: number | null,
      partyname?: string | null,
      partycontactnumberid?: number | null,
      lastupdatedby?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      relatedphonecontacts?:  Array< {
        __typename: "PhoneContacts",
        id?: number | null,
        objecttype?: string | null,
        objectid?: string | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        countrycode?: string | null,
        phonenumber?: string | null,
        verifieddatetime?: number | null,
        promotionssignup?: string | null,
        smsallowed?: string | null,
        callallowed?: string | null,
        whatsappallowed?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
    } | null > | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreatePOSPartyMutationVariables = {
  createPOSPartyInput?: CreatePOSPartyInput | null,
};

export type CreatePOSPartyMutation = {
  createPOSParty?:  {
    __typename: "POSParty",
    pospartyid?: number | null,
    companyid?: number | null,
    partyname?: string | null,
    partycontactnumberid?: number | null,
    lastupdatedby?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    relatedphonecontacts?:  Array< {
      __typename: "PhoneContacts",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      countrycode?: string | null,
      phonenumber?: string | null,
      verifieddatetime?: number | null,
      promotionssignup?: string | null,
      smsallowed?: string | null,
      callallowed?: string | null,
      whatsappallowed?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
  } | null,
};

export type CreatePhoneContactsMutationVariables = {
  createPhoneContactsInput?: Array< CreatePhoneContactsInput | null > | null,
};

export type CreatePhoneContactsMutation = {
  createPhoneContacts?:  Array< {
    __typename: "PhoneContacts",
    id?: number | null,
    objecttype?: string | null,
    objectid?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    countrycode?: string | null,
    phonenumber?: string | null,
    verifieddatetime?: number | null,
    promotionssignup?: string | null,
    smsallowed?: string | null,
    callallowed?: string | null,
    whatsappallowed?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreateNumberTrackerMutationVariables = {
  createNumberTrackerInput?: Array< CreateNumberTrackerInput | null > | null,
};

export type CreateNumberTrackerMutation = {
  createNumberTracker?:  Array< {
    __typename: "NumberTracker",
    id?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    financialyearid?: number | null,
    entrytypecd?: string | null,
    serialnumber?: string | null,
    serialisactive?: number | null,
    serialisused?: number | null,
    nextinvoicenumber?: number | null,
    prefix?: string | null,
    suffix?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialflag?: number | null,
    startinvoicenumber?: number | null,
    taxability?: number | null,
    lastused?: number | null,
    secondlastused?: number | null,
    restrictedflag?: number | null,
  } | null > | null,
};

export type CreatePartyAddressEntityMutationVariables = {
  createPartyAddressEntityInput: Array< CreatePartyAddressEntityInput | null >,
};

export type CreatePartyAddressEntityMutation = {
  createPartyAddressEntity:  Array< {
    __typename: "AddressEntity",
    id?: number | null,
    objecttype?: string | null,
    objectid?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    line1?: string | null,
    line2?: string | null,
    line3?: string | null,
    city?: string | null,
    statecode?: string | null,
    statename?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    pincode?: string | null,
    countrycode?: string | null,
    codevalue?: string | null,
    district?: string | null,
    lastupdatedby?: string | null,
    godownname?: string | null,
    gstin?: string | null,
    phone?: string | null,
    email?: string | null,
    personincharge?: string | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    foreignstate?: string | null,
    foreigndistrict?: string | null,
    defaultflag?: number | null,
    addresstitle?: string | null,
    addressindex?: number | null,
  } >,
};

export type CreateCompanyDocumentsMutationVariables = {
  createCompanyDocumentsInput: Array< CreateCompanyDocumentsInput >,
};

export type CreateCompanyDocumentsMutation = {
  createCompanyDocuments:  Array< {
    __typename: "CompanyDocuments",
    id?: number | null,
    companyid?: number | null,
    partyid?: number | null,
    documenttype?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    imagename?: string | null,
    imageurl?: string | null,
    lastupdatedby?: string | null,
    isactive?: number | null,
    type?: string | null,
    documentname?: string | null,
  } >,
};

export type CreateEmailContactsMutationVariables = {
  createEmailContactsInput: CreateEmailContactsInput,
};

export type CreateEmailContactsMutation = {
  createEmailContacts?:  {
    __typename: "EmailContacts",
    id: number,
    objecttype: string,
    objectid: string,
    enteredtimestamp: number,
    expiredtimestamp: number,
    emailaddress: string,
    verifieddatetime?: number | null,
    promotionssignup?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
  } | null,
};

export type CreateMultipleTestEntriesMutationVariables = {
  inputArray: Array< TestInput >,
};

export type CreateMultipleTestEntriesMutation = {
  createMultipleTestEntries:  Array< {
    __typename: "TestEntry",
    id: string,
    name: string,
    value: number,
  } >,
};

export type CreateEInvoiceMasterMutationVariables = {
  eInvoiceMasterInputs: Array< eInvoiceMasterInput >,
};

export type CreateEInvoiceMasterMutation = {
  createEInvoiceMaster:  Array< {
    __typename: "eInvoiceMaster",
    id?: number | null,
    invoiceid?: number | null,
    invoicetype: string,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    ackno?: string | null,
    ackdt?: number | null,
    irn?: string | null,
    signedqrcode?: string | null,
    lastupdatedby?: string | null,
    is_cancelled?: number | null,
    cancel_reason?: string | null,
    cancel_remarks?: string | null,
  } >,
};

export type CreateEInvoiceUsersMutationVariables = {
  eInvoiceUsersInputs: Array< EInvoiceUsersInput >,
};

export type CreateEInvoiceUsersMutation = {
  createEInvoiceUsers:  Array< {
    __typename: "EInvoiceUsers",
    id?: number | null,
    companyid?: number | null,
    username?: string | null,
    password?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    is_active?: number | null,
    lastupdatedby?: string | null,
  } >,
};

export type CreateItemMasterMutationVariables = {
  createItemMasterInput: CreateItemMasterInput,
};

export type CreateItemMasterMutation = {
  createItemMaster?:  {
    __typename: "itemmaster",
    itemid?: number | null,
    itemcode?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    itemname?: string | null,
    salesinvoiceflag?: number | null,
    purchaseinvoiceflag?: number | null,
    itemcategorycd?: string | null,
    measurementcd?: string | null,
    currencycd?: string | null,
    salesaccountid?: number | null,
    purchaseaccountid?: number | null,
    taxabilitycd?: string | null,
    reversechargeflag?: number | null,
    itemtype?: string | null,
    hsnid?: string | null,
    is_active?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relateditemamountdetails?:  Array< {
      __typename: "ItemAmountDetails",
      id?: number | null,
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      amount?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstcompensationvalue?: number | null,
      gstrate?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      invoicetype?: number | null,
      pricetype?: string | null,
      isactive?: number | null,
      isdefault?: number | null,
      pricetypeid?: number | null,
      tabletype?: number | null,
    } | null > | null,
    relateditemgstdetails?:  Array< {
      __typename: "ItemGstDetails",
      itemid: number,
      companyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      hsnid: string,
      gstcesstype: string,
      gstcompensationvalue: number,
      effectivedate?: number | null,
      expireddate?: number | null,
      gstcessvalue?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relateditemimages?:  Array< {
      __typename: "ItemImages",
      attachmentid?: number | null,
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      imagename?: string | null,
      imageurl?: string | null,
      documentname?: string | null,
      type?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    serialnumber?: string | null,
    financialyearid?: number | null,
    description?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsncodevalue?: string | null,
    hsndescription?: string | null,
    cessexist?: number | null,
    barcode?: string | null,
  } | null,
};

export type CreateItemAmountDetailsMutationVariables = {
  createItemAmountDetailsInput: Array< CreateItemAmountDetailsInput >,
};

export type CreateItemAmountDetailsMutation = {
  createItemAmountDetails:  Array< {
    __typename: "ItemAmountDetails",
    id?: number | null,
    itemid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    amount?: number | null,
    effectivedate?: number | null,
    expireddate?: number | null,
    hsnid?: string | null,
    gstcompensationtype?: string | null,
    gstcompensationvalue?: number | null,
    gstrate?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    invoicetype?: number | null,
    pricetype?: string | null,
    isactive?: number | null,
    isdefault?: number | null,
    pricetypeid?: number | null,
    tabletype?: number | null,
  } >,
};

export type CreateItemImagesMutationVariables = {
  createItemImagesInput: Array< CreateItemImagesInput >,
};

export type CreateItemImagesMutation = {
  createItemImages:  Array< {
    __typename: "ItemImages",
    attachmentid?: number | null,
    itemid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    imagename?: string | null,
    imageurl?: string | null,
    documentname?: string | null,
    type?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } >,
};

export type CreatePartyMasterMutationVariables = {
  createPartyMasterInput: CreatePartyMasterInput,
};

export type CreatePartyMasterMutation = {
  createPartyMaster?:  {
    __typename: "partymaster",
    partyid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    partytypecd?: string | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    groupaccountid?: number | null,
    gstcategory?: string | null,
    placeofsupply?: string | null,
    entity?: string | null,
    email?: string | null,
    contactnumber?: string | null,
    whatsappnumber?: string | null,
    accountsid?: number | null,
    is_active?: number | null,
    msmetype?: string | null,
    deliveryconsigneename?: string | null,
    deliveryconsigneegstin?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedpartygstdetails?:  Array< {
      __typename: "PartyGSTDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      pannumber?: string | null,
      gstin?: string | null,
      partyaddressid?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycreditdetails?:  Array< {
      __typename: "PartyCreditDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      creditperiodduration?: string | null,
      billingcurrency?: string | null,
      creditlimitcd?: number | null,
      creditlimitamount?: number | null,
      billwiseflag?: number | null,
      notes?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycontact?:  Array< {
      __typename: "PartyContact",
      partyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      contacttypename: string,
      contactdesignationname: string,
      contactorder: number,
      email: string,
      phonenumber?: string | null,
      whatsappnumber?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
    } | null > | null,
    relatedpartyimages?:  Array< {
      __typename: "PartyImages",
      attachmentid?: number | null,
      partyid: number,
      companyid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      type: string,
      documentname: string,
      imagename: string,
      imageurl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    tdspercentage?: number | null,
    udhyamregno?: string | null,
    sameaddressflag?: number | null,
    comments?: string | null,
    tdssection?: string | null,
    accountname?: string | null,
    deliverystatecode?: number | null,
    deliverystatename?: string | null,
    contactcountry?: string | null,
    whatsappcountry?: string | null,
    entityname?: string | null,
  } | null,
};

export type CreatePartyContactMutationVariables = {
  createPartyContactInput: Array< CreatePartyContactInput >,
};

export type CreatePartyContactMutation = {
  createPartyContact:  Array< {
    __typename: "PartyContact",
    partyid: number,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    contacttypename: string,
    contactdesignationname: string,
    contactorder: number,
    email: string,
    phonenumber?: string | null,
    whatsappnumber?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    contactcountry?: string | null,
    whatsappcountry?: string | null,
  } >,
};

export type CreatePartyImagesMutationVariables = {
  createPartyImagesInput: Array< CreatePartyImagesInput >,
};

export type CreatePartyImagesMutation = {
  createPartyImages:  Array< {
    __typename: "PartyImages",
    attachmentid?: number | null,
    partyid: number,
    companyid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    type: string,
    documentname: string,
    imagename: string,
    imageurl: string,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } >,
};

export type CreateInvoiceMasterMutationVariables = {
  createInvoiceMasterInput: CreateInvoiceMasterInput,
};

export type CreateInvoiceMasterMutation = {
  createInvoiceMaster?:  {
    __typename: "Invoicemaster",
    invoiceid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoicetypecd?: string | null,
    partyid?: number | null,
    paymentaccountid?: number | null,
    invoicedate?: number | null,
    invoicenumber?: string | null,
    customerordernumber?: string | null,
    customerorderdate?: number | null,
    invoiceamount?: number | null,
    paymenttype?: string | null,
    creditduration?: number | null,
    invoicebillingaddressid?: number | null,
    invoicedeliveryaddressid?: number | null,
    invoicetaxabletypecd?: string | null,
    receipturl?: string | null,
    invoicelinetypecd?: string | null,
    invoicecurrencycd?: string | null,
    exchangerate?: number | null,
    comments?: string | null,
    receivedamount?: number | null,
    adjustmentamount?: number | null,
    placeofsupply?: string | null,
    balancedueamount?: number | null,
    reversechargeflag?: number | null,
    tcsapplicableflag?: number | null,
    relatedinvoicetcsdetails?:  Array< {
      __typename: "InvoiceTCSDetails",
      invoiceid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedinvoicelineitems?:  Array< {
      __typename: "InvoiceLineItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemnumber?: number | null,
      invoicelineitemtype?: string | null,
      itemid?: number | null,
      quantity?: number | null,
      unittypecd?: string | null,
      itemrate?: number | null,
      itemamount?: number | null,
      itemdiscount?: number | null,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      salesaccountname?: string | null,
      salesaccountid?: number | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      itemmaster_timestamp?: number | null,
      description?: string | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoicelinenonitems?:  Array< {
      __typename: "InvoiceLineNonItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      invoicelineitemtype?: string | null,
      incomeaccountid?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      itemdescription?: string | null,
      taxableamount?: number | null,
      netamount?: number | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      incomeaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoiceattachment?:  Array< {
      __typename: "InvoiceAttachment",
      invoiceid?: number | null,
      attachmentid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      attachmentname?: string | null,
      attachmenturl?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedinvoicedispatch?:  Array< {
      __typename: "InvoiceDispatch",
      invoiceid: number,
      dispatchid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transportationcd: string,
      vehiclenumber: string,
      dispatchdate: number,
      ewaybillnumber: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoiceposdetails?:  Array< {
      __typename: "InvoicePOSDetails",
      posid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      partyposid: number,
      lastupdatedby?: string | null,
      relatedposparty?:  Array< {
        __typename: "POSParty",
        pospartyid?: number | null,
        companyid?: number | null,
        partyname?: string | null,
        partycontactnumberid?: number | null,
        lastupdatedby?: string | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        relatedphonecontacts?:  Array< {
          __typename: "PhoneContacts",
          id?: number | null,
          objecttype?: string | null,
          objectid?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          countrycode?: string | null,
          phonenumber?: string | null,
          verifieddatetime?: number | null,
          promotionssignup?: string | null,
          smsallowed?: string | null,
          callallowed?: string | null,
          whatsappallowed?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
      } | null > | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinegst?:  Array< {
      __typename: "InvoiceLineGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinenongst?:  Array< {
      __typename: "InvoiceLineNonGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicenumbertracker?:  Array< {
      __typename: "InvoiceNumberTracker",
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      nextinvoicenumber: string,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedinvoicetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedinvoiceaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    companystate?: string | null,
    cancelremark?: string | null,
    deleteremark?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    serialnumber?: string | null,
    serialflag?: number | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    paymentstatus?: number | null,
    ackno?: string | null,
    ackdt?: number | null,
    irn?: string | null,
    signedqrcode?: string | null,
    partyemail?: string | null,
    invoicepdf?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    partygstcategory?: string | null,
    is_cancelled?: number | null,
    cancel_reason?: string | null,
    cancel_remarks?: string | null,
    phonenumber?: string | null,
    bankaccountid?: number | null,
    bankamount?: number | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    ewaybill_cancel_rsn_code?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    invoicetype?: string | null,
    accountname?: string | null,
    partyisactive?: number | null,
    goods_exist?: number | null,
    overduedays?: number | null,
    duedatetimestamp?: number | null,
    isvouchereditable?: number | null,
    itcflag?: number | null,
    taxability?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
  } | null,
};

export type CreateInvoiceAttachmentMutationVariables = {
  createInvoiceAttachmentInput?: Array< CreateInvoiceAttachmentInput | null > | null,
};

export type CreateInvoiceAttachmentMutation = {
  createInvoiceAttachment?:  Array< {
    __typename: "InvoiceAttachment",
    invoiceid?: number | null,
    attachmentid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    attachmentname?: string | null,
    attachmenturl?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    documentname?: string | null,
    type?: string | null,
  } | null > | null,
};

export type CreateInvoiceDispatchMutationVariables = {
  createInvoiceDispatchInput?: Array< CreateInvoiceDispatchInput | null > | null,
};

export type CreateInvoiceDispatchMutation = {
  createInvoiceDispatch?:  Array< {
    __typename: "InvoiceDispatch",
    invoiceid: number,
    dispatchid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    transportationcd: string,
    vehiclenumber: string,
    dispatchdate: number,
    ewaybillnumber: string,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreateInvoiceLineGSTMutationVariables = {
  createInvoiceLineGSTInput?: Array< CreateInvoiceLineGSTInput | null > | null,
};

export type CreateInvoiceLineGSTMutation = {
  createInvoiceLineGST?:  Array< {
    __typename: "InvoiceLineGST",
    invoiceid: number,
    invoiceitemid: number,
    companyid: number,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    gstrate?: number | null,
    gsttypecd?: string | null,
    gstamount?: number | null,
    cessamount?: number | null,
    cessrate?: number | null,
    cesstype?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreateInvoiceLineItemsMutationVariables = {
  createInvoiceLineItemsInput?: Array< CreateInvoiceLineItemsInput | null > | null,
};

export type CreateInvoiceLineItemsMutation = {
  createInvoiceLineItems?:  Array< {
    __typename: "InvoiceLineItems",
    invoiceid?: number | null,
    invoiceitemid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    lineitemnumber?: number | null,
    invoicelineitemtype?: string | null,
    itemid?: number | null,
    quantity?: number | null,
    unittypecd?: string | null,
    itemrate?: number | null,
    itemamount?: number | null,
    itemdiscount?: number | null,
    discounttype?: string | null,
    discountrate?: number | null,
    netamount?: number | null,
    hsnsaccode?: string | null,
    taxability?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    pricetype?: string | null,
    lotid?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsncodevalue?: string | null,
    hsndescription?: string | null,
    gstrate?: number | null,
    gsttypecd?: string | null,
    gstamount?: number | null,
    cessamount?: number | null,
    unit?: string | null,
    uqc?: string | null,
    salesaccountname?: string | null,
    salesaccountid?: number | null,
    itemname?: string | null,
    itemcode?: string | null,
    itemtype?: string | null,
    manualdiscount?: number | null,
    manualcess?: number | null,
    itemmaster_timestamp?: number | null,
    description?: string | null,
    relatedinvoicelinegst?:  Array< {
      __typename: "InvoiceLineGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relateditemmaster?:  Array< {
      __typename: "itemmaster",
      itemid?: number | null,
      itemcode?: string | null,
      companyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      itemname?: string | null,
      salesinvoiceflag?: number | null,
      purchaseinvoiceflag?: number | null,
      itemcategorycd?: string | null,
      measurementcd?: string | null,
      currencycd?: string | null,
      salesaccountid?: number | null,
      purchaseaccountid?: number | null,
      taxabilitycd?: string | null,
      reversechargeflag?: number | null,
      itemtype?: string | null,
      hsnid?: string | null,
      is_active?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relateditemamountdetails?:  Array< {
        __typename: "ItemAmountDetails",
        id?: number | null,
        itemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        amount?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstcompensationvalue?: number | null,
        gstrate?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        lastupdatedby?: string | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        invoicetype?: number | null,
        pricetype?: string | null,
        isactive?: number | null,
        isdefault?: number | null,
        pricetypeid?: number | null,
        tabletype?: number | null,
      } | null > | null,
      relateditemgstdetails?:  Array< {
        __typename: "ItemGstDetails",
        itemid: number,
        companyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        hsnid: string,
        gstcesstype: string,
        gstcompensationvalue: number,
        effectivedate?: number | null,
        expireddate?: number | null,
        gstcessvalue?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemimages?:  Array< {
        __typename: "ItemImages",
        attachmentid?: number | null,
        itemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        imagename?: string | null,
        imageurl?: string | null,
        documentname?: string | null,
        type?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      serialnumber?: string | null,
      financialyearid?: number | null,
      description?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      cessexist?: number | null,
      barcode?: string | null,
    } | null > | null,
    pricetypeid?: number | null,
    manualgst?: number | null,
    cessrate?: number | null,
    cesstype?: string | null,
  } | null > | null,
};

export type CreateInvoiceLineNonGSTMutationVariables = {
  createInvoiceLineNonGSTInput?: Array< CreateInvoiceLineNonGSTInput | null > | null,
};

export type CreateInvoiceLineNonGSTMutation = {
  createInvoiceLineNonGST?:  Array< {
    __typename: "InvoiceLineNonGST",
    invoiceid: number,
    invoiceitemid: number,
    companyid: number,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    gstrate?: number | null,
    gsttypecd?: string | null,
    gstamount?: number | null,
    cessamount?: number | null,
    cessrate?: number | null,
    cesstype?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreateInvoiceLineNonItemsMutationVariables = {
  createInvoiceLineNonItemsInput?: Array< CreateInvoiceLineNonItemsInput | null > | null,
};

export type CreateInvoiceLineNonItemsMutation = {
  createInvoiceLineNonItems?:  Array< {
    __typename: "InvoiceLineNonItems",
    invoiceid?: number | null,
    invoiceitemid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoicelineitemtype?: string | null,
    incomeaccountid?: number | null,
    hsnsaccode?: string | null,
    taxability?: string | null,
    itemdescription?: string | null,
    taxableamount?: number | null,
    netamount?: number | null,
    relatedaccounts?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsncodevalue?: string | null,
    hsndescription?: string | null,
    gstrate?: number | null,
    gsttypecd?: string | null,
    gstamount?: number | null,
    cessamount?: number | null,
    incomeaccountname?: string | null,
    manualgst?: number | null,
    manualcess?: number | null,
    cessrate?: number | null,
    cesstype?: string | null,
  } | null > | null,
};

export type CreateCompanyCodeTranslationArrayMutationVariables = {
  createCompanyCodeTranslationArrayInput: Array< CreateCompanyCodeTranslationArrayInput >,
};

export type CreateCompanyCodeTranslationArrayMutation = {
  createCompanyCodeTranslationArray:  Array< {
    __typename: "CompanyCodeTranslation",
    id?: number | null,
    companyid?: number | null,
    codetype?: string | null,
    codevalue?: string | null,
    language?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    codetext?: string | null,
    codeorder?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
    uqc?: string | null,
    is_active?: string | null,
    section?: string | null,
  } >,
};

export type CreateInvoiceTCSDetailsMutationVariables = {
  createInvoiceTCSDetailsInput?: Array< CreateInvoiceTCSDetailsInput | null > | null,
};

export type CreateInvoiceTCSDetailsMutation = {
  createInvoiceTCSDetails?:  Array< {
    __typename: "InvoiceTCSDetails",
    invoiceid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    tcsapplicablecd?: number | null,
    totaltaxableamount?: number | null,
    ineligibletcflag?: number | null,
    reversechargeflag?: number | null,
    gstcesstotal?: number | null,
    tcsamount?: number | null,
    adjustmentamount?: number | null,
    tcssection?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    tcspercentage?: number | null,
    tcsmanual?: number | null,
  } | null > | null,
};

export type CreatePurchaseLineGSTMutationVariables = {
  createPurchaseLineGSTInput?: Array< CreatePurchaseLineGSTInput | null > | null,
};

export type CreatePurchaseLineGSTMutation = {
  createPurchaseLineGST?:  Array< {
    __typename: "PurchaseLineGST",
    purchaseid: number,
    purchaseitemid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    gstrate: number,
    cessamount: number,
    gstamount: number,
    cessrate?: number | null,
    cesstype?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreatePurchaseAttachmentMutationVariables = {
  createPurchaseAttachmentInput?: Array< CreatePurchaseAttachmentInput | null > | null,
};

export type CreatePurchaseAttachmentMutation = {
  createPurchaseAttachment?:  Array< {
    __typename: "PurchaseAttachment",
    purchaseid: number,
    attachmentid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    attachmentname: string,
    attachmenturl: string,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    documentname?: string | null,
    type?: string | null,
  } | null > | null,
};

export type CreatePurchaseLineItemsMutationVariables = {
  createPurchaseLineItemsInput?: Array< CreatePurchaseLineItemsInput | null > | null,
};

export type CreatePurchaseLineItemsMutation = {
  createPurchaseLineItems?:  Array< {
    __typename: "PurchaseLineItems",
    purchaseid: number,
    purchaseitemid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    itemnumber: number,
    itemid: number,
    purchaseaccountid: number,
    hsncode: string,
    itemquantity: number,
    unittypecd: string,
    itemrate: number,
    itemamount: number,
    itemdiscount: number,
    discounttype?: string | null,
    discountrate?: number | null,
    netamount: number,
    relatedpurchaselinegst?:  Array< {
      __typename: "PurchaseLineGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relateditemmaster?:  Array< {
      __typename: "itemmaster",
      itemid?: number | null,
      itemcode?: string | null,
      companyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      itemname?: string | null,
      salesinvoiceflag?: number | null,
      purchaseinvoiceflag?: number | null,
      itemcategorycd?: string | null,
      measurementcd?: string | null,
      currencycd?: string | null,
      salesaccountid?: number | null,
      purchaseaccountid?: number | null,
      taxabilitycd?: string | null,
      reversechargeflag?: number | null,
      itemtype?: string | null,
      hsnid?: string | null,
      is_active?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relateditemamountdetails?:  Array< {
        __typename: "ItemAmountDetails",
        id?: number | null,
        itemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        amount?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstcompensationvalue?: number | null,
        gstrate?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        lastupdatedby?: string | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        invoicetype?: number | null,
        pricetype?: string | null,
        isactive?: number | null,
        isdefault?: number | null,
        pricetypeid?: number | null,
        tabletype?: number | null,
      } | null > | null,
      relateditemgstdetails?:  Array< {
        __typename: "ItemGstDetails",
        itemid: number,
        companyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        hsnid: string,
        gstcesstype: string,
        gstcompensationvalue: number,
        effectivedate?: number | null,
        expireddate?: number | null,
        gstcessvalue?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemimages?:  Array< {
        __typename: "ItemImages",
        attachmentid?: number | null,
        itemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        imagename?: string | null,
        imageurl?: string | null,
        documentname?: string | null,
        type?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      serialnumber?: string | null,
      financialyearid?: number | null,
      description?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      cessexist?: number | null,
      barcode?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    taxability?: string | null,
    pricetype?: string | null,
    lotid?: string | null,
    hsnid?: string | null,
    hsncodetype?: string | null,
    hsndescription?: string | null,
    gstrate?: number | null,
    gstamount?: number | null,
    cessamount?: number | null,
    unit?: string | null,
    uqc?: string | null,
    purchaseaccountname?: string | null,
    itemname?: string | null,
    itemcode?: string | null,
    itemtype?: string | null,
    manualdiscount?: number | null,
    manualcess?: number | null,
    pricetypeid?: number | null,
    manualgst?: number | null,
    cessrate?: number | null,
    cesstype?: string | null,
  } | null > | null,
};

export type CreatePurchaseLineNonGSTMutationVariables = {
  createPurchaseLineNonGSTInput?: Array< CreatePurchaseLineNonGSTInput | null > | null,
};

export type CreatePurchaseLineNonGSTMutation = {
  createPurchaseLineNonGST?:  Array< {
    __typename: "PurchaseLineNonGST",
    purchaseid: number,
    purchaseitemid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    gstrate: number,
    cessamount: number,
    gstamount: number,
    cessrate?: number | null,
    cesstype?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreatePurchaseLineNonItemsMutationVariables = {
  createPurchaseLineNonItemsInput?: Array< CreatePurchaseLineNonItemsInput | null > | null,
};

export type CreatePurchaseLineNonItemsMutation = {
  createPurchaseLineNonItems?:  Array< {
    __typename: "PurchaseLineNonItems",
    purchaseid: number,
    purchaseitemid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    purchaselineitemtype: string,
    purchaseaccountid: number,
    hsnsaccode: string,
    itemdescription: string,
    taxableamount: number,
    netamount: number,
    relatedpurchaselinenongst?:  Array< {
      __typename: "PurchaseLineNonGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    taxability?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsncodevalue?: string | null,
    hsndescription?: string | null,
    gstrate?: number | null,
    gstamount?: number | null,
    cessamount?: number | null,
    purchaseaccountname?: string | null,
    manualgst?: number | null,
    manualcess?: number | null,
    cessrate?: number | null,
    cesstype?: string | null,
  } | null > | null,
};

export type CreatePurchaseTCSDetailsMutationVariables = {
  createPurchaseTCSDetailsInput?: Array< CreatePurchaseTCSDetailsInput | null > | null,
};

export type CreatePurchaseTCSDetailsMutation = {
  createPurchaseTCSDetails?:  Array< {
    __typename: "PurchaseTCSDetails",
    purchaseid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    tcsapplicablecd?: number | null,
    totaltaxableamount?: number | null,
    ineligibletcflag?: number | null,
    reversechargeflag?: number | null,
    gstcesstotal?: number | null,
    tcsamount?: number | null,
    adjustmentamount?: number | null,
    tcssection?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    tcspercentage?: number | null,
    tcsmanual?: number | null,
  } | null > | null,
};

export type CreatePurchaseTDSDetailsMutationVariables = {
  createPurchaseTDSDetailsInput?: Array< CreatePurchaseTDSDetailsInput | null > | null,
};

export type CreatePurchaseTDSDetailsMutation = {
  createPurchaseTDSDetails?:  Array< {
    __typename: "PurchaseTDSDetails",
    purchaseid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    tdsapplicablecd?: number | null,
    totaltaxableamount?: number | null,
    ineligibletcflag?: number | null,
    reversechargeflag?: number | null,
    gstcesstotal?: number | null,
    tdsamount?: number | null,
    adjustmentamount?: number | null,
    tdssection?: string | null,
    tdspercentage?: number | null,
    tdsmanual?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreatePurchaseMasterMutationVariables = {
  createPurchaseMasterInput: CreatePurchaseMasterInput,
};

export type CreatePurchaseMasterMutation = {
  createPurchaseMaster?:  {
    __typename: "PurchaseMaster",
    purchaseid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    purchasegsttypecd?: string | null,
    supplierid?: number | null,
    entrydate?: number | null,
    vouchernumber?: string | null,
    supplierinvoicedate?: number | null,
    supplierinvoicenumber?: string | null,
    supplieraddressid?: number | null,
    paymenttypecd?: string | null,
    paidamount?: number | null,
    creditduration?: number | null,
    paymentaccountid?: number | null,
    comments?: string | null,
    tdsapplicableflag?: number | null,
    granttotalamount?: number | null,
    balancedueamount?: number | null,
    paymentclearedflag?: number | null,
    placeofsupply?: string | null,
    companystate?: string | null,
    relatedpurchasetdsdetails?:  Array< {
      __typename: "PurchaseTDSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tdsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tdsamount?: number | null,
      adjustmentamount?: number | null,
      tdssection?: string | null,
      tdspercentage?: number | null,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchasetcsdetails?:  Array< {
      __typename: "PurchaseTCSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedpurchaselineitems?:  Array< {
      __typename: "PurchaseLineItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      itemnumber: number,
      itemid: number,
      purchaseaccountid: number,
      hsncode: string,
      itemquantity: number,
      unittypecd: string,
      itemrate: number,
      itemamount: number,
      itemdiscount: number,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount: number,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnid?: string | null,
      hsncodetype?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      purchaseaccountname?: string | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinenonitems?:  Array< {
      __typename: "PurchaseLineNonItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchaselineitemtype: string,
      purchaseaccountid: number,
      hsnsaccode: string,
      itemdescription: string,
      taxableamount: number,
      netamount: number,
      relatedpurchaselinenongst?:  Array< {
        __typename: "PurchaseLineNonGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      purchaseaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinegst?:  Array< {
      __typename: "PurchaseLineGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaselinenongst?:  Array< {
      __typename: "PurchaseLineNonGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaseattachment?:  Array< {
      __typename: "PurchaseAttachment",
      purchaseid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedpurchasetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpartyaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedpurchaseaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    cancelflag?: number | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    adjustmentamount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    reversechargeflag?: number | null,
    overduedays?: number | null,
    paymentstatus?: number | null,
    partyregistrationtype?: string | null,
    purchaseinvoicepdf?: string | null,
    partygstcategory?: string | null,
    partyemail?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    accountname?: string | null,
    duedatetimestamp?: number | null,
    partyisactive?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    isvouchereditable?: number | null,
    goods_exist?: number | null,
    itcflag?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
    totalgstamount?: number | null,
    tdsamount?: number | null,
    tcsamount?: number | null,
    taxableamount?: number | null,
    igstamount?: number | null,
    cgstamount?: number | null,
    sgstamount?: number | null,
    cessamount?: number | null,
    sourceofsupply?: string | null,
    taxabilitylabel?: string | null,
    additionaldiscount?: number | null,
    netinvoiceamount?: number | null,
  } | null,
};

export type CreateCrDrAttachmentMutationVariables = {
  createCrDrAttachmentInput?: Array< CreateCrDrAttachmentInput | null > | null,
};

export type CreateCrDrAttachmentMutation = {
  createCrDrAttachment?:  Array< {
    __typename: "CrDrAttachment",
    crdrnoteid?: number | null,
    attachmentid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    attachmentname?: string | null,
    attachmenturl?: string | null,
    userid?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    documentname?: string | null,
    type?: string | null,
  } | null > | null,
};

export type CreateCrDrNoteDetailsMutationVariables = {
  createCrDrNoteDetailsInput?: Array< CreateCrDrNoteDetailsInput | null > | null,
};

export type CreateCrDrNoteDetailsMutation = {
  createCrDrNoteDetails?:  Array< {
    __typename: "CrDrNoteDetails",
    crdrnoteid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    totaltaxableamount?: number | null,
    totalgst?: number | null,
    totalgstcess?: number | null,
    totaladjustments?: number | null,
    comments?: string | null,
    accountid?: number | null,
    partamount?: number | null,
    transportationcd?: string | null,
    vehiclenumber?: string | null,
    dispatchdate?: number | null,
    ewaybillnumber?: string | null,
    userid?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreateCrDrNoteDispatchMutationVariables = {
  createCrDrNoteDispatchInput?: Array< CreateCrDrNoteDispatchInput | null > | null,
};

export type CreateCrDrNoteDispatchMutation = {
  createCrDrNoteDispatch?:  Array< {
    __typename: "CrDrNoteDispatch",
    crdrnoteid: number,
    dispatchid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    transportationcd: string,
    vehiclenumber: string,
    dispatchdate: number,
    ewaybillnumber: string,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreateCrDrNoteInvoicesMutationVariables = {
  createCrDrNoteInvoicesInput?: Array< CreateCrDrNoteInvoicesInput | null > | null,
};

export type CreateCrDrNoteInvoicesMutation = {
  createCrDrNoteInvoices?:  Array< {
    __typename: "CrDrNoteInvoices",
    crdrnoteid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoiceid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
  } | null > | null,
};

export type CreateCrDrNoteLineItemsMutationVariables = {
  createCrDrNoteLineItemsInput?: Array< CreateCrDrNoteLineItemsInput | null > | null,
};

export type CreateCrDrNoteLineItemsMutation = {
  createCrDrNoteLineItems?:  Array< {
    __typename: "CrDrNoteLineItems",
    crdrnoteid?: number | null,
    crdrnoteitemid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    lineitemnumber?: number | null,
    lineitemtype?: string | null,
    itemid?: number | null,
    quantity?: number | null,
    unittypecd?: string | null,
    itemrate?: number | null,
    itemamount?: number | null,
    itemdiscount?: number | null,
    discounttype?: string | null,
    discountrate?: number | null,
    gstrate?: number | null,
    gsttypecd?: string | null,
    gstamount?: number | null,
    gstcess?: number | null,
    hsnsaccode?: string | null,
    netamount?: number | null,
    userid?: string | null,
    taxability?: string | null,
    reason?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    pricetype?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsncodevalue?: string | null,
    hsndescription?: string | null,
    unit?: string | null,
    uqc?: string | null,
    salesaccountname?: string | null,
    purchaseaccountname?: string | null,
    salesaccountid?: number | null,
    purchaseaccountid?: number | null,
    itemname?: string | null,
    itemcode?: string | null,
    itemtype?: string | null,
    manualdiscount?: number | null,
    manualcess?: number | null,
    pricetypeid?: number | null,
    manualgst?: number | null,
    cessrate?: number | null,
    cesstype?: string | null,
  } | null > | null,
};

export type CreateCrDrNoteLineNonItemsMutationVariables = {
  createCrDrNoteLineNonItemsInput?: Array< CreateCrDrNoteLineNonItemsInput | null > | null,
};

export type CreateCrDrNoteLineNonItemsMutation = {
  createCrDrNoteLineNonItems?:  Array< {
    __typename: "CrDrNoteLineNonItems",
    crdrnoteid?: number | null,
    crdrnoteitemid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    lineitemtype?: string | null,
    ledgeraccountid?: number | null,
    hsnsaccode?: string | null,
    itemdescription?: string | null,
    taxableamount?: number | null,
    gstrate?: number | null,
    gsttypecd?: string | null,
    gstamount?: number | null,
    gstcess?: number | null,
    netamount?: number | null,
    userid?: string | null,
    taxability?: string | null,
    reason?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsncodevalue?: string | null,
    hsndescription?: string | null,
    ledgeraccountname?: string | null,
    manualgst?: number | null,
    manualcess?: number | null,
    cessrate?: number | null,
    cesstype?: string | null,
  } | null > | null,
};

export type CreateCrDrNoteTCSDetailsMutationVariables = {
  createCrDrNoteTCSDetailsInput?: Array< CreateCrDrNoteTCSDetailsInput | null > | null,
};

export type CreateCrDrNoteTCSDetailsMutation = {
  createCrDrNoteTCSDetails?:  Array< {
    __typename: "CrDrNoteTCSDetails",
    crdrnoteid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    tcsapplicablecd?: number | null,
    totaltaxableamount?: number | null,
    ineligibletcflag?: number | null,
    reversechargeflag?: number | null,
    gstcesstotal?: number | null,
    tcsamount?: number | null,
    adjustmentamount?: number | null,
    tcssection?: string | null,
    tcsmanual?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    tcspercentage?: number | null,
  } | null > | null,
};

export type CreateCrDrNoteTDSDetailsMutationVariables = {
  createCrDrNoteTDSDetailsInput?: Array< CreateCrDrNoteTDSDetailsInput | null > | null,
};

export type CreateCrDrNoteTDSDetailsMutation = {
  createCrDrNoteTDSDetails?:  Array< {
    __typename: "CrDrNoteTDSDetails",
    crdrnoteid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    tdsapplicablecd: number,
    totaltaxableamount: number,
    ineligibletcflag: number,
    reversechargeflag: number,
    gstcesstotal: number,
    tdsamount: number,
    adjustmentamount: number,
    tdssection?: string | null,
    tdspercentage?: number | null,
    tcsmanual?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CreateCrDrNoteMasterMutationVariables = {
  createCrDrNoteMasterInput: CreateCrDrNoteMasterInput,
};

export type CreateCrDrNoteMasterMutation = {
  createCrDrNoteMaster?:  {
    __typename: "CrDrNoteMaster",
    crdrnoteid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    crdrnotetypecd?: string | null,
    crdrnotedate?: number | null,
    crdrnotenumber?: string | null,
    invoicetypecd?: string | null,
    gsttypecd?: string | null,
    partyid?: number | null,
    deliveryaddressid?: number | null,
    paymenttype?: string | null,
    grandtotalamount?: number | null,
    transactionid?: number | null,
    userid?: string | null,
    creditduration?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    psflag?: number | null,
    reversechargeflag?: number | null,
    balancedueamount?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    companystate?: string | null,
    placeofsupply?: string | null,
    cancelflag?: number | null,
    cancelremark?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    adjustmentamount?: number | null,
    relatedcrdrnoteinvoices?:  Array< {
      __typename: "CrDrNoteInvoices",
      crdrnoteid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      invoiceid?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedcrdrattachment?:  Array< {
      __typename: "CrDrAttachment",
      crdrnoteid?: number | null,
      attachmentid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      attachmentname?: string | null,
      attachmenturl?: string | null,
      userid?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedcrdrnotedetails?:  Array< {
      __typename: "CrDrNoteDetails",
      crdrnoteid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      totaltaxableamount?: number | null,
      totalgst?: number | null,
      totalgstcess?: number | null,
      totaladjustments?: number | null,
      comments?: string | null,
      accountid?: number | null,
      partamount?: number | null,
      transportationcd?: string | null,
      vehiclenumber?: string | null,
      dispatchdate?: number | null,
      ewaybillnumber?: string | null,
      userid?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedcrdrnotelineitems?:  Array< {
      __typename: "CrDrNoteLineItems",
      crdrnoteid?: number | null,
      crdrnoteitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemnumber?: number | null,
      lineitemtype?: string | null,
      itemid?: number | null,
      quantity?: number | null,
      unittypecd?: string | null,
      itemrate?: number | null,
      itemamount?: number | null,
      itemdiscount?: number | null,
      discounttype?: string | null,
      discountrate?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      gstcess?: number | null,
      hsnsaccode?: string | null,
      netamount?: number | null,
      userid?: string | null,
      taxability?: string | null,
      reason?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pricetype?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      unit?: string | null,
      uqc?: string | null,
      salesaccountname?: string | null,
      purchaseaccountname?: string | null,
      salesaccountid?: number | null,
      purchaseaccountid?: number | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedcrdrnotelinenonitems?:  Array< {
      __typename: "CrDrNoteLineNonItems",
      crdrnoteid?: number | null,
      crdrnoteitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemtype?: string | null,
      ledgeraccountid?: number | null,
      hsnsaccode?: string | null,
      itemdescription?: string | null,
      taxableamount?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      gstcess?: number | null,
      netamount?: number | null,
      userid?: string | null,
      taxability?: string | null,
      reason?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      ledgeraccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedcrdrnotetcsdetails?:  Array< {
      __typename: "CrDrNoteTCSDetails",
      crdrnoteid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      tcsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
    } | null > | null,
    relatedcrdrnotetdsdetails?:  Array< {
      __typename: "CrDrNoteTDSDetails",
      crdrnoteid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      tdsapplicablecd: number,
      totaltaxableamount: number,
      ineligibletcflag: number,
      reversechargeflag: number,
      gstcesstotal: number,
      tdsamount: number,
      adjustmentamount: number,
      tdssection?: string | null,
      tdspercentage?: number | null,
      tcsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedcrdrnotedispatch?:  Array< {
      __typename: "CrDrNoteDispatch",
      crdrnoteid: number,
      dispatchid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transportationcd: string,
      vehiclenumber: string,
      dispatchdate: number,
      ewaybillnumber: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partamount?: number | null,
    originalinvoicenumber?: string | null,
    partyinvoicenumber?: string | null,
    totalgst?: number | null,
    totalgstcess?: number | null,
    totaltaxableamount?: number | null,
    totaladjustments?: number | null,
    comments?: string | null,
    accountid?: number | null,
    transportationcd?: string | null,
    vehiclenumber?: string | null,
    dispatchdate?: number | null,
    ewaybillnumber?: string | null,
    paymentstatus?: number | null,
    crdrnotepdf?: string | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    partygstcategory?: string | null,
    partyemail?: string | null,
    partytypecd?: string | null,
    partygstin?: string | null,
    accountname?: string | null,
    partyregistrationtype?: string | null,
    duedatetimestamp?: number | null,
    overduedays?: number | null,
    partyisactive?: number | null,
    isvouchereditable?: number | null,
    itcflag?: number | null,
    cessexist?: number | null,
  } | null,
};

export type UpdateAccountMasterMutationVariables = {
  updateAccountMasterInput: UpdateAccountMasterInput,
};

export type UpdateAccountMasterMutation = {
  updateAccountMaster?:  {
    __typename: "AccountMaster",
    accountsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    accountgroupid?: number | null,
    hsnsaccode?: string | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    accounttypeflag?: number | null,
    relatedaccountgstdetails?:  Array< {
      __typename: "AccountGSTDetails",
      accountid?: number | null,
      companyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstrate?: number | null,
      cessamount?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsaccode?: string | null,
      codetype?: string | null,
      description?: string | null,
      taxability?: string | null,
    } | null > | null,
    relatedaccountopeningbalance?:  Array< {
      __typename: "AccountOpeningBalance",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      financialyearid?: number | null,
      startdate?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedaccountgroupmaster?:  Array< {
      __typename: "AccountGroupMasterNew",
      accountgroupid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accounttypecd?: string | null,
      accountgroupname?: string | null,
      accountparentgroupid?: number | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      is_active?: number | null,
      restrictedflag?: number | null,
      path?: string | null,
    } | null > | null,
    relatedaccountbalance?:  Array< {
      __typename: "AccountBalanceNew",
      accountid?: number | null,
      accountbalance?: number | null,
      actualbalance?: number | null,
    } | null > | null,
    path?: string | null,
  } | null,
};

export type UpdateAccountGroupMasterMutationVariables = {
  updateAccountGroupMasterInput: UpdateAccountGroupMasterInput,
};

export type UpdateAccountGroupMasterMutation = {
  updateAccountGroupMaster?:  {
    __typename: "AccountGroupMaster",
    accountgroupid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accounttypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    relatedaccounts?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    path?: string | null,
  } | null,
};

export type DeleteAccountMasterMutationVariables = {
  accountsid: number,
};

export type DeleteAccountMasterMutation = {
  deleteAccountMaster?:  {
    __typename: "AccountMaster",
    accountsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    accountgroupid?: number | null,
    hsnsaccode?: string | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    accounttypeflag?: number | null,
    relatedaccountgstdetails?:  Array< {
      __typename: "AccountGSTDetails",
      accountid?: number | null,
      companyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstrate?: number | null,
      cessamount?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsaccode?: string | null,
      codetype?: string | null,
      description?: string | null,
      taxability?: string | null,
    } | null > | null,
    relatedaccountopeningbalance?:  Array< {
      __typename: "AccountOpeningBalance",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      financialyearid?: number | null,
      startdate?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedaccountgroupmaster?:  Array< {
      __typename: "AccountGroupMasterNew",
      accountgroupid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accounttypecd?: string | null,
      accountgroupname?: string | null,
      accountparentgroupid?: number | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      is_active?: number | null,
      restrictedflag?: number | null,
      path?: string | null,
    } | null > | null,
    relatedaccountbalance?:  Array< {
      __typename: "AccountBalanceNew",
      accountid?: number | null,
      accountbalance?: number | null,
      actualbalance?: number | null,
    } | null > | null,
    path?: string | null,
  } | null,
};

export type DeleteAccountGroupMasterMutationVariables = {
  accountgroupid: number,
};

export type DeleteAccountGroupMasterMutation = {
  deleteAccountGroupMaster?:  {
    __typename: "AccountGroupMaster",
    accountgroupid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accounttypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    relatedaccounts?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    path?: string | null,
  } | null,
};

export type DeleteNumberTrackerMutationVariables = {
  deleteNumberTrackerInput?: DeleteNumberTrackerInput | null,
};

export type DeleteNumberTrackerMutation = {
  deleteNumberTracker?:  {
    __typename: "NumberTracker",
    id?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    financialyearid?: number | null,
    entrytypecd?: string | null,
    serialnumber?: string | null,
    serialisactive?: number | null,
    serialisused?: number | null,
    nextinvoicenumber?: number | null,
    prefix?: string | null,
    suffix?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialflag?: number | null,
    startinvoicenumber?: number | null,
    taxability?: number | null,
    lastused?: number | null,
    secondlastused?: number | null,
    restrictedflag?: number | null,
  } | null,
};

export type UpdateNumberTrackerMutationVariables = {
  updateNumberTrackerInput: UpdateNumberTrackerInput,
};

export type UpdateNumberTrackerMutation = {
  updateNumberTracker?:  {
    __typename: "NumberTracker",
    id?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    financialyearid?: number | null,
    entrytypecd?: string | null,
    serialnumber?: string | null,
    serialisactive?: number | null,
    serialisused?: number | null,
    nextinvoicenumber?: number | null,
    prefix?: string | null,
    suffix?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialflag?: number | null,
    startinvoicenumber?: number | null,
    taxability?: number | null,
    lastused?: number | null,
    secondlastused?: number | null,
    restrictedflag?: number | null,
  } | null,
};

export type UpdateAccountGSTDetailsMutationVariables = {
  updateAccountGSTDetailsInput: UpdateAccountGSTDetailsInput,
};

export type UpdateAccountGSTDetailsMutation = {
  updateAccountGSTDetails?:  {
    __typename: "AccountGSTDetails",
    accountid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    effectivedate?: number | null,
    expireddate?: number | null,
    hsnid?: string | null,
    gstcompensationtype?: string | null,
    gstrate?: number | null,
    cessamount?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    hsnsaccode?: string | null,
    codetype?: string | null,
    description?: string | null,
    taxability?: string | null,
  } | null,
};

export type DeleteTransactionMasterMutationVariables = {
  transactionid: number,
};

export type DeleteTransactionMasterMutation = {
  deleteTransactionMaster?:  {
    __typename: "TransactionMaster",
    transactionid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    transactiontypecd?: string | null,
    vouchernumber?: string | null,
    entrydate?: number | null,
    bankreferencenumber?: string | null,
    comments?: string | null,
    relatedtransactiondetails?:  Array< {
      __typename: "TransactionDetailsCustom",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      accountid?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      comments?: string | null,
      entryordernumber?: number | null,
      transactionbalance?: number | null,
      openingbalance?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      financialyearid?: number | null,
    } | null > | null,
    relatedtransactionattachment?:  Array< {
      __typename: "TransactionAttachment",
      transactionid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      documentname: string,
      statuscode?: string | null,
      statusmessage?: string | null,
      type?: string | null,
    } | null > | null,
    relatedtransactiontdsdetails?:  Array< {
      __typename: "TransactionTDSDetails",
      transactionid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      tdsapplicablecd: string,
      tdsamount: number,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tdspercentage?: number | null,
    } | null > | null,
    relatedpurchasemaster?:  Array< {
      __typename: "PurchaseMasterNew",
      purchaseid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchasegsttypecd: string,
      supplierid: number,
      entrydate: number,
      vouchernumber: string,
      supplierinvoicedate: number,
      supplierinvoicenumber: string,
      supplieraddressid: number,
      paymenttypecd: string,
      paidamount: number,
      creditduration: number,
      paymentaccountid: number,
      comments: string,
      tdsapplicableflag: number,
      granttotalamount?: number | null,
      balancedueamount?: number | null,
      paymentclearedflag?: number | null,
      placeofsupply?: string | null,
      companystate?: string | null,
      relatedpurchasetdsdetails?:  Array< {
        __typename: "PurchaseTDSDetails",
        purchaseid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        tdsapplicablecd?: number | null,
        totaltaxableamount?: number | null,
        ineligibletcflag?: number | null,
        reversechargeflag?: number | null,
        gstcesstotal?: number | null,
        tdsamount?: number | null,
        adjustmentamount?: number | null,
        tdssection?: string | null,
        tdspercentage?: number | null,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaselineitems?:  Array< {
        __typename: "PurchaseLineItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        itemnumber: number,
        itemid: number,
        purchaseaccountid: number,
        hsncode: string,
        itemquantity: number,
        unittypecd: string,
        itemrate: number,
        itemamount: number,
        itemdiscount: number,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount: number,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnid?: string | null,
        hsncodetype?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        purchaseaccountname?: string | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinenonitems?:  Array< {
        __typename: "PurchaseLineNonItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchaselineitemtype: string,
        purchaseaccountid: number,
        hsnsaccode: string,
        itemdescription: string,
        taxableamount: number,
        netamount: number,
        relatedpurchaselinenongst?:  Array< {
          __typename: "PurchaseLineNonGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        purchaseaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaseattachment?:  Array< {
        __typename: "PurchaseAttachment",
        purchaseid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedpurchasetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      relatedpurchasetransactionrelation?:  Array< {
        __typename: "TransactionRelation",
        transactionid?: number | null,
        transactiontypecd?: string | null,
        objecttype?: string | null,
        objectid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        linkedamount?: number | null,
        objectattribute?: string | null,
        isdirect?: number | null,
        lastupdatedby?: string | null,
        accountid?: number | null,
        paymentvouchernumber?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      adjustmentamount?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      reversechargeflag?: number | null,
      paymentstatus?: number | null,
      partyregistrationtype?: string | null,
      partygstcategory?: string | null,
      itcflag?: number | null,
    } | null > | null,
    relatedinvoicemaster?:  Array< {
      __typename: "Invoicemasternew",
      invoiceid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      invoicetypecd: string,
      partyid: number,
      paymentaccountid: number,
      invoicedate: number,
      invoicenumber: string,
      customerordernumber: string,
      customerorderdate?: number | null,
      invoiceamount: number,
      paymenttype: string,
      creditduration: number,
      invoicebillingaddressid: number,
      invoicedeliveryaddressid: number,
      invoicetaxabletypecd: string,
      receipturl: string,
      invoicelinetypecd: string,
      invoicecurrencycd: string,
      exchangerate: number,
      comments: string,
      receivedamount: number,
      adjustmentamount: number,
      placeofsupply?: string | null,
      balancedueamount?: number | null,
      reversechargeflag?: number | null,
      tcsapplicableflag?: number | null,
      relatedinvoicelineitems?:  Array< {
        __typename: "InvoiceLineItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        lineitemnumber?: number | null,
        invoicelineitemtype?: string | null,
        itemid?: number | null,
        quantity?: number | null,
        unittypecd?: string | null,
        itemrate?: number | null,
        itemamount?: number | null,
        itemdiscount?: number | null,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        salesaccountname?: string | null,
        salesaccountid?: number | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        itemmaster_timestamp?: number | null,
        description?: string | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoicelinenonitems?:  Array< {
        __typename: "InvoiceLineNonItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        invoicelineitemtype?: string | null,
        incomeaccountid?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        itemdescription?: string | null,
        taxableamount?: number | null,
        netamount?: number | null,
        relatedaccounts?:  Array< {
          __typename: "AccountMaster",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accountname?: string | null,
          accounttypecd?: string | null,
          accountgroupid?: number | null,
          hsnsaccode?: string | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          restrictedflag?: number | null,
          is_active?: number | null,
          accounttypeflag?: number | null,
          relatedaccountgstdetails?:  Array< {
            __typename: "AccountGSTDetails",
            accountid?: number | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstrate?: number | null,
            cessamount?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsaccode?: string | null,
            codetype?: string | null,
            description?: string | null,
            taxability?: string | null,
          } | null > | null,
          relatedaccountopeningbalance?:  Array< {
            __typename: "AccountOpeningBalance",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            financialyearid?: number | null,
            startdate?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedaccountgroupmaster?:  Array< {
            __typename: "AccountGroupMasterNew",
            accountgroupid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accounttypecd?: string | null,
            accountgroupname?: string | null,
            accountparentgroupid?: number | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            is_active?: number | null,
            restrictedflag?: number | null,
            path?: string | null,
          } | null > | null,
          relatedaccountbalance?:  Array< {
            __typename: "AccountBalanceNew",
            accountid?: number | null,
            accountbalance?: number | null,
            actualbalance?: number | null,
          } | null > | null,
          path?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        incomeaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoiceattachment?:  Array< {
        __typename: "InvoiceAttachment",
        invoiceid?: number | null,
        attachmentid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        attachmentname?: string | null,
        attachmenturl?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedinvoicedispatch?:  Array< {
        __typename: "InvoiceDispatch",
        invoiceid: number,
        dispatchid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        transportationcd: string,
        vehiclenumber: string,
        dispatchdate: number,
        ewaybillnumber: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoiceposdetails?:  Array< {
        __typename: "InvoicePOSDetails",
        posid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        partyposid: number,
        lastupdatedby?: string | null,
        relatedposparty?:  Array< {
          __typename: "POSParty",
          pospartyid?: number | null,
          companyid?: number | null,
          partyname?: string | null,
          partycontactnumberid?: number | null,
          lastupdatedby?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          relatedphonecontacts?:  Array< {
            __typename: "PhoneContacts",
            id?: number | null,
            objecttype?: string | null,
            objectid?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            countrycode?: string | null,
            phonenumber?: string | null,
            verifieddatetime?: number | null,
            promotionssignup?: string | null,
            smsallowed?: string | null,
            callallowed?: string | null,
            whatsappallowed?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
        } | null > | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicenumbertracker?:  Array< {
        __typename: "InvoiceNumberTracker",
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        nextinvoicenumber: string,
        lastupdatedby?: string | null,
      } | null > | null,
      relatedinvoicetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      companystate?: string | null,
      cancelremark?: string | null,
      deleteremark?: string | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      paymentstatus?: number | null,
      ackno?: string | null,
      ackdt?: number | null,
      irn?: string | null,
      signedqrcode?: string | null,
      itcflag?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    cancelremark?: string | null,
    serialnumber?: string | null,
    pdflink?: string | null,
    towards?: string | null,
    isvouchereditable?: number | null,
  } | null,
};

export type DeleteNumberTrackerByTypeMutationVariables = {
  deleteNumberTrackerByTypeInput?: DeleteNumberTrackerByTypeInput | null,
};

export type DeleteNumberTrackerByTypeMutation = {
  deleteNumberTrackerByType?:  Array< {
    __typename: "NumberTracker",
    id?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    financialyearid?: number | null,
    entrytypecd?: string | null,
    serialnumber?: string | null,
    serialisactive?: number | null,
    serialisused?: number | null,
    nextinvoicenumber?: number | null,
    prefix?: string | null,
    suffix?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialflag?: number | null,
    startinvoicenumber?: number | null,
    taxability?: number | null,
    lastused?: number | null,
    secondlastused?: number | null,
    restrictedflag?: number | null,
  } | null > | null,
};

export type DeleteNumberTrackerAutoMutationVariables = {
  deleteNumberTrackerAutoByTypeInput?: DeleteNumberTrackerAutoByTypeInput | null,
};

export type DeleteNumberTrackerAutoMutation = {
  deleteNumberTrackerAuto?:  {
    __typename: "NumberTracker",
    id?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    financialyearid?: number | null,
    entrytypecd?: string | null,
    serialnumber?: string | null,
    serialisactive?: number | null,
    serialisused?: number | null,
    nextinvoicenumber?: number | null,
    prefix?: string | null,
    suffix?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialflag?: number | null,
    startinvoicenumber?: number | null,
    taxability?: number | null,
    lastused?: number | null,
    secondlastused?: number | null,
    restrictedflag?: number | null,
  } | null,
};

export type CloseFinancialYearMutationVariables = {
  currentfinancialyearid: number,
  nextfinancialyearid: number,
  excludedaccountidlist: string,
};

export type CloseFinancialYearMutation = {
  closeFinancialYear?:  {
    __typename: "Success",
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type TransferAccountsToFinancialYearMutationVariables = {
  excludedaccountidlist: string,
  excludedaccountgroupidlist: string,
  ledger_transfer_option: number,
  party_transfer_option: number,
  item_transfer_option: number,
  transfer_groups_ledgers: number,
  ledger_closing_balance: number,
  party_closing_balance: number,
  from_financialyearid: number,
  to_financialyearid: number,
};

export type TransferAccountsToFinancialYearMutation = {
  transferAccountsToFinancialYear?:  {
    __typename: "Success",
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreatetransferfinancialyeardataMutationVariables = {
  companybranchid: number,
  startdate: number,
  enddate: number,
  startyear: string,
  endyear: string,
  comments: string,
  aliasname: string,
  excludedaccountidlist: string,
  excludedaccountgroupidlist: string,
  ledger_transfer_option: number,
  party_transfer_option: number,
  item_transfer_option: number,
  transfer_groups_ledgers: number,
  ledger_closing_balance: number,
  party_closing_balance: number,
  from_financialyearid: number,
  to_financialyearid: number,
};

export type CreatetransferfinancialyeardataMutation = {
  createtransferfinancialyeardata?:  {
    __typename: "FinancialYearTransfer",
    statuscode?: string | null,
    statusmessage?: string | null,
    financialyearid?: number | null,
  } | null,
};

export type DeleteFinancialYearMutationVariables = {
  financialyearid: number,
};

export type DeleteFinancialYearMutation = {
  deleteFinancialYear?:  {
    __typename: "FinancialYear",
    financialyearid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    startdate?: number | null,
    enddate?: number | null,
    startyear?: string | null,
    endyear?: string | null,
    comments?: string | null,
    userid?: string | null,
    aliasname?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    freezestatus?: number | null,
    transferdate?: number | null,
    freezedate?: number | null,
    stepscompleted?: Array< string | null > | null,
  } | null,
};

export type FreezeFinancialYearMutationVariables = {
  financialyearid: number,
};

export type FreezeFinancialYearMutation = {
  freezeFinancialYear?:  {
    __typename: "FinancialYear",
    financialyearid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    startdate?: number | null,
    enddate?: number | null,
    startyear?: string | null,
    endyear?: string | null,
    comments?: string | null,
    userid?: string | null,
    aliasname?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    freezestatus?: number | null,
    transferdate?: number | null,
    freezedate?: number | null,
    stepscompleted?: Array< string | null > | null,
  } | null,
};

export type UnFreezeFinancialYearMutationVariables = {
  financialyearid: number,
};

export type UnFreezeFinancialYearMutation = {
  unFreezeFinancialYear?:  {
    __typename: "FinancialYear",
    financialyearid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    startdate?: number | null,
    enddate?: number | null,
    startyear?: string | null,
    endyear?: string | null,
    comments?: string | null,
    userid?: string | null,
    aliasname?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    freezestatus?: number | null,
    transferdate?: number | null,
    freezedate?: number | null,
    stepscompleted?: Array< string | null > | null,
  } | null,
};

export type DeletecancelinvoicesMutationVariables = {
  invoicetype: string,
  invoiceid: number,
  mode: string,
  paymentincluded: number,
  reason: string,
};

export type DeletecancelinvoicesMutation = {
  deletecancelinvoices?:  {
    __typename: "DeleteInvoiceStatus",
    newid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreateuserissueMutationVariables = {
  userIssueInput?: UserIssueInput | null,
};

export type CreateuserissueMutation = {
  createuserissue?:  {
    __typename: "UserIssue",
    statusmessage?: string | null,
    statuscode?: string | null,
    id?: number | null,
    name?: string | null,
    email?: string | null,
    phone?: string | null,
    issuetype?: string | null,
    status?: string | null,
    description?: string | null,
    filename?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    lastupdatedby?: string | null,
    pageurl?: string | null,
    personalname?: string | null,
    shortdescription?: string | null,
  } | null,
};

export type CreatetransporterMutationVariables = {
  transporterMasterInput: TransporterMasterInput,
};

export type CreatetransporterMutation = {
  createtransporter?:  {
    __typename: "TransporterMaster",
    transporterid: number,
    transportername: string,
    companyid: number,
    enteredtimestamp: number,
    lastupdatedby: string,
    expiredtimestamp: number,
    transportergstin: string,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreateEwayBillMutationVariables = {
  createEwayBillInput: CreateEwayBillInput,
};

export type CreateEwayBillMutation = {
  createEwayBill?:  {
    __typename: "EwayBill",
    id: number,
    invoiceid?: number | null,
    invoicetype?: string | null,
    companyid?: number | null,
    enteredtimestamp: number,
    expiredtimestamp: number,
    ewaybillno?: number | null,
    expirydate?: number | null,
    is_cancelled?: number | null,
    cancel_remarks?: string | null,
    lastupdatedby?: string | null,
    cancel_rsn_code?: string | null,
    ewaybilldate?: number | null,
    supplytype?: string | null,
    subtype?: string | null,
    partyid?: number | null,
    transporterid?: number | null,
    modeoftransport?: string | null,
    vehicleno?: string | null,
    distance?: number | null,
    invoiceno?: string | null,
    invoicedate?: number | null,
    fromgstin?: string | null,
    togstin?: string | null,
    fromstate?: string | null,
    tostate?: string | null,
    frompincode?: number | null,
    topincode?: number | null,
    billingstate?: string | null,
    billingpincode?: string | null,
    transportername?: string | null,
    transportergstin?: string | null,
    validupto?: number | null,
    total_items_count?: number | null,
    gstrate?: number | null,
    gstamount?: number | null,
    cessamount?: number | null,
    ewbrejecteddate?: number | null,
    totalitemamount?: number | null,
    totalinvoiceamount?: number | null,
    fromtradename?: string | null,
    totradename?: string | null,
    transactiontype?: string | null,
    doctype?: string | null,
    status?: string | null,
    transdocno?: string | null,
    transdocdate?: number | null,
    vehicletype?: string | null,
    ewaybillpdf?: string | null,
    addresses?:  Array< {
      __typename: "EwayBillAddress",
      objectid?: number | null,
      objecttype?: string | null,
      statecode?: number | null,
      statename?: string | null,
      pincode?: string | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      countrycode?: string | null,
      district?: string | null,
    } | null > | null,
  } | null,
};

export type CreateAppVersionMutationVariables = {
  version_number: string,
  release_notes?: string | null,
  is_mandatory: boolean,
};

export type CreateAppVersionMutation = {
  createAppVersion?:  {
    __typename: "AppVersion",
    id: number,
    version_number: string,
    release_notes?: string | null,
    release_date?: string | null,
    is_mandatory: boolean,
  } | null,
};

export type CreateTransactionAttachmentMutationVariables = {
  createTransactionAttachmentInput: Array< CreateTransactionAttachmentInput >,
};

export type CreateTransactionAttachmentMutation = {
  createTransactionAttachment:  Array< {
    __typename: "TransactionAttachment",
    transactionid: number,
    attachmentid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    attachmentname: string,
    attachmenturl: string,
    lastupdatedby?: string | null,
    documentname: string,
    statuscode?: string | null,
    statusmessage?: string | null,
    type?: string | null,
  } >,
};

export type CreateItemOpeningStockMutationVariables = {
  createItemOpeningStockInput: CreateItemOpeningStockInput,
};

export type CreateItemOpeningStockMutation = {
  createItemOpeningStock?:  {
    __typename: "ItemOpeningStockResponse",
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type CreateUserInvitationMutationVariables = {
  createUserInvitationInput: CreateUserInvitationInput,
};

export type CreateUserInvitationMutation = {
  createUserInvitation?:  {
    __typename: "UserInvitation",
    id: number,
    email: string,
    companyid: number,
    invitedby: string,
    status: string,
    invitationtoken: string,
    invitationsource: string,
    acceptedtimestamp?: number | null,
    enteredtimestamp: number,
    expiredtimestamp?: number | null,
  } | null,
};

export type CreateTransactionWithSpecificTimev2MutationVariables = {
  createTransactionWithSpecificTimeInput: CreateTransactionWithSpecificTimeInput,
};

export type CreateTransactionWithSpecificTimev2Mutation = {
  createTransactionWithSpecificTimev2?:  {
    __typename: "TransactionSpecificTime",
    transactionid?: number | null,
    companyid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null,
};

export type UpdatefinancialyearstepsMutationVariables = {
  updatefinancialyearstepsInput: Array< UpdatefinancialyearstepsInput >,
};

export type UpdatefinancialyearstepsMutation = {
  updatefinancialyearsteps:  Array< {
    __typename: "Stepscompleted",
    financialyearid: number,
    stepscompleted: string,
    statuscode?: string | null,
    statusmessage?: string | null,
  } >,
};

export type SaveTablePreferencesMutationVariables = {
  input: Array< SaveTablePreferenceInput >,
};

export type SaveTablePreferencesMutation = {
  saveTablePreferences?:  Array< {
    __typename: "BatchPreferenceResponse",
    statuscode?: string | null,
    statusmessage?: string | null,
    table_key?: string | null,
    column_settings?: string | null,
    table_configs?: string | null,
  } | null > | null,
};

export type ListAccountMasterv2QueryVariables = {
};

export type ListAccountMasterv2Query = {
  listAccountMasterv2?:  Array< {
    __typename: "AccountMasterv2",
    accountsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    accountgroupid?: number | null,
    hsnsaccode?: string | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    accountgroupenteredtimestamp?: number | null,
    accountgroupexpiredtimestamp?: number | null,
    accountgrouptypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    accountgroupdisplayordernumber?: number | null,
    accountgrouprestrictedflag?: number | null,
    accountgroupis_active?: number | null,
    accountgstenteredtimestamp?: number | null,
    accountgstexpiredtimestamp?: number | null,
    accountgsteffectivedate?: number | null,
    accountgstexpireddate?: number | null,
    hsnid?: string | null,
    gstcompensationtype?: string | null,
    gstrate?: number | null,
    cessamount?: number | null,
    accounttypeflag?: number | null,
    partyid?: number | null,
    tdspercentage?: number | null,
    tdssection?: string | null,
    path?: string | null,
    tax_type?: number | null,
    balancesign?: number | null,
    accountcreationdate?: number | null,
  } | null > | null,
};

export type GetCognitoUserSessionsQueryVariables = {
};

export type GetCognitoUserSessionsQuery = {
  getCognitoUserSessions?:  Array< {
    __typename: "CognitoUserSession",
    sessionid?: number | null,
    cognitousername?: string | null,
    logintimestamp?: string | null,
    logouttimestamp?: string | null,
    linkedsessionid?: string | null,
    deviceinfo?: string | null,
    ipaddress?: string | null,
  } | null > | null,
};

export type GetOTPDetailsQueryVariables = {
};

export type GetOTPDetailsQuery = {
  getOTPDetails?:  Array< {
    __typename: "OTPDetails",
    id?: number | null,
    purpose?: string | null,
    otpcode?: number | null,
    enteredtimestamp?: number | null,
    active?: number | null,
    userid?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type ListPhoneContactsQueryVariables = {
};

export type ListPhoneContactsQuery = {
  listPhoneContacts?:  Array< {
    __typename: "PhoneContacts",
    id?: number | null,
    objecttype?: string | null,
    objectid?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    countrycode?: string | null,
    phonenumber?: string | null,
    verifieddatetime?: number | null,
    promotionssignup?: string | null,
    smsallowed?: string | null,
    callallowed?: string | null,
    whatsappallowed?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type ListPOSPartiesQueryVariables = {
};

export type ListPOSPartiesQuery = {
  listPOSParties?:  Array< {
    __typename: "POSParty",
    pospartyid?: number | null,
    companyid?: number | null,
    partyname?: string | null,
    partycontactnumberid?: number | null,
    lastupdatedby?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    relatedphonecontacts?:  Array< {
      __typename: "PhoneContacts",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      countrycode?: string | null,
      phonenumber?: string | null,
      verifieddatetime?: number | null,
      promotionssignup?: string | null,
      smsallowed?: string | null,
      callallowed?: string | null,
      whatsappallowed?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
  } | null > | null,
};

export type SearchHSNQueryVariables = {
  rowfrom: number,
  limitno: number,
  codetype: string,
  word: string,
};

export type SearchHSNQuery = {
  searchHSN?:  Array< {
    __typename: "hsnsacmaster",
    hsnsacid?: number | null,
    codetype?: string | null,
    hsnsaccode?: string | null,
    description?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    companyid?: number | null,
  } | null > | null,
};

export type GetAccountGSTDetailsQueryVariables = {
  accountid: number,
};

export type GetAccountGSTDetailsQuery = {
  getAccountGSTDetails?:  Array< {
    __typename: "AccountGSTDetails",
    accountid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    effectivedate?: number | null,
    expireddate?: number | null,
    hsnid?: string | null,
    gstcompensationtype?: string | null,
    gstrate?: number | null,
    cessamount?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    hsnsaccode?: string | null,
    codetype?: string | null,
    description?: string | null,
    taxability?: string | null,
  } | null > | null,
};

export type GetBankDetailsQueryVariables = {
  objectid: string,
  objecttype: string,
};

export type GetBankDetailsQuery = {
  getBankDetails?:  Array< {
    __typename: "BankDetails",
    bankdetailsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    objecttype?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    objectid?: string | null,
    userid?: string | null,
    bankname?: string | null,
    bankaccountnumber?: string | null,
    ifsccode?: string | null,
    branch?: string | null,
    notes?: string | null,
    ledgeraccount?: string | null,
    bankaccounttype?: string | null,
    cash?: number | null,
    swiftcode?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    upi?: string | null,
  } | null > | null,
};

export type GetBankDetailsByAccountNameQueryVariables = {
  accountname: string,
};

export type GetBankDetailsByAccountNameQuery = {
  getBankDetailsByAccountName?:  Array< {
    __typename: "BankDetails",
    bankdetailsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    objecttype?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    objectid?: string | null,
    userid?: string | null,
    bankname?: string | null,
    bankaccountnumber?: string | null,
    ifsccode?: string | null,
    branch?: string | null,
    notes?: string | null,
    ledgeraccount?: string | null,
    bankaccounttype?: string | null,
    cash?: number | null,
    swiftcode?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    upi?: string | null,
  } | null > | null,
};

export type GetCodeTranslationQueryVariables = {
  codetype: string,
};

export type GetCodeTranslationQuery = {
  getCodeTranslation?:  Array< {
    __typename: "CodeTranslation",
    id?: number | null,
    companyid?: number | null,
    codetype?: string | null,
    codevalue?: string | null,
    language?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    codetext?: string | null,
    statecode?: number | null,
    codeorder?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
    uqc?: string | null,
    is_active?: string | null,
  } | null > | null,
};

export type ListVoucherSerialNumbersQueryVariables = {
  entrytypecd: string,
};

export type ListVoucherSerialNumbersQuery = {
  listVoucherSerialNumbers?:  Array< {
    __typename: "NumberTracker",
    id?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    financialyearid?: number | null,
    entrytypecd?: string | null,
    serialnumber?: string | null,
    serialisactive?: number | null,
    serialisused?: number | null,
    nextinvoicenumber?: number | null,
    prefix?: string | null,
    suffix?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialflag?: number | null,
    startinvoicenumber?: number | null,
    taxability?: number | null,
    lastused?: number | null,
    secondlastused?: number | null,
    restrictedflag?: number | null,
  } | null > | null,
};

export type ListUserPreferenceQueryVariables = {
};

export type ListUserPreferenceQuery = {
  listUserPreference?:  Array< {
    __typename: "UserPreference",
    userid?: string | null,
    attributetypecd?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    attributevalue?: number | null,
    additionalvalue?: string | null,
  } | null > | null,
};

export type ListCompanyPreferenceQueryVariables = {
};

export type ListCompanyPreferenceQuery = {
  listCompanyPreference?:  Array< {
    __typename: "CompanyPreference",
    companyid?: number | null,
    attributetypecd?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    attributevalue?: number | null,
    additionalvalue?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type ListUserCompaniesQueryVariables = {
};

export type ListUserCompaniesQuery = {
  listUserCompanies?:  Array< {
    __typename: "CompanyDetails",
    companyid: number,
    enteredtimestamp: number,
    expiredtimestamp?: number | null,
    websiteurl?: string | null,
    currencycd?: number | null,
    accountinventoryflag?: number | null,
    pannumber?: string | null,
    tdstcsnumber?: string | null,
    cinregistrationnumber?: string | null,
    registrationtype?: number | null,
    comppercentage?: number | null,
    gstrperiod?: string | null,
    lut?: string | null,
    lutbondvalidfrom?: number | null,
    ewaybillflag?: number | null,
    gstapplicablefrom?: number | null,
    thresholdlimitcd?: number | null,
    thresholdlimitamount?: number | null,
    companylegalname?: string | null,
    companyshort?: string | null,
    lutbondtodate?: number | null,
    invoicedetailapplicablefromdate?: number | null,
    tdsapplicable?: number | null,
    gstcategory?: string | null,
    financialyearstartandendmonth?: number | null,
    companylogourl?: string | null,
    msmetype?: string | null,
    udhyamregno?: string | null,
    udhyamdocs?: string | null,
    ewaybillstartdate?: number | null,
    minamountewayinter?: number | null,
    minamountewayintra?: number | null,
    einvoiceflag?: number | null,
    einvoicestartingdate?: number | null,
    gstcompensationcessflag?: number | null,
    tradelicensenumber?: string | null,
    tradelicensestartdate?: number | null,
    tradelicenseenddate?: number | null,
    lastupdatedby?: string | null,
    cinregistrationdate?: number | null,
    einvoiceconnect?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    activeflag?: number | null,
    relatedfinancialyeardata?:  Array< {
      __typename: "FinancialYear",
      financialyearid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      startdate?: number | null,
      enddate?: number | null,
      startyear?: string | null,
      endyear?: string | null,
      comments?: string | null,
      userid?: string | null,
      aliasname?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      freezestatus?: number | null,
      transferdate?: number | null,
      freezedate?: number | null,
      stepscompleted?: Array< string | null > | null,
    } | null > | null,
    financialyearid?: number | null,
    lastupdatedtimestamp?: number | null,
    companydeletiontime?: number | null,
    ewaybillconnect?: number | null,
    stepscompleted?: Array< string | null > | null,
    disablegstcompensation?: number | null,
    businesstypeid?: Array< number | null > | null,
    industrytypeid?: Array< number | null > | null,
  } | null > | null,
};

export type ListPriceTypeQueryVariables = {
};

export type ListPriceTypeQuery = {
  listPriceType?:  Array< {
    __typename: "PriceType",
    id?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    pricetype?: string | null,
    userid?: string | null,
    is_default?: number | null,
    is_active?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    tabletype?: number | null,
  } | null > | null,
};

export type GetInvoiceMasterQueryVariables = {
  invoiceid: number,
};

export type GetInvoiceMasterQuery = {
  getInvoiceMaster?:  Array< {
    __typename: "Invoicemaster",
    invoiceid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoicetypecd?: string | null,
    partyid?: number | null,
    paymentaccountid?: number | null,
    invoicedate?: number | null,
    invoicenumber?: string | null,
    customerordernumber?: string | null,
    customerorderdate?: number | null,
    invoiceamount?: number | null,
    paymenttype?: string | null,
    creditduration?: number | null,
    invoicebillingaddressid?: number | null,
    invoicedeliveryaddressid?: number | null,
    invoicetaxabletypecd?: string | null,
    receipturl?: string | null,
    invoicelinetypecd?: string | null,
    invoicecurrencycd?: string | null,
    exchangerate?: number | null,
    comments?: string | null,
    receivedamount?: number | null,
    adjustmentamount?: number | null,
    placeofsupply?: string | null,
    balancedueamount?: number | null,
    reversechargeflag?: number | null,
    tcsapplicableflag?: number | null,
    relatedinvoicetcsdetails?:  Array< {
      __typename: "InvoiceTCSDetails",
      invoiceid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedinvoicelineitems?:  Array< {
      __typename: "InvoiceLineItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemnumber?: number | null,
      invoicelineitemtype?: string | null,
      itemid?: number | null,
      quantity?: number | null,
      unittypecd?: string | null,
      itemrate?: number | null,
      itemamount?: number | null,
      itemdiscount?: number | null,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      salesaccountname?: string | null,
      salesaccountid?: number | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      itemmaster_timestamp?: number | null,
      description?: string | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoicelinenonitems?:  Array< {
      __typename: "InvoiceLineNonItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      invoicelineitemtype?: string | null,
      incomeaccountid?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      itemdescription?: string | null,
      taxableamount?: number | null,
      netamount?: number | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      incomeaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoiceattachment?:  Array< {
      __typename: "InvoiceAttachment",
      invoiceid?: number | null,
      attachmentid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      attachmentname?: string | null,
      attachmenturl?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedinvoicedispatch?:  Array< {
      __typename: "InvoiceDispatch",
      invoiceid: number,
      dispatchid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transportationcd: string,
      vehiclenumber: string,
      dispatchdate: number,
      ewaybillnumber: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoiceposdetails?:  Array< {
      __typename: "InvoicePOSDetails",
      posid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      partyposid: number,
      lastupdatedby?: string | null,
      relatedposparty?:  Array< {
        __typename: "POSParty",
        pospartyid?: number | null,
        companyid?: number | null,
        partyname?: string | null,
        partycontactnumberid?: number | null,
        lastupdatedby?: string | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        relatedphonecontacts?:  Array< {
          __typename: "PhoneContacts",
          id?: number | null,
          objecttype?: string | null,
          objectid?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          countrycode?: string | null,
          phonenumber?: string | null,
          verifieddatetime?: number | null,
          promotionssignup?: string | null,
          smsallowed?: string | null,
          callallowed?: string | null,
          whatsappallowed?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
      } | null > | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinegst?:  Array< {
      __typename: "InvoiceLineGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinenongst?:  Array< {
      __typename: "InvoiceLineNonGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicenumbertracker?:  Array< {
      __typename: "InvoiceNumberTracker",
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      nextinvoicenumber: string,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedinvoicetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedinvoiceaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    companystate?: string | null,
    cancelremark?: string | null,
    deleteremark?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    serialnumber?: string | null,
    serialflag?: number | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    paymentstatus?: number | null,
    ackno?: string | null,
    ackdt?: number | null,
    irn?: string | null,
    signedqrcode?: string | null,
    partyemail?: string | null,
    invoicepdf?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    partygstcategory?: string | null,
    is_cancelled?: number | null,
    cancel_reason?: string | null,
    cancel_remarks?: string | null,
    phonenumber?: string | null,
    bankaccountid?: number | null,
    bankamount?: number | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    ewaybill_cancel_rsn_code?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    invoicetype?: string | null,
    accountname?: string | null,
    partyisactive?: number | null,
    goods_exist?: number | null,
    overduedays?: number | null,
    duedatetimestamp?: number | null,
    isvouchereditable?: number | null,
    itcflag?: number | null,
    taxability?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
  } | null > | null,
};

export type GetPartyInvoicesQueryVariables = {
  partyid: number,
  partytypecd: string,
};

export type GetPartyInvoicesQuery = {
  getPartyInvoices?:  Array< {
    __typename: "PurchaseInvoiceList",
    invoiceid?: number | null,
    purchaseid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoicetypecd?: string | null,
    purchasegsttypecd?: string | null,
    partyid?: number | null,
    supplierid?: number | null,
    paymentaccountid?: number | null,
    invoicedate?: number | null,
    entrydate?: number | null,
    invoicenumber?: string | null,
    vouchernumber?: string | null,
    customerordernumber?: string | null,
    supplierinvoicenumber?: string | null,
    customerorderdate?: number | null,
    invoiceamount?: number | null,
    granttotalamount?: number | null,
    paymenttype?: string | null,
    creditduration?: number | null,
    invoicebillingaddressid?: number | null,
    supplieraddressid?: number | null,
    invoicedeliveryaddressid?: number | null,
    invoicetaxabletypecd?: string | null,
    receipturl?: string | null,
    invoicelinetypecd?: string | null,
    invoicecurrencycd?: string | null,
    paymenttypecd?: string | null,
    exchangerate?: number | null,
    currencyrate?: number | null,
    comments?: string | null,
    receivedamount?: number | null,
    adjustmentamount?: number | null,
    placeofsupply?: string | null,
    statename?: string | null,
    balancedueamount?: number | null,
    reversechargeflag?: number | null,
    lastupdatedby?: string | null,
    cancelflag?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    tcsapplicableflag?: number | null,
    tdsapplicableflag?: number | null,
    companystate?: string | null,
    cancelremark?: string | null,
    deleteremark?: string | null,
    financialyearid?: number | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    serialnumber?: string | null,
    paymentclearedflag?: number | null,
    paymentstatus?: string | null,
    partyregistrationtype?: string | null,
    currencycode?: string | null,
  } | null > | null,
};

export type GetFinancialYearQueryVariables = {
  financialyearid: number,
};

export type GetFinancialYearQuery = {
  getFinancialYear?:  Array< {
    __typename: "FinancialYear",
    financialyearid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    startdate?: number | null,
    enddate?: number | null,
    startyear?: string | null,
    endyear?: string | null,
    comments?: string | null,
    userid?: string | null,
    aliasname?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    freezestatus?: number | null,
    transferdate?: number | null,
    freezedate?: number | null,
    stepscompleted?: Array< string | null > | null,
  } | null > | null,
};

export type GetEmailTemplateMasterQueryVariables = {
};

export type GetEmailTemplateMasterQuery = {
  getEmailTemplateMaster?:  Array< {
    __typename: "EmailTemplateMaster",
    templateid?: number | null,
    templatename?: string | null,
    valueid?: number | null,
    fieldname?: string | null,
  } | null > | null,
};

export type GetEmailSettingsQueryVariables = {
};

export type GetEmailSettingsQuery = {
  getEmailSettings?:  Array< {
    __typename: "EmailSettings",
    email?: string | null,
    templateid?: number | null,
    emailbody?: string | null,
    smtp_port?: number | null,
    smtp_hostname?: string | null,
    username?: string | null,
    password?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    lastupdatedby?: string | null,
  } | null > | null,
};

export type GeteInvoiceMasterQueryVariables = {
  invoiceid: number,
};

export type GeteInvoiceMasterQuery = {
  geteInvoiceMaster?:  Array< {
    __typename: "eInvoiceMaster",
    id?: number | null,
    invoiceid?: number | null,
    invoicetype: string,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    ackno?: string | null,
    ackdt?: number | null,
    irn?: string | null,
    signedqrcode?: string | null,
    lastupdatedby?: string | null,
    is_cancelled?: number | null,
    cancel_reason?: string | null,
    cancel_remarks?: string | null,
  } | null > | null,
};

export type ListUsedVoucherSerialNumbersQueryVariables = {
  entryTypecd: string,
};

export type ListUsedVoucherSerialNumbersQuery = {
  listUsedVoucherSerialNumbers?:  Array< {
    __typename: "NumberTracker",
    id?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    financialyearid?: number | null,
    entrytypecd?: string | null,
    serialnumber?: string | null,
    serialisactive?: number | null,
    serialisused?: number | null,
    nextinvoicenumber?: number | null,
    prefix?: string | null,
    suffix?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialflag?: number | null,
    startinvoicenumber?: number | null,
    taxability?: number | null,
    lastused?: number | null,
    secondlastused?: number | null,
    restrictedflag?: number | null,
  } | null > | null,
};

export type ListTransactionMasterv2QueryVariables = {
  transactiontypecd?: string | null,
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListTransactionMasterv2Query = {
  listTransactionMasterv2?:  Array< {
    __typename: "TransactionMasterv2",
    transactionid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    transactiontypecd?: string | null,
    vouchernumber?: string | null,
    entrydate?: number | null,
    bankreferencenumber?: string | null,
    comments?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    cancelremark?: string | null,
    serialnumber?: string | null,
    paidfrom?: string | null,
    paidto?: string | null,
    paidfromamount?: string | null,
    paidtoamount?: string | null,
    paidfromaccountid?: string | null,
    paidtoaccountid?: string | null,
    paidfromemail?: string | null,
    paidtoemail?: string | null,
    paidfrompartyid?: string | null,
    paidtopartyid?: string | null,
    paidfrompartytypecd?: string | null,
    paidtopartytypecd?: string | null,
    paidfromcomments?: string | null,
    paidtocomments?: string | null,
    pdflink?: string | null,
    tds_payable_amount?: number | null,
    tds_receivable_amount?: number | null,
    tcs_payable_amount?: number | null,
    tcs_receivable_amount?: number | null,
    receiptamount?: number | null,
    paymentamount?: number | null,
    totalamount?: number | null,
    lastpaidtoaccountid?: number | null,
    lastpaidfromaccountid?: number | null,
    towards?: string | null,
  } | null > | null,
};

export type ListTransactionMasterQueryVariables = {
};

export type ListTransactionMasterQuery = {
  listTransactionMaster?:  Array< {
    __typename: "TransactionMaster",
    transactionid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    transactiontypecd?: string | null,
    vouchernumber?: string | null,
    entrydate?: number | null,
    bankreferencenumber?: string | null,
    comments?: string | null,
    relatedtransactiondetails?:  Array< {
      __typename: "TransactionDetailsCustom",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      accountid?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      comments?: string | null,
      entryordernumber?: number | null,
      transactionbalance?: number | null,
      openingbalance?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      financialyearid?: number | null,
    } | null > | null,
    relatedtransactionattachment?:  Array< {
      __typename: "TransactionAttachment",
      transactionid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      documentname: string,
      statuscode?: string | null,
      statusmessage?: string | null,
      type?: string | null,
    } | null > | null,
    relatedtransactiontdsdetails?:  Array< {
      __typename: "TransactionTDSDetails",
      transactionid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      tdsapplicablecd: string,
      tdsamount: number,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tdspercentage?: number | null,
    } | null > | null,
    relatedpurchasemaster?:  Array< {
      __typename: "PurchaseMasterNew",
      purchaseid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchasegsttypecd: string,
      supplierid: number,
      entrydate: number,
      vouchernumber: string,
      supplierinvoicedate: number,
      supplierinvoicenumber: string,
      supplieraddressid: number,
      paymenttypecd: string,
      paidamount: number,
      creditduration: number,
      paymentaccountid: number,
      comments: string,
      tdsapplicableflag: number,
      granttotalamount?: number | null,
      balancedueamount?: number | null,
      paymentclearedflag?: number | null,
      placeofsupply?: string | null,
      companystate?: string | null,
      relatedpurchasetdsdetails?:  Array< {
        __typename: "PurchaseTDSDetails",
        purchaseid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        tdsapplicablecd?: number | null,
        totaltaxableamount?: number | null,
        ineligibletcflag?: number | null,
        reversechargeflag?: number | null,
        gstcesstotal?: number | null,
        tdsamount?: number | null,
        adjustmentamount?: number | null,
        tdssection?: string | null,
        tdspercentage?: number | null,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaselineitems?:  Array< {
        __typename: "PurchaseLineItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        itemnumber: number,
        itemid: number,
        purchaseaccountid: number,
        hsncode: string,
        itemquantity: number,
        unittypecd: string,
        itemrate: number,
        itemamount: number,
        itemdiscount: number,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount: number,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnid?: string | null,
        hsncodetype?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        purchaseaccountname?: string | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinenonitems?:  Array< {
        __typename: "PurchaseLineNonItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchaselineitemtype: string,
        purchaseaccountid: number,
        hsnsaccode: string,
        itemdescription: string,
        taxableamount: number,
        netamount: number,
        relatedpurchaselinenongst?:  Array< {
          __typename: "PurchaseLineNonGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        purchaseaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaseattachment?:  Array< {
        __typename: "PurchaseAttachment",
        purchaseid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedpurchasetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      relatedpurchasetransactionrelation?:  Array< {
        __typename: "TransactionRelation",
        transactionid?: number | null,
        transactiontypecd?: string | null,
        objecttype?: string | null,
        objectid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        linkedamount?: number | null,
        objectattribute?: string | null,
        isdirect?: number | null,
        lastupdatedby?: string | null,
        accountid?: number | null,
        paymentvouchernumber?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      adjustmentamount?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      reversechargeflag?: number | null,
      paymentstatus?: number | null,
      partyregistrationtype?: string | null,
      partygstcategory?: string | null,
      itcflag?: number | null,
    } | null > | null,
    relatedinvoicemaster?:  Array< {
      __typename: "Invoicemasternew",
      invoiceid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      invoicetypecd: string,
      partyid: number,
      paymentaccountid: number,
      invoicedate: number,
      invoicenumber: string,
      customerordernumber: string,
      customerorderdate?: number | null,
      invoiceamount: number,
      paymenttype: string,
      creditduration: number,
      invoicebillingaddressid: number,
      invoicedeliveryaddressid: number,
      invoicetaxabletypecd: string,
      receipturl: string,
      invoicelinetypecd: string,
      invoicecurrencycd: string,
      exchangerate: number,
      comments: string,
      receivedamount: number,
      adjustmentamount: number,
      placeofsupply?: string | null,
      balancedueamount?: number | null,
      reversechargeflag?: number | null,
      tcsapplicableflag?: number | null,
      relatedinvoicelineitems?:  Array< {
        __typename: "InvoiceLineItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        lineitemnumber?: number | null,
        invoicelineitemtype?: string | null,
        itemid?: number | null,
        quantity?: number | null,
        unittypecd?: string | null,
        itemrate?: number | null,
        itemamount?: number | null,
        itemdiscount?: number | null,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        salesaccountname?: string | null,
        salesaccountid?: number | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        itemmaster_timestamp?: number | null,
        description?: string | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoicelinenonitems?:  Array< {
        __typename: "InvoiceLineNonItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        invoicelineitemtype?: string | null,
        incomeaccountid?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        itemdescription?: string | null,
        taxableamount?: number | null,
        netamount?: number | null,
        relatedaccounts?:  Array< {
          __typename: "AccountMaster",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accountname?: string | null,
          accounttypecd?: string | null,
          accountgroupid?: number | null,
          hsnsaccode?: string | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          restrictedflag?: number | null,
          is_active?: number | null,
          accounttypeflag?: number | null,
          relatedaccountgstdetails?:  Array< {
            __typename: "AccountGSTDetails",
            accountid?: number | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstrate?: number | null,
            cessamount?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsaccode?: string | null,
            codetype?: string | null,
            description?: string | null,
            taxability?: string | null,
          } | null > | null,
          relatedaccountopeningbalance?:  Array< {
            __typename: "AccountOpeningBalance",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            financialyearid?: number | null,
            startdate?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedaccountgroupmaster?:  Array< {
            __typename: "AccountGroupMasterNew",
            accountgroupid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accounttypecd?: string | null,
            accountgroupname?: string | null,
            accountparentgroupid?: number | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            is_active?: number | null,
            restrictedflag?: number | null,
            path?: string | null,
          } | null > | null,
          relatedaccountbalance?:  Array< {
            __typename: "AccountBalanceNew",
            accountid?: number | null,
            accountbalance?: number | null,
            actualbalance?: number | null,
          } | null > | null,
          path?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        incomeaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoiceattachment?:  Array< {
        __typename: "InvoiceAttachment",
        invoiceid?: number | null,
        attachmentid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        attachmentname?: string | null,
        attachmenturl?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedinvoicedispatch?:  Array< {
        __typename: "InvoiceDispatch",
        invoiceid: number,
        dispatchid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        transportationcd: string,
        vehiclenumber: string,
        dispatchdate: number,
        ewaybillnumber: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoiceposdetails?:  Array< {
        __typename: "InvoicePOSDetails",
        posid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        partyposid: number,
        lastupdatedby?: string | null,
        relatedposparty?:  Array< {
          __typename: "POSParty",
          pospartyid?: number | null,
          companyid?: number | null,
          partyname?: string | null,
          partycontactnumberid?: number | null,
          lastupdatedby?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          relatedphonecontacts?:  Array< {
            __typename: "PhoneContacts",
            id?: number | null,
            objecttype?: string | null,
            objectid?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            countrycode?: string | null,
            phonenumber?: string | null,
            verifieddatetime?: number | null,
            promotionssignup?: string | null,
            smsallowed?: string | null,
            callallowed?: string | null,
            whatsappallowed?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
        } | null > | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicenumbertracker?:  Array< {
        __typename: "InvoiceNumberTracker",
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        nextinvoicenumber: string,
        lastupdatedby?: string | null,
      } | null > | null,
      relatedinvoicetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      companystate?: string | null,
      cancelremark?: string | null,
      deleteremark?: string | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      paymentstatus?: number | null,
      ackno?: string | null,
      ackdt?: number | null,
      irn?: string | null,
      signedqrcode?: string | null,
      itcflag?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    cancelremark?: string | null,
    serialnumber?: string | null,
    pdflink?: string | null,
    towards?: string | null,
    isvouchereditable?: number | null,
  } | null > | null,
};

export type ListTransactionManualJournalQueryVariables = {
};

export type ListTransactionManualJournalQuery = {
  listTransactionManualJournal?:  Array< {
    __typename: "TransactionMaster",
    transactionid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    transactiontypecd?: string | null,
    vouchernumber?: string | null,
    entrydate?: number | null,
    bankreferencenumber?: string | null,
    comments?: string | null,
    relatedtransactiondetails?:  Array< {
      __typename: "TransactionDetailsCustom",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      accountid?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      comments?: string | null,
      entryordernumber?: number | null,
      transactionbalance?: number | null,
      openingbalance?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      financialyearid?: number | null,
    } | null > | null,
    relatedtransactionattachment?:  Array< {
      __typename: "TransactionAttachment",
      transactionid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      documentname: string,
      statuscode?: string | null,
      statusmessage?: string | null,
      type?: string | null,
    } | null > | null,
    relatedtransactiontdsdetails?:  Array< {
      __typename: "TransactionTDSDetails",
      transactionid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      tdsapplicablecd: string,
      tdsamount: number,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tdspercentage?: number | null,
    } | null > | null,
    relatedpurchasemaster?:  Array< {
      __typename: "PurchaseMasterNew",
      purchaseid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchasegsttypecd: string,
      supplierid: number,
      entrydate: number,
      vouchernumber: string,
      supplierinvoicedate: number,
      supplierinvoicenumber: string,
      supplieraddressid: number,
      paymenttypecd: string,
      paidamount: number,
      creditduration: number,
      paymentaccountid: number,
      comments: string,
      tdsapplicableflag: number,
      granttotalamount?: number | null,
      balancedueamount?: number | null,
      paymentclearedflag?: number | null,
      placeofsupply?: string | null,
      companystate?: string | null,
      relatedpurchasetdsdetails?:  Array< {
        __typename: "PurchaseTDSDetails",
        purchaseid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        tdsapplicablecd?: number | null,
        totaltaxableamount?: number | null,
        ineligibletcflag?: number | null,
        reversechargeflag?: number | null,
        gstcesstotal?: number | null,
        tdsamount?: number | null,
        adjustmentamount?: number | null,
        tdssection?: string | null,
        tdspercentage?: number | null,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaselineitems?:  Array< {
        __typename: "PurchaseLineItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        itemnumber: number,
        itemid: number,
        purchaseaccountid: number,
        hsncode: string,
        itemquantity: number,
        unittypecd: string,
        itemrate: number,
        itemamount: number,
        itemdiscount: number,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount: number,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnid?: string | null,
        hsncodetype?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        purchaseaccountname?: string | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinenonitems?:  Array< {
        __typename: "PurchaseLineNonItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchaselineitemtype: string,
        purchaseaccountid: number,
        hsnsaccode: string,
        itemdescription: string,
        taxableamount: number,
        netamount: number,
        relatedpurchaselinenongst?:  Array< {
          __typename: "PurchaseLineNonGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        purchaseaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaseattachment?:  Array< {
        __typename: "PurchaseAttachment",
        purchaseid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedpurchasetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      relatedpurchasetransactionrelation?:  Array< {
        __typename: "TransactionRelation",
        transactionid?: number | null,
        transactiontypecd?: string | null,
        objecttype?: string | null,
        objectid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        linkedamount?: number | null,
        objectattribute?: string | null,
        isdirect?: number | null,
        lastupdatedby?: string | null,
        accountid?: number | null,
        paymentvouchernumber?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      adjustmentamount?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      reversechargeflag?: number | null,
      paymentstatus?: number | null,
      partyregistrationtype?: string | null,
      partygstcategory?: string | null,
      itcflag?: number | null,
    } | null > | null,
    relatedinvoicemaster?:  Array< {
      __typename: "Invoicemasternew",
      invoiceid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      invoicetypecd: string,
      partyid: number,
      paymentaccountid: number,
      invoicedate: number,
      invoicenumber: string,
      customerordernumber: string,
      customerorderdate?: number | null,
      invoiceamount: number,
      paymenttype: string,
      creditduration: number,
      invoicebillingaddressid: number,
      invoicedeliveryaddressid: number,
      invoicetaxabletypecd: string,
      receipturl: string,
      invoicelinetypecd: string,
      invoicecurrencycd: string,
      exchangerate: number,
      comments: string,
      receivedamount: number,
      adjustmentamount: number,
      placeofsupply?: string | null,
      balancedueamount?: number | null,
      reversechargeflag?: number | null,
      tcsapplicableflag?: number | null,
      relatedinvoicelineitems?:  Array< {
        __typename: "InvoiceLineItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        lineitemnumber?: number | null,
        invoicelineitemtype?: string | null,
        itemid?: number | null,
        quantity?: number | null,
        unittypecd?: string | null,
        itemrate?: number | null,
        itemamount?: number | null,
        itemdiscount?: number | null,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        salesaccountname?: string | null,
        salesaccountid?: number | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        itemmaster_timestamp?: number | null,
        description?: string | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoicelinenonitems?:  Array< {
        __typename: "InvoiceLineNonItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        invoicelineitemtype?: string | null,
        incomeaccountid?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        itemdescription?: string | null,
        taxableamount?: number | null,
        netamount?: number | null,
        relatedaccounts?:  Array< {
          __typename: "AccountMaster",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accountname?: string | null,
          accounttypecd?: string | null,
          accountgroupid?: number | null,
          hsnsaccode?: string | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          restrictedflag?: number | null,
          is_active?: number | null,
          accounttypeflag?: number | null,
          relatedaccountgstdetails?:  Array< {
            __typename: "AccountGSTDetails",
            accountid?: number | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstrate?: number | null,
            cessamount?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsaccode?: string | null,
            codetype?: string | null,
            description?: string | null,
            taxability?: string | null,
          } | null > | null,
          relatedaccountopeningbalance?:  Array< {
            __typename: "AccountOpeningBalance",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            financialyearid?: number | null,
            startdate?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedaccountgroupmaster?:  Array< {
            __typename: "AccountGroupMasterNew",
            accountgroupid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accounttypecd?: string | null,
            accountgroupname?: string | null,
            accountparentgroupid?: number | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            is_active?: number | null,
            restrictedflag?: number | null,
            path?: string | null,
          } | null > | null,
          relatedaccountbalance?:  Array< {
            __typename: "AccountBalanceNew",
            accountid?: number | null,
            accountbalance?: number | null,
            actualbalance?: number | null,
          } | null > | null,
          path?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        incomeaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoiceattachment?:  Array< {
        __typename: "InvoiceAttachment",
        invoiceid?: number | null,
        attachmentid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        attachmentname?: string | null,
        attachmenturl?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedinvoicedispatch?:  Array< {
        __typename: "InvoiceDispatch",
        invoiceid: number,
        dispatchid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        transportationcd: string,
        vehiclenumber: string,
        dispatchdate: number,
        ewaybillnumber: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoiceposdetails?:  Array< {
        __typename: "InvoicePOSDetails",
        posid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        partyposid: number,
        lastupdatedby?: string | null,
        relatedposparty?:  Array< {
          __typename: "POSParty",
          pospartyid?: number | null,
          companyid?: number | null,
          partyname?: string | null,
          partycontactnumberid?: number | null,
          lastupdatedby?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          relatedphonecontacts?:  Array< {
            __typename: "PhoneContacts",
            id?: number | null,
            objecttype?: string | null,
            objectid?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            countrycode?: string | null,
            phonenumber?: string | null,
            verifieddatetime?: number | null,
            promotionssignup?: string | null,
            smsallowed?: string | null,
            callallowed?: string | null,
            whatsappallowed?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
        } | null > | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicenumbertracker?:  Array< {
        __typename: "InvoiceNumberTracker",
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        nextinvoicenumber: string,
        lastupdatedby?: string | null,
      } | null > | null,
      relatedinvoicetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      companystate?: string | null,
      cancelremark?: string | null,
      deleteremark?: string | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      paymentstatus?: number | null,
      ackno?: string | null,
      ackdt?: number | null,
      irn?: string | null,
      signedqrcode?: string | null,
      itcflag?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    cancelremark?: string | null,
    serialnumber?: string | null,
    pdflink?: string | null,
    towards?: string | null,
    isvouchereditable?: number | null,
  } | null > | null,
};

export type GetItemImagesQueryVariables = {
  itemid: number,
};

export type GetItemImagesQuery = {
  getItemImages?:  Array< {
    __typename: "ItemImages",
    attachmentid?: number | null,
    itemid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    imagename?: string | null,
    imageurl?: string | null,
    documentname?: string | null,
    type?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type GetItemmasterQueryVariables = {
  itemid: number,
};

export type GetItemmasterQuery = {
  getItemmaster?:  Array< {
    __typename: "itemmaster",
    itemid?: number | null,
    itemcode?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    itemname?: string | null,
    salesinvoiceflag?: number | null,
    purchaseinvoiceflag?: number | null,
    itemcategorycd?: string | null,
    measurementcd?: string | null,
    currencycd?: string | null,
    salesaccountid?: number | null,
    purchaseaccountid?: number | null,
    taxabilitycd?: string | null,
    reversechargeflag?: number | null,
    itemtype?: string | null,
    hsnid?: string | null,
    is_active?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relateditemamountdetails?:  Array< {
      __typename: "ItemAmountDetails",
      id?: number | null,
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      amount?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstcompensationvalue?: number | null,
      gstrate?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      invoicetype?: number | null,
      pricetype?: string | null,
      isactive?: number | null,
      isdefault?: number | null,
      pricetypeid?: number | null,
      tabletype?: number | null,
    } | null > | null,
    relateditemgstdetails?:  Array< {
      __typename: "ItemGstDetails",
      itemid: number,
      companyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      hsnid: string,
      gstcesstype: string,
      gstcompensationvalue: number,
      effectivedate?: number | null,
      expireddate?: number | null,
      gstcessvalue?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relateditemimages?:  Array< {
      __typename: "ItemImages",
      attachmentid?: number | null,
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      imagename?: string | null,
      imageurl?: string | null,
      documentname?: string | null,
      type?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    serialnumber?: string | null,
    financialyearid?: number | null,
    description?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsncodevalue?: string | null,
    hsndescription?: string | null,
    cessexist?: number | null,
    barcode?: string | null,
  } | null > | null,
};

export type GetbarcodeitemdataQueryVariables = {
  barcode: string,
  itemin?: string | null,
};

export type GetbarcodeitemdataQuery = {
  getbarcodeitemdata?:  Array< {
    __typename: "itemmaster",
    itemid?: number | null,
    itemcode?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    itemname?: string | null,
    salesinvoiceflag?: number | null,
    purchaseinvoiceflag?: number | null,
    itemcategorycd?: string | null,
    measurementcd?: string | null,
    currencycd?: string | null,
    salesaccountid?: number | null,
    purchaseaccountid?: number | null,
    taxabilitycd?: string | null,
    reversechargeflag?: number | null,
    itemtype?: string | null,
    hsnid?: string | null,
    is_active?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relateditemamountdetails?:  Array< {
      __typename: "ItemAmountDetails",
      id?: number | null,
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      amount?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstcompensationvalue?: number | null,
      gstrate?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      invoicetype?: number | null,
      pricetype?: string | null,
      isactive?: number | null,
      isdefault?: number | null,
      pricetypeid?: number | null,
      tabletype?: number | null,
    } | null > | null,
    relateditemgstdetails?:  Array< {
      __typename: "ItemGstDetails",
      itemid: number,
      companyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      hsnid: string,
      gstcesstype: string,
      gstcompensationvalue: number,
      effectivedate?: number | null,
      expireddate?: number | null,
      gstcessvalue?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relateditemimages?:  Array< {
      __typename: "ItemImages",
      attachmentid?: number | null,
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      imagename?: string | null,
      imageurl?: string | null,
      documentname?: string | null,
      type?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    serialnumber?: string | null,
    financialyearid?: number | null,
    description?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsncodevalue?: string | null,
    hsndescription?: string | null,
    cessexist?: number | null,
    barcode?: string | null,
  } | null > | null,
};

export type GetLinkedReceiptsQueryVariables = {
  vouchernumber: string,
  accountid?: number | null,
};

export type GetLinkedReceiptsQuery = {
  getLinkedReceipts?:  Array< {
    __typename: "LinkedReceipts",
    transactionid?: number | null,
    transactiontypecd?: string | null,
    objecttype?: string | null,
    objectid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    linkedamount?: number | null,
    invoicenumber?: string | null,
    invoicedate?: number | null,
    receiptvouchernumber?: string | null,
    grandtotalamount?: number | null,
    balancedueamount?: number | null,
  } | null > | null,
};

export type GetLocationQueryVariables = {
  pincode: string,
};

export type GetLocationQuery = {
  getLocation?:  Array< {
    __typename: "Location",
    pincode: string,
    state: string,
    district: string,
    city?: Array< string | null > | null,
  } | null > | null,
};

export type GetPartyAddressEntityQueryVariables = {
  objecttype: string,
  objectid: string,
};

export type GetPartyAddressEntityQuery = {
  getPartyAddressEntity?:  Array< {
    __typename: "AddressEntity",
    id?: number | null,
    objecttype?: string | null,
    objectid?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    line1?: string | null,
    line2?: string | null,
    line3?: string | null,
    city?: string | null,
    statecode?: string | null,
    statename?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    pincode?: string | null,
    countrycode?: string | null,
    codevalue?: string | null,
    district?: string | null,
    lastupdatedby?: string | null,
    godownname?: string | null,
    gstin?: string | null,
    phone?: string | null,
    email?: string | null,
    personincharge?: string | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    foreignstate?: string | null,
    foreigndistrict?: string | null,
    defaultflag?: number | null,
    addresstitle?: string | null,
    addressindex?: number | null,
  } | null > | null,
};

export type GetPartyMasterQueryVariables = {
  partyid: number,
};

export type GetPartyMasterQuery = {
  getPartyMaster?:  Array< {
    __typename: "partymaster",
    partyid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    partytypecd?: string | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    groupaccountid?: number | null,
    gstcategory?: string | null,
    placeofsupply?: string | null,
    entity?: string | null,
    email?: string | null,
    contactnumber?: string | null,
    whatsappnumber?: string | null,
    accountsid?: number | null,
    is_active?: number | null,
    msmetype?: string | null,
    deliveryconsigneename?: string | null,
    deliveryconsigneegstin?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedpartygstdetails?:  Array< {
      __typename: "PartyGSTDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      pannumber?: string | null,
      gstin?: string | null,
      partyaddressid?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycreditdetails?:  Array< {
      __typename: "PartyCreditDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      creditperiodduration?: string | null,
      billingcurrency?: string | null,
      creditlimitcd?: number | null,
      creditlimitamount?: number | null,
      billwiseflag?: number | null,
      notes?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycontact?:  Array< {
      __typename: "PartyContact",
      partyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      contacttypename: string,
      contactdesignationname: string,
      contactorder: number,
      email: string,
      phonenumber?: string | null,
      whatsappnumber?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
    } | null > | null,
    relatedpartyimages?:  Array< {
      __typename: "PartyImages",
      attachmentid?: number | null,
      partyid: number,
      companyid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      type: string,
      documentname: string,
      imagename: string,
      imageurl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    tdspercentage?: number | null,
    udhyamregno?: string | null,
    sameaddressflag?: number | null,
    comments?: string | null,
    tdssection?: string | null,
    accountname?: string | null,
    deliverystatecode?: number | null,
    deliverystatename?: string | null,
    contactcountry?: string | null,
    whatsappcountry?: string | null,
    entityname?: string | null,
  } | null > | null,
};

export type GetPartyMasterAccountWiseQueryVariables = {
  accountsid: number,
};

export type GetPartyMasterAccountWiseQuery = {
  getPartyMasterAccountWise?:  Array< {
    __typename: "partymaster",
    partyid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    partytypecd?: string | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    groupaccountid?: number | null,
    gstcategory?: string | null,
    placeofsupply?: string | null,
    entity?: string | null,
    email?: string | null,
    contactnumber?: string | null,
    whatsappnumber?: string | null,
    accountsid?: number | null,
    is_active?: number | null,
    msmetype?: string | null,
    deliveryconsigneename?: string | null,
    deliveryconsigneegstin?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedpartygstdetails?:  Array< {
      __typename: "PartyGSTDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      pannumber?: string | null,
      gstin?: string | null,
      partyaddressid?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycreditdetails?:  Array< {
      __typename: "PartyCreditDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      creditperiodduration?: string | null,
      billingcurrency?: string | null,
      creditlimitcd?: number | null,
      creditlimitamount?: number | null,
      billwiseflag?: number | null,
      notes?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycontact?:  Array< {
      __typename: "PartyContact",
      partyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      contacttypename: string,
      contactdesignationname: string,
      contactorder: number,
      email: string,
      phonenumber?: string | null,
      whatsappnumber?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
    } | null > | null,
    relatedpartyimages?:  Array< {
      __typename: "PartyImages",
      attachmentid?: number | null,
      partyid: number,
      companyid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      type: string,
      documentname: string,
      imagename: string,
      imageurl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    tdspercentage?: number | null,
    udhyamregno?: string | null,
    sameaddressflag?: number | null,
    comments?: string | null,
    tdssection?: string | null,
    accountname?: string | null,
    deliverystatecode?: number | null,
    deliverystatename?: string | null,
    contactcountry?: string | null,
    whatsappcountry?: string | null,
    entityname?: string | null,
  } | null > | null,
};

export type GetPaymentSettingsQueryVariables = {
};

export type GetPaymentSettingsQuery = {
  getPaymentSettings?:  Array< {
    __typename: "PaymentSettings",
    enable_itemwiseentry?: number | null,
    enable_creditperiod?: number | null,
    enable_creditlimit?: number | null,
    enable_autopayreminder?: number | null,
    enable_autoreminderdays?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    lastupdatedby?: string | null,
  } | null > | null,
};

export type GetPhoneContactsQueryVariables = {
  id: number,
};

export type GetPhoneContactsQuery = {
  getPhoneContacts?:  Array< {
    __typename: "PhoneContacts",
    id?: number | null,
    objecttype?: string | null,
    objectid?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    countrycode?: string | null,
    phonenumber?: string | null,
    verifieddatetime?: number | null,
    promotionssignup?: string | null,
    smsallowed?: string | null,
    callallowed?: string | null,
    whatsappallowed?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type GetPurchaseMasterQueryVariables = {
  purchaseid: number,
};

export type GetPurchaseMasterQuery = {
  getPurchaseMaster?:  Array< {
    __typename: "PurchaseMaster",
    purchaseid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    purchasegsttypecd?: string | null,
    supplierid?: number | null,
    entrydate?: number | null,
    vouchernumber?: string | null,
    supplierinvoicedate?: number | null,
    supplierinvoicenumber?: string | null,
    supplieraddressid?: number | null,
    paymenttypecd?: string | null,
    paidamount?: number | null,
    creditduration?: number | null,
    paymentaccountid?: number | null,
    comments?: string | null,
    tdsapplicableflag?: number | null,
    granttotalamount?: number | null,
    balancedueamount?: number | null,
    paymentclearedflag?: number | null,
    placeofsupply?: string | null,
    companystate?: string | null,
    relatedpurchasetdsdetails?:  Array< {
      __typename: "PurchaseTDSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tdsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tdsamount?: number | null,
      adjustmentamount?: number | null,
      tdssection?: string | null,
      tdspercentage?: number | null,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchasetcsdetails?:  Array< {
      __typename: "PurchaseTCSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedpurchaselineitems?:  Array< {
      __typename: "PurchaseLineItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      itemnumber: number,
      itemid: number,
      purchaseaccountid: number,
      hsncode: string,
      itemquantity: number,
      unittypecd: string,
      itemrate: number,
      itemamount: number,
      itemdiscount: number,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount: number,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnid?: string | null,
      hsncodetype?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      purchaseaccountname?: string | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinenonitems?:  Array< {
      __typename: "PurchaseLineNonItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchaselineitemtype: string,
      purchaseaccountid: number,
      hsnsaccode: string,
      itemdescription: string,
      taxableamount: number,
      netamount: number,
      relatedpurchaselinenongst?:  Array< {
        __typename: "PurchaseLineNonGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      purchaseaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinegst?:  Array< {
      __typename: "PurchaseLineGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaselinenongst?:  Array< {
      __typename: "PurchaseLineNonGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaseattachment?:  Array< {
      __typename: "PurchaseAttachment",
      purchaseid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedpurchasetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpartyaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedpurchaseaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    cancelflag?: number | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    adjustmentamount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    reversechargeflag?: number | null,
    overduedays?: number | null,
    paymentstatus?: number | null,
    partyregistrationtype?: string | null,
    purchaseinvoicepdf?: string | null,
    partygstcategory?: string | null,
    partyemail?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    accountname?: string | null,
    duedatetimestamp?: number | null,
    partyisactive?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    isvouchereditable?: number | null,
    goods_exist?: number | null,
    itcflag?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
    totalgstamount?: number | null,
    tdsamount?: number | null,
    tcsamount?: number | null,
    taxableamount?: number | null,
    igstamount?: number | null,
    cgstamount?: number | null,
    sgstamount?: number | null,
    cessamount?: number | null,
    sourceofsupply?: string | null,
    taxabilitylabel?: string | null,
    additionaldiscount?: number | null,
    netinvoiceamount?: number | null,
  } | null > | null,
};

export type GetReceiptDetailsQueryVariables = {
  transactionid?: number | null,
  financialyearid?: number | null,
};

export type GetReceiptDetailsQuery = {
  getReceiptDetails?:  Array< {
    __typename: "ReceiptDetails",
    id?: number | null,
    transactionid?: number | null,
    companyid?: number | null,
    financialyearid?: number | null,
    lastupdatedby?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    tan?: string | null,
    partyname?: string | null,
  } | null > | null,
};

export type ListTransactionDetailsQueryVariables = {
};

export type ListTransactionDetailsQuery = {
  listTransactionDetails?:  Array< {
    __typename: "TransactionDetailsCustom",
    transactionid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    transactiontypecd?: string | null,
    accountid?: number | null,
    creditamount?: number | null,
    debitamount?: number | null,
    comments?: string | null,
    entryordernumber?: number | null,
    transactionbalance?: number | null,
    openingbalance?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    financialyearid?: number | null,
  } | null > | null,
};

export type ListTransactionAttachmentQueryVariables = {
};

export type ListTransactionAttachmentQuery = {
  listTransactionAttachment?:  Array< {
    __typename: "TransactionAttachment",
    transactionid: number,
    attachmentid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    attachmentname: string,
    attachmenturl: string,
    lastupdatedby?: string | null,
    documentname: string,
    statuscode?: string | null,
    statusmessage?: string | null,
    type?: string | null,
  } | null > | null,
};

export type ListThemeColorsQueryVariables = {
};

export type ListThemeColorsQuery = {
  listThemeColors?:  Array< {
    __typename: "ThemeColor",
    themecolorid?: number | null,
    color?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
  } | null > | null,
};

export type ListspecificaccountbalanceQueryVariables = {
  accountid: string,
};

export type ListspecificaccountbalanceQuery = {
  listspecificaccountbalance?:  Array< {
    __typename: "AccountBalancev2",
    accountid?: number | null,
    accountbalance?: number | null,
    actualbalance?: number | null,
  } | null > | null,
};

export type ListPurchaseMasterTestQueryVariables = {
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListPurchaseMasterTestQuery = {
  listPurchaseMasterTest?:  Array< {
    __typename: "PurchaseMaster",
    purchaseid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    purchasegsttypecd?: string | null,
    supplierid?: number | null,
    entrydate?: number | null,
    vouchernumber?: string | null,
    supplierinvoicedate?: number | null,
    supplierinvoicenumber?: string | null,
    supplieraddressid?: number | null,
    paymenttypecd?: string | null,
    paidamount?: number | null,
    creditduration?: number | null,
    paymentaccountid?: number | null,
    comments?: string | null,
    tdsapplicableflag?: number | null,
    granttotalamount?: number | null,
    balancedueamount?: number | null,
    paymentclearedflag?: number | null,
    placeofsupply?: string | null,
    companystate?: string | null,
    relatedpurchasetdsdetails?:  Array< {
      __typename: "PurchaseTDSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tdsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tdsamount?: number | null,
      adjustmentamount?: number | null,
      tdssection?: string | null,
      tdspercentage?: number | null,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchasetcsdetails?:  Array< {
      __typename: "PurchaseTCSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedpurchaselineitems?:  Array< {
      __typename: "PurchaseLineItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      itemnumber: number,
      itemid: number,
      purchaseaccountid: number,
      hsncode: string,
      itemquantity: number,
      unittypecd: string,
      itemrate: number,
      itemamount: number,
      itemdiscount: number,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount: number,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnid?: string | null,
      hsncodetype?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      purchaseaccountname?: string | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinenonitems?:  Array< {
      __typename: "PurchaseLineNonItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchaselineitemtype: string,
      purchaseaccountid: number,
      hsnsaccode: string,
      itemdescription: string,
      taxableamount: number,
      netamount: number,
      relatedpurchaselinenongst?:  Array< {
        __typename: "PurchaseLineNonGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      purchaseaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinegst?:  Array< {
      __typename: "PurchaseLineGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaselinenongst?:  Array< {
      __typename: "PurchaseLineNonGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaseattachment?:  Array< {
      __typename: "PurchaseAttachment",
      purchaseid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedpurchasetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpartyaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedpurchaseaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    cancelflag?: number | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    adjustmentamount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    reversechargeflag?: number | null,
    overduedays?: number | null,
    paymentstatus?: number | null,
    partyregistrationtype?: string | null,
    purchaseinvoicepdf?: string | null,
    partygstcategory?: string | null,
    partyemail?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    accountname?: string | null,
    duedatetimestamp?: number | null,
    partyisactive?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    isvouchereditable?: number | null,
    goods_exist?: number | null,
    itcflag?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
    totalgstamount?: number | null,
    tdsamount?: number | null,
    tcsamount?: number | null,
    taxableamount?: number | null,
    igstamount?: number | null,
    cgstamount?: number | null,
    sgstamount?: number | null,
    cessamount?: number | null,
    sourceofsupply?: string | null,
    taxabilitylabel?: string | null,
    additionaldiscount?: number | null,
    netinvoiceamount?: number | null,
  } | null > | null,
};

export type GetSideBarUserPreferenceQueryVariables = {
  financialyearid: number,
};

export type GetSideBarUserPreferenceQuery = {
  getSideBarUserPreference?:  Array< {
    __typename: "UserPreference",
    userid?: string | null,
    attributetypecd?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    attributevalue?: number | null,
    additionalvalue?: string | null,
  } | null > | null,
};

export type GetTransactionDetailsQueryVariables = {
  transactionid: number,
};

export type GetTransactionDetailsQuery = {
  getTransactionDetails?:  Array< {
    __typename: "TransactionDetailsCustom",
    transactionid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    transactiontypecd?: string | null,
    accountid?: number | null,
    creditamount?: number | null,
    debitamount?: number | null,
    comments?: string | null,
    entryordernumber?: number | null,
    transactionbalance?: number | null,
    openingbalance?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    financialyearid?: number | null,
  } | null > | null,
};

export type GetTransactionMasterQueryVariables = {
  transactionid: number,
};

export type GetTransactionMasterQuery = {
  getTransactionMaster?:  Array< {
    __typename: "TransactionMaster",
    transactionid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    transactiontypecd?: string | null,
    vouchernumber?: string | null,
    entrydate?: number | null,
    bankreferencenumber?: string | null,
    comments?: string | null,
    relatedtransactiondetails?:  Array< {
      __typename: "TransactionDetailsCustom",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      accountid?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      comments?: string | null,
      entryordernumber?: number | null,
      transactionbalance?: number | null,
      openingbalance?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      financialyearid?: number | null,
    } | null > | null,
    relatedtransactionattachment?:  Array< {
      __typename: "TransactionAttachment",
      transactionid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      documentname: string,
      statuscode?: string | null,
      statusmessage?: string | null,
      type?: string | null,
    } | null > | null,
    relatedtransactiontdsdetails?:  Array< {
      __typename: "TransactionTDSDetails",
      transactionid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      tdsapplicablecd: string,
      tdsamount: number,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tdspercentage?: number | null,
    } | null > | null,
    relatedpurchasemaster?:  Array< {
      __typename: "PurchaseMasterNew",
      purchaseid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchasegsttypecd: string,
      supplierid: number,
      entrydate: number,
      vouchernumber: string,
      supplierinvoicedate: number,
      supplierinvoicenumber: string,
      supplieraddressid: number,
      paymenttypecd: string,
      paidamount: number,
      creditduration: number,
      paymentaccountid: number,
      comments: string,
      tdsapplicableflag: number,
      granttotalamount?: number | null,
      balancedueamount?: number | null,
      paymentclearedflag?: number | null,
      placeofsupply?: string | null,
      companystate?: string | null,
      relatedpurchasetdsdetails?:  Array< {
        __typename: "PurchaseTDSDetails",
        purchaseid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        tdsapplicablecd?: number | null,
        totaltaxableamount?: number | null,
        ineligibletcflag?: number | null,
        reversechargeflag?: number | null,
        gstcesstotal?: number | null,
        tdsamount?: number | null,
        adjustmentamount?: number | null,
        tdssection?: string | null,
        tdspercentage?: number | null,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaselineitems?:  Array< {
        __typename: "PurchaseLineItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        itemnumber: number,
        itemid: number,
        purchaseaccountid: number,
        hsncode: string,
        itemquantity: number,
        unittypecd: string,
        itemrate: number,
        itemamount: number,
        itemdiscount: number,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount: number,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnid?: string | null,
        hsncodetype?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        purchaseaccountname?: string | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinenonitems?:  Array< {
        __typename: "PurchaseLineNonItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchaselineitemtype: string,
        purchaseaccountid: number,
        hsnsaccode: string,
        itemdescription: string,
        taxableamount: number,
        netamount: number,
        relatedpurchaselinenongst?:  Array< {
          __typename: "PurchaseLineNonGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        purchaseaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaseattachment?:  Array< {
        __typename: "PurchaseAttachment",
        purchaseid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedpurchasetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      relatedpurchasetransactionrelation?:  Array< {
        __typename: "TransactionRelation",
        transactionid?: number | null,
        transactiontypecd?: string | null,
        objecttype?: string | null,
        objectid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        linkedamount?: number | null,
        objectattribute?: string | null,
        isdirect?: number | null,
        lastupdatedby?: string | null,
        accountid?: number | null,
        paymentvouchernumber?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      adjustmentamount?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      reversechargeflag?: number | null,
      paymentstatus?: number | null,
      partyregistrationtype?: string | null,
      partygstcategory?: string | null,
      itcflag?: number | null,
    } | null > | null,
    relatedinvoicemaster?:  Array< {
      __typename: "Invoicemasternew",
      invoiceid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      invoicetypecd: string,
      partyid: number,
      paymentaccountid: number,
      invoicedate: number,
      invoicenumber: string,
      customerordernumber: string,
      customerorderdate?: number | null,
      invoiceamount: number,
      paymenttype: string,
      creditduration: number,
      invoicebillingaddressid: number,
      invoicedeliveryaddressid: number,
      invoicetaxabletypecd: string,
      receipturl: string,
      invoicelinetypecd: string,
      invoicecurrencycd: string,
      exchangerate: number,
      comments: string,
      receivedamount: number,
      adjustmentamount: number,
      placeofsupply?: string | null,
      balancedueamount?: number | null,
      reversechargeflag?: number | null,
      tcsapplicableflag?: number | null,
      relatedinvoicelineitems?:  Array< {
        __typename: "InvoiceLineItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        lineitemnumber?: number | null,
        invoicelineitemtype?: string | null,
        itemid?: number | null,
        quantity?: number | null,
        unittypecd?: string | null,
        itemrate?: number | null,
        itemamount?: number | null,
        itemdiscount?: number | null,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        salesaccountname?: string | null,
        salesaccountid?: number | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        itemmaster_timestamp?: number | null,
        description?: string | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoicelinenonitems?:  Array< {
        __typename: "InvoiceLineNonItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        invoicelineitemtype?: string | null,
        incomeaccountid?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        itemdescription?: string | null,
        taxableamount?: number | null,
        netamount?: number | null,
        relatedaccounts?:  Array< {
          __typename: "AccountMaster",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accountname?: string | null,
          accounttypecd?: string | null,
          accountgroupid?: number | null,
          hsnsaccode?: string | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          restrictedflag?: number | null,
          is_active?: number | null,
          accounttypeflag?: number | null,
          relatedaccountgstdetails?:  Array< {
            __typename: "AccountGSTDetails",
            accountid?: number | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstrate?: number | null,
            cessamount?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsaccode?: string | null,
            codetype?: string | null,
            description?: string | null,
            taxability?: string | null,
          } | null > | null,
          relatedaccountopeningbalance?:  Array< {
            __typename: "AccountOpeningBalance",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            financialyearid?: number | null,
            startdate?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedaccountgroupmaster?:  Array< {
            __typename: "AccountGroupMasterNew",
            accountgroupid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accounttypecd?: string | null,
            accountgroupname?: string | null,
            accountparentgroupid?: number | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            is_active?: number | null,
            restrictedflag?: number | null,
            path?: string | null,
          } | null > | null,
          relatedaccountbalance?:  Array< {
            __typename: "AccountBalanceNew",
            accountid?: number | null,
            accountbalance?: number | null,
            actualbalance?: number | null,
          } | null > | null,
          path?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        incomeaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoiceattachment?:  Array< {
        __typename: "InvoiceAttachment",
        invoiceid?: number | null,
        attachmentid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        attachmentname?: string | null,
        attachmenturl?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedinvoicedispatch?:  Array< {
        __typename: "InvoiceDispatch",
        invoiceid: number,
        dispatchid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        transportationcd: string,
        vehiclenumber: string,
        dispatchdate: number,
        ewaybillnumber: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoiceposdetails?:  Array< {
        __typename: "InvoicePOSDetails",
        posid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        partyposid: number,
        lastupdatedby?: string | null,
        relatedposparty?:  Array< {
          __typename: "POSParty",
          pospartyid?: number | null,
          companyid?: number | null,
          partyname?: string | null,
          partycontactnumberid?: number | null,
          lastupdatedby?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          relatedphonecontacts?:  Array< {
            __typename: "PhoneContacts",
            id?: number | null,
            objecttype?: string | null,
            objectid?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            countrycode?: string | null,
            phonenumber?: string | null,
            verifieddatetime?: number | null,
            promotionssignup?: string | null,
            smsallowed?: string | null,
            callallowed?: string | null,
            whatsappallowed?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
        } | null > | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicenumbertracker?:  Array< {
        __typename: "InvoiceNumberTracker",
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        nextinvoicenumber: string,
        lastupdatedby?: string | null,
      } | null > | null,
      relatedinvoicetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      companystate?: string | null,
      cancelremark?: string | null,
      deleteremark?: string | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      paymentstatus?: number | null,
      ackno?: string | null,
      ackdt?: number | null,
      irn?: string | null,
      signedqrcode?: string | null,
      itcflag?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    cancelremark?: string | null,
    serialnumber?: string | null,
    pdflink?: string | null,
    towards?: string | null,
    isvouchereditable?: number | null,
  } | null > | null,
};

export type GetSetOffDetailsQueryVariables = {
  invoiceid: number,
  transactiontype: string,
  accountid?: number | null,
};

export type GetSetOffDetailsQuery = {
  getSetOffDetails?:  Array< {
    __typename: "SetOffDetails",
    invoiceid?: number | null,
    invoicenumber?: string | null,
    invoicedate?: number | null,
    invoiceamount_converted?: number | null,
    partyid?: number | null,
    companyid?: number | null,
    transactiontype?: string | null,
    transactiontypedesc?: string | null,
    net_adjustments?: number | null,
    payments_receipts?: number | null,
    setoff_balance?: number | null,
    setoff_status?: string | null,
    available_amount?: number | null,
    linked_to_target?: number | null,
    can_setoff?: number | null,
    setoff_priority?: number | null,
  } | null > | null,
};

export type GetTransactionRelationQueryVariables = {
  objectid: number,
};

export type GetTransactionRelationQuery = {
  getTransactionRelation?:  Array< {
    __typename: "TransactionRelation",
    transactionid?: number | null,
    transactiontypecd?: string | null,
    objecttype?: string | null,
    objectid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    linkedamount?: number | null,
    objectattribute?: string | null,
    isdirect?: number | null,
    lastupdatedby?: string | null,
    accountid?: number | null,
    paymentvouchernumber?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type GetTransactionRelationWithAccountIDQueryVariables = {
  accountid: number,
};

export type GetTransactionRelationWithAccountIDQuery = {
  getTransactionRelationWithAccountID?:  Array< {
    __typename: "TransactionRelation",
    transactionid?: number | null,
    transactiontypecd?: string | null,
    objecttype?: string | null,
    objectid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    linkedamount?: number | null,
    objectattribute?: string | null,
    isdirect?: number | null,
    lastupdatedby?: string | null,
    accountid?: number | null,
    paymentvouchernumber?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type GetTransactionTDSDetailsQueryVariables = {
  transactionid: number,
};

export type GetTransactionTDSDetailsQuery = {
  getTransactionTDSDetails?:  Array< {
    __typename: "TransactionTDSDetails",
    transactionid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    tdsapplicablecd: string,
    tdsamount: number,
    tdsmanual?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    tdspercentage?: number | null,
  } | null > | null,
};

export type GetUserPreferenceQueryVariables = {
  financialyearid: number,
};

export type GetUserPreferenceQuery = {
  getUserPreference?:  Array< {
    __typename: "UserPreference",
    userid?: string | null,
    attributetypecd?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    attributevalue?: number | null,
    additionalvalue?: string | null,
  } | null > | null,
};

export type GetUserThemePreferenceQueryVariables = {
};

export type GetUserThemePreferenceQuery = {
  getUserThemePreference?:  Array< {
    __typename: "UserThemePreference",
    userid?: string | null,
    attributetypecd?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    attributevalue?: number | null,
    additionalvalue?: string | null,
    relatedthemecolor?:  Array< {
      __typename: "ThemeColor",
      themecolorid?: number | null,
      color?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
    } | null > | null,
  } | null > | null,
};

export type ListaccountbalancesQueryVariables = {
};

export type ListaccountbalancesQuery = {
  listaccountbalances?:  Array< {
    __typename: "AccountBalancev2",
    accountid?: number | null,
    accountbalance?: number | null,
    actualbalance?: number | null,
  } | null > | null,
};

export type ListAccountGroupMasterQueryVariables = {
};

export type ListAccountGroupMasterQuery = {
  listAccountGroupMaster?:  Array< {
    __typename: "AccountGroupMaster",
    accountgroupid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accounttypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    relatedaccounts?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    path?: string | null,
  } | null > | null,
};

export type ListAccountGroupMasterv2QueryVariables = {
};

export type ListAccountGroupMasterv2Query = {
  listAccountGroupMasterv2?:  Array< {
    __typename: "AccountGroupMasterv2",
    accountgroupid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accounttypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    path?: string | null,
  } | null > | null,
};

export type ListAccountGroupsDropdownQueryVariables = {
  rowfrom: number,
  limitno: number,
  word: string,
};

export type ListAccountGroupsDropdownQuery = {
  listAccountGroupsDropdown?:  Array< {
    __typename: "AccountGroupMaster",
    accountgroupid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accounttypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    relatedaccounts?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    path?: string | null,
  } | null > | null,
};

export type ListAccountMasterQueryVariables = {
};

export type ListAccountMasterQuery = {
  listAccountMaster?:  Array< {
    __typename: "AccountMaster",
    accountsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    accountgroupid?: number | null,
    hsnsaccode?: string | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    accounttypeflag?: number | null,
    relatedaccountgstdetails?:  Array< {
      __typename: "AccountGSTDetails",
      accountid?: number | null,
      companyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstrate?: number | null,
      cessamount?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsaccode?: string | null,
      codetype?: string | null,
      description?: string | null,
      taxability?: string | null,
    } | null > | null,
    relatedaccountopeningbalance?:  Array< {
      __typename: "AccountOpeningBalance",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      financialyearid?: number | null,
      startdate?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedaccountgroupmaster?:  Array< {
      __typename: "AccountGroupMasterNew",
      accountgroupid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accounttypecd?: string | null,
      accountgroupname?: string | null,
      accountparentgroupid?: number | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      is_active?: number | null,
      restrictedflag?: number | null,
      path?: string | null,
    } | null > | null,
    relatedaccountbalance?:  Array< {
      __typename: "AccountBalanceNew",
      accountid?: number | null,
      accountbalance?: number | null,
      actualbalance?: number | null,
    } | null > | null,
    path?: string | null,
  } | null > | null,
};

export type ListAccountMasterSearchQueryVariables = {
  word: string,
};

export type ListAccountMasterSearchQuery = {
  listAccountMasterSearch?:  Array< {
    __typename: "AccountMasterv2",
    accountsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    accountgroupid?: number | null,
    hsnsaccode?: string | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    accountgroupenteredtimestamp?: number | null,
    accountgroupexpiredtimestamp?: number | null,
    accountgrouptypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    accountgroupdisplayordernumber?: number | null,
    accountgrouprestrictedflag?: number | null,
    accountgroupis_active?: number | null,
    accountgstenteredtimestamp?: number | null,
    accountgstexpiredtimestamp?: number | null,
    accountgsteffectivedate?: number | null,
    accountgstexpireddate?: number | null,
    hsnid?: string | null,
    gstcompensationtype?: string | null,
    gstrate?: number | null,
    cessamount?: number | null,
    accounttypeflag?: number | null,
    partyid?: number | null,
    tdspercentage?: number | null,
    tdssection?: string | null,
    path?: string | null,
    tax_type?: number | null,
    balancesign?: number | null,
    accountcreationdate?: number | null,
  } | null > | null,
};

export type ListPartymastersQueryVariables = {
};

export type ListPartymastersQuery = {
  listPartymasters?:  Array< {
    __typename: "partymaster",
    partyid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    partytypecd?: string | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    groupaccountid?: number | null,
    gstcategory?: string | null,
    placeofsupply?: string | null,
    entity?: string | null,
    email?: string | null,
    contactnumber?: string | null,
    whatsappnumber?: string | null,
    accountsid?: number | null,
    is_active?: number | null,
    msmetype?: string | null,
    deliveryconsigneename?: string | null,
    deliveryconsigneegstin?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedpartygstdetails?:  Array< {
      __typename: "PartyGSTDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      pannumber?: string | null,
      gstin?: string | null,
      partyaddressid?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycreditdetails?:  Array< {
      __typename: "PartyCreditDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      creditperiodduration?: string | null,
      billingcurrency?: string | null,
      creditlimitcd?: number | null,
      creditlimitamount?: number | null,
      billwiseflag?: number | null,
      notes?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycontact?:  Array< {
      __typename: "PartyContact",
      partyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      contacttypename: string,
      contactdesignationname: string,
      contactorder: number,
      email: string,
      phonenumber?: string | null,
      whatsappnumber?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
    } | null > | null,
    relatedpartyimages?:  Array< {
      __typename: "PartyImages",
      attachmentid?: number | null,
      partyid: number,
      companyid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      type: string,
      documentname: string,
      imagename: string,
      imageurl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    tdspercentage?: number | null,
    udhyamregno?: string | null,
    sameaddressflag?: number | null,
    comments?: string | null,
    tdssection?: string | null,
    accountname?: string | null,
    deliverystatecode?: number | null,
    deliverystatename?: string | null,
    contactcountry?: string | null,
    whatsappcountry?: string | null,
    entityname?: string | null,
  } | null > | null,
};

export type ListPartymastersv2QueryVariables = {
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListPartymastersv2Query = {
  listPartymastersv2?:  Array< {
    __typename: "partymasterv2",
    partyid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    partytypecd?: string | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    groupaccountid?: number | null,
    gstcategory?: string | null,
    placeofsupply?: string | null,
    entity?: string | null,
    email?: string | null,
    contactnumber?: string | null,
    whatsappnumber?: string | null,
    accountsid?: number | null,
    is_active?: number | null,
    msmetype?: string | null,
    deliveryconsigneename?: string | null,
    deliveryconsigneegstin?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
    tdspercentage?: number | null,
    udhyamregno?: string | null,
    partygstenteredtimestamp?: number | null,
    partygstexpiredtimestamp?: number | null,
    pannumber?: string | null,
    gstin?: string | null,
    partyaddressid?: number | null,
    contacttypename?: string | null,
    contactdesignationname?: string | null,
    contactorder?: number | null,
    partycontactemail?: string | null,
    phonenumber?: string | null,
    partycontactwhatsappnumber?: string | null,
    creditperiodduration?: number | null,
    billingcurrency?: number | null,
    creditlimitcd?: number | null,
    creditlimitamount?: number | null,
    billwiseflag?: number | null,
    notes?: string | null,
    sameaddressflag?: number | null,
    comments?: string | null,
    accountbalance?: number | null,
    tdssection?: string | null,
    accounttypeflag?: number | null,
    accountgroup?: string | null,
    contactcountry?: string | null,
    whatsappcountry?: string | null,
  } | null > | null,
};

export type ListPartymastersv2CountQueryVariables = {
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListPartymastersv2CountQuery = {
  listPartymastersv2Count?:  Array< {
    __typename: "PartyMasterListCount",
    partycount?: number | null,
    minbalancedue?: number | null,
    maxbalancedue?: number | null,
    totalpartybalance?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type ListPartyDropdownQueryVariables = {
  rowfrom: number,
  limitno: number,
  word: string,
};

export type ListPartyDropdownQuery = {
  listPartyDropdown?:  Array< {
    __typename: "partymaster",
    partyid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    partytypecd?: string | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    groupaccountid?: number | null,
    gstcategory?: string | null,
    placeofsupply?: string | null,
    entity?: string | null,
    email?: string | null,
    contactnumber?: string | null,
    whatsappnumber?: string | null,
    accountsid?: number | null,
    is_active?: number | null,
    msmetype?: string | null,
    deliveryconsigneename?: string | null,
    deliveryconsigneegstin?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedpartygstdetails?:  Array< {
      __typename: "PartyGSTDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      pannumber?: string | null,
      gstin?: string | null,
      partyaddressid?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycreditdetails?:  Array< {
      __typename: "PartyCreditDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      creditperiodduration?: string | null,
      billingcurrency?: string | null,
      creditlimitcd?: number | null,
      creditlimitamount?: number | null,
      billwiseflag?: number | null,
      notes?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycontact?:  Array< {
      __typename: "PartyContact",
      partyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      contacttypename: string,
      contactdesignationname: string,
      contactorder: number,
      email: string,
      phonenumber?: string | null,
      whatsappnumber?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
    } | null > | null,
    relatedpartyimages?:  Array< {
      __typename: "PartyImages",
      attachmentid?: number | null,
      partyid: number,
      companyid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      type: string,
      documentname: string,
      imagename: string,
      imageurl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    tdspercentage?: number | null,
    udhyamregno?: string | null,
    sameaddressflag?: number | null,
    comments?: string | null,
    tdssection?: string | null,
    accountname?: string | null,
    deliverystatecode?: number | null,
    deliverystatename?: string | null,
    contactcountry?: string | null,
    whatsappcountry?: string | null,
    entityname?: string | null,
  } | null > | null,
};

export type ListPartyInvoicesQueryVariables = {
  partyid: number,
};

export type ListPartyInvoicesQuery = {
  listPartyInvoices?:  Array< {
    __typename: "Invoicemaster",
    invoiceid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoicetypecd?: string | null,
    partyid?: number | null,
    paymentaccountid?: number | null,
    invoicedate?: number | null,
    invoicenumber?: string | null,
    customerordernumber?: string | null,
    customerorderdate?: number | null,
    invoiceamount?: number | null,
    paymenttype?: string | null,
    creditduration?: number | null,
    invoicebillingaddressid?: number | null,
    invoicedeliveryaddressid?: number | null,
    invoicetaxabletypecd?: string | null,
    receipturl?: string | null,
    invoicelinetypecd?: string | null,
    invoicecurrencycd?: string | null,
    exchangerate?: number | null,
    comments?: string | null,
    receivedamount?: number | null,
    adjustmentamount?: number | null,
    placeofsupply?: string | null,
    balancedueamount?: number | null,
    reversechargeflag?: number | null,
    tcsapplicableflag?: number | null,
    relatedinvoicetcsdetails?:  Array< {
      __typename: "InvoiceTCSDetails",
      invoiceid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedinvoicelineitems?:  Array< {
      __typename: "InvoiceLineItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemnumber?: number | null,
      invoicelineitemtype?: string | null,
      itemid?: number | null,
      quantity?: number | null,
      unittypecd?: string | null,
      itemrate?: number | null,
      itemamount?: number | null,
      itemdiscount?: number | null,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      salesaccountname?: string | null,
      salesaccountid?: number | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      itemmaster_timestamp?: number | null,
      description?: string | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoicelinenonitems?:  Array< {
      __typename: "InvoiceLineNonItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      invoicelineitemtype?: string | null,
      incomeaccountid?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      itemdescription?: string | null,
      taxableamount?: number | null,
      netamount?: number | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      incomeaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoiceattachment?:  Array< {
      __typename: "InvoiceAttachment",
      invoiceid?: number | null,
      attachmentid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      attachmentname?: string | null,
      attachmenturl?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedinvoicedispatch?:  Array< {
      __typename: "InvoiceDispatch",
      invoiceid: number,
      dispatchid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transportationcd: string,
      vehiclenumber: string,
      dispatchdate: number,
      ewaybillnumber: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoiceposdetails?:  Array< {
      __typename: "InvoicePOSDetails",
      posid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      partyposid: number,
      lastupdatedby?: string | null,
      relatedposparty?:  Array< {
        __typename: "POSParty",
        pospartyid?: number | null,
        companyid?: number | null,
        partyname?: string | null,
        partycontactnumberid?: number | null,
        lastupdatedby?: string | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        relatedphonecontacts?:  Array< {
          __typename: "PhoneContacts",
          id?: number | null,
          objecttype?: string | null,
          objectid?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          countrycode?: string | null,
          phonenumber?: string | null,
          verifieddatetime?: number | null,
          promotionssignup?: string | null,
          smsallowed?: string | null,
          callallowed?: string | null,
          whatsappallowed?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
      } | null > | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinegst?:  Array< {
      __typename: "InvoiceLineGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinenongst?:  Array< {
      __typename: "InvoiceLineNonGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicenumbertracker?:  Array< {
      __typename: "InvoiceNumberTracker",
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      nextinvoicenumber: string,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedinvoicetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedinvoiceaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    companystate?: string | null,
    cancelremark?: string | null,
    deleteremark?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    serialnumber?: string | null,
    serialflag?: number | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    paymentstatus?: number | null,
    ackno?: string | null,
    ackdt?: number | null,
    irn?: string | null,
    signedqrcode?: string | null,
    partyemail?: string | null,
    invoicepdf?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    partygstcategory?: string | null,
    is_cancelled?: number | null,
    cancel_reason?: string | null,
    cancel_remarks?: string | null,
    phonenumber?: string | null,
    bankaccountid?: number | null,
    bankamount?: number | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    ewaybill_cancel_rsn_code?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    invoicetype?: string | null,
    accountname?: string | null,
    partyisactive?: number | null,
    goods_exist?: number | null,
    overduedays?: number | null,
    duedatetimestamp?: number | null,
    isvouchereditable?: number | null,
    itcflag?: number | null,
    taxability?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
  } | null > | null,
};

export type ListOutstandingInvoiceMasterQueryVariables = {
  basedon?: number | null,
  ageing?: number | null,
  word: string,
  startdate: number,
  enddate: number,
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListOutstandingInvoiceMasterQuery = {
  listOutstandingInvoiceMaster?:  Array< {
    __typename: "OutstandingInvoicemaster",
    invoiceid?: number | null,
    invoicetype?: string | null,
    invoicenumber?: string | null,
    invoicedate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    invoiceamount?: number | null,
    receivedamount?: number | null,
    balancedueamount?: string | null,
    creditduration?: number | null,
    overduedays?: number | null,
    duedate?: number | null,
    recordcount?: number | null,
    total_balancedueamount?: string | null,
    partyid?: number | null,
    partyaccountid?: number | null,
    adjustment_details?:  Array< {
      __typename: "AdjustmentDetail",
      transactionid?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      linkedamount?: number | null,
      linkeddate?: string | null,
      isdirect?: number | null,
      paymentvouchernumber?: string | null,
      objectattribute?: string | null,
      transactiondate?: string | null,
      description?: string | null,
    } | null > | null,
    adjustment_summary?:  {
      __typename: "AdjustmentSummary",
      total_receipts?: number | null,
      total_credit_notes?: number | null,
      total_debit_notes?: number | null,
      total_payments?: number | null,
      adjustment_count?: number | null,
    } | null,
  } | null > | null,
};

export type ListOutstandingPurchaseMasterQueryVariables = {
  basedon?: number | null,
  ageing?: number | null,
  word: string,
  startdate: number,
  enddate: number,
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListOutstandingPurchaseMasterQuery = {
  listOutstandingPurchaseMaster?:  Array< {
    __typename: "OutstandingPurchasemaster",
    purchaseid?: number | null,
    invoicetype?: string | null,
    purchaseinvoicenumber?: string | null,
    purchaseinvoicedate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    granttotalamount?: number | null,
    receivedamount?: number | null,
    balancedueamount?: string | null,
    creditduration?: number | null,
    overduedays?: number | null,
    duedate?: number | null,
    recordcount?: number | null,
    total_balancedueamount?: string | null,
    partyid?: number | null,
    partyaccountid?: number | null,
  } | null > | null,
};

export type ListLUTBondMasterQueryVariables = {
};

export type ListLUTBondMasterQuery = {
  listLUTBondMaster?:  Array< {
    __typename: "LUTBondMaster",
    id?: number | null,
    lutno?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    validfrom?: number | null,
    validto?: number | null,
    financialyearid?: number | null,
  } | null > | null,
};

export type ListLineItemsQueryVariables = {
  jsondata: string,
};

export type ListLineItemsQuery = {
  listLineItems?:  Array< {
    __typename: "LineItemsList",
    type?: string | null,
    invoiceid?: number | null,
    purchaseid?: number | null,
    itemid?: number | null,
    quantity?: number | null,
    unittypecd?: string | null,
    itemrate?: number | null,
    itemamount?: number | null,
    itemdiscount?: number | null,
    itemdiscounttype?: string | null,
    itemdiscountrate?: number | null,
    netamount?: number | null,
    lineitemnumber?: number | null,
    invoicelineitemtype?: string | null,
    hsnsaccode?: string | null,
    taxability?: string | null,
    pricetype?: string | null,
    lotid?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    vouchernumber?: string | null,
    invoicelinetypecd?: string | null,
    comments?: string | null,
    balancedueamount?: number | null,
    reversechargeflag?: number | null,
    cancelflag?: number | null,
    invoiceitemid?: number | null,
    purchaseitemid?: number | null,
    gstrate?: number | null,
    gstamount?: number | null,
    cessamount?: number | null,
    itemquantity?: number | null,
    hsncode?: string | null,
    itemname?: string | null,
    salesaccountid?: number | null,
    purchaseaccountid?: number | null,
    hsndescription?: string | null,
    itemcode?: string | null,
    itemtype?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsnmastercode?: string | null,
    pricetypeid?: number | null,
    manualgst?: number | null,
    manualdiscount?: number | null,
    manualcess?: number | null,
    cessrate?: number | null,
    cesstype?: string | null,
    placeofsupply?: string | null,
    statename?: string | null,
  } | null > | null,
};

export type ListlatestInvoiceQueryVariables = {
};

export type ListlatestInvoiceQuery = {
  listlatestInvoice?:  Array< {
    __typename: "Invoicemaster",
    invoiceid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoicetypecd?: string | null,
    partyid?: number | null,
    paymentaccountid?: number | null,
    invoicedate?: number | null,
    invoicenumber?: string | null,
    customerordernumber?: string | null,
    customerorderdate?: number | null,
    invoiceamount?: number | null,
    paymenttype?: string | null,
    creditduration?: number | null,
    invoicebillingaddressid?: number | null,
    invoicedeliveryaddressid?: number | null,
    invoicetaxabletypecd?: string | null,
    receipturl?: string | null,
    invoicelinetypecd?: string | null,
    invoicecurrencycd?: string | null,
    exchangerate?: number | null,
    comments?: string | null,
    receivedamount?: number | null,
    adjustmentamount?: number | null,
    placeofsupply?: string | null,
    balancedueamount?: number | null,
    reversechargeflag?: number | null,
    tcsapplicableflag?: number | null,
    relatedinvoicetcsdetails?:  Array< {
      __typename: "InvoiceTCSDetails",
      invoiceid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedinvoicelineitems?:  Array< {
      __typename: "InvoiceLineItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemnumber?: number | null,
      invoicelineitemtype?: string | null,
      itemid?: number | null,
      quantity?: number | null,
      unittypecd?: string | null,
      itemrate?: number | null,
      itemamount?: number | null,
      itemdiscount?: number | null,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      salesaccountname?: string | null,
      salesaccountid?: number | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      itemmaster_timestamp?: number | null,
      description?: string | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoicelinenonitems?:  Array< {
      __typename: "InvoiceLineNonItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      invoicelineitemtype?: string | null,
      incomeaccountid?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      itemdescription?: string | null,
      taxableamount?: number | null,
      netamount?: number | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      incomeaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoiceattachment?:  Array< {
      __typename: "InvoiceAttachment",
      invoiceid?: number | null,
      attachmentid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      attachmentname?: string | null,
      attachmenturl?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedinvoicedispatch?:  Array< {
      __typename: "InvoiceDispatch",
      invoiceid: number,
      dispatchid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transportationcd: string,
      vehiclenumber: string,
      dispatchdate: number,
      ewaybillnumber: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoiceposdetails?:  Array< {
      __typename: "InvoicePOSDetails",
      posid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      partyposid: number,
      lastupdatedby?: string | null,
      relatedposparty?:  Array< {
        __typename: "POSParty",
        pospartyid?: number | null,
        companyid?: number | null,
        partyname?: string | null,
        partycontactnumberid?: number | null,
        lastupdatedby?: string | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        relatedphonecontacts?:  Array< {
          __typename: "PhoneContacts",
          id?: number | null,
          objecttype?: string | null,
          objectid?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          countrycode?: string | null,
          phonenumber?: string | null,
          verifieddatetime?: number | null,
          promotionssignup?: string | null,
          smsallowed?: string | null,
          callallowed?: string | null,
          whatsappallowed?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
      } | null > | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinegst?:  Array< {
      __typename: "InvoiceLineGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinenongst?:  Array< {
      __typename: "InvoiceLineNonGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicenumbertracker?:  Array< {
      __typename: "InvoiceNumberTracker",
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      nextinvoicenumber: string,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedinvoicetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedinvoiceaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    companystate?: string | null,
    cancelremark?: string | null,
    deleteremark?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    serialnumber?: string | null,
    serialflag?: number | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    paymentstatus?: number | null,
    ackno?: string | null,
    ackdt?: number | null,
    irn?: string | null,
    signedqrcode?: string | null,
    partyemail?: string | null,
    invoicepdf?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    partygstcategory?: string | null,
    is_cancelled?: number | null,
    cancel_reason?: string | null,
    cancel_remarks?: string | null,
    phonenumber?: string | null,
    bankaccountid?: number | null,
    bankamount?: number | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    ewaybill_cancel_rsn_code?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    invoicetype?: string | null,
    accountname?: string | null,
    partyisactive?: number | null,
    goods_exist?: number | null,
    overduedays?: number | null,
    duedatetimestamp?: number | null,
    isvouchereditable?: number | null,
    itcflag?: number | null,
    taxability?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
  } | null > | null,
};

export type ListlatestPurchaseQueryVariables = {
};

export type ListlatestPurchaseQuery = {
  listlatestPurchase?:  Array< {
    __typename: "PurchaseMaster",
    purchaseid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    purchasegsttypecd?: string | null,
    supplierid?: number | null,
    entrydate?: number | null,
    vouchernumber?: string | null,
    supplierinvoicedate?: number | null,
    supplierinvoicenumber?: string | null,
    supplieraddressid?: number | null,
    paymenttypecd?: string | null,
    paidamount?: number | null,
    creditduration?: number | null,
    paymentaccountid?: number | null,
    comments?: string | null,
    tdsapplicableflag?: number | null,
    granttotalamount?: number | null,
    balancedueamount?: number | null,
    paymentclearedflag?: number | null,
    placeofsupply?: string | null,
    companystate?: string | null,
    relatedpurchasetdsdetails?:  Array< {
      __typename: "PurchaseTDSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tdsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tdsamount?: number | null,
      adjustmentamount?: number | null,
      tdssection?: string | null,
      tdspercentage?: number | null,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchasetcsdetails?:  Array< {
      __typename: "PurchaseTCSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedpurchaselineitems?:  Array< {
      __typename: "PurchaseLineItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      itemnumber: number,
      itemid: number,
      purchaseaccountid: number,
      hsncode: string,
      itemquantity: number,
      unittypecd: string,
      itemrate: number,
      itemamount: number,
      itemdiscount: number,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount: number,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnid?: string | null,
      hsncodetype?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      purchaseaccountname?: string | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinenonitems?:  Array< {
      __typename: "PurchaseLineNonItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchaselineitemtype: string,
      purchaseaccountid: number,
      hsnsaccode: string,
      itemdescription: string,
      taxableamount: number,
      netamount: number,
      relatedpurchaselinenongst?:  Array< {
        __typename: "PurchaseLineNonGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      purchaseaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinegst?:  Array< {
      __typename: "PurchaseLineGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaselinenongst?:  Array< {
      __typename: "PurchaseLineNonGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaseattachment?:  Array< {
      __typename: "PurchaseAttachment",
      purchaseid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedpurchasetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpartyaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedpurchaseaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    cancelflag?: number | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    adjustmentamount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    reversechargeflag?: number | null,
    overduedays?: number | null,
    paymentstatus?: number | null,
    partyregistrationtype?: string | null,
    purchaseinvoicepdf?: string | null,
    partygstcategory?: string | null,
    partyemail?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    accountname?: string | null,
    duedatetimestamp?: number | null,
    partyisactive?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    isvouchereditable?: number | null,
    goods_exist?: number | null,
    itcflag?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
    totalgstamount?: number | null,
    tdsamount?: number | null,
    tcsamount?: number | null,
    taxableamount?: number | null,
    igstamount?: number | null,
    cgstamount?: number | null,
    sgstamount?: number | null,
    cessamount?: number | null,
    sourceofsupply?: string | null,
    taxabilitylabel?: string | null,
    additionaldiscount?: number | null,
    netinvoiceamount?: number | null,
  } | null > | null,
};

export type ListitemtablepreferenceQueryVariables = {
};

export type ListitemtablepreferenceQuery = {
  listitemtablepreference?:  Array< {
    __typename: "ItemTablePreference",
    id?: number | null,
    companyid?: number | null,
    type?: number | null,
    itemcode?: number | null,
    itemname?: number | null,
    category?: number | null,
    unit?: number | null,
    showitemin?: number | null,
    purchaseac?: number | null,
    salesac?: number | null,
    hsnSAC?: number | null,
    taxability?: number | null,
    purchaseamount?: number | null,
    sellingprice?: number | null,
    updateprice?: number | null,
    totalsellingprice?: number | null,
    effectivefrom?: number | null,
    effectiveto?: number | null,
    actions?: number | null,
    userid?: string | null,
  } | null > | null,
};

export type ListItemmastersv2QueryVariables = {
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListItemmastersv2Query = {
  listItemmastersv2?:  Array< {
    __typename: "itemmasterv2",
    itemid?: number | null,
    itemcode?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    itemname?: string | null,
    salesinvoiceflag?: number | null,
    purchaseinvoiceflag?: number | null,
    itemcategorycd?: string | null,
    measurementcd?: string | null,
    currencycd?: string | null,
    salesaccountid?: number | null,
    purchaseaccountid?: number | null,
    taxabilitycd?: string | null,
    reversechargeflag?: number | null,
    itemtype?: string | null,
    hsnid?: string | null,
    is_active?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
    itemamountenteredtimestamp?: number | null,
    itemamountexpiredtimestamp?: number | null,
    amount?: number | null,
    effectivedate?: number | null,
    expireddate?: number | null,
    sellinghsnid?: string | null,
    purchasehsnid?: string | null,
    gstcompensationtype?: string | null,
    gstcompensationvalue?: number | null,
    gstrate?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    imagename?: string | null,
    imageurl?: string | null,
    serialnumber?: string | null,
    isdefault?: number | null,
    invoicetype?: number | null,
    defaultsellingprice?: number | null,
    defaultpurchaseprice?: number | null,
    codetext?: string | null,
    itemcategory?: string | null,
    sellinggstcompensationtype?: string | null,
    purchasegstcompensationtype?: string | null,
    sellinggstcompensationvalue?: number | null,
    purchasegstcompensationvalue?: number | null,
    sellinggstrate?: number | null,
    purchasegstrate?: number | null,
    sellingdiscounttype?: number | null,
    purchasediscounttype?: number | null,
    sellingdiscountvalue?: number | null,
    purchasediscountvalue?: number | null,
    purchaseaccountname?: string | null,
    salesaccountname?: string | null,
    defaultnetsellingprice?: number | null,
    defaultnetpurchaseprice?: number | null,
    description?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsnsaccode?: string | null,
    hsndescription?: string | null,
    cessexist?: number | null,
    barcode?: string | null,
  } | null > | null,
};

export type ListItemmastersv2CountQueryVariables = {
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListItemmastersv2CountQuery = {
  listItemmastersv2Count?:  Array< {
    __typename: "ItemMasterListCount",
    itemcount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type ListItemmastersQueryVariables = {
};

export type ListItemmastersQuery = {
  listItemmasters?:  Array< {
    __typename: "itemmaster",
    itemid?: number | null,
    itemcode?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    itemname?: string | null,
    salesinvoiceflag?: number | null,
    purchaseinvoiceflag?: number | null,
    itemcategorycd?: string | null,
    measurementcd?: string | null,
    currencycd?: string | null,
    salesaccountid?: number | null,
    purchaseaccountid?: number | null,
    taxabilitycd?: string | null,
    reversechargeflag?: number | null,
    itemtype?: string | null,
    hsnid?: string | null,
    is_active?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relateditemamountdetails?:  Array< {
      __typename: "ItemAmountDetails",
      id?: number | null,
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      amount?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstcompensationvalue?: number | null,
      gstrate?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      invoicetype?: number | null,
      pricetype?: string | null,
      isactive?: number | null,
      isdefault?: number | null,
      pricetypeid?: number | null,
      tabletype?: number | null,
    } | null > | null,
    relateditemgstdetails?:  Array< {
      __typename: "ItemGstDetails",
      itemid: number,
      companyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      hsnid: string,
      gstcesstype: string,
      gstcompensationvalue: number,
      effectivedate?: number | null,
      expireddate?: number | null,
      gstcessvalue?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relateditemimages?:  Array< {
      __typename: "ItemImages",
      attachmentid?: number | null,
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      imagename?: string | null,
      imageurl?: string | null,
      documentname?: string | null,
      type?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    serialnumber?: string | null,
    financialyearid?: number | null,
    description?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsncodevalue?: string | null,
    hsndescription?: string | null,
    cessexist?: number | null,
    barcode?: string | null,
  } | null > | null,
};

export type ListItemLotDetailsQueryVariables = {
};

export type ListItemLotDetailsQuery = {
  listItemLotDetails?:  Array< {
    __typename: "ItemLotDetails",
    lotid?: number | null,
    itemid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    lotnumber?: number | null,
    lotquantity?: number | null,
    itemrate?: number | null,
    typecd?: string | null,
    balance?: number | null,
  } | null > | null,
};

export type ListItemCategorymasterQueryVariables = {
  maincategory: string,
};

export type ListItemCategorymasterQuery = {
  listItemCategorymaster?:  Array< {
    __typename: "ItemCategoryMaster",
    itemcategoryid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    category?: string | null,
    itemcategorygroupid?: number | null,
    maincategory?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
  } | null > | null,
};

export type ListInvoiceSettingsQueryVariables = {
  type: string,
};

export type ListInvoiceSettingsQuery = {
  listInvoiceSettings?:  Array< {
    __typename: "InvoiceSettings",
    invoicesettingsid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    typecd?: string | null,
    invoiceheading?: string | null,
    signaturetext?: string | null,
    declarationatfooter?: string | null,
    termsandcondition?: string | null,
    declarationatfooterflag?: number | null,
    termsandconditionsflag?: number | null,
    companyname?: number | null,
    companycin?: number | null,
    invoicenumber?: number | null,
    companyaddress?: number | null,
    companylogo?: number | null,
    invoicedate?: number | null,
    companycontactnumber?: number | null,
    companyemail?: number | null,
    paymentmode?: number | null,
    companygstin?: number | null,
    companywebsite?: number | null,
    creditperiod?: number | null,
    companypan?: number | null,
    companybankdetails?: number | null,
    paymentduedate?: number | null,
    customerlegalname?: number | null,
    customergstin?: number | null,
    lutbonddetails?: number | null,
    customerdisplayname?: number | null,
    placeofsupply?: number | null,
    dispatchdetails?: number | null,
    customerbillingaddress?: number | null,
    customercontactperson?: number | null,
    customercontactnumber?: number | null,
    customername?: number | null,
    ewaybilldetails?: number | null,
    customershippingaddress?: number | null,
    customerordernoanddate?: number | null,
    einvoicedetails?: number | null,
    itemwisediscount?: number | null,
    hsnsacode?: number | null,
    showroundoff?: number | null,
    hsnsasummarytable?: number | null,
    invoicedescription?: number | null,
    regularinvoicesignaturefilename?: string | null,
    last_updated_by?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    posinvoicesignaturefilename?: string | null,
    defaultsetting?: number | null,
    bankdetails?: string | null,
    upi_id?: string | null,
    acknowledgement?: string | null,
    acknowledgementflag?: number | null,
    bosinvoiceheading?: string | null,
    bank_name?: string | null,
    branch?: string | null,
    ac_name?: string | null,
    ac_no?: string | null,
    ifsc?: string | null,
    swift_code?: string | null,
  } | null > | null,
};

export type ListInvoiceMastervr2QueryVariables = {
};

export type ListInvoiceMastervr2Query = {
  listInvoiceMastervr2?:  Array< {
    __typename: "Invoicemasterv2",
    invoiceid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoicetypecd?: string | null,
    partyid?: number | null,
    paymentaccountid?: number | null,
    invoicedate?: number | null,
    invoicenumber?: string | null,
    customerordernumber?: string | null,
    customerorderdate?: number | null,
    invoiceamount?: number | null,
    paymenttype?: string | null,
    creditduration?: number | null,
    invoicebillingaddressid?: number | null,
    invoicedeliveryaddressid?: number | null,
    invoicetaxabletypecd?: string | null,
    receipturl?: string | null,
    invoicelinetypecd?: string | null,
    invoicecurrencycd?: string | null,
    exchangerate?: number | null,
    comments?: string | null,
    receivedamount?: number | null,
    adjustmentamount?: number | null,
    placeofsupply?: string | null,
    balancedueamount?: number | null,
    reversechargeflag?: number | null,
    tcsapplicableflag?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    companystate?: string | null,
    cancelremark?: string | null,
    deleteremark?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    paymentstatus?: number | null,
    ackno?: string | null,
    ackdt?: number | null,
    irn?: string | null,
    signedqrcode?: string | null,
    partyemail?: string | null,
    invoicepdf?: string | null,
  } | null > | null,
};

export type ListInvoiceMasterv2QueryVariables = {
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListInvoiceMasterv2Query = {
  listInvoiceMasterv2?:  Array< {
    __typename: "Invoicemaster",
    invoiceid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoicetypecd?: string | null,
    partyid?: number | null,
    paymentaccountid?: number | null,
    invoicedate?: number | null,
    invoicenumber?: string | null,
    customerordernumber?: string | null,
    customerorderdate?: number | null,
    invoiceamount?: number | null,
    paymenttype?: string | null,
    creditduration?: number | null,
    invoicebillingaddressid?: number | null,
    invoicedeliveryaddressid?: number | null,
    invoicetaxabletypecd?: string | null,
    receipturl?: string | null,
    invoicelinetypecd?: string | null,
    invoicecurrencycd?: string | null,
    exchangerate?: number | null,
    comments?: string | null,
    receivedamount?: number | null,
    adjustmentamount?: number | null,
    placeofsupply?: string | null,
    balancedueamount?: number | null,
    reversechargeflag?: number | null,
    tcsapplicableflag?: number | null,
    relatedinvoicetcsdetails?:  Array< {
      __typename: "InvoiceTCSDetails",
      invoiceid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedinvoicelineitems?:  Array< {
      __typename: "InvoiceLineItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemnumber?: number | null,
      invoicelineitemtype?: string | null,
      itemid?: number | null,
      quantity?: number | null,
      unittypecd?: string | null,
      itemrate?: number | null,
      itemamount?: number | null,
      itemdiscount?: number | null,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      salesaccountname?: string | null,
      salesaccountid?: number | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      itemmaster_timestamp?: number | null,
      description?: string | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoicelinenonitems?:  Array< {
      __typename: "InvoiceLineNonItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      invoicelineitemtype?: string | null,
      incomeaccountid?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      itemdescription?: string | null,
      taxableamount?: number | null,
      netamount?: number | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      incomeaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoiceattachment?:  Array< {
      __typename: "InvoiceAttachment",
      invoiceid?: number | null,
      attachmentid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      attachmentname?: string | null,
      attachmenturl?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedinvoicedispatch?:  Array< {
      __typename: "InvoiceDispatch",
      invoiceid: number,
      dispatchid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transportationcd: string,
      vehiclenumber: string,
      dispatchdate: number,
      ewaybillnumber: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoiceposdetails?:  Array< {
      __typename: "InvoicePOSDetails",
      posid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      partyposid: number,
      lastupdatedby?: string | null,
      relatedposparty?:  Array< {
        __typename: "POSParty",
        pospartyid?: number | null,
        companyid?: number | null,
        partyname?: string | null,
        partycontactnumberid?: number | null,
        lastupdatedby?: string | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        relatedphonecontacts?:  Array< {
          __typename: "PhoneContacts",
          id?: number | null,
          objecttype?: string | null,
          objectid?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          countrycode?: string | null,
          phonenumber?: string | null,
          verifieddatetime?: number | null,
          promotionssignup?: string | null,
          smsallowed?: string | null,
          callallowed?: string | null,
          whatsappallowed?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
      } | null > | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinegst?:  Array< {
      __typename: "InvoiceLineGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinenongst?:  Array< {
      __typename: "InvoiceLineNonGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicenumbertracker?:  Array< {
      __typename: "InvoiceNumberTracker",
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      nextinvoicenumber: string,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedinvoicetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedinvoiceaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    companystate?: string | null,
    cancelremark?: string | null,
    deleteremark?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    serialnumber?: string | null,
    serialflag?: number | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    paymentstatus?: number | null,
    ackno?: string | null,
    ackdt?: number | null,
    irn?: string | null,
    signedqrcode?: string | null,
    partyemail?: string | null,
    invoicepdf?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    partygstcategory?: string | null,
    is_cancelled?: number | null,
    cancel_reason?: string | null,
    cancel_remarks?: string | null,
    phonenumber?: string | null,
    bankaccountid?: number | null,
    bankamount?: number | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    ewaybill_cancel_rsn_code?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    invoicetype?: string | null,
    accountname?: string | null,
    partyisactive?: number | null,
    goods_exist?: number | null,
    overduedays?: number | null,
    duedatetimestamp?: number | null,
    isvouchereditable?: number | null,
    itcflag?: number | null,
    taxability?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
  } | null > | null,
};

export type ListInvoiceMasterRangeQueryVariables = {
  startdate: number,
  enddate: number,
};

export type ListInvoiceMasterRangeQuery = {
  listInvoiceMasterRange?:  Array< {
    __typename: "Invoicemaster",
    invoiceid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoicetypecd?: string | null,
    partyid?: number | null,
    paymentaccountid?: number | null,
    invoicedate?: number | null,
    invoicenumber?: string | null,
    customerordernumber?: string | null,
    customerorderdate?: number | null,
    invoiceamount?: number | null,
    paymenttype?: string | null,
    creditduration?: number | null,
    invoicebillingaddressid?: number | null,
    invoicedeliveryaddressid?: number | null,
    invoicetaxabletypecd?: string | null,
    receipturl?: string | null,
    invoicelinetypecd?: string | null,
    invoicecurrencycd?: string | null,
    exchangerate?: number | null,
    comments?: string | null,
    receivedamount?: number | null,
    adjustmentamount?: number | null,
    placeofsupply?: string | null,
    balancedueamount?: number | null,
    reversechargeflag?: number | null,
    tcsapplicableflag?: number | null,
    relatedinvoicetcsdetails?:  Array< {
      __typename: "InvoiceTCSDetails",
      invoiceid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedinvoicelineitems?:  Array< {
      __typename: "InvoiceLineItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemnumber?: number | null,
      invoicelineitemtype?: string | null,
      itemid?: number | null,
      quantity?: number | null,
      unittypecd?: string | null,
      itemrate?: number | null,
      itemamount?: number | null,
      itemdiscount?: number | null,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      salesaccountname?: string | null,
      salesaccountid?: number | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      itemmaster_timestamp?: number | null,
      description?: string | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoicelinenonitems?:  Array< {
      __typename: "InvoiceLineNonItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      invoicelineitemtype?: string | null,
      incomeaccountid?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      itemdescription?: string | null,
      taxableamount?: number | null,
      netamount?: number | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      incomeaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoiceattachment?:  Array< {
      __typename: "InvoiceAttachment",
      invoiceid?: number | null,
      attachmentid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      attachmentname?: string | null,
      attachmenturl?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedinvoicedispatch?:  Array< {
      __typename: "InvoiceDispatch",
      invoiceid: number,
      dispatchid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transportationcd: string,
      vehiclenumber: string,
      dispatchdate: number,
      ewaybillnumber: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoiceposdetails?:  Array< {
      __typename: "InvoicePOSDetails",
      posid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      partyposid: number,
      lastupdatedby?: string | null,
      relatedposparty?:  Array< {
        __typename: "POSParty",
        pospartyid?: number | null,
        companyid?: number | null,
        partyname?: string | null,
        partycontactnumberid?: number | null,
        lastupdatedby?: string | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        relatedphonecontacts?:  Array< {
          __typename: "PhoneContacts",
          id?: number | null,
          objecttype?: string | null,
          objectid?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          countrycode?: string | null,
          phonenumber?: string | null,
          verifieddatetime?: number | null,
          promotionssignup?: string | null,
          smsallowed?: string | null,
          callallowed?: string | null,
          whatsappallowed?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
      } | null > | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinegst?:  Array< {
      __typename: "InvoiceLineGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinenongst?:  Array< {
      __typename: "InvoiceLineNonGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicenumbertracker?:  Array< {
      __typename: "InvoiceNumberTracker",
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      nextinvoicenumber: string,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedinvoicetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedinvoiceaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    companystate?: string | null,
    cancelremark?: string | null,
    deleteremark?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    serialnumber?: string | null,
    serialflag?: number | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    paymentstatus?: number | null,
    ackno?: string | null,
    ackdt?: number | null,
    irn?: string | null,
    signedqrcode?: string | null,
    partyemail?: string | null,
    invoicepdf?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    partygstcategory?: string | null,
    is_cancelled?: number | null,
    cancel_reason?: string | null,
    cancel_remarks?: string | null,
    phonenumber?: string | null,
    bankaccountid?: number | null,
    bankamount?: number | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    ewaybill_cancel_rsn_code?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    invoicetype?: string | null,
    accountname?: string | null,
    partyisactive?: number | null,
    goods_exist?: number | null,
    overduedays?: number | null,
    duedatetimestamp?: number | null,
    isvouchereditable?: number | null,
    itcflag?: number | null,
    taxability?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
  } | null > | null,
};

export type ListInvoiceMasterCountQueryVariables = {
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListInvoiceMasterCountQuery = {
  listInvoiceMasterCount?:  Array< {
    __typename: "InvoiceMasterListCount",
    invoicemasterlistcount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type ListInvoiceMasterQueryVariables = {
};

export type ListInvoiceMasterQuery = {
  listInvoiceMaster?:  Array< {
    __typename: "Invoicemaster",
    invoiceid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoicetypecd?: string | null,
    partyid?: number | null,
    paymentaccountid?: number | null,
    invoicedate?: number | null,
    invoicenumber?: string | null,
    customerordernumber?: string | null,
    customerorderdate?: number | null,
    invoiceamount?: number | null,
    paymenttype?: string | null,
    creditduration?: number | null,
    invoicebillingaddressid?: number | null,
    invoicedeliveryaddressid?: number | null,
    invoicetaxabletypecd?: string | null,
    receipturl?: string | null,
    invoicelinetypecd?: string | null,
    invoicecurrencycd?: string | null,
    exchangerate?: number | null,
    comments?: string | null,
    receivedamount?: number | null,
    adjustmentamount?: number | null,
    placeofsupply?: string | null,
    balancedueamount?: number | null,
    reversechargeflag?: number | null,
    tcsapplicableflag?: number | null,
    relatedinvoicetcsdetails?:  Array< {
      __typename: "InvoiceTCSDetails",
      invoiceid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedinvoicelineitems?:  Array< {
      __typename: "InvoiceLineItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemnumber?: number | null,
      invoicelineitemtype?: string | null,
      itemid?: number | null,
      quantity?: number | null,
      unittypecd?: string | null,
      itemrate?: number | null,
      itemamount?: number | null,
      itemdiscount?: number | null,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      salesaccountname?: string | null,
      salesaccountid?: number | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      itemmaster_timestamp?: number | null,
      description?: string | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoicelinenonitems?:  Array< {
      __typename: "InvoiceLineNonItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      invoicelineitemtype?: string | null,
      incomeaccountid?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      itemdescription?: string | null,
      taxableamount?: number | null,
      netamount?: number | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      incomeaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoiceattachment?:  Array< {
      __typename: "InvoiceAttachment",
      invoiceid?: number | null,
      attachmentid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      attachmentname?: string | null,
      attachmenturl?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedinvoicedispatch?:  Array< {
      __typename: "InvoiceDispatch",
      invoiceid: number,
      dispatchid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transportationcd: string,
      vehiclenumber: string,
      dispatchdate: number,
      ewaybillnumber: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoiceposdetails?:  Array< {
      __typename: "InvoicePOSDetails",
      posid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      partyposid: number,
      lastupdatedby?: string | null,
      relatedposparty?:  Array< {
        __typename: "POSParty",
        pospartyid?: number | null,
        companyid?: number | null,
        partyname?: string | null,
        partycontactnumberid?: number | null,
        lastupdatedby?: string | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        relatedphonecontacts?:  Array< {
          __typename: "PhoneContacts",
          id?: number | null,
          objecttype?: string | null,
          objectid?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          countrycode?: string | null,
          phonenumber?: string | null,
          verifieddatetime?: number | null,
          promotionssignup?: string | null,
          smsallowed?: string | null,
          callallowed?: string | null,
          whatsappallowed?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
      } | null > | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinegst?:  Array< {
      __typename: "InvoiceLineGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinenongst?:  Array< {
      __typename: "InvoiceLineNonGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicenumbertracker?:  Array< {
      __typename: "InvoiceNumberTracker",
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      nextinvoicenumber: string,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedinvoicetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedinvoiceaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    companystate?: string | null,
    cancelremark?: string | null,
    deleteremark?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    serialnumber?: string | null,
    serialflag?: number | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    paymentstatus?: number | null,
    ackno?: string | null,
    ackdt?: number | null,
    irn?: string | null,
    signedqrcode?: string | null,
    partyemail?: string | null,
    invoicepdf?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    partygstcategory?: string | null,
    is_cancelled?: number | null,
    cancel_reason?: string | null,
    cancel_remarks?: string | null,
    phonenumber?: string | null,
    bankaccountid?: number | null,
    bankamount?: number | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    ewaybill_cancel_rsn_code?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    invoicetype?: string | null,
    accountname?: string | null,
    partyisactive?: number | null,
    goods_exist?: number | null,
    overduedays?: number | null,
    duedatetimestamp?: number | null,
    isvouchereditable?: number | null,
    itcflag?: number | null,
    taxability?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
  } | null > | null,
};

export type ListInvoiceDenominationsQueryVariables = {
  invoiceid?: number | null,
};

export type ListInvoiceDenominationsQuery = {
  listInvoiceDenominations?:  Array< {
    __typename: "Denomination",
    invoiceid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    denomination?: number | null,
    number_of_notes?: number | null,
    typecd?: string | null,
    last_updated_by?: string | null,
  } | null > | null,
};

export type ListIndustryTypeQueryVariables = {
};

export type ListIndustryTypeQuery = {
  listIndustryType?:  Array< {
    __typename: "IndustryType",
    industrytypeid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    industrytype?: string | null,
    lastupdatedby?: string | null,
    restrictedflag?: number | null,
    isactive?: number | null,
  } | null > | null,
};

export type ListHSNQueryVariables = {
  rowfrom: number,
  limitno: number,
};

export type ListHSNQuery = {
  listHSN?:  Array< {
    __typename: "hsnsacmaster",
    hsnsacid?: number | null,
    codetype?: string | null,
    hsnsaccode?: string | null,
    description?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    companyid?: number | null,
  } | null > | null,
};

export type ListGeneralSettingQueryVariables = {
  entrytypecd: string,
  financialyearid?: number | null,
};

export type ListGeneralSettingQuery = {
  listGeneralSetting?:  Array< {
    __typename: "NumberTracker",
    id?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    financialyearid?: number | null,
    entrytypecd?: string | null,
    serialnumber?: string | null,
    serialisactive?: number | null,
    serialisused?: number | null,
    nextinvoicenumber?: number | null,
    prefix?: string | null,
    suffix?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialflag?: number | null,
    startinvoicenumber?: number | null,
    taxability?: number | null,
    lastused?: number | null,
    secondlastused?: number | null,
    restrictedflag?: number | null,
  } | null > | null,
};

export type ListFinancialYearTransferHistoryQueryVariables = {
};

export type ListFinancialYearTransferHistoryQuery = {
  listFinancialYearTransferHistory?:  Array< {
    __typename: "FinancialYearTransferHistory",
    id?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    financialyearidfrom?: number | null,
    financialyearidto?: number | null,
    transferdate?: string | null,
    ledgertransferdate?: string | null,
    ledgercbtransferdate?: string | null,
    partyledgertransferdate?: string | null,
    partycbtransferdate?: string | null,
    itemtransferdate?: string | null,
    itemcbtransferdate?: string | null,
  } | null > | null,
};

export type ListFinancialYearStatusQueryVariables = {
};

export type ListFinancialYearStatusQuery = {
  listFinancialYearStatus?:  Array< {
    __typename: "FinancialYearStatus",
    financialyearid?: number | null,
    statustypecd?: string | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    statusvalue?: string | null,
    userid?: string | null,
  } | null > | null,
};

export type ListFinancialYearQueryVariables = {
};

export type ListFinancialYearQuery = {
  listFinancialYear?:  Array< {
    __typename: "FinancialYear",
    financialyearid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    startdate?: number | null,
    enddate?: number | null,
    startyear?: string | null,
    endyear?: string | null,
    comments?: string | null,
    userid?: string | null,
    aliasname?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    freezestatus?: number | null,
    transferdate?: number | null,
    freezedate?: number | null,
    stepscompleted?: Array< string | null > | null,
  } | null > | null,
};

export type ListEmailContactsQueryVariables = {
};

export type ListEmailContactsQuery = {
  listEmailContacts?:  Array< {
    __typename: "EmailContacts",
    id: number,
    objecttype: string,
    objectid: string,
    enteredtimestamp: number,
    expiredtimestamp: number,
    emailaddress: string,
    verifieddatetime?: number | null,
    promotionssignup?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
  } | null > | null,
};

export type ListeInvoiceUsersQueryVariables = {
};

export type ListeInvoiceUsersQuery = {
  listeInvoiceUsers?:  Array< {
    __typename: "EInvoiceUsers",
    id?: number | null,
    companyid?: number | null,
    username?: string | null,
    password?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    is_active?: number | null,
    lastupdatedby?: string | null,
  } | null > | null,
};

export type ListDeletedPaymentsQueryVariables = {
  type: string,
};

export type ListDeletedPaymentsQuery = {
  listDeletedPayments?:  Array< {
    __typename: "DeletedTransactionMaster",
    transactionid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    transactiontypecd: string,
    vouchernumber: string,
    entrydate: number,
    bankreferencenumber?: string | null,
    comments?: string | null,
    relatedtransactiondetails?:  Array< {
      __typename: "TransactionDetailsCustomDeleted",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      accountid?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      comments?: string | null,
      entryordernumber?: number | null,
      transactionbalance?: number | null,
      openingbalance?: number | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      financialyearid?: number | null,
    } | null > | null,
    relatedtransactionattachment?:  Array< {
      __typename: "TransactionAttachment",
      transactionid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      documentname: string,
      statuscode?: string | null,
      statusmessage?: string | null,
      type?: string | null,
    } | null > | null,
    relatedtransactiontdsdetails?:  Array< {
      __typename: "TransactionTDSDetails",
      transactionid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      tdsapplicablecd: string,
      tdsamount: number,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tdspercentage?: number | null,
    } | null > | null,
    relatedpurchasemaster?:  Array< {
      __typename: "PurchaseMasterNew",
      purchaseid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchasegsttypecd: string,
      supplierid: number,
      entrydate: number,
      vouchernumber: string,
      supplierinvoicedate: number,
      supplierinvoicenumber: string,
      supplieraddressid: number,
      paymenttypecd: string,
      paidamount: number,
      creditduration: number,
      paymentaccountid: number,
      comments: string,
      tdsapplicableflag: number,
      granttotalamount?: number | null,
      balancedueamount?: number | null,
      paymentclearedflag?: number | null,
      placeofsupply?: string | null,
      companystate?: string | null,
      relatedpurchasetdsdetails?:  Array< {
        __typename: "PurchaseTDSDetails",
        purchaseid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        tdsapplicablecd?: number | null,
        totaltaxableamount?: number | null,
        ineligibletcflag?: number | null,
        reversechargeflag?: number | null,
        gstcesstotal?: number | null,
        tdsamount?: number | null,
        adjustmentamount?: number | null,
        tdssection?: string | null,
        tdspercentage?: number | null,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaselineitems?:  Array< {
        __typename: "PurchaseLineItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        itemnumber: number,
        itemid: number,
        purchaseaccountid: number,
        hsncode: string,
        itemquantity: number,
        unittypecd: string,
        itemrate: number,
        itemamount: number,
        itemdiscount: number,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount: number,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnid?: string | null,
        hsncodetype?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        purchaseaccountname?: string | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinenonitems?:  Array< {
        __typename: "PurchaseLineNonItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchaselineitemtype: string,
        purchaseaccountid: number,
        hsnsaccode: string,
        itemdescription: string,
        taxableamount: number,
        netamount: number,
        relatedpurchaselinenongst?:  Array< {
          __typename: "PurchaseLineNonGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        purchaseaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaseattachment?:  Array< {
        __typename: "PurchaseAttachment",
        purchaseid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedpurchasetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      relatedpurchasetransactionrelation?:  Array< {
        __typename: "TransactionRelation",
        transactionid?: number | null,
        transactiontypecd?: string | null,
        objecttype?: string | null,
        objectid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        linkedamount?: number | null,
        objectattribute?: string | null,
        isdirect?: number | null,
        lastupdatedby?: string | null,
        accountid?: number | null,
        paymentvouchernumber?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      adjustmentamount?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      reversechargeflag?: number | null,
      paymentstatus?: number | null,
      partyregistrationtype?: string | null,
      partygstcategory?: string | null,
      itcflag?: number | null,
    } | null > | null,
    relatedinvoicemaster?:  Array< {
      __typename: "Invoicemasternew",
      invoiceid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      invoicetypecd: string,
      partyid: number,
      paymentaccountid: number,
      invoicedate: number,
      invoicenumber: string,
      customerordernumber: string,
      customerorderdate?: number | null,
      invoiceamount: number,
      paymenttype: string,
      creditduration: number,
      invoicebillingaddressid: number,
      invoicedeliveryaddressid: number,
      invoicetaxabletypecd: string,
      receipturl: string,
      invoicelinetypecd: string,
      invoicecurrencycd: string,
      exchangerate: number,
      comments: string,
      receivedamount: number,
      adjustmentamount: number,
      placeofsupply?: string | null,
      balancedueamount?: number | null,
      reversechargeflag?: number | null,
      tcsapplicableflag?: number | null,
      relatedinvoicelineitems?:  Array< {
        __typename: "InvoiceLineItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        lineitemnumber?: number | null,
        invoicelineitemtype?: string | null,
        itemid?: number | null,
        quantity?: number | null,
        unittypecd?: string | null,
        itemrate?: number | null,
        itemamount?: number | null,
        itemdiscount?: number | null,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        salesaccountname?: string | null,
        salesaccountid?: number | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        itemmaster_timestamp?: number | null,
        description?: string | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoicelinenonitems?:  Array< {
        __typename: "InvoiceLineNonItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        invoicelineitemtype?: string | null,
        incomeaccountid?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        itemdescription?: string | null,
        taxableamount?: number | null,
        netamount?: number | null,
        relatedaccounts?:  Array< {
          __typename: "AccountMaster",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accountname?: string | null,
          accounttypecd?: string | null,
          accountgroupid?: number | null,
          hsnsaccode?: string | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          restrictedflag?: number | null,
          is_active?: number | null,
          accounttypeflag?: number | null,
          relatedaccountgstdetails?:  Array< {
            __typename: "AccountGSTDetails",
            accountid?: number | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstrate?: number | null,
            cessamount?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsaccode?: string | null,
            codetype?: string | null,
            description?: string | null,
            taxability?: string | null,
          } | null > | null,
          relatedaccountopeningbalance?:  Array< {
            __typename: "AccountOpeningBalance",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            financialyearid?: number | null,
            startdate?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedaccountgroupmaster?:  Array< {
            __typename: "AccountGroupMasterNew",
            accountgroupid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accounttypecd?: string | null,
            accountgroupname?: string | null,
            accountparentgroupid?: number | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            is_active?: number | null,
            restrictedflag?: number | null,
            path?: string | null,
          } | null > | null,
          relatedaccountbalance?:  Array< {
            __typename: "AccountBalanceNew",
            accountid?: number | null,
            accountbalance?: number | null,
            actualbalance?: number | null,
          } | null > | null,
          path?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        incomeaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoiceattachment?:  Array< {
        __typename: "InvoiceAttachment",
        invoiceid?: number | null,
        attachmentid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        attachmentname?: string | null,
        attachmenturl?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedinvoicedispatch?:  Array< {
        __typename: "InvoiceDispatch",
        invoiceid: number,
        dispatchid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        transportationcd: string,
        vehiclenumber: string,
        dispatchdate: number,
        ewaybillnumber: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoiceposdetails?:  Array< {
        __typename: "InvoicePOSDetails",
        posid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        partyposid: number,
        lastupdatedby?: string | null,
        relatedposparty?:  Array< {
          __typename: "POSParty",
          pospartyid?: number | null,
          companyid?: number | null,
          partyname?: string | null,
          partycontactnumberid?: number | null,
          lastupdatedby?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          relatedphonecontacts?:  Array< {
            __typename: "PhoneContacts",
            id?: number | null,
            objecttype?: string | null,
            objectid?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            countrycode?: string | null,
            phonenumber?: string | null,
            verifieddatetime?: number | null,
            promotionssignup?: string | null,
            smsallowed?: string | null,
            callallowed?: string | null,
            whatsappallowed?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
        } | null > | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicenumbertracker?:  Array< {
        __typename: "InvoiceNumberTracker",
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        nextinvoicenumber: string,
        lastupdatedby?: string | null,
      } | null > | null,
      relatedinvoicetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      companystate?: string | null,
      cancelremark?: string | null,
      deleteremark?: string | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      paymentstatus?: number | null,
      ackno?: string | null,
      ackdt?: number | null,
      irn?: string | null,
      signedqrcode?: string | null,
      itcflag?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
  } | null > | null,
};

export type ListDeletedPartyQueryVariables = {
  type: string,
};

export type ListDeletedPartyQuery = {
  listDeletedParty?:  Array< {
    __typename: "partymasterDeleted",
    partyid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    partytypecd?: string | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    groupaccountid?: number | null,
    gstcategory?: string | null,
    placeofsupply?: string | null,
    entity?: string | null,
    email?: string | null,
    contactnumber?: string | null,
    whatsappnumber?: string | null,
    accountsid?: number | null,
    is_active?: number | null,
    msmetype?: string | null,
    deliveryconsigneename?: string | null,
    deliveryconsigneegstin?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedpartygstdetails?:  Array< {
      __typename: "PartyGSTDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      pannumber?: string | null,
      gstin?: string | null,
      partyaddressid?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycreditdetails?:  Array< {
      __typename: "PartyCreditDetails",
      partyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      creditperiodduration?: string | null,
      billingcurrency?: string | null,
      creditlimitcd?: number | null,
      creditlimitamount?: number | null,
      billwiseflag?: number | null,
      notes?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpartycontact?:  Array< {
      __typename: "PartyContact",
      partyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      contacttypename: string,
      contactdesignationname: string,
      contactorder: number,
      email: string,
      phonenumber?: string | null,
      whatsappnumber?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
    } | null > | null,
    relatedpartyimages?:  Array< {
      __typename: "PartyImages",
      attachmentid?: number | null,
      partyid: number,
      companyid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      type: string,
      documentname: string,
      imagename: string,
      imageurl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchasemaster?:  Array< {
      __typename: "PurchaseMasterNew",
      purchaseid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchasegsttypecd: string,
      supplierid: number,
      entrydate: number,
      vouchernumber: string,
      supplierinvoicedate: number,
      supplierinvoicenumber: string,
      supplieraddressid: number,
      paymenttypecd: string,
      paidamount: number,
      creditduration: number,
      paymentaccountid: number,
      comments: string,
      tdsapplicableflag: number,
      granttotalamount?: number | null,
      balancedueamount?: number | null,
      paymentclearedflag?: number | null,
      placeofsupply?: string | null,
      companystate?: string | null,
      relatedpurchasetdsdetails?:  Array< {
        __typename: "PurchaseTDSDetails",
        purchaseid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        tdsapplicablecd?: number | null,
        totaltaxableamount?: number | null,
        ineligibletcflag?: number | null,
        reversechargeflag?: number | null,
        gstcesstotal?: number | null,
        tdsamount?: number | null,
        adjustmentamount?: number | null,
        tdssection?: string | null,
        tdspercentage?: number | null,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaselineitems?:  Array< {
        __typename: "PurchaseLineItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        itemnumber: number,
        itemid: number,
        purchaseaccountid: number,
        hsncode: string,
        itemquantity: number,
        unittypecd: string,
        itemrate: number,
        itemamount: number,
        itemdiscount: number,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount: number,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnid?: string | null,
        hsncodetype?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        purchaseaccountname?: string | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinenonitems?:  Array< {
        __typename: "PurchaseLineNonItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchaselineitemtype: string,
        purchaseaccountid: number,
        hsnsaccode: string,
        itemdescription: string,
        taxableamount: number,
        netamount: number,
        relatedpurchaselinenongst?:  Array< {
          __typename: "PurchaseLineNonGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        purchaseaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaseattachment?:  Array< {
        __typename: "PurchaseAttachment",
        purchaseid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedpurchasetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      relatedpurchasetransactionrelation?:  Array< {
        __typename: "TransactionRelation",
        transactionid?: number | null,
        transactiontypecd?: string | null,
        objecttype?: string | null,
        objectid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        linkedamount?: number | null,
        objectattribute?: string | null,
        isdirect?: number | null,
        lastupdatedby?: string | null,
        accountid?: number | null,
        paymentvouchernumber?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      adjustmentamount?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      reversechargeflag?: number | null,
      paymentstatus?: number | null,
      partyregistrationtype?: string | null,
      partygstcategory?: string | null,
      itcflag?: number | null,
    } | null > | null,
    relatedinvoicemaster?:  Array< {
      __typename: "Invoicemasternew",
      invoiceid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      invoicetypecd: string,
      partyid: number,
      paymentaccountid: number,
      invoicedate: number,
      invoicenumber: string,
      customerordernumber: string,
      customerorderdate?: number | null,
      invoiceamount: number,
      paymenttype: string,
      creditduration: number,
      invoicebillingaddressid: number,
      invoicedeliveryaddressid: number,
      invoicetaxabletypecd: string,
      receipturl: string,
      invoicelinetypecd: string,
      invoicecurrencycd: string,
      exchangerate: number,
      comments: string,
      receivedamount: number,
      adjustmentamount: number,
      placeofsupply?: string | null,
      balancedueamount?: number | null,
      reversechargeflag?: number | null,
      tcsapplicableflag?: number | null,
      relatedinvoicelineitems?:  Array< {
        __typename: "InvoiceLineItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        lineitemnumber?: number | null,
        invoicelineitemtype?: string | null,
        itemid?: number | null,
        quantity?: number | null,
        unittypecd?: string | null,
        itemrate?: number | null,
        itemamount?: number | null,
        itemdiscount?: number | null,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        salesaccountname?: string | null,
        salesaccountid?: number | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        itemmaster_timestamp?: number | null,
        description?: string | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoicelinenonitems?:  Array< {
        __typename: "InvoiceLineNonItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        invoicelineitemtype?: string | null,
        incomeaccountid?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        itemdescription?: string | null,
        taxableamount?: number | null,
        netamount?: number | null,
        relatedaccounts?:  Array< {
          __typename: "AccountMaster",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accountname?: string | null,
          accounttypecd?: string | null,
          accountgroupid?: number | null,
          hsnsaccode?: string | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          restrictedflag?: number | null,
          is_active?: number | null,
          accounttypeflag?: number | null,
          relatedaccountgstdetails?:  Array< {
            __typename: "AccountGSTDetails",
            accountid?: number | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstrate?: number | null,
            cessamount?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsaccode?: string | null,
            codetype?: string | null,
            description?: string | null,
            taxability?: string | null,
          } | null > | null,
          relatedaccountopeningbalance?:  Array< {
            __typename: "AccountOpeningBalance",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            financialyearid?: number | null,
            startdate?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedaccountgroupmaster?:  Array< {
            __typename: "AccountGroupMasterNew",
            accountgroupid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accounttypecd?: string | null,
            accountgroupname?: string | null,
            accountparentgroupid?: number | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            is_active?: number | null,
            restrictedflag?: number | null,
            path?: string | null,
          } | null > | null,
          relatedaccountbalance?:  Array< {
            __typename: "AccountBalanceNew",
            accountid?: number | null,
            accountbalance?: number | null,
            actualbalance?: number | null,
          } | null > | null,
          path?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        incomeaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoiceattachment?:  Array< {
        __typename: "InvoiceAttachment",
        invoiceid?: number | null,
        attachmentid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        attachmentname?: string | null,
        attachmenturl?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedinvoicedispatch?:  Array< {
        __typename: "InvoiceDispatch",
        invoiceid: number,
        dispatchid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        transportationcd: string,
        vehiclenumber: string,
        dispatchdate: number,
        ewaybillnumber: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoiceposdetails?:  Array< {
        __typename: "InvoicePOSDetails",
        posid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        partyposid: number,
        lastupdatedby?: string | null,
        relatedposparty?:  Array< {
          __typename: "POSParty",
          pospartyid?: number | null,
          companyid?: number | null,
          partyname?: string | null,
          partycontactnumberid?: number | null,
          lastupdatedby?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          relatedphonecontacts?:  Array< {
            __typename: "PhoneContacts",
            id?: number | null,
            objecttype?: string | null,
            objectid?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            countrycode?: string | null,
            phonenumber?: string | null,
            verifieddatetime?: number | null,
            promotionssignup?: string | null,
            smsallowed?: string | null,
            callallowed?: string | null,
            whatsappallowed?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
        } | null > | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicenumbertracker?:  Array< {
        __typename: "InvoiceNumberTracker",
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        nextinvoicenumber: string,
        lastupdatedby?: string | null,
      } | null > | null,
      relatedinvoicetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      companystate?: string | null,
      cancelremark?: string | null,
      deleteremark?: string | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      paymentstatus?: number | null,
      ackno?: string | null,
      ackdt?: number | null,
      irn?: string | null,
      signedqrcode?: string | null,
      itcflag?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    tdspercentage?: number | null,
    udhyamregno?: string | null,
    sameaddressflag?: number | null,
    comments?: string | null,
    tdssection?: string | null,
  } | null > | null,
};

export type ListDeletedItemQueryVariables = {
  type: string,
};

export type ListDeletedItemQuery = {
  listDeletedItem?:  Array< {
    __typename: "itemmasterDeleted",
    itemid?: number | null,
    itemcode?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    itemname?: string | null,
    salesinvoiceflag?: number | null,
    purchaseinvoiceflag?: number | null,
    itemcategorycd?: string | null,
    measurementcd?: string | null,
    currencycd?: string | null,
    salesaccountid?: number | null,
    purchaseaccountid?: number | null,
    taxabilitycd?: string | null,
    reversechargeflag?: number | null,
    itemtype?: string | null,
    hsnid?: string | null,
    is_active?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relateditemamountdetails?:  Array< {
      __typename: "ItemAmountDetailsDeleted",
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      amount?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstcompensationvalue?: number | null,
      gstrate?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      invoicetype?: number | null,
      pricetype?: string | null,
      isactive?: number | null,
      isdefault?: number | null,
    } | null > | null,
    relateditemgstdetails?:  Array< {
      __typename: "ItemGstDetails",
      itemid: number,
      companyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      hsnid: string,
      gstcesstype: string,
      gstcompensationvalue: number,
      effectivedate?: number | null,
      expireddate?: number | null,
      gstcessvalue?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relateditemimages?:  Array< {
      __typename: "ItemImages",
      attachmentid?: number | null,
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      imagename?: string | null,
      imageurl?: string | null,
      documentname?: string | null,
      type?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    serialnumber?: string | null,
  } | null > | null,
};

export type ListDeletedTransactionManualJournalQueryVariables = {
};

export type ListDeletedTransactionManualJournalQuery = {
  listDeletedTransactionManualJournal?:  Array< {
    __typename: "DeletedTransactionMaster",
    transactionid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp: number,
    transactiontypecd: string,
    vouchernumber: string,
    entrydate: number,
    bankreferencenumber?: string | null,
    comments?: string | null,
    relatedtransactiondetails?:  Array< {
      __typename: "TransactionDetailsCustomDeleted",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      accountid?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      comments?: string | null,
      entryordernumber?: number | null,
      transactionbalance?: number | null,
      openingbalance?: number | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      financialyearid?: number | null,
    } | null > | null,
    relatedtransactionattachment?:  Array< {
      __typename: "TransactionAttachment",
      transactionid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      documentname: string,
      statuscode?: string | null,
      statusmessage?: string | null,
      type?: string | null,
    } | null > | null,
    relatedtransactiontdsdetails?:  Array< {
      __typename: "TransactionTDSDetails",
      transactionid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      tdsapplicablecd: string,
      tdsamount: number,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tdspercentage?: number | null,
    } | null > | null,
    relatedpurchasemaster?:  Array< {
      __typename: "PurchaseMasterNew",
      purchaseid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchasegsttypecd: string,
      supplierid: number,
      entrydate: number,
      vouchernumber: string,
      supplierinvoicedate: number,
      supplierinvoicenumber: string,
      supplieraddressid: number,
      paymenttypecd: string,
      paidamount: number,
      creditduration: number,
      paymentaccountid: number,
      comments: string,
      tdsapplicableflag: number,
      granttotalamount?: number | null,
      balancedueamount?: number | null,
      paymentclearedflag?: number | null,
      placeofsupply?: string | null,
      companystate?: string | null,
      relatedpurchasetdsdetails?:  Array< {
        __typename: "PurchaseTDSDetails",
        purchaseid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        tdsapplicablecd?: number | null,
        totaltaxableamount?: number | null,
        ineligibletcflag?: number | null,
        reversechargeflag?: number | null,
        gstcesstotal?: number | null,
        tdsamount?: number | null,
        adjustmentamount?: number | null,
        tdssection?: string | null,
        tdspercentage?: number | null,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaselineitems?:  Array< {
        __typename: "PurchaseLineItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        itemnumber: number,
        itemid: number,
        purchaseaccountid: number,
        hsncode: string,
        itemquantity: number,
        unittypecd: string,
        itemrate: number,
        itemamount: number,
        itemdiscount: number,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount: number,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnid?: string | null,
        hsncodetype?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        purchaseaccountname?: string | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinenonitems?:  Array< {
        __typename: "PurchaseLineNonItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchaselineitemtype: string,
        purchaseaccountid: number,
        hsnsaccode: string,
        itemdescription: string,
        taxableamount: number,
        netamount: number,
        relatedpurchaselinenongst?:  Array< {
          __typename: "PurchaseLineNonGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        purchaseaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaseattachment?:  Array< {
        __typename: "PurchaseAttachment",
        purchaseid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedpurchasetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      relatedpurchasetransactionrelation?:  Array< {
        __typename: "TransactionRelation",
        transactionid?: number | null,
        transactiontypecd?: string | null,
        objecttype?: string | null,
        objectid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        linkedamount?: number | null,
        objectattribute?: string | null,
        isdirect?: number | null,
        lastupdatedby?: string | null,
        accountid?: number | null,
        paymentvouchernumber?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      adjustmentamount?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      reversechargeflag?: number | null,
      paymentstatus?: number | null,
      partyregistrationtype?: string | null,
      partygstcategory?: string | null,
      itcflag?: number | null,
    } | null > | null,
    relatedinvoicemaster?:  Array< {
      __typename: "Invoicemasternew",
      invoiceid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      invoicetypecd: string,
      partyid: number,
      paymentaccountid: number,
      invoicedate: number,
      invoicenumber: string,
      customerordernumber: string,
      customerorderdate?: number | null,
      invoiceamount: number,
      paymenttype: string,
      creditduration: number,
      invoicebillingaddressid: number,
      invoicedeliveryaddressid: number,
      invoicetaxabletypecd: string,
      receipturl: string,
      invoicelinetypecd: string,
      invoicecurrencycd: string,
      exchangerate: number,
      comments: string,
      receivedamount: number,
      adjustmentamount: number,
      placeofsupply?: string | null,
      balancedueamount?: number | null,
      reversechargeflag?: number | null,
      tcsapplicableflag?: number | null,
      relatedinvoicelineitems?:  Array< {
        __typename: "InvoiceLineItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        lineitemnumber?: number | null,
        invoicelineitemtype?: string | null,
        itemid?: number | null,
        quantity?: number | null,
        unittypecd?: string | null,
        itemrate?: number | null,
        itemamount?: number | null,
        itemdiscount?: number | null,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        salesaccountname?: string | null,
        salesaccountid?: number | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        itemmaster_timestamp?: number | null,
        description?: string | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoicelinenonitems?:  Array< {
        __typename: "InvoiceLineNonItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        invoicelineitemtype?: string | null,
        incomeaccountid?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        itemdescription?: string | null,
        taxableamount?: number | null,
        netamount?: number | null,
        relatedaccounts?:  Array< {
          __typename: "AccountMaster",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accountname?: string | null,
          accounttypecd?: string | null,
          accountgroupid?: number | null,
          hsnsaccode?: string | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          restrictedflag?: number | null,
          is_active?: number | null,
          accounttypeflag?: number | null,
          relatedaccountgstdetails?:  Array< {
            __typename: "AccountGSTDetails",
            accountid?: number | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstrate?: number | null,
            cessamount?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsaccode?: string | null,
            codetype?: string | null,
            description?: string | null,
            taxability?: string | null,
          } | null > | null,
          relatedaccountopeningbalance?:  Array< {
            __typename: "AccountOpeningBalance",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            financialyearid?: number | null,
            startdate?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedaccountgroupmaster?:  Array< {
            __typename: "AccountGroupMasterNew",
            accountgroupid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accounttypecd?: string | null,
            accountgroupname?: string | null,
            accountparentgroupid?: number | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            is_active?: number | null,
            restrictedflag?: number | null,
            path?: string | null,
          } | null > | null,
          relatedaccountbalance?:  Array< {
            __typename: "AccountBalanceNew",
            accountid?: number | null,
            accountbalance?: number | null,
            actualbalance?: number | null,
          } | null > | null,
          path?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        incomeaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoiceattachment?:  Array< {
        __typename: "InvoiceAttachment",
        invoiceid?: number | null,
        attachmentid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        attachmentname?: string | null,
        attachmenturl?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedinvoicedispatch?:  Array< {
        __typename: "InvoiceDispatch",
        invoiceid: number,
        dispatchid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        transportationcd: string,
        vehiclenumber: string,
        dispatchdate: number,
        ewaybillnumber: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoiceposdetails?:  Array< {
        __typename: "InvoicePOSDetails",
        posid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        partyposid: number,
        lastupdatedby?: string | null,
        relatedposparty?:  Array< {
          __typename: "POSParty",
          pospartyid?: number | null,
          companyid?: number | null,
          partyname?: string | null,
          partycontactnumberid?: number | null,
          lastupdatedby?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          relatedphonecontacts?:  Array< {
            __typename: "PhoneContacts",
            id?: number | null,
            objecttype?: string | null,
            objectid?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            countrycode?: string | null,
            phonenumber?: string | null,
            verifieddatetime?: number | null,
            promotionssignup?: string | null,
            smsallowed?: string | null,
            callallowed?: string | null,
            whatsappallowed?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
        } | null > | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicenumbertracker?:  Array< {
        __typename: "InvoiceNumberTracker",
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        nextinvoicenumber: string,
        lastupdatedby?: string | null,
      } | null > | null,
      relatedinvoicetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      companystate?: string | null,
      cancelremark?: string | null,
      deleteremark?: string | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      paymentstatus?: number | null,
      ackno?: string | null,
      ackdt?: number | null,
      irn?: string | null,
      signedqrcode?: string | null,
      itcflag?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
  } | null > | null,
};

export type ListDeletedPurchasesQueryVariables = {
};

export type ListDeletedPurchasesQuery = {
  listDeletedPurchases?:  Array< {
    __typename: "PurchaseMasterDeleted",
    purchaseid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    purchasegsttypecd?: string | null,
    supplierid?: number | null,
    entrydate?: number | null,
    vouchernumber?: string | null,
    supplierinvoicedate?: number | null,
    supplierinvoicenumber?: string | null,
    supplieraddressid?: number | null,
    paymenttypecd?: string | null,
    paidamount?: number | null,
    creditduration?: number | null,
    paymentaccountid?: number | null,
    comments?: string | null,
    tdsapplicableflag?: number | null,
    granttotalamount?: number | null,
    balancedueamount?: number | null,
    paymentclearedflag?: number | null,
    placeofsupply?: string | null,
    companystate?: string | null,
    relatedpurchasetdsdetails?:  Array< {
      __typename: "PurchaseTDSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tdsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tdsamount?: number | null,
      adjustmentamount?: number | null,
      tdssection?: string | null,
      tdspercentage?: number | null,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaselineitems?:  Array< {
      __typename: "PurchaseLineItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      itemnumber: number,
      itemid: number,
      purchaseaccountid: number,
      hsncode: string,
      itemquantity: number,
      unittypecd: string,
      itemrate: number,
      itemamount: number,
      itemdiscount: number,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount: number,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnid?: string | null,
      hsncodetype?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      purchaseaccountname?: string | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinenonitems?:  Array< {
      __typename: "PurchaseLineNonItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchaselineitemtype: string,
      purchaseaccountid: number,
      hsnsaccode: string,
      itemdescription: string,
      taxableamount: number,
      netamount: number,
      relatedpurchaselinenongst?:  Array< {
        __typename: "PurchaseLineNonGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      purchaseaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinegst?:  Array< {
      __typename: "PurchaseLineGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaseattachment?:  Array< {
      __typename: "PurchaseAttachment",
      purchaseid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedpurchasetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpartyaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    cancelflag?: number | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    adjustmentamount?: number | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    reversechargeflag?: number | null,
    paymentstatus?: number | null,
    partyregistrationtype?: string | null,
    partygstcategory?: string | null,
  } | null > | null,
};

export type ListDeletedInvoicesQueryVariables = {
};

export type ListDeletedInvoicesQuery = {
  listDeletedInvoices?:  Array< {
    __typename: "InvoicemasterDeleted",
    invoiceid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    invoicetypecd?: string | null,
    partyid?: number | null,
    paymentaccountid?: number | null,
    invoicedate?: number | null,
    invoicenumber?: string | null,
    customerordernumber?: string | null,
    customerorderdate?: number | null,
    invoiceamount?: number | null,
    paymenttype?: string | null,
    creditduration?: number | null,
    invoicebillingaddressid?: number | null,
    invoicedeliveryaddressid?: number | null,
    invoicetaxabletypecd?: string | null,
    receipturl?: string | null,
    invoicelinetypecd?: string | null,
    invoicecurrencycd?: string | null,
    exchangerate?: number | null,
    comments?: string | null,
    receivedamount?: number | null,
    adjustmentamount?: number | null,
    placeofsupply?: string | null,
    balancedueamount?: number | null,
    reversechargeflag?: number | null,
    tcsapplicableflag?: number | null,
    relatedinvoicelineitems?:  Array< {
      __typename: "InvoiceLineItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemnumber?: number | null,
      invoicelineitemtype?: string | null,
      itemid?: number | null,
      quantity?: number | null,
      unittypecd?: string | null,
      itemrate?: number | null,
      itemamount?: number | null,
      itemdiscount?: number | null,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      salesaccountname?: string | null,
      salesaccountid?: number | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      itemmaster_timestamp?: number | null,
      description?: string | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoicelinonitems?:  Array< {
      __typename: "InvoiceLineNonItems",
      invoiceid?: number | null,
      invoiceitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      invoicelineitemtype?: string | null,
      incomeaccountid?: number | null,
      hsnsaccode?: string | null,
      taxability?: string | null,
      itemdescription?: string | null,
      taxableamount?: number | null,
      netamount?: number | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      incomeaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedinvoiceattachment?:  Array< {
      __typename: "InvoiceAttachment",
      invoiceid?: number | null,
      attachmentid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      attachmentname?: string | null,
      attachmenturl?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedinvoicedispatch?:  Array< {
      __typename: "InvoiceDispatch",
      invoiceid: number,
      dispatchid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transportationcd: string,
      vehiclenumber: string,
      dispatchdate: number,
      ewaybillnumber: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoiceposdetails?:  Array< {
      __typename: "InvoicePOSDetails",
      posid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      partyposid: number,
      lastupdatedby?: string | null,
      relatedposparty?:  Array< {
        __typename: "POSParty",
        pospartyid?: number | null,
        companyid?: number | null,
        partyname?: string | null,
        partycontactnumberid?: number | null,
        lastupdatedby?: string | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        relatedphonecontacts?:  Array< {
          __typename: "PhoneContacts",
          id?: number | null,
          objecttype?: string | null,
          objectid?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          countrycode?: string | null,
          phonenumber?: string | null,
          verifieddatetime?: number | null,
          promotionssignup?: string | null,
          smsallowed?: string | null,
          callallowed?: string | null,
          whatsappallowed?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
      } | null > | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicelinegst?:  Array< {
      __typename: "InvoiceLineGST",
      invoiceid: number,
      invoiceitemid: number,
      companyid: number,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      cessamount?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedinvoicenumbertracker?:  Array< {
      __typename: "InvoiceNumberTracker",
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      nextinvoicenumber: string,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedinvoicetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpartybillingaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    relatedpartydeliveryaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    consigneename?: string | null,
    consigneeGSTIN?: string | null,
    companystate?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    paymentstatus?: number | null,
    ackno?: string | null,
    ackdt?: number | null,
    irn?: string | null,
    signedqrcode?: string | null,
  } | null > | null,
};

export type ListDeletedAccountGroupsQueryVariables = {
};

export type ListDeletedAccountGroupsQuery = {
  listDeletedAccountGroups?:  Array< {
    __typename: "AccountGroupMasterDeleted",
    AccountGroupID?: number | null,
    CompanyID?: number | null,
    CompanyBranchID?: number | null,
    EnteredTimeStamp?: number | null,
    ExpiredTimeStamp?: number | null,
    AccountTypeCD?: string | null,
    AccountGroupName?: string | null,
    AccountParentGroupID?: number | null,
    DisplayOrderNumber?: number | null,
    StatusCode?: string | null,
    StatusMessage?: string | null,
    Restrictedflag?: number | null,
    Is_Active?: number | null,
    RelatedAccounts?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    path?: string | null,
  } | null > | null,
};

export type ListDeletedCrDrNoteMasterQueryVariables = {
  type: string,
};

export type ListDeletedCrDrNoteMasterQuery = {
  listDeletedCrDrNoteMaster?:  Array< {
    __typename: "CrDrNoteMasterDeleted",
    crdrnoteid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    crdrnotetypecd?: string | null,
    crdrnotedate?: number | null,
    crdrnotenumber?: string | null,
    invoicetypecd?: string | null,
    gsttypecd?: string | null,
    partyid?: number | null,
    deliveryaddressid?: number | null,
    paymenttype?: string | null,
    grandtotalamount?: number | null,
    transactionid?: number | null,
    userid?: string | null,
    creditduration?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    psflag?: number | null,
    reversechargeflag?: number | null,
    balancedueamount?: number | null,
    consigneeName?: string | null,
    consigneeGstin?: string | null,
    companystate?: string | null,
    placeofsupply?: string | null,
    relatedcrdrnoteinvoices?:  Array< {
      __typename: "CrDrNoteInvoices",
      crdrnoteid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      invoiceid?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedcrdrattachment?:  Array< {
      __typename: "CrDrAttachment",
      crdrnoteid?: number | null,
      attachmentid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      attachmentname?: string | null,
      attachmenturl?: string | null,
      userid?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedcrdrnotedetails?:  Array< {
      __typename: "CrDrNoteDetails",
      crdrnoteid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      totaltaxableamount?: number | null,
      totalgst?: number | null,
      totalgstcess?: number | null,
      totaladjustments?: number | null,
      comments?: string | null,
      accountid?: number | null,
      partamount?: number | null,
      transportationcd?: string | null,
      vehiclenumber?: string | null,
      dispatchdate?: number | null,
      ewaybillnumber?: string | null,
      userid?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedcrdrnotelineitems?:  Array< {
      __typename: "CrDrNoteLineItems",
      crdrnoteid?: number | null,
      crdrnoteitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemnumber?: number | null,
      lineitemtype?: string | null,
      itemid?: number | null,
      quantity?: number | null,
      unittypecd?: string | null,
      itemrate?: number | null,
      itemamount?: number | null,
      itemdiscount?: number | null,
      discounttype?: string | null,
      discountrate?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      gstcess?: number | null,
      hsnsaccode?: string | null,
      netamount?: number | null,
      userid?: string | null,
      taxability?: string | null,
      reason?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pricetype?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      unit?: string | null,
      uqc?: string | null,
      salesaccountname?: string | null,
      purchaseaccountname?: string | null,
      salesaccountid?: number | null,
      purchaseaccountid?: number | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedcrdrnotelinnonitems?:  Array< {
      __typename: "CrDrNoteLineNonItems",
      crdrnoteid?: number | null,
      crdrnoteitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemtype?: string | null,
      ledgeraccountid?: number | null,
      hsnsaccode?: string | null,
      itemdescription?: string | null,
      taxableamount?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      gstcess?: number | null,
      netamount?: number | null,
      userid?: string | null,
      taxability?: string | null,
      reason?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      ledgeraccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    originalinvoicenumber?: string | null,
    partyinvoicenumber?: string | null,
    paymentstatus?: number | null,
    partyregistrationtype?: string | null,
  } | null > | null,
};

export type ListDeletedAccountsQueryVariables = {
};

export type ListDeletedAccountsQuery = {
  listDeletedAccounts?:  Array< {
    __typename: "AccountMasterDeleted",
    accountid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    accountgroupid?: number | null,
    hsnsaccode?: string | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    relatedaccountgstdetails?:  Array< {
      __typename: "AccountGSTDetails",
      accountid?: number | null,
      companyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstrate?: number | null,
      cessamount?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsaccode?: string | null,
      codetype?: string | null,
      description?: string | null,
      taxability?: string | null,
    } | null > | null,
    relatedaccountopeningbalance?:  Array< {
      __typename: "AccountOpeningBalance",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      financialyearid?: number | null,
      startdate?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedaccountgroupmaster?:  Array< {
      __typename: "AccountGroupMasterNew",
      accountgroupid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accounttypecd?: string | null,
      accountgroupname?: string | null,
      accountparentgroupid?: number | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      is_active?: number | null,
      restrictedflag?: number | null,
      path?: string | null,
    } | null > | null,
    relatedaccountbalance?:  Array< {
      __typename: "AccountBalanceNew",
      accountid?: number | null,
      accountbalance?: number | null,
      actualbalance?: number | null,
    } | null > | null,
    path?: string | null,
  } | null > | null,
};

export type ListPlaceOfSupplyQueryVariables = {
};

export type ListPlaceOfSupplyQuery = {
  listPlaceOfSupply?:  Array< {
    __typename: "PlaceOfSupply",
    id?: number | null,
    statename?: string | null,
    statecode?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    isactive?: number | null,
  } | null > | null,
};

export type ListDayBookTransactionsCountQueryVariables = {
  startdate: number,
  enddate: number,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListDayBookTransactionsCountQuery = {
  listDayBookTransactionsCount?:  Array< {
    __typename: "AccountTransactionCount",
    transactioncount?: number | null,
  } | null > | null,
};

export type ListDayBookTransactionDetailsQueryVariables = {
  startdate: number,
  enddate: number,
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListDayBookTransactionDetailsQuery = {
  listDayBookTransactionDetails?:  Array< {
    __typename: "DayBookTransactionDetails",
    transactionid: number,
    companyid: number,
    companybranchid: number,
    enteredtimestamp: number,
    expiredtimestamp?: number | null,
    transactiontypecd: string,
    accountid: number,
    accountname: string,
    balancesign: number,
    totalcreditamount: number,
    totaldebitamount: number,
    comments?: string | null,
    entryordernumber: number,
    financialyearid: number,
    cancelflag?: number | null,
    balance: number,
    transactiontype?: string | null,
    vouchernumber?: string | null,
    voucherid?: number | null,
  } | null > | null,
};

export type Listaccountopeningbalancev2QueryVariables = {
  companyid: number,
};

export type Listaccountopeningbalancev2Query = {
  listaccountopeningbalancev2?:  Array< {
    __typename: "AccountOpeningBalancev2",
    accountid?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    displayordernumber?: number | null,
    path?: string | null,
    accountgroupid?: number | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    companyid?: number | null,
    financialyearid?: number | null,
    creditamount?: number | null,
    debitamount?: number | null,
    enteredtimestamp?: number | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    root_group_id?: number | null,
    root_group_name?: string | null,
    balancesign?: number | null,
    balance?: number | null,
    type?: string | null,
  } | null > | null,
};

export type ListAccountsDropdownQueryVariables = {
  rowfrom: number,
  limitno: number,
  word: string,
};

export type ListAccountsDropdownQuery = {
  listAccountsDropdown?:  Array< {
    __typename: "AccountMaster",
    accountsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    accountgroupid?: number | null,
    hsnsaccode?: string | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    accounttypeflag?: number | null,
    relatedaccountgstdetails?:  Array< {
      __typename: "AccountGSTDetails",
      accountid?: number | null,
      companyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstrate?: number | null,
      cessamount?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsaccode?: string | null,
      codetype?: string | null,
      description?: string | null,
      taxability?: string | null,
    } | null > | null,
    relatedaccountopeningbalance?:  Array< {
      __typename: "AccountOpeningBalance",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      financialyearid?: number | null,
      startdate?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedaccountgroupmaster?:  Array< {
      __typename: "AccountGroupMasterNew",
      accountgroupid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accounttypecd?: string | null,
      accountgroupname?: string | null,
      accountparentgroupid?: number | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      is_active?: number | null,
      restrictedflag?: number | null,
      path?: string | null,
    } | null > | null,
    relatedaccountbalance?:  Array< {
      __typename: "AccountBalanceNew",
      accountid?: number | null,
      accountbalance?: number | null,
      actualbalance?: number | null,
    } | null > | null,
    path?: string | null,
  } | null > | null,
};

export type ListaccountsubgroupsQueryVariables = {
  accountgroupid?: number | null,
};

export type ListaccountsubgroupsQuery = {
  listaccountsubgroups?:  Array< {
    __typename: "AccountGroupMaster",
    accountgroupid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accounttypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    relatedaccounts?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    path?: string | null,
  } | null > | null,
};

export type ListAccountTransactionDetailsv3QueryVariables = {
  accountid: number,
  startdate: number,
  enddate: number,
  limitno: number,
  rowfrom: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
  openingbalance?: number | null,
};

export type ListAccountTransactionDetailsv3Query = {
  listAccountTransactionDetailsv3?:  Array< {
    __typename: "TransactionDetailsv3",
    transactionid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    financialyearid?: number | null,
    invoiceid?: number | null,
    purchaseid?: number | null,
    crdrnoteid?: number | null,
    vouchertype?: string | null,
    vouchernumber?: string | null,
    accountid?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    balancesign?: number | null,
    accountgroupname?: string | null,
    transactiontype?: string | null,
    entryordernumber?: number | null,
    totaldebitamount?: number | null,
    totalcreditamount?: number | null,
    balance?: number | null,
    oppositeaccountid?: number | null,
    oppositeaccountname?: string | null,
    comments?: string | null,
    setoffremarks?: string | null,
    setoffbalance?: number | null,
    accounttypeflag?: number | null,
  } | null > | null,
};

export type ListAddressEntitysQueryVariables = {
};

export type ListAddressEntitysQuery = {
  listAddressEntitys?:  Array< {
    __typename: "AddressEntity",
    id?: number | null,
    objecttype?: string | null,
    objectid?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    line1?: string | null,
    line2?: string | null,
    line3?: string | null,
    city?: string | null,
    statecode?: string | null,
    statename?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    pincode?: string | null,
    countrycode?: string | null,
    codevalue?: string | null,
    district?: string | null,
    lastupdatedby?: string | null,
    godownname?: string | null,
    gstin?: string | null,
    phone?: string | null,
    email?: string | null,
    personincharge?: string | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    foreignstate?: string | null,
    foreigndistrict?: string | null,
    defaultflag?: number | null,
    addresstitle?: string | null,
    addressindex?: number | null,
  } | null > | null,
};

export type ListAllFinancialYearsQueryVariables = {
};

export type ListAllFinancialYearsQuery = {
  listAllFinancialYears?:  Array< {
    __typename: "FinancialYear",
    financialyearid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    startdate?: number | null,
    enddate?: number | null,
    startyear?: string | null,
    endyear?: string | null,
    comments?: string | null,
    userid?: string | null,
    aliasname?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    freezestatus?: number | null,
    transferdate?: number | null,
    freezedate?: number | null,
    stepscompleted?: Array< string | null > | null,
  } | null > | null,
};

export type ListBankAccountsQueryVariables = {
};

export type ListBankAccountsQuery = {
  listBankAccounts?:  Array< {
    __typename: "AccountMasterv2",
    accountsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    accountgroupid?: number | null,
    hsnsaccode?: string | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    accountgroupenteredtimestamp?: number | null,
    accountgroupexpiredtimestamp?: number | null,
    accountgrouptypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    accountgroupdisplayordernumber?: number | null,
    accountgrouprestrictedflag?: number | null,
    accountgroupis_active?: number | null,
    accountgstenteredtimestamp?: number | null,
    accountgstexpiredtimestamp?: number | null,
    accountgsteffectivedate?: number | null,
    accountgstexpireddate?: number | null,
    hsnid?: string | null,
    gstcompensationtype?: string | null,
    gstrate?: number | null,
    cessamount?: number | null,
    accounttypeflag?: number | null,
    partyid?: number | null,
    tdspercentage?: number | null,
    tdssection?: string | null,
    path?: string | null,
    tax_type?: number | null,
    balancesign?: number | null,
    accountcreationdate?: number | null,
  } | null > | null,
};

export type ListBankDetailsQueryVariables = {
};

export type ListBankDetailsQuery = {
  listBankDetails?:  Array< {
    __typename: "BankDetails",
    bankdetailsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    objecttype?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    objectid?: string | null,
    userid?: string | null,
    bankname?: string | null,
    bankaccountnumber?: string | null,
    ifsccode?: string | null,
    branch?: string | null,
    notes?: string | null,
    ledgeraccount?: string | null,
    bankaccounttype?: string | null,
    cash?: number | null,
    swiftcode?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    upi?: string | null,
  } | null > | null,
};

export type ListBusinessTypeQueryVariables = {
};

export type ListBusinessTypeQuery = {
  listBusinessType?:  Array< {
    __typename: "BusinessType",
    businesstypeid?: number | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    businesstype?: string | null,
    lastupdatedby?: string | null,
    restrictedflag?: number | null,
    isactive?: number | null,
  } | null > | null,
};

export type ListCashAccountsQueryVariables = {
};

export type ListCashAccountsQuery = {
  listCashAccounts?:  Array< {
    __typename: "AccountMasterv2",
    accountsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    accountgroupid?: number | null,
    hsnsaccode?: string | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    accountgroupenteredtimestamp?: number | null,
    accountgroupexpiredtimestamp?: number | null,
    accountgrouptypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    accountgroupdisplayordernumber?: number | null,
    accountgrouprestrictedflag?: number | null,
    accountgroupis_active?: number | null,
    accountgstenteredtimestamp?: number | null,
    accountgstexpiredtimestamp?: number | null,
    accountgsteffectivedate?: number | null,
    accountgstexpireddate?: number | null,
    hsnid?: string | null,
    gstcompensationtype?: string | null,
    gstrate?: number | null,
    cessamount?: number | null,
    accounttypeflag?: number | null,
    partyid?: number | null,
    tdspercentage?: number | null,
    tdssection?: string | null,
    path?: string | null,
    tax_type?: number | null,
    balancesign?: number | null,
    accountcreationdate?: number | null,
  } | null > | null,
};

export type ListCashTransactionDetailsQueryVariables = {
  rowfrom: number,
  limitno: number,
  startdate: number,
  enddate: number,
};

export type ListCashTransactionDetailsQuery = {
  listCashTransactionDetails?:  Array< {
    __typename: "TransactionDetails",
    transactionid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    transactiontypecd?: string | null,
    accountid?: number | null,
    creditamount?: number | null,
    debitamount?: number | null,
    comments?: string | null,
    entryordernumber?: number | null,
    transactionbalance?: number | null,
    openingbalance?: number | null,
    relatedaccounts?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedaccountstransaction?:  Array< {
      __typename: "RelatedAccountsTransactionDetails",
      transactionid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transactiontypecd?: string | null,
      accountid?: number | null,
      creditamount: number,
      debitamount: number,
      comments?: string | null,
      entryordernumber?: number | null,
      transactionbalance?: number | null,
      openingbalance?: number | null,
      vouchernumber?: string | null,
      transactionmastertypecd?: string | null,
      relatedaccounts?:  Array< {
        __typename: "AccountMaster",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accountname?: string | null,
        accounttypecd?: string | null,
        accountgroupid?: number | null,
        hsnsaccode?: string | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        restrictedflag?: number | null,
        is_active?: number | null,
        accounttypeflag?: number | null,
        relatedaccountgstdetails?:  Array< {
          __typename: "AccountGSTDetails",
          accountid?: number | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstrate?: number | null,
          cessamount?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsaccode?: string | null,
          codetype?: string | null,
          description?: string | null,
          taxability?: string | null,
        } | null > | null,
        relatedaccountopeningbalance?:  Array< {
          __typename: "AccountOpeningBalance",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          financialyearid?: number | null,
          startdate?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedaccountgroupmaster?:  Array< {
          __typename: "AccountGroupMasterNew",
          accountgroupid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accounttypecd?: string | null,
          accountgroupname?: string | null,
          accountparentgroupid?: number | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          is_active?: number | null,
          restrictedflag?: number | null,
          path?: string | null,
        } | null > | null,
        relatedaccountbalance?:  Array< {
          __typename: "AccountBalanceNew",
          accountid?: number | null,
          accountbalance?: number | null,
          actualbalance?: number | null,
        } | null > | null,
        path?: string | null,
      } | null > | null,
      financialyearid?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    financialyearid?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type ListCompanyDocumentsQueryVariables = {
  documenttype: string,
  partyid: number,
};

export type ListCompanyDocumentsQuery = {
  listCompanyDocuments?:  Array< {
    __typename: "CompanyDocuments",
    id?: number | null,
    companyid?: number | null,
    partyid?: number | null,
    documenttype?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    imagename?: string | null,
    imageurl?: string | null,
    lastupdatedby?: string | null,
    isactive?: number | null,
    type?: string | null,
    documentname?: string | null,
  } | null > | null,
};

export type ListTransactionMasterCountQueryVariables = {
  transactiontypecd?: string | null,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListTransactionMasterCountQuery = {
  listTransactionMasterCount?:  Array< {
    __typename: "TransactionMasterCount",
    transactionmasterlistcount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    min_paymentamount?: number | null,
    max_paymentamount?: number | null,
    min_receiptamount?: number | null,
    max_receiptamount?: number | null,
    min_tds_payable_amount?: number | null,
    max_tds_payable_amount?: number | null,
    min_tds_receivable_amount?: number | null,
    max_tds_receivable_amount?: number | null,
    min_totalamount?: number | null,
    max_totalamount?: number | null,
  } | null > | null,
};

export type ListReceiptsTransactionTypeQueryVariables = {
};

export type ListReceiptsTransactionTypeQuery = {
  listReceiptsTransactionType?:  Array< {
    __typename: "TransactionMaster",
    transactionid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    transactiontypecd?: string | null,
    vouchernumber?: string | null,
    entrydate?: number | null,
    bankreferencenumber?: string | null,
    comments?: string | null,
    relatedtransactiondetails?:  Array< {
      __typename: "TransactionDetailsCustom",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      accountid?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      comments?: string | null,
      entryordernumber?: number | null,
      transactionbalance?: number | null,
      openingbalance?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      financialyearid?: number | null,
    } | null > | null,
    relatedtransactionattachment?:  Array< {
      __typename: "TransactionAttachment",
      transactionid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      documentname: string,
      statuscode?: string | null,
      statusmessage?: string | null,
      type?: string | null,
    } | null > | null,
    relatedtransactiontdsdetails?:  Array< {
      __typename: "TransactionTDSDetails",
      transactionid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      tdsapplicablecd: string,
      tdsamount: number,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tdspercentage?: number | null,
    } | null > | null,
    relatedpurchasemaster?:  Array< {
      __typename: "PurchaseMasterNew",
      purchaseid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchasegsttypecd: string,
      supplierid: number,
      entrydate: number,
      vouchernumber: string,
      supplierinvoicedate: number,
      supplierinvoicenumber: string,
      supplieraddressid: number,
      paymenttypecd: string,
      paidamount: number,
      creditduration: number,
      paymentaccountid: number,
      comments: string,
      tdsapplicableflag: number,
      granttotalamount?: number | null,
      balancedueamount?: number | null,
      paymentclearedflag?: number | null,
      placeofsupply?: string | null,
      companystate?: string | null,
      relatedpurchasetdsdetails?:  Array< {
        __typename: "PurchaseTDSDetails",
        purchaseid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        tdsapplicablecd?: number | null,
        totaltaxableamount?: number | null,
        ineligibletcflag?: number | null,
        reversechargeflag?: number | null,
        gstcesstotal?: number | null,
        tdsamount?: number | null,
        adjustmentamount?: number | null,
        tdssection?: string | null,
        tdspercentage?: number | null,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaselineitems?:  Array< {
        __typename: "PurchaseLineItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        itemnumber: number,
        itemid: number,
        purchaseaccountid: number,
        hsncode: string,
        itemquantity: number,
        unittypecd: string,
        itemrate: number,
        itemamount: number,
        itemdiscount: number,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount: number,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnid?: string | null,
        hsncodetype?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        purchaseaccountname?: string | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinenonitems?:  Array< {
        __typename: "PurchaseLineNonItems",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchaselineitemtype: string,
        purchaseaccountid: number,
        hsnsaccode: string,
        itemdescription: string,
        taxableamount: number,
        netamount: number,
        relatedpurchaselinenongst?:  Array< {
          __typename: "PurchaseLineNonGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        taxability?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gstamount?: number | null,
        cessamount?: number | null,
        purchaseaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpurchaseattachment?:  Array< {
        __typename: "PurchaseAttachment",
        purchaseid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedpurchasetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      relatedpurchasetransactionrelation?:  Array< {
        __typename: "TransactionRelation",
        transactionid?: number | null,
        transactiontypecd?: string | null,
        objecttype?: string | null,
        objectid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        linkedamount?: number | null,
        objectattribute?: string | null,
        isdirect?: number | null,
        lastupdatedby?: string | null,
        accountid?: number | null,
        paymentvouchernumber?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      adjustmentamount?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      reversechargeflag?: number | null,
      paymentstatus?: number | null,
      partyregistrationtype?: string | null,
      partygstcategory?: string | null,
      itcflag?: number | null,
    } | null > | null,
    relatedinvoicemaster?:  Array< {
      __typename: "Invoicemasternew",
      invoiceid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      invoicetypecd: string,
      partyid: number,
      paymentaccountid: number,
      invoicedate: number,
      invoicenumber: string,
      customerordernumber: string,
      customerorderdate?: number | null,
      invoiceamount: number,
      paymenttype: string,
      creditduration: number,
      invoicebillingaddressid: number,
      invoicedeliveryaddressid: number,
      invoicetaxabletypecd: string,
      receipturl: string,
      invoicelinetypecd: string,
      invoicecurrencycd: string,
      exchangerate: number,
      comments: string,
      receivedamount: number,
      adjustmentamount: number,
      placeofsupply?: string | null,
      balancedueamount?: number | null,
      reversechargeflag?: number | null,
      tcsapplicableflag?: number | null,
      relatedinvoicelineitems?:  Array< {
        __typename: "InvoiceLineItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        lineitemnumber?: number | null,
        invoicelineitemtype?: string | null,
        itemid?: number | null,
        quantity?: number | null,
        unittypecd?: string | null,
        itemrate?: number | null,
        itemamount?: number | null,
        itemdiscount?: number | null,
        discounttype?: string | null,
        discountrate?: number | null,
        netamount?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        pricetype?: string | null,
        lotid?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        unit?: string | null,
        uqc?: string | null,
        salesaccountname?: string | null,
        salesaccountid?: number | null,
        itemname?: string | null,
        itemcode?: string | null,
        itemtype?: string | null,
        manualdiscount?: number | null,
        manualcess?: number | null,
        itemmaster_timestamp?: number | null,
        description?: string | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemmaster?:  Array< {
          __typename: "itemmaster",
          itemid?: number | null,
          itemcode?: string | null,
          companyid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          itemname?: string | null,
          salesinvoiceflag?: number | null,
          purchaseinvoiceflag?: number | null,
          itemcategorycd?: string | null,
          measurementcd?: string | null,
          currencycd?: string | null,
          salesaccountid?: number | null,
          purchaseaccountid?: number | null,
          taxabilitycd?: string | null,
          reversechargeflag?: number | null,
          itemtype?: string | null,
          hsnid?: string | null,
          is_active?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          relateditemamountdetails?:  Array< {
            __typename: "ItemAmountDetails",
            id?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            amount?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstcompensationvalue?: number | null,
            gstrate?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            lastupdatedby?: string | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            invoicetype?: number | null,
            pricetype?: string | null,
            isactive?: number | null,
            isdefault?: number | null,
            pricetypeid?: number | null,
            tabletype?: number | null,
          } | null > | null,
          relateditemgstdetails?:  Array< {
            __typename: "ItemGstDetails",
            itemid: number,
            companyid: number,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            hsnid: string,
            gstcesstype: string,
            gstcompensationvalue: number,
            effectivedate?: number | null,
            expireddate?: number | null,
            gstcessvalue?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemimages?:  Array< {
            __typename: "ItemImages",
            attachmentid?: number | null,
            itemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            imagename?: string | null,
            imageurl?: string | null,
            documentname?: string | null,
            type?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          serialnumber?: string | null,
          financialyearid?: number | null,
          description?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          cessexist?: number | null,
          barcode?: string | null,
        } | null > | null,
        pricetypeid?: number | null,
        manualgst?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoicelinenonitems?:  Array< {
        __typename: "InvoiceLineNonItems",
        invoiceid?: number | null,
        invoiceitemid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        invoicelineitemtype?: string | null,
        incomeaccountid?: number | null,
        hsnsaccode?: string | null,
        taxability?: string | null,
        itemdescription?: string | null,
        taxableamount?: number | null,
        netamount?: number | null,
        relatedaccounts?:  Array< {
          __typename: "AccountMaster",
          accountsid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          accountname?: string | null,
          accounttypecd?: string | null,
          accountgroupid?: number | null,
          hsnsaccode?: string | null,
          displayordernumber?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          restrictedflag?: number | null,
          is_active?: number | null,
          accounttypeflag?: number | null,
          relatedaccountgstdetails?:  Array< {
            __typename: "AccountGSTDetails",
            accountid?: number | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            effectivedate?: number | null,
            expireddate?: number | null,
            hsnid?: string | null,
            gstcompensationtype?: string | null,
            gstrate?: number | null,
            cessamount?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsaccode?: string | null,
            codetype?: string | null,
            description?: string | null,
            taxability?: string | null,
          } | null > | null,
          relatedaccountopeningbalance?:  Array< {
            __typename: "AccountOpeningBalance",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            financialyearid?: number | null,
            startdate?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedaccountgroupmaster?:  Array< {
            __typename: "AccountGroupMasterNew",
            accountgroupid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accounttypecd?: string | null,
            accountgroupname?: string | null,
            accountparentgroupid?: number | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            is_active?: number | null,
            restrictedflag?: number | null,
            path?: string | null,
          } | null > | null,
          relatedaccountbalance?:  Array< {
            __typename: "AccountBalanceNew",
            accountid?: number | null,
            accountbalance?: number | null,
            actualbalance?: number | null,
          } | null > | null,
          path?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        incomeaccountname?: string | null,
        manualgst?: number | null,
        manualcess?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
      } | null > | null,
      relatedinvoiceattachment?:  Array< {
        __typename: "InvoiceAttachment",
        invoiceid?: number | null,
        attachmentid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        attachmentname?: string | null,
        attachmenturl?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        documentname?: string | null,
        type?: string | null,
      } | null > | null,
      relatedinvoicedispatch?:  Array< {
        __typename: "InvoiceDispatch",
        invoiceid: number,
        dispatchid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        transportationcd: string,
        vehiclenumber: string,
        dispatchdate: number,
        ewaybillnumber: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoiceposdetails?:  Array< {
        __typename: "InvoicePOSDetails",
        posid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        partyposid: number,
        lastupdatedby?: string | null,
        relatedposparty?:  Array< {
          __typename: "POSParty",
          pospartyid?: number | null,
          companyid?: number | null,
          partyname?: string | null,
          partycontactnumberid?: number | null,
          lastupdatedby?: string | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          relatedphonecontacts?:  Array< {
            __typename: "PhoneContacts",
            id?: number | null,
            objecttype?: string | null,
            objectid?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            countrycode?: string | null,
            phonenumber?: string | null,
            verifieddatetime?: number | null,
            promotionssignup?: string | null,
            smsallowed?: string | null,
            callallowed?: string | null,
            whatsappallowed?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
        } | null > | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicelinegst?:  Array< {
        __typename: "InvoiceLineGST",
        invoiceid: number,
        invoiceitemid: number,
        companyid: number,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        gstrate?: number | null,
        gsttypecd?: string | null,
        gstamount?: number | null,
        cessamount?: number | null,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedinvoicenumbertracker?:  Array< {
        __typename: "InvoiceNumberTracker",
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        nextinvoicenumber: string,
        lastupdatedby?: string | null,
      } | null > | null,
      relatedinvoicetransactiondetails?:  Array< {
        __typename: "TransactionMaster",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        vouchernumber?: string | null,
        entrydate?: number | null,
        bankreferencenumber?: string | null,
        comments?: string | null,
        relatedtransactiondetails?:  Array< {
          __typename: "TransactionDetailsCustom",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          accountid?: number | null,
          creditamount?: number | null,
          debitamount?: number | null,
          comments?: string | null,
          entryordernumber?: number | null,
          transactionbalance?: number | null,
          openingbalance?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          financialyearid?: number | null,
        } | null > | null,
        relatedtransactionattachment?:  Array< {
          __typename: "TransactionAttachment",
          transactionid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          documentname: string,
          statuscode?: string | null,
          statusmessage?: string | null,
          type?: string | null,
        } | null > | null,
        relatedtransactiontdsdetails?:  Array< {
          __typename: "TransactionTDSDetails",
          transactionid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          tdsapplicablecd: string,
          tdsamount: number,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          tdspercentage?: number | null,
        } | null > | null,
        relatedpurchasemaster?:  Array< {
          __typename: "PurchaseMasterNew",
          purchaseid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchasegsttypecd: string,
          supplierid: number,
          entrydate: number,
          vouchernumber: string,
          supplierinvoicedate: number,
          supplierinvoicenumber: string,
          supplieraddressid: number,
          paymenttypecd: string,
          paidamount: number,
          creditduration: number,
          paymentaccountid: number,
          comments: string,
          tdsapplicableflag: number,
          granttotalamount?: number | null,
          balancedueamount?: number | null,
          paymentclearedflag?: number | null,
          placeofsupply?: string | null,
          companystate?: string | null,
          relatedpurchasetdsdetails?:  Array< {
            __typename: "PurchaseTDSDetails",
            purchaseid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            tdsapplicablecd?: number | null,
            totaltaxableamount?: number | null,
            ineligibletcflag?: number | null,
            reversechargeflag?: number | null,
            gstcesstotal?: number | null,
            tdsamount?: number | null,
            adjustmentamount?: number | null,
            tdssection?: string | null,
            tdspercentage?: number | null,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaselineitems?:  Array< {
            __typename: "PurchaseLineItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            itemnumber: number,
            itemid: number,
            purchaseaccountid: number,
            hsncode: string,
            itemquantity: number,
            unittypecd: string,
            itemrate: number,
            itemamount: number,
            itemdiscount: number,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount: number,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnid?: string | null,
            hsncodetype?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            purchaseaccountname?: string | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinenonitems?:  Array< {
            __typename: "PurchaseLineNonItems",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchaselineitemtype: string,
            purchaseaccountid: number,
            hsnsaccode: string,
            itemdescription: string,
            taxableamount: number,
            netamount: number,
            relatedpurchaselinenongst?:  Array< {
              __typename: "PurchaseLineNonGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            taxability?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gstamount?: number | null,
            cessamount?: number | null,
            purchaseaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedpurchaseattachment?:  Array< {
            __typename: "PurchaseAttachment",
            purchaseid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedpurchasetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          relatedpurchasetransactionrelation?:  Array< {
            __typename: "TransactionRelation",
            transactionid?: number | null,
            transactiontypecd?: string | null,
            objecttype?: string | null,
            objectid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            linkedamount?: number | null,
            objectattribute?: string | null,
            isdirect?: number | null,
            lastupdatedby?: string | null,
            accountid?: number | null,
            paymentvouchernumber?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          adjustmentamount?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          reversechargeflag?: number | null,
          paymentstatus?: number | null,
          partyregistrationtype?: string | null,
          partygstcategory?: string | null,
          itcflag?: number | null,
        } | null > | null,
        relatedinvoicemaster?:  Array< {
          __typename: "Invoicemasternew",
          invoiceid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          invoicetypecd: string,
          partyid: number,
          paymentaccountid: number,
          invoicedate: number,
          invoicenumber: string,
          customerordernumber: string,
          customerorderdate?: number | null,
          invoiceamount: number,
          paymenttype: string,
          creditduration: number,
          invoicebillingaddressid: number,
          invoicedeliveryaddressid: number,
          invoicetaxabletypecd: string,
          receipturl: string,
          invoicelinetypecd: string,
          invoicecurrencycd: string,
          exchangerate: number,
          comments: string,
          receivedamount: number,
          adjustmentamount: number,
          placeofsupply?: string | null,
          balancedueamount?: number | null,
          reversechargeflag?: number | null,
          tcsapplicableflag?: number | null,
          relatedinvoicelineitems?:  Array< {
            __typename: "InvoiceLineItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            lineitemnumber?: number | null,
            invoicelineitemtype?: string | null,
            itemid?: number | null,
            quantity?: number | null,
            unittypecd?: string | null,
            itemrate?: number | null,
            itemamount?: number | null,
            itemdiscount?: number | null,
            discounttype?: string | null,
            discountrate?: number | null,
            netamount?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            pricetype?: string | null,
            lotid?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            unit?: string | null,
            uqc?: string | null,
            salesaccountname?: string | null,
            salesaccountid?: number | null,
            itemname?: string | null,
            itemcode?: string | null,
            itemtype?: string | null,
            manualdiscount?: number | null,
            manualcess?: number | null,
            itemmaster_timestamp?: number | null,
            description?: string | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemmaster?:  Array< {
              __typename: "itemmaster",
              itemid?: number | null,
              itemcode?: string | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              itemname?: string | null,
              salesinvoiceflag?: number | null,
              purchaseinvoiceflag?: number | null,
              itemcategorycd?: string | null,
              measurementcd?: string | null,
              currencycd?: string | null,
              salesaccountid?: number | null,
              purchaseaccountid?: number | null,
              taxabilitycd?: string | null,
              reversechargeflag?: number | null,
              itemtype?: string | null,
              hsnid?: string | null,
              is_active?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              serialnumber?: string | null,
              financialyearid?: number | null,
              description?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              cessexist?: number | null,
              barcode?: string | null,
            } | null > | null,
            pricetypeid?: number | null,
            manualgst?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoicelinenonitems?:  Array< {
            __typename: "InvoiceLineNonItems",
            invoiceid?: number | null,
            invoiceitemid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            invoicelineitemtype?: string | null,
            incomeaccountid?: number | null,
            hsnsaccode?: string | null,
            taxability?: string | null,
            itemdescription?: string | null,
            taxableamount?: number | null,
            netamount?: number | null,
            relatedaccounts?:  Array< {
              __typename: "AccountMaster",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accountname?: string | null,
              accounttypecd?: string | null,
              accountgroupid?: number | null,
              hsnsaccode?: string | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              restrictedflag?: number | null,
              is_active?: number | null,
              accounttypeflag?: number | null,
              path?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            incomeaccountname?: string | null,
            manualgst?: number | null,
            manualcess?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
          } | null > | null,
          relatedinvoiceattachment?:  Array< {
            __typename: "InvoiceAttachment",
            invoiceid?: number | null,
            attachmentid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            attachmentname?: string | null,
            attachmenturl?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            documentname?: string | null,
            type?: string | null,
          } | null > | null,
          relatedinvoicedispatch?:  Array< {
            __typename: "InvoiceDispatch",
            invoiceid: number,
            dispatchid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            transportationcd: string,
            vehiclenumber: string,
            dispatchdate: number,
            ewaybillnumber: string,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoiceposdetails?:  Array< {
            __typename: "InvoicePOSDetails",
            posid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            partyposid: number,
            lastupdatedby?: string | null,
            relatedposparty?:  Array< {
              __typename: "POSParty",
              pospartyid?: number | null,
              companyid?: number | null,
              partyname?: string | null,
              partycontactnumberid?: number | null,
              lastupdatedby?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
            } | null > | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relatedinvoicenumbertracker?:  Array< {
            __typename: "InvoiceNumberTracker",
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            nextinvoicenumber: string,
            lastupdatedby?: string | null,
          } | null > | null,
          relatedinvoicetransactiondetails?:  Array< {
            __typename: "TransactionMaster",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            vouchernumber?: string | null,
            entrydate?: number | null,
            bankreferencenumber?: string | null,
            comments?: string | null,
            relatedtransactiondetails?:  Array< {
              __typename: "TransactionDetailsCustom",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              accountid?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              comments?: string | null,
              entryordernumber?: number | null,
              transactionbalance?: number | null,
              openingbalance?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              financialyearid?: number | null,
            } | null > | null,
            relatedtransactionattachment?:  Array< {
              __typename: "TransactionAttachment",
              transactionid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              documentname: string,
              statuscode?: string | null,
              statusmessage?: string | null,
              type?: string | null,
            } | null > | null,
            relatedtransactiontdsdetails?:  Array< {
              __typename: "TransactionTDSDetails",
              transactionid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              tdsapplicablecd: string,
              tdsamount: number,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              tdspercentage?: number | null,
            } | null > | null,
            relatedpurchasemaster?:  Array< {
              __typename: "PurchaseMasterNew",
              purchaseid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchasegsttypecd: string,
              supplierid: number,
              entrydate: number,
              vouchernumber: string,
              supplierinvoicedate: number,
              supplierinvoicenumber: string,
              supplieraddressid: number,
              paymenttypecd: string,
              paidamount: number,
              creditduration: number,
              paymentaccountid: number,
              comments: string,
              tdsapplicableflag: number,
              granttotalamount?: number | null,
              balancedueamount?: number | null,
              paymentclearedflag?: number | null,
              placeofsupply?: string | null,
              companystate?: string | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              adjustmentamount?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              reversechargeflag?: number | null,
              paymentstatus?: number | null,
              partyregistrationtype?: string | null,
              partygstcategory?: string | null,
              itcflag?: number | null,
            } | null > | null,
            relatedinvoicemaster?:  Array< {
              __typename: "Invoicemasternew",
              invoiceid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              invoicetypecd: string,
              partyid: number,
              paymentaccountid: number,
              invoicedate: number,
              invoicenumber: string,
              customerordernumber: string,
              customerorderdate?: number | null,
              invoiceamount: number,
              paymenttype: string,
              creditduration: number,
              invoicebillingaddressid: number,
              invoicedeliveryaddressid: number,
              invoicetaxabletypecd: string,
              receipturl: string,
              invoicelinetypecd: string,
              invoicecurrencycd: string,
              exchangerate: number,
              comments: string,
              receivedamount: number,
              adjustmentamount: number,
              placeofsupply?: string | null,
              balancedueamount?: number | null,
              reversechargeflag?: number | null,
              tcsapplicableflag?: number | null,
              lastupdatedby?: string | null,
              cancelflag?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              consigneename?: string | null,
              consigneegstin?: string | null,
              companystate?: string | null,
              cancelremark?: string | null,
              deleteremark?: string | null,
              roundoffamount?: number | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              serialnumber?: string | null,
              currencycode?: string | null,
              currencyrate?: number | null,
              paymentstatus?: number | null,
              ackno?: string | null,
              ackdt?: number | null,
              irn?: string | null,
              signedqrcode?: string | null,
              itcflag?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            cancelflag?: number | null,
            cancelremark?: string | null,
            serialnumber?: string | null,
            pdflink?: string | null,
            towards?: string | null,
            isvouchereditable?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          cancelflag?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          consigneename?: string | null,
          consigneegstin?: string | null,
          companystate?: string | null,
          cancelremark?: string | null,
          deleteremark?: string | null,
          roundoffamount?: number | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          serialnumber?: string | null,
          currencycode?: string | null,
          currencyrate?: number | null,
          paymentstatus?: number | null,
          ackno?: string | null,
          ackdt?: number | null,
          irn?: string | null,
          signedqrcode?: string | null,
          itcflag?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        cancelflag?: number | null,
        cancelremark?: string | null,
        serialnumber?: string | null,
        pdflink?: string | null,
        towards?: string | null,
        isvouchereditable?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      cancelflag?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      companystate?: string | null,
      cancelremark?: string | null,
      deleteremark?: string | null,
      roundoffamount?: number | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      serialnumber?: string | null,
      currencycode?: string | null,
      currencyrate?: number | null,
      paymentstatus?: number | null,
      ackno?: string | null,
      ackdt?: number | null,
      irn?: string | null,
      signedqrcode?: string | null,
      itcflag?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    cancelflag?: number | null,
    cancelremark?: string | null,
    serialnumber?: string | null,
    pdflink?: string | null,
    towards?: string | null,
    isvouchereditable?: number | null,
  } | null > | null,
};

export type ListRelatedPaymentTransactionIDQueryVariables = {
  objectid: number,
};

export type ListRelatedPaymentTransactionIDQuery = {
  listRelatedPaymentTransactionID?:  Array< {
    __typename: "TransactionRelation",
    transactionid?: number | null,
    transactiontypecd?: string | null,
    objecttype?: string | null,
    objectid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    linkedamount?: number | null,
    objectattribute?: string | null,
    isdirect?: number | null,
    lastupdatedby?: string | null,
    accountid?: number | null,
    paymentvouchernumber?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type ListPurchaseMasterv2QueryVariables = {
};

export type ListPurchaseMasterv2Query = {
  listPurchaseMasterv2?:  Array< {
    __typename: "PurchaseMasterv2",
    purchaseid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    purchasegsttypecd?: string | null,
    supplierid?: number | null,
    entrydate?: number | null,
    vouchernumber?: string | null,
    supplierinvoicedate?: number | null,
    supplierinvoicenumber?: string | null,
    supplieraddressid?: number | null,
    paymenttypecd?: string | null,
    paidamount?: number | null,
    creditduration?: number | null,
    paymentaccountid?: number | null,
    comments?: string | null,
    tdsapplicableflag?: number | null,
    granttotalamount?: number | null,
    balancedueamount?: number | null,
    paymentclearedflag?: number | null,
    placeofsupply?: string | null,
    companystate?: string | null,
    lastupdatedby?: string | null,
    cancelflag?: number | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    adjustmentamount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partyaccountid?: number | null,
    reversechargeflag?: number | null,
    paymentstatus?: number | null,
    partyregistrationtype?: string | null,
    partygstcategory?: string | null,
  } | null > | null,
};

export type ListPurchaseMasterCountQueryVariables = {
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListPurchaseMasterCountQuery = {
  listPurchaseMasterCount?:  Array< {
    __typename: "PurchaseMasterListCount",
    purchasemasterlistcount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type ListPartyPurchasesQueryVariables = {
  supplierid: number,
};

export type ListPartyPurchasesQuery = {
  listPartyPurchases?:  Array< {
    __typename: "PurchaseMaster",
    purchaseid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    purchasegsttypecd?: string | null,
    supplierid?: number | null,
    entrydate?: number | null,
    vouchernumber?: string | null,
    supplierinvoicedate?: number | null,
    supplierinvoicenumber?: string | null,
    supplieraddressid?: number | null,
    paymenttypecd?: string | null,
    paidamount?: number | null,
    creditduration?: number | null,
    paymentaccountid?: number | null,
    comments?: string | null,
    tdsapplicableflag?: number | null,
    granttotalamount?: number | null,
    balancedueamount?: number | null,
    paymentclearedflag?: number | null,
    placeofsupply?: string | null,
    companystate?: string | null,
    relatedpurchasetdsdetails?:  Array< {
      __typename: "PurchaseTDSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tdsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tdsamount?: number | null,
      adjustmentamount?: number | null,
      tdssection?: string | null,
      tdspercentage?: number | null,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchasetcsdetails?:  Array< {
      __typename: "PurchaseTCSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedpurchaselineitems?:  Array< {
      __typename: "PurchaseLineItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      itemnumber: number,
      itemid: number,
      purchaseaccountid: number,
      hsncode: string,
      itemquantity: number,
      unittypecd: string,
      itemrate: number,
      itemamount: number,
      itemdiscount: number,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount: number,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnid?: string | null,
      hsncodetype?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      purchaseaccountname?: string | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinenonitems?:  Array< {
      __typename: "PurchaseLineNonItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchaselineitemtype: string,
      purchaseaccountid: number,
      hsnsaccode: string,
      itemdescription: string,
      taxableamount: number,
      netamount: number,
      relatedpurchaselinenongst?:  Array< {
        __typename: "PurchaseLineNonGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      purchaseaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinegst?:  Array< {
      __typename: "PurchaseLineGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaselinenongst?:  Array< {
      __typename: "PurchaseLineNonGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaseattachment?:  Array< {
      __typename: "PurchaseAttachment",
      purchaseid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedpurchasetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpartyaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedpurchaseaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    cancelflag?: number | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    adjustmentamount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    reversechargeflag?: number | null,
    overduedays?: number | null,
    paymentstatus?: number | null,
    partyregistrationtype?: string | null,
    purchaseinvoicepdf?: string | null,
    partygstcategory?: string | null,
    partyemail?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    accountname?: string | null,
    duedatetimestamp?: number | null,
    partyisactive?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    isvouchereditable?: number | null,
    goods_exist?: number | null,
    itcflag?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
    totalgstamount?: number | null,
    tdsamount?: number | null,
    tcsamount?: number | null,
    taxableamount?: number | null,
    igstamount?: number | null,
    cgstamount?: number | null,
    sgstamount?: number | null,
    cessamount?: number | null,
    sourceofsupply?: string | null,
    taxabilitylabel?: string | null,
    additionaldiscount?: number | null,
    netinvoiceamount?: number | null,
  } | null > | null,
};

export type ListPartyInvoicePurchasesQueryVariables = {
  accountid?: number | null,
  transactiontype?: string | null,
};

export type ListPartyInvoicePurchasesQuery = {
  listPartyInvoicePurchases?:  Array< {
    __typename: "PartyInvoicePurchases",
    partyid?: number | null,
    companyid?: number | null,
    partytypecd?: string | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    groupaccountid?: number | null,
    gstcategory?: string | null,
    placeofsupply?: string | null,
    entity?: string | null,
    email?: string | null,
    contactnumber?: string | null,
    whatsappnumber?: string | null,
    accountsid?: number | null,
    is_active?: number | null,
    msmetype?: string | null,
    deliveryconsigneename?: string | null,
    deliveryconsigneegstin?: string | null,
    lastupdatedby?: string | null,
    tdspercentage?: number | null,
    udhyamregno?: string | null,
    sameaddressflag?: number | null,
    invoiceid?: number | null,
    invoicetypecd?: string | null,
    invoicepaymentaccountid?: number | null,
    invoicedate?: number | null,
    invoicenumber?: string | null,
    customerordernumber?: string | null,
    customerorderdate?: number | null,
    invoiceamount?: number | null,
    paymenttype?: string | null,
    invoicecreditduration?: number | null,
    invoicebillingaddressid?: number | null,
    invoicedeliveryaddressid?: number | null,
    invoicetaxabletypecd?: string | null,
    receipturl?: string | null,
    invoicelinetypecd?: string | null,
    invoicecurrencycd?: string | null,
    invoiceexchangerate?: number | null,
    invoicecomments?: string | null,
    receivedamount?: number | null,
    invoiceadjustmentamount?: number | null,
    invoiceplaceofsupply?: string | null,
    invoicebalancedueamount?: number | null,
    invoicereversechargeflag?: number | null,
    invoicetcsapplicableflag?: number | null,
    invoicelastupdatedby?: string | null,
    invoicestatuscode?: string | null,
    invoicestatusmessage?: string | null,
    invoicecancelflag?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    invoicecompanystate?: string | null,
    cancelremark?: string | null,
    deleteremark?: string | null,
    invoiceroundoffamount?: number | null,
    invoicediscounttype?: number | null,
    invoicediscountvalue?: number | null,
    invoiceserialnumber?: string | null,
    invoicecurrencycode?: string | null,
    invoicecurrencyrate?: number | null,
    invoicepartydisplayname?: string | null,
    invoicepartylegalname?: string | null,
    invoicepartyaccountid?: number | null,
    purchaseid?: number | null,
    purchasegsttypecd?: string | null,
    supplierid?: number | null,
    entrydate?: number | null,
    vouchernumber?: string | null,
    supplierinvoicedate?: number | null,
    supplierinvoicenumber?: string | null,
    supplieraddressid?: number | null,
    paymenttypecd?: string | null,
    paidamount?: number | null,
    purchasecreditduration?: number | null,
    purchasepaymentaccountid?: number | null,
    purchasecomments?: string | null,
    tdsapplicableflag?: number | null,
    granttotalamount?: number | null,
    purchasebalancedueamount?: number | null,
    paymentclearedflag?: number | null,
    purchaseplaceofsupply?: string | null,
    purchasecompanystate?: string | null,
    purchaselastupdatedby?: string | null,
    purchasecancelflag?: number | null,
    purchaseroundoffamount?: number | null,
    purchasediscounttype?: number | null,
    purchasediscountvalue?: number | null,
    purchaseadjustmentamount?: number | null,
    purchasestatuscode?: string | null,
    purchasestatusmessage?: string | null,
    purchaseserialnumber?: string | null,
    purchasecurrencycode?: string | null,
    purchasecurrencyrate?: number | null,
    purchasepartydisplayname?: string | null,
    purchasepartylegalname?: string | null,
    purchasepartyaccountid?: number | null,
    purchasereversechargeflag?: number | null,
    crdrnoteid?: number | null,
    crdrnotetypecd?: string | null,
    crdrnotedate?: number | null,
    crdrnotenumber?: string | null,
    crdrinvoicetypecd?: string | null,
    crdrgsttypecd?: string | null,
    crdrpartyid?: number | null,
    crdrdeliveryaddressid?: number | null,
    crdrpaymenttype?: string | null,
    crdrgrandtotalamount?: number | null,
    crdrtransactionid?: number | null,
    crdruserid?: string | null,
    crdrcreditduration?: number | null,
    crdrpsflag?: number | null,
    crdrreversechargeflag?: number | null,
    crdrbalancedueamount?: number | null,
    crdrconsigneename?: string | null,
    crdrconsigneegstin?: string | null,
    crdrplaceofsupply?: string | null,
    crdrcancelflag?: number | null,
    crdrcancelremark?: string | null,
    crdrroundoffamount?: number | null,
    crdrdiscounttype?: number | null,
    crdrdiscountvalue?: number | null,
    crdradjustmentamount?: number | null,
    crdrserialnumber?: string | null,
    crdrcurrencycode?: string | null,
    crdrcurrencyrate?: number | null,
    crdroriginalinvoicenumber?: string | null,
    crdrpaymentstatus?: number | null,
  } | null > | null,
};

export type ListCrDrNoteMasterv2QueryVariables = {
  crdrnotetypecd: string,
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListCrDrNoteMasterv2Query = {
  listCrDrNoteMasterv2?:  Array< {
    __typename: "CrDrNoteMasterv2",
    crdrnoteid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    crdrnotetypecd?: string | null,
    crdrnotedate?: number | null,
    crdrnotenumber?: string | null,
    invoicetypecd?: string | null,
    gsttypecd?: string | null,
    partyid?: number | null,
    deliveryaddressid?: number | null,
    paymenttype?: string | null,
    grandtotalamount?: number | null,
    transactionid?: number | null,
    userid?: string | null,
    creditduration?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    psflag?: number | null,
    reversechargeflag?: number | null,
    balancedueamount?: number | null,
    consigneename?: string | null,
    consignegstin?: string | null,
    companystate?: string | null,
    placeofsupply?: string | null,
    cancelflag?: number | null,
    cancelremark?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    adjustmentamount?: number | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partamount?: number | null,
    partydisplayname?: string | null,
    partyaccountid?: number | null,
    partytypecd?: string | null,
    originalinvoicenumber?: string | null,
    partyinvoicenumber?: string | null,
    paymentstatus?: number | null,
    crdrnotepdf?: string | null,
    receivedamount?: number | null,
    partyregistrationtype?: string | null,
    duedatetimestamp?: number | null,
    overduedays?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
  } | null > | null,
};

export type ListCrDrNoteMasterCountQueryVariables = {
  crdrnotetypecd: string,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListCrDrNoteMasterCountQuery = {
  listCrDrNoteMasterCount?:  Array< {
    __typename: "CrDrNoteMasterListCount",
    crdrnotemasterlistcount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type GetCompanyDetailsQueryVariables = {
  companyid?: number | null,
};

export type GetCompanyDetailsQuery = {
  getCompanyDetails?:  Array< {
    __typename: "CompanyFullDetails",
    companyid: number,
    enteredtimestamp: number,
    expiredtimestamp?: number | null,
    websiteurl?: string | null,
    currencycd?: number | null,
    accountinventoryflag?: number | null,
    pannumber?: string | null,
    tdstcsnumber?: string | null,
    cinregistrationnumber?: string | null,
    registrationtype?: number | null,
    gstrperiod?: string | null,
    lut?: string | null,
    lutbondvalidfrom?: number | null,
    ewaybillflag?: number | null,
    gstapplicablefrom?: number | null,
    thresholdlimitcd?: number | null,
    thresholdlimitamount?: number | null,
    companyshort?: string | null,
    lutbondtodate?: number | null,
    invoicedetailapplicablefromdate?: number | null,
    tdsapplicable?: number | null,
    gstcategory?: string | null,
    financialyearstartandendmonth?: number | null,
    companylogourl?: string | null,
    msmetype?: string | null,
    udhyamregno?: string | null,
    udhyamdocs?: string | null,
    ewaybillstartdate?: number | null,
    minamountewayinter?: number | null,
    minamountewayintra?: number | null,
    einvoiceflag?: number | null,
    einvoicestartingdate?: number | null,
    gstcompensationcessflag?: number | null,
    tradelicensenumber?: string | null,
    tradelicensestartdate?: number | null,
    tradelicenseenddate?: number | null,
    lastupdatedby?: string | null,
    cinregistrationdate?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    activeflag?: number | null,
  } | null > | null,
};

export type GetCompanyCodeTranslationQueryVariables = {
  codetype: string,
};

export type GetCompanyCodeTranslationQuery = {
  getCompanyCodeTranslation?:  Array< {
    __typename: "CompanyCodeTranslation",
    id?: number | null,
    companyid?: number | null,
    codetype?: string | null,
    codevalue?: string | null,
    language?: string | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    codetext?: string | null,
    codeorder?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
    uqc?: string | null,
    is_active?: string | null,
    section?: string | null,
  } | null > | null,
};

export type GetCompanyQueryVariables = {
};

export type GetCompanyQuery = {
  getCompany?:  Array< {
    __typename: "Company",
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    companyname?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relatedcompanydetailsnew?:  Array< {
      __typename: "CompanyDetails",
      companyid: number,
      enteredtimestamp: number,
      expiredtimestamp?: number | null,
      websiteurl?: string | null,
      currencycd?: number | null,
      accountinventoryflag?: number | null,
      pannumber?: string | null,
      tdstcsnumber?: string | null,
      cinregistrationnumber?: string | null,
      registrationtype?: number | null,
      comppercentage?: number | null,
      gstrperiod?: string | null,
      lut?: string | null,
      lutbondvalidfrom?: number | null,
      ewaybillflag?: number | null,
      gstapplicablefrom?: number | null,
      thresholdlimitcd?: number | null,
      thresholdlimitamount?: number | null,
      companylegalname?: string | null,
      companyshort?: string | null,
      lutbondtodate?: number | null,
      invoicedetailapplicablefromdate?: number | null,
      tdsapplicable?: number | null,
      gstcategory?: string | null,
      financialyearstartandendmonth?: number | null,
      companylogourl?: string | null,
      msmetype?: string | null,
      udhyamregno?: string | null,
      udhyamdocs?: string | null,
      ewaybillstartdate?: number | null,
      minamountewayinter?: number | null,
      minamountewayintra?: number | null,
      einvoiceflag?: number | null,
      einvoicestartingdate?: number | null,
      gstcompensationcessflag?: number | null,
      tradelicensenumber?: string | null,
      tradelicensestartdate?: number | null,
      tradelicenseenddate?: number | null,
      lastupdatedby?: string | null,
      cinregistrationdate?: number | null,
      einvoiceconnect?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      activeflag?: number | null,
      relatedfinancialyeardata?:  Array< {
        __typename: "FinancialYear",
        financialyearid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        startdate?: number | null,
        enddate?: number | null,
        startyear?: string | null,
        endyear?: string | null,
        comments?: string | null,
        userid?: string | null,
        aliasname?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        freezestatus?: number | null,
        transferdate?: number | null,
        freezedate?: number | null,
        stepscompleted?: Array< string | null > | null,
      } | null > | null,
      financialyearid?: number | null,
      lastupdatedtimestamp?: number | null,
      companydeletiontime?: number | null,
      ewaybillconnect?: number | null,
      stepscompleted?: Array< string | null > | null,
      disablegstcompensation?: number | null,
      businesstypeid?: Array< number | null > | null,
      industrytypeid?: Array< number | null > | null,
    } | null > | null,
    relatedcompanyentity?:  Array< {
      __typename: "CompanyEntity",
      id?: number | null,
      companyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      legalname?: string | null,
      gstin?: string | null,
      financialyearcode?: string | null,
      companyentitytype?: string | null,
      startdate?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
      financialyearid?: number | null,
    } | null > | null,
    relatedemailcontacts?:  Array< {
      __typename: "EmailContacts",
      id: number,
      objecttype: string,
      objectid: string,
      enteredtimestamp: number,
      expiredtimestamp: number,
      emailaddress: string,
      verifieddatetime?: number | null,
      promotionssignup?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedphonecontacts?:  Array< {
      __typename: "PhoneContacts",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      countrycode?: string | null,
      phonenumber?: string | null,
      verifieddatetime?: number | null,
      promotionssignup?: string | null,
      smsallowed?: string | null,
      callallowed?: string | null,
      whatsappallowed?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedaddressentity?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    addressentityid?: number | null,
    objecttype?: string | null,
    line1?: string | null,
    line2?: string | null,
    line3?: string | null,
    city?: string | null,
    statecode?: string | null,
    statename?: string | null,
    pincode?: string | null,
    countrycode?: string | null,
    district?: string | null,
    financialyearid?: number | null,
    einvoiceusername?: string | null,
    companydeletiontime?: number | null,
    ewaybillusername?: string | null,
  } | null > | null,
};

export type GetAccountGroupMasterQueryVariables = {
  accountgroupid: number,
};

export type GetAccountGroupMasterQuery = {
  getAccountGroupMaster?:  Array< {
    __typename: "AccountGroupMaster",
    accountgroupid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accounttypecd?: string | null,
    accountgroupname?: string | null,
    accountparentgroupid?: number | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    relatedaccounts?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    path?: string | null,
  } | null > | null,
};

export type GetAccountBalanceQueryVariables = {
  accountid: number,
};

export type GetAccountBalanceQuery = {
  getAccountBalance?:  Array< {
    __typename: "AccountBalance",
    accountid?: number | null,
    accountbalance?: number | null,
    actualbalance?: number | null,
    balancesign?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type ListGeneralSettingDateWiseQueryVariables = {
  entrytypecd: string,
  inputdate: number,
};

export type ListGeneralSettingDateWiseQuery = {
  listGeneralSettingDateWise?:  Array< {
    __typename: "NumberTracker",
    id?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    financialyearid?: number | null,
    entrytypecd?: string | null,
    serialnumber?: string | null,
    serialisactive?: number | null,
    serialisused?: number | null,
    nextinvoicenumber?: number | null,
    prefix?: string | null,
    suffix?: string | null,
    lastupdatedby?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialflag?: number | null,
    startinvoicenumber?: number | null,
    taxability?: number | null,
    lastused?: number | null,
    secondlastused?: number | null,
    restrictedflag?: number | null,
  } | null > | null,
};

export type GetCrDrNoteMasterQueryVariables = {
  crdrnoteid: number,
};

export type GetCrDrNoteMasterQuery = {
  getCrDrNoteMaster?:  Array< {
    __typename: "CrDrNoteMaster",
    crdrnoteid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    crdrnotetypecd?: string | null,
    crdrnotedate?: number | null,
    crdrnotenumber?: string | null,
    invoicetypecd?: string | null,
    gsttypecd?: string | null,
    partyid?: number | null,
    deliveryaddressid?: number | null,
    paymenttype?: string | null,
    grandtotalamount?: number | null,
    transactionid?: number | null,
    userid?: string | null,
    creditduration?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    psflag?: number | null,
    reversechargeflag?: number | null,
    balancedueamount?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    companystate?: string | null,
    placeofsupply?: string | null,
    cancelflag?: number | null,
    cancelremark?: string | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    adjustmentamount?: number | null,
    relatedcrdrnoteinvoices?:  Array< {
      __typename: "CrDrNoteInvoices",
      crdrnoteid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      invoiceid?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
    } | null > | null,
    relatedcrdrattachment?:  Array< {
      __typename: "CrDrAttachment",
      crdrnoteid?: number | null,
      attachmentid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      attachmentname?: string | null,
      attachmenturl?: string | null,
      userid?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedcrdrnotedetails?:  Array< {
      __typename: "CrDrNoteDetails",
      crdrnoteid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      totaltaxableamount?: number | null,
      totalgst?: number | null,
      totalgstcess?: number | null,
      totaladjustments?: number | null,
      comments?: string | null,
      accountid?: number | null,
      partamount?: number | null,
      transportationcd?: string | null,
      vehiclenumber?: string | null,
      dispatchdate?: number | null,
      ewaybillnumber?: string | null,
      userid?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedcrdrnotelineitems?:  Array< {
      __typename: "CrDrNoteLineItems",
      crdrnoteid?: number | null,
      crdrnoteitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemnumber?: number | null,
      lineitemtype?: string | null,
      itemid?: number | null,
      quantity?: number | null,
      unittypecd?: string | null,
      itemrate?: number | null,
      itemamount?: number | null,
      itemdiscount?: number | null,
      discounttype?: string | null,
      discountrate?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      gstcess?: number | null,
      hsnsaccode?: string | null,
      netamount?: number | null,
      userid?: string | null,
      taxability?: string | null,
      reason?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pricetype?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      unit?: string | null,
      uqc?: string | null,
      salesaccountname?: string | null,
      purchaseaccountname?: string | null,
      salesaccountid?: number | null,
      purchaseaccountid?: number | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedcrdrnotelinenonitems?:  Array< {
      __typename: "CrDrNoteLineNonItems",
      crdrnoteid?: number | null,
      crdrnoteitemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      lineitemtype?: string | null,
      ledgeraccountid?: number | null,
      hsnsaccode?: string | null,
      itemdescription?: string | null,
      taxableamount?: number | null,
      gstrate?: number | null,
      gsttypecd?: string | null,
      gstamount?: number | null,
      gstcess?: number | null,
      netamount?: number | null,
      userid?: string | null,
      taxability?: string | null,
      reason?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      ledgeraccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedcrdrnotetcsdetails?:  Array< {
      __typename: "CrDrNoteTCSDetails",
      crdrnoteid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      tcsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
    } | null > | null,
    relatedcrdrnotetdsdetails?:  Array< {
      __typename: "CrDrNoteTDSDetails",
      crdrnoteid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      tdsapplicablecd: number,
      totaltaxableamount: number,
      ineligibletcflag: number,
      reversechargeflag: number,
      gstcesstotal: number,
      tdsamount: number,
      adjustmentamount: number,
      tdssection?: string | null,
      tdspercentage?: number | null,
      tcsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedcrdrnotedispatch?:  Array< {
      __typename: "CrDrNoteDispatch",
      crdrnoteid: number,
      dispatchid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      transportationcd: string,
      vehiclenumber: string,
      dispatchdate: number,
      ewaybillnumber: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partamount?: number | null,
    originalinvoicenumber?: string | null,
    partyinvoicenumber?: string | null,
    totalgst?: number | null,
    totalgstcess?: number | null,
    totaltaxableamount?: number | null,
    totaladjustments?: number | null,
    comments?: string | null,
    accountid?: number | null,
    transportationcd?: string | null,
    vehiclenumber?: string | null,
    dispatchdate?: number | null,
    ewaybillnumber?: string | null,
    paymentstatus?: number | null,
    crdrnotepdf?: string | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    partygstcategory?: string | null,
    partyemail?: string | null,
    partytypecd?: string | null,
    partygstin?: string | null,
    accountname?: string | null,
    partyregistrationtype?: string | null,
    duedatetimestamp?: number | null,
    overduedays?: number | null,
    partyisactive?: number | null,
    isvouchereditable?: number | null,
    itcflag?: number | null,
    cessexist?: number | null,
  } | null > | null,
};

export type ListTransactionRelationQueryVariables = {
};

export type ListTransactionRelationQuery = {
  listTransactionRelation?:  Array< {
    __typename: "TransactionRelation",
    transactionid?: number | null,
    transactiontypecd?: string | null,
    objecttype?: string | null,
    objectid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    linkedamount?: number | null,
    objectattribute?: string | null,
    isdirect?: number | null,
    lastupdatedby?: string | null,
    accountid?: number | null,
    paymentvouchernumber?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type GetRelatedPaymentDetailsQueryVariables = {
  invoicetype: string,
  id: number,
};

export type GetRelatedPaymentDetailsQuery = {
  getRelatedPaymentDetails?:  Array< {
    __typename: "RelatedPaymentDetails",
    id?: number | null,
    serialnumber?: string | null,
    paymenttransactionid?: number | null,
    paymentvouchernumber?: string | null,
    transactiontypecd?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type ListdashboardbalancesQueryVariables = {
  startdate: number,
  enddate: number,
  openingbalance: number,
  companyid: number,
  financialyearid: number,
};

export type ListdashboardbalancesQuery = {
  listdashboardbalances?:  Array< {
    __typename: "DashboardBalances",
    companyid?: number | null,
    expiredtimestamp?: number | null,
    financialyearid?: number | null,
    type?: string | null,
    accountid?: number | null,
    accountname?: string | null,
    immediate_parent_group_id?: number | null,
    immediate_parent_group_name?: string | null,
    root_group_id?: number | null,
    root_group_name?: string | null,
    accounttypecd?: string | null,
    restrictedflag?: number | null,
    creditamount?: number | null,
    debitamount?: number | null,
    balance?: number | null,
    is_active?: number | null,
    group_path?: string | null,
    balancesign?: number | null,
    accounttypeflag?: number | null,
  } | null > | null,
};

export type ListbusinessoverviewQueryVariables = {
  startdate: number,
  enddate: number,
  openingbalance: number,
  companyid: number,
  financialyearid: number,
};

export type ListbusinessoverviewQuery = {
  listbusinessoverview?:  Array< {
    __typename: "BusinessOverview",
    companyid?: number | null,
    expiredtimestamp?: number | null,
    financialyearid?: number | null,
    group_name?: string | null,
    level?: number | null,
    group_path?: string | null,
    balance?: number | null,
    closingstockamt?: number | null,
    openingstockamt?: number | null,
  } | null > | null,
};

export type Listtop5expenseQueryVariables = {
  startdate: number,
  enddate: number,
  openingbalance: number,
  companyid: number,
  financialyearid: number,
};

export type Listtop5expenseQuery = {
  listtop5expense?:  Array< {
    __typename: "Top5Expense",
    companyid: number,
    financialyearid: number,
    account_id: number,
    account_name: string,
    balance: number,
    type: string,
  } | null > | null,
};

export type GetAccountMasterQueryVariables = {
  accountsid: number,
};

export type GetAccountMasterQuery = {
  getAccountMaster?:  {
    __typename: "AccountMaster",
    accountsid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    accountname?: string | null,
    accounttypecd?: string | null,
    accountgroupid?: number | null,
    hsnsaccode?: string | null,
    displayordernumber?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    restrictedflag?: number | null,
    is_active?: number | null,
    accounttypeflag?: number | null,
    relatedaccountgstdetails?:  Array< {
      __typename: "AccountGSTDetails",
      accountid?: number | null,
      companyid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstrate?: number | null,
      cessamount?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      hsnsaccode?: string | null,
      codetype?: string | null,
      description?: string | null,
      taxability?: string | null,
    } | null > | null,
    relatedaccountopeningbalance?:  Array< {
      __typename: "AccountOpeningBalance",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      financialyearid?: number | null,
      startdate?: number | null,
      creditamount?: number | null,
      debitamount?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedaccountgroupmaster?:  Array< {
      __typename: "AccountGroupMasterNew",
      accountgroupid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accounttypecd?: string | null,
      accountgroupname?: string | null,
      accountparentgroupid?: number | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      is_active?: number | null,
      restrictedflag?: number | null,
      path?: string | null,
    } | null > | null,
    relatedaccountbalance?:  Array< {
      __typename: "AccountBalanceNew",
      accountid?: number | null,
      accountbalance?: number | null,
      actualbalance?: number | null,
    } | null > | null,
    path?: string | null,
  } | null,
};

export type ListPurchaseMasterRangeQueryVariables = {
  startdate: number,
  enddate: number,
};

export type ListPurchaseMasterRangeQuery = {
  listPurchaseMasterRange?:  Array< {
    __typename: "PurchaseMaster",
    purchaseid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    purchasegsttypecd?: string | null,
    supplierid?: number | null,
    entrydate?: number | null,
    vouchernumber?: string | null,
    supplierinvoicedate?: number | null,
    supplierinvoicenumber?: string | null,
    supplieraddressid?: number | null,
    paymenttypecd?: string | null,
    paidamount?: number | null,
    creditduration?: number | null,
    paymentaccountid?: number | null,
    comments?: string | null,
    tdsapplicableflag?: number | null,
    granttotalamount?: number | null,
    balancedueamount?: number | null,
    paymentclearedflag?: number | null,
    placeofsupply?: string | null,
    companystate?: string | null,
    relatedpurchasetdsdetails?:  Array< {
      __typename: "PurchaseTDSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tdsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tdsamount?: number | null,
      adjustmentamount?: number | null,
      tdssection?: string | null,
      tdspercentage?: number | null,
      tdsmanual?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchasetcsdetails?:  Array< {
      __typename: "PurchaseTCSDetails",
      purchaseid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      tcsapplicablecd?: number | null,
      totaltaxableamount?: number | null,
      ineligibletcflag?: number | null,
      reversechargeflag?: number | null,
      gstcesstotal?: number | null,
      tcsamount?: number | null,
      adjustmentamount?: number | null,
      tcssection?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      tcspercentage?: number | null,
      tcsmanual?: number | null,
    } | null > | null,
    relatedpurchaselineitems?:  Array< {
      __typename: "PurchaseLineItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      itemnumber: number,
      itemid: number,
      purchaseaccountid: number,
      hsncode: string,
      itemquantity: number,
      unittypecd: string,
      itemrate: number,
      itemamount: number,
      itemdiscount: number,
      discounttype?: string | null,
      discountrate?: number | null,
      netamount: number,
      relatedpurchaselinegst?:  Array< {
        __typename: "PurchaseLineGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relateditemmaster?:  Array< {
        __typename: "itemmaster",
        itemid?: number | null,
        itemcode?: string | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        itemname?: string | null,
        salesinvoiceflag?: number | null,
        purchaseinvoiceflag?: number | null,
        itemcategorycd?: string | null,
        measurementcd?: string | null,
        currencycd?: string | null,
        salesaccountid?: number | null,
        purchaseaccountid?: number | null,
        taxabilitycd?: string | null,
        reversechargeflag?: number | null,
        itemtype?: string | null,
        hsnid?: string | null,
        is_active?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        relateditemamountdetails?:  Array< {
          __typename: "ItemAmountDetails",
          id?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          amount?: number | null,
          effectivedate?: number | null,
          expireddate?: number | null,
          hsnid?: string | null,
          gstcompensationtype?: string | null,
          gstcompensationvalue?: number | null,
          gstrate?: number | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          lastupdatedby?: string | null,
          discounttype?: number | null,
          discountvalue?: number | null,
          invoicetype?: number | null,
          pricetype?: string | null,
          isactive?: number | null,
          isdefault?: number | null,
          pricetypeid?: number | null,
          tabletype?: number | null,
        } | null > | null,
        relateditemgstdetails?:  Array< {
          __typename: "ItemGstDetails",
          itemid: number,
          companyid: number,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          hsnid: string,
          gstcesstype: string,
          gstcompensationvalue: number,
          effectivedate?: number | null,
          expireddate?: number | null,
          gstcessvalue?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relateditemimages?:  Array< {
          __typename: "ItemImages",
          attachmentid?: number | null,
          itemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          imagename?: string | null,
          imageurl?: string | null,
          documentname?: string | null,
          type?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        serialnumber?: string | null,
        financialyearid?: number | null,
        description?: string | null,
        hsnsacid?: number | null,
        hsncodetype?: string | null,
        hsncodevalue?: string | null,
        hsndescription?: string | null,
        cessexist?: number | null,
        barcode?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      pricetype?: string | null,
      lotid?: string | null,
      hsnid?: string | null,
      hsncodetype?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      unit?: string | null,
      uqc?: string | null,
      purchaseaccountname?: string | null,
      itemname?: string | null,
      itemcode?: string | null,
      itemtype?: string | null,
      manualdiscount?: number | null,
      manualcess?: number | null,
      pricetypeid?: number | null,
      manualgst?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinenonitems?:  Array< {
      __typename: "PurchaseLineNonItems",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      purchaselineitemtype: string,
      purchaseaccountid: number,
      hsnsaccode: string,
      itemdescription: string,
      taxableamount: number,
      netamount: number,
      relatedpurchaselinenongst?:  Array< {
        __typename: "PurchaseLineNonGST",
        purchaseid: number,
        purchaseitemid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        gstrate: number,
        cessamount: number,
        gstamount: number,
        cessrate?: number | null,
        cesstype?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      taxability?: string | null,
      hsnsacid?: number | null,
      hsncodetype?: string | null,
      hsncodevalue?: string | null,
      hsndescription?: string | null,
      gstrate?: number | null,
      gstamount?: number | null,
      cessamount?: number | null,
      purchaseaccountname?: string | null,
      manualgst?: number | null,
      manualcess?: number | null,
      cessrate?: number | null,
      cesstype?: string | null,
    } | null > | null,
    relatedpurchaselinegst?:  Array< {
      __typename: "PurchaseLineGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaselinenongst?:  Array< {
      __typename: "PurchaseLineNonGST",
      purchaseid: number,
      purchaseitemid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      gstrate: number,
      cessamount: number,
      gstamount: number,
      cessrate?: number | null,
      cesstype?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relatedpurchaseattachment?:  Array< {
      __typename: "PurchaseAttachment",
      purchaseid: number,
      attachmentid: number,
      companyid: number,
      companybranchid: number,
      enteredtimestamp: number,
      expiredtimestamp: number,
      attachmentname: string,
      attachmenturl: string,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      documentname?: string | null,
      type?: string | null,
    } | null > | null,
    relatedpurchasetransactiondetails?:  Array< {
      __typename: "TransactionMaster",
      transactionid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      transactiontypecd?: string | null,
      vouchernumber?: string | null,
      entrydate?: number | null,
      bankreferencenumber?: string | null,
      comments?: string | null,
      relatedtransactiondetails?:  Array< {
        __typename: "TransactionDetailsCustom",
        transactionid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        transactiontypecd?: string | null,
        accountid?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        comments?: string | null,
        entryordernumber?: number | null,
        transactionbalance?: number | null,
        openingbalance?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        financialyearid?: number | null,
      } | null > | null,
      relatedtransactionattachment?:  Array< {
        __typename: "TransactionAttachment",
        transactionid: number,
        attachmentid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        attachmentname: string,
        attachmenturl: string,
        lastupdatedby?: string | null,
        documentname: string,
        statuscode?: string | null,
        statusmessage?: string | null,
        type?: string | null,
      } | null > | null,
      relatedtransactiontdsdetails?:  Array< {
        __typename: "TransactionTDSDetails",
        transactionid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        tdsapplicablecd: string,
        tdsamount: number,
        tdsmanual?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        tdspercentage?: number | null,
      } | null > | null,
      relatedpurchasemaster?:  Array< {
        __typename: "PurchaseMasterNew",
        purchaseid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        purchasegsttypecd: string,
        supplierid: number,
        entrydate: number,
        vouchernumber: string,
        supplierinvoicedate: number,
        supplierinvoicenumber: string,
        supplieraddressid: number,
        paymenttypecd: string,
        paidamount: number,
        creditduration: number,
        paymentaccountid: number,
        comments: string,
        tdsapplicableflag: number,
        granttotalamount?: number | null,
        balancedueamount?: number | null,
        paymentclearedflag?: number | null,
        placeofsupply?: string | null,
        companystate?: string | null,
        relatedpurchasetdsdetails?:  Array< {
          __typename: "PurchaseTDSDetails",
          purchaseid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          tdsapplicablecd?: number | null,
          totaltaxableamount?: number | null,
          ineligibletcflag?: number | null,
          reversechargeflag?: number | null,
          gstcesstotal?: number | null,
          tdsamount?: number | null,
          adjustmentamount?: number | null,
          tdssection?: string | null,
          tdspercentage?: number | null,
          tdsmanual?: number | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaselineitems?:  Array< {
          __typename: "PurchaseLineItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          itemnumber: number,
          itemid: number,
          purchaseaccountid: number,
          hsncode: string,
          itemquantity: number,
          unittypecd: string,
          itemrate: number,
          itemamount: number,
          itemdiscount: number,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount: number,
          relatedpurchaselinegst?:  Array< {
            __typename: "PurchaseLineGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnid?: string | null,
          hsncodetype?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          purchaseaccountname?: string | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinenonitems?:  Array< {
          __typename: "PurchaseLineNonItems",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          purchaselineitemtype: string,
          purchaseaccountid: number,
          hsnsaccode: string,
          itemdescription: string,
          taxableamount: number,
          netamount: number,
          relatedpurchaselinenongst?:  Array< {
            __typename: "PurchaseLineNonGST",
            purchaseid: number,
            purchaseitemid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            gstrate: number,
            cessamount: number,
            gstamount: number,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          taxability?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gstamount?: number | null,
          cessamount?: number | null,
          purchaseaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedpurchaselinegst?:  Array< {
          __typename: "PurchaseLineGST",
          purchaseid: number,
          purchaseitemid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          gstrate: number,
          cessamount: number,
          gstamount: number,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedpurchaseattachment?:  Array< {
          __typename: "PurchaseAttachment",
          purchaseid: number,
          attachmentid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          attachmentname: string,
          attachmenturl: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedpurchasetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        relatedpurchasetransactionrelation?:  Array< {
          __typename: "TransactionRelation",
          transactionid?: number | null,
          transactiontypecd?: string | null,
          objecttype?: string | null,
          objectid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          linkedamount?: number | null,
          objectattribute?: string | null,
          isdirect?: number | null,
          lastupdatedby?: string | null,
          accountid?: number | null,
          paymentvouchernumber?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        adjustmentamount?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        reversechargeflag?: number | null,
        paymentstatus?: number | null,
        partyregistrationtype?: string | null,
        partygstcategory?: string | null,
        itcflag?: number | null,
      } | null > | null,
      relatedinvoicemaster?:  Array< {
        __typename: "Invoicemasternew",
        invoiceid: number,
        companyid: number,
        companybranchid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        invoicetypecd: string,
        partyid: number,
        paymentaccountid: number,
        invoicedate: number,
        invoicenumber: string,
        customerordernumber: string,
        customerorderdate?: number | null,
        invoiceamount: number,
        paymenttype: string,
        creditduration: number,
        invoicebillingaddressid: number,
        invoicedeliveryaddressid: number,
        invoicetaxabletypecd: string,
        receipturl: string,
        invoicelinetypecd: string,
        invoicecurrencycd: string,
        exchangerate: number,
        comments: string,
        receivedamount: number,
        adjustmentamount: number,
        placeofsupply?: string | null,
        balancedueamount?: number | null,
        reversechargeflag?: number | null,
        tcsapplicableflag?: number | null,
        relatedinvoicelineitems?:  Array< {
          __typename: "InvoiceLineItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          lineitemnumber?: number | null,
          invoicelineitemtype?: string | null,
          itemid?: number | null,
          quantity?: number | null,
          unittypecd?: string | null,
          itemrate?: number | null,
          itemamount?: number | null,
          itemdiscount?: number | null,
          discounttype?: string | null,
          discountrate?: number | null,
          netamount?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          pricetype?: string | null,
          lotid?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          unit?: string | null,
          uqc?: string | null,
          salesaccountname?: string | null,
          salesaccountid?: number | null,
          itemname?: string | null,
          itemcode?: string | null,
          itemtype?: string | null,
          manualdiscount?: number | null,
          manualcess?: number | null,
          itemmaster_timestamp?: number | null,
          description?: string | null,
          relatedinvoicelinegst?:  Array< {
            __typename: "InvoiceLineGST",
            invoiceid: number,
            invoiceitemid: number,
            companyid: number,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            gstrate?: number | null,
            gsttypecd?: string | null,
            gstamount?: number | null,
            cessamount?: number | null,
            cessrate?: number | null,
            cesstype?: string | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
          } | null > | null,
          relateditemmaster?:  Array< {
            __typename: "itemmaster",
            itemid?: number | null,
            itemcode?: string | null,
            companyid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            itemname?: string | null,
            salesinvoiceflag?: number | null,
            purchaseinvoiceflag?: number | null,
            itemcategorycd?: string | null,
            measurementcd?: string | null,
            currencycd?: string | null,
            salesaccountid?: number | null,
            purchaseaccountid?: number | null,
            taxabilitycd?: string | null,
            reversechargeflag?: number | null,
            itemtype?: string | null,
            hsnid?: string | null,
            is_active?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            relateditemamountdetails?:  Array< {
              __typename: "ItemAmountDetails",
              id?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              amount?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstcompensationvalue?: number | null,
              gstrate?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              lastupdatedby?: string | null,
              discounttype?: number | null,
              discountvalue?: number | null,
              invoicetype?: number | null,
              pricetype?: string | null,
              isactive?: number | null,
              isdefault?: number | null,
              pricetypeid?: number | null,
              tabletype?: number | null,
            } | null > | null,
            relateditemgstdetails?:  Array< {
              __typename: "ItemGstDetails",
              itemid: number,
              companyid: number,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              hsnid: string,
              gstcesstype: string,
              gstcompensationvalue: number,
              effectivedate?: number | null,
              expireddate?: number | null,
              gstcessvalue?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relateditemimages?:  Array< {
              __typename: "ItemImages",
              attachmentid?: number | null,
              itemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              imagename?: string | null,
              imageurl?: string | null,
              documentname?: string | null,
              type?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            serialnumber?: string | null,
            financialyearid?: number | null,
            description?: string | null,
            hsnsacid?: number | null,
            hsncodetype?: string | null,
            hsncodevalue?: string | null,
            hsndescription?: string | null,
            cessexist?: number | null,
            barcode?: string | null,
          } | null > | null,
          pricetypeid?: number | null,
          manualgst?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoicelinenonitems?:  Array< {
          __typename: "InvoiceLineNonItems",
          invoiceid?: number | null,
          invoiceitemid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          invoicelineitemtype?: string | null,
          incomeaccountid?: number | null,
          hsnsaccode?: string | null,
          taxability?: string | null,
          itemdescription?: string | null,
          taxableamount?: number | null,
          netamount?: number | null,
          relatedaccounts?:  Array< {
            __typename: "AccountMaster",
            accountsid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            accountname?: string | null,
            accounttypecd?: string | null,
            accountgroupid?: number | null,
            hsnsaccode?: string | null,
            displayordernumber?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            restrictedflag?: number | null,
            is_active?: number | null,
            accounttypeflag?: number | null,
            relatedaccountgstdetails?:  Array< {
              __typename: "AccountGSTDetails",
              accountid?: number | null,
              companyid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              effectivedate?: number | null,
              expireddate?: number | null,
              hsnid?: string | null,
              gstcompensationtype?: string | null,
              gstrate?: number | null,
              cessamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsaccode?: string | null,
              codetype?: string | null,
              description?: string | null,
              taxability?: string | null,
            } | null > | null,
            relatedaccountopeningbalance?:  Array< {
              __typename: "AccountOpeningBalance",
              accountsid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              financialyearid?: number | null,
              startdate?: number | null,
              creditamount?: number | null,
              debitamount?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedaccountgroupmaster?:  Array< {
              __typename: "AccountGroupMasterNew",
              accountgroupid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              accounttypecd?: string | null,
              accountgroupname?: string | null,
              accountparentgroupid?: number | null,
              displayordernumber?: number | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              is_active?: number | null,
              restrictedflag?: number | null,
              path?: string | null,
            } | null > | null,
            relatedaccountbalance?:  Array< {
              __typename: "AccountBalanceNew",
              accountid?: number | null,
              accountbalance?: number | null,
              actualbalance?: number | null,
            } | null > | null,
            path?: string | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          hsnsacid?: number | null,
          hsncodetype?: string | null,
          hsncodevalue?: string | null,
          hsndescription?: string | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          incomeaccountname?: string | null,
          manualgst?: number | null,
          manualcess?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
        } | null > | null,
        relatedinvoiceattachment?:  Array< {
          __typename: "InvoiceAttachment",
          invoiceid?: number | null,
          attachmentid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          attachmentname?: string | null,
          attachmenturl?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          documentname?: string | null,
          type?: string | null,
        } | null > | null,
        relatedinvoicedispatch?:  Array< {
          __typename: "InvoiceDispatch",
          invoiceid: number,
          dispatchid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          transportationcd: string,
          vehiclenumber: string,
          dispatchdate: number,
          ewaybillnumber: string,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoiceposdetails?:  Array< {
          __typename: "InvoicePOSDetails",
          posid: number,
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          partyposid: number,
          lastupdatedby?: string | null,
          relatedposparty?:  Array< {
            __typename: "POSParty",
            pospartyid?: number | null,
            companyid?: number | null,
            partyname?: string | null,
            partycontactnumberid?: number | null,
            lastupdatedby?: string | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            relatedphonecontacts?:  Array< {
              __typename: "PhoneContacts",
              id?: number | null,
              objecttype?: string | null,
              objectid?: string | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              countrycode?: string | null,
              phonenumber?: string | null,
              verifieddatetime?: number | null,
              promotionssignup?: string | null,
              smsallowed?: string | null,
              callallowed?: string | null,
              whatsappallowed?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
          } | null > | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicelinegst?:  Array< {
          __typename: "InvoiceLineGST",
          invoiceid: number,
          invoiceitemid: number,
          companyid: number,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          gstrate?: number | null,
          gsttypecd?: string | null,
          gstamount?: number | null,
          cessamount?: number | null,
          cessrate?: number | null,
          cesstype?: string | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
        } | null > | null,
        relatedinvoicenumbertracker?:  Array< {
          __typename: "InvoiceNumberTracker",
          companyid: number,
          companybranchid: number,
          enteredtimestamp: number,
          expiredtimestamp: number,
          nextinvoicenumber: string,
          lastupdatedby?: string | null,
        } | null > | null,
        relatedinvoicetransactiondetails?:  Array< {
          __typename: "TransactionMaster",
          transactionid?: number | null,
          companyid?: number | null,
          companybranchid?: number | null,
          enteredtimestamp?: number | null,
          expiredtimestamp?: number | null,
          transactiontypecd?: string | null,
          vouchernumber?: string | null,
          entrydate?: number | null,
          bankreferencenumber?: string | null,
          comments?: string | null,
          relatedtransactiondetails?:  Array< {
            __typename: "TransactionDetailsCustom",
            transactionid?: number | null,
            companyid?: number | null,
            companybranchid?: number | null,
            enteredtimestamp?: number | null,
            expiredtimestamp?: number | null,
            transactiontypecd?: string | null,
            accountid?: number | null,
            creditamount?: number | null,
            debitamount?: number | null,
            comments?: string | null,
            entryordernumber?: number | null,
            transactionbalance?: number | null,
            openingbalance?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            financialyearid?: number | null,
          } | null > | null,
          relatedtransactionattachment?:  Array< {
            __typename: "TransactionAttachment",
            transactionid: number,
            attachmentid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            attachmentname: string,
            attachmenturl: string,
            lastupdatedby?: string | null,
            documentname: string,
            statuscode?: string | null,
            statusmessage?: string | null,
            type?: string | null,
          } | null > | null,
          relatedtransactiontdsdetails?:  Array< {
            __typename: "TransactionTDSDetails",
            transactionid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            tdsapplicablecd: string,
            tdsamount: number,
            tdsmanual?: number | null,
            lastupdatedby?: string | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            tdspercentage?: number | null,
          } | null > | null,
          relatedpurchasemaster?:  Array< {
            __typename: "PurchaseMasterNew",
            purchaseid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            purchasegsttypecd: string,
            supplierid: number,
            entrydate: number,
            vouchernumber: string,
            supplierinvoicedate: number,
            supplierinvoicenumber: string,
            supplieraddressid: number,
            paymenttypecd: string,
            paidamount: number,
            creditduration: number,
            paymentaccountid: number,
            comments: string,
            tdsapplicableflag: number,
            granttotalamount?: number | null,
            balancedueamount?: number | null,
            paymentclearedflag?: number | null,
            placeofsupply?: string | null,
            companystate?: string | null,
            relatedpurchasetdsdetails?:  Array< {
              __typename: "PurchaseTDSDetails",
              purchaseid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              tdsapplicablecd?: number | null,
              totaltaxableamount?: number | null,
              ineligibletcflag?: number | null,
              reversechargeflag?: number | null,
              gstcesstotal?: number | null,
              tdsamount?: number | null,
              adjustmentamount?: number | null,
              tdssection?: string | null,
              tdspercentage?: number | null,
              tdsmanual?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaselineitems?:  Array< {
              __typename: "PurchaseLineItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              itemnumber: number,
              itemid: number,
              purchaseaccountid: number,
              hsncode: string,
              itemquantity: number,
              unittypecd: string,
              itemrate: number,
              itemamount: number,
              itemdiscount: number,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnid?: string | null,
              hsncodetype?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              purchaseaccountname?: string | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinenonitems?:  Array< {
              __typename: "PurchaseLineNonItems",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              purchaselineitemtype: string,
              purchaseaccountid: number,
              hsnsaccode: string,
              itemdescription: string,
              taxableamount: number,
              netamount: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              taxability?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gstamount?: number | null,
              cessamount?: number | null,
              purchaseaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedpurchaselinegst?:  Array< {
              __typename: "PurchaseLineGST",
              purchaseid: number,
              purchaseitemid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              gstrate: number,
              cessamount: number,
              gstamount: number,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedpurchaseattachment?:  Array< {
              __typename: "PurchaseAttachment",
              purchaseid: number,
              attachmentid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              attachmentname: string,
              attachmenturl: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedpurchasetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            relatedpurchasetransactionrelation?:  Array< {
              __typename: "TransactionRelation",
              transactionid?: number | null,
              transactiontypecd?: string | null,
              objecttype?: string | null,
              objectid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              linkedamount?: number | null,
              objectattribute?: string | null,
              isdirect?: number | null,
              lastupdatedby?: string | null,
              accountid?: number | null,
              paymentvouchernumber?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            adjustmentamount?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            reversechargeflag?: number | null,
            paymentstatus?: number | null,
            partyregistrationtype?: string | null,
            partygstcategory?: string | null,
            itcflag?: number | null,
          } | null > | null,
          relatedinvoicemaster?:  Array< {
            __typename: "Invoicemasternew",
            invoiceid: number,
            companyid: number,
            companybranchid: number,
            enteredtimestamp: number,
            expiredtimestamp: number,
            invoicetypecd: string,
            partyid: number,
            paymentaccountid: number,
            invoicedate: number,
            invoicenumber: string,
            customerordernumber: string,
            customerorderdate?: number | null,
            invoiceamount: number,
            paymenttype: string,
            creditduration: number,
            invoicebillingaddressid: number,
            invoicedeliveryaddressid: number,
            invoicetaxabletypecd: string,
            receipturl: string,
            invoicelinetypecd: string,
            invoicecurrencycd: string,
            exchangerate: number,
            comments: string,
            receivedamount: number,
            adjustmentamount: number,
            placeofsupply?: string | null,
            balancedueamount?: number | null,
            reversechargeflag?: number | null,
            tcsapplicableflag?: number | null,
            relatedinvoicelineitems?:  Array< {
              __typename: "InvoiceLineItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              lineitemnumber?: number | null,
              invoicelineitemtype?: string | null,
              itemid?: number | null,
              quantity?: number | null,
              unittypecd?: string | null,
              itemrate?: number | null,
              itemamount?: number | null,
              itemdiscount?: number | null,
              discounttype?: string | null,
              discountrate?: number | null,
              netamount?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              pricetype?: string | null,
              lotid?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              unit?: string | null,
              uqc?: string | null,
              salesaccountname?: string | null,
              salesaccountid?: number | null,
              itemname?: string | null,
              itemcode?: string | null,
              itemtype?: string | null,
              manualdiscount?: number | null,
              manualcess?: number | null,
              itemmaster_timestamp?: number | null,
              description?: string | null,
              pricetypeid?: number | null,
              manualgst?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoicelinenonitems?:  Array< {
              __typename: "InvoiceLineNonItems",
              invoiceid?: number | null,
              invoiceitemid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              invoicelineitemtype?: string | null,
              incomeaccountid?: number | null,
              hsnsaccode?: string | null,
              taxability?: string | null,
              itemdescription?: string | null,
              taxableamount?: number | null,
              netamount?: number | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              hsnsacid?: number | null,
              hsncodetype?: string | null,
              hsncodevalue?: string | null,
              hsndescription?: string | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              incomeaccountname?: string | null,
              manualgst?: number | null,
              manualcess?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
            } | null > | null,
            relatedinvoiceattachment?:  Array< {
              __typename: "InvoiceAttachment",
              invoiceid?: number | null,
              attachmentid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              attachmentname?: string | null,
              attachmenturl?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              documentname?: string | null,
              type?: string | null,
            } | null > | null,
            relatedinvoicedispatch?:  Array< {
              __typename: "InvoiceDispatch",
              invoiceid: number,
              dispatchid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              transportationcd: string,
              vehiclenumber: string,
              dispatchdate: number,
              ewaybillnumber: string,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoiceposdetails?:  Array< {
              __typename: "InvoicePOSDetails",
              posid: number,
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              partyposid: number,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicelinegst?:  Array< {
              __typename: "InvoiceLineGST",
              invoiceid: number,
              invoiceitemid: number,
              companyid: number,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              gstrate?: number | null,
              gsttypecd?: string | null,
              gstamount?: number | null,
              cessamount?: number | null,
              cessrate?: number | null,
              cesstype?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
            } | null > | null,
            relatedinvoicenumbertracker?:  Array< {
              __typename: "InvoiceNumberTracker",
              companyid: number,
              companybranchid: number,
              enteredtimestamp: number,
              expiredtimestamp: number,
              nextinvoicenumber: string,
              lastupdatedby?: string | null,
            } | null > | null,
            relatedinvoicetransactiondetails?:  Array< {
              __typename: "TransactionMaster",
              transactionid?: number | null,
              companyid?: number | null,
              companybranchid?: number | null,
              enteredtimestamp?: number | null,
              expiredtimestamp?: number | null,
              transactiontypecd?: string | null,
              vouchernumber?: string | null,
              entrydate?: number | null,
              bankreferencenumber?: string | null,
              comments?: string | null,
              lastupdatedby?: string | null,
              statuscode?: string | null,
              statusmessage?: string | null,
              cancelflag?: number | null,
              cancelremark?: string | null,
              serialnumber?: string | null,
              pdflink?: string | null,
              towards?: string | null,
              isvouchereditable?: number | null,
            } | null > | null,
            lastupdatedby?: string | null,
            cancelflag?: number | null,
            statuscode?: string | null,
            statusmessage?: string | null,
            consigneename?: string | null,
            consigneegstin?: string | null,
            companystate?: string | null,
            cancelremark?: string | null,
            deleteremark?: string | null,
            roundoffamount?: number | null,
            discounttype?: number | null,
            discountvalue?: number | null,
            serialnumber?: string | null,
            currencycode?: string | null,
            currencyrate?: number | null,
            paymentstatus?: number | null,
            ackno?: string | null,
            ackdt?: number | null,
            irn?: string | null,
            signedqrcode?: string | null,
            itcflag?: number | null,
          } | null > | null,
          lastupdatedby?: string | null,
          statuscode?: string | null,
          statusmessage?: string | null,
          cancelflag?: number | null,
          cancelremark?: string | null,
          serialnumber?: string | null,
          pdflink?: string | null,
          towards?: string | null,
          isvouchereditable?: number | null,
        } | null > | null,
        lastupdatedby?: string | null,
        cancelflag?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        consigneename?: string | null,
        consigneegstin?: string | null,
        companystate?: string | null,
        cancelremark?: string | null,
        deleteremark?: string | null,
        roundoffamount?: number | null,
        discounttype?: number | null,
        discountvalue?: number | null,
        serialnumber?: string | null,
        currencycode?: string | null,
        currencyrate?: number | null,
        paymentstatus?: number | null,
        ackno?: string | null,
        ackdt?: number | null,
        irn?: string | null,
        signedqrcode?: string | null,
        itcflag?: number | null,
      } | null > | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      cancelflag?: number | null,
      cancelremark?: string | null,
      serialnumber?: string | null,
      pdflink?: string | null,
      towards?: string | null,
      isvouchereditable?: number | null,
    } | null > | null,
    relatedpartymaster?:  Array< {
      __typename: "partymaster",
      partyid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      partytypecd?: string | null,
      partydisplayname?: string | null,
      partylegalname?: string | null,
      groupaccountid?: number | null,
      gstcategory?: string | null,
      placeofsupply?: string | null,
      entity?: string | null,
      email?: string | null,
      contactnumber?: string | null,
      whatsappnumber?: string | null,
      accountsid?: number | null,
      is_active?: number | null,
      msmetype?: string | null,
      deliveryconsigneename?: string | null,
      deliveryconsigneegstin?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      relatedpartygstdetails?:  Array< {
        __typename: "PartyGSTDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        pannumber?: string | null,
        gstin?: string | null,
        partyaddressid?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycreditdetails?:  Array< {
        __typename: "PartyCreditDetails",
        partyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        creditperiodduration?: string | null,
        billingcurrency?: string | null,
        creditlimitcd?: number | null,
        creditlimitamount?: number | null,
        billwiseflag?: number | null,
        notes?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedpartycontact?:  Array< {
        __typename: "PartyContact",
        partyid: number,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        contacttypename: string,
        contactdesignationname: string,
        contactorder: number,
        email: string,
        phonenumber?: string | null,
        whatsappnumber?: string | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        contactcountry?: string | null,
        whatsappcountry?: string | null,
      } | null > | null,
      relatedpartyimages?:  Array< {
        __typename: "PartyImages",
        attachmentid?: number | null,
        partyid: number,
        companyid: number,
        enteredtimestamp: number,
        expiredtimestamp: number,
        type: string,
        documentname: string,
        imagename: string,
        imageurl: string,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      lastupdatedby?: string | null,
      tdspercentage?: number | null,
      udhyamregno?: string | null,
      sameaddressflag?: number | null,
      comments?: string | null,
      tdssection?: string | null,
      accountname?: string | null,
      deliverystatecode?: number | null,
      deliverystatename?: string | null,
      contactcountry?: string | null,
      whatsappcountry?: string | null,
      entityname?: string | null,
    } | null > | null,
    relatedpartyaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    relatedpaymentaccountdetails?:  Array< {
      __typename: "AccountMaster",
      accountsid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      accountname?: string | null,
      accounttypecd?: string | null,
      accountgroupid?: number | null,
      hsnsaccode?: string | null,
      displayordernumber?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      restrictedflag?: number | null,
      is_active?: number | null,
      accounttypeflag?: number | null,
      relatedaccountgstdetails?:  Array< {
        __typename: "AccountGSTDetails",
        accountid?: number | null,
        companyid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        effectivedate?: number | null,
        expireddate?: number | null,
        hsnid?: string | null,
        gstcompensationtype?: string | null,
        gstrate?: number | null,
        cessamount?: number | null,
        lastupdatedby?: string | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        hsnsaccode?: string | null,
        codetype?: string | null,
        description?: string | null,
        taxability?: string | null,
      } | null > | null,
      relatedaccountopeningbalance?:  Array< {
        __typename: "AccountOpeningBalance",
        accountsid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        financialyearid?: number | null,
        startdate?: number | null,
        creditamount?: number | null,
        debitamount?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
      } | null > | null,
      relatedaccountgroupmaster?:  Array< {
        __typename: "AccountGroupMasterNew",
        accountgroupid?: number | null,
        companyid?: number | null,
        companybranchid?: number | null,
        enteredtimestamp?: number | null,
        expiredtimestamp?: number | null,
        accounttypecd?: string | null,
        accountgroupname?: string | null,
        accountparentgroupid?: number | null,
        displayordernumber?: number | null,
        statuscode?: string | null,
        statusmessage?: string | null,
        is_active?: number | null,
        restrictedflag?: number | null,
        path?: string | null,
      } | null > | null,
      relatedaccountbalance?:  Array< {
        __typename: "AccountBalanceNew",
        accountid?: number | null,
        accountbalance?: number | null,
        actualbalance?: number | null,
      } | null > | null,
      path?: string | null,
    } | null > | null,
    relatedpurchaseaddressdetails?:  Array< {
      __typename: "AddressEntity",
      id?: number | null,
      objecttype?: string | null,
      objectid?: string | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      statecode?: string | null,
      statename?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      pincode?: string | null,
      countrycode?: string | null,
      codevalue?: string | null,
      district?: string | null,
      lastupdatedby?: string | null,
      godownname?: string | null,
      gstin?: string | null,
      phone?: string | null,
      email?: string | null,
      personincharge?: string | null,
      consigneename?: string | null,
      consigneegstin?: string | null,
      foreignstate?: string | null,
      foreigndistrict?: string | null,
      defaultflag?: number | null,
      addresstitle?: string | null,
      addressindex?: number | null,
    } | null > | null,
    lastupdatedby?: string | null,
    cancelflag?: number | null,
    roundoffamount?: number | null,
    discounttype?: number | null,
    discountvalue?: number | null,
    adjustmentamount?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    serialnumber?: string | null,
    currencycode?: string | null,
    currencyrate?: number | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    partyaccountid?: number | null,
    reversechargeflag?: number | null,
    overduedays?: number | null,
    paymentstatus?: number | null,
    partyregistrationtype?: string | null,
    purchaseinvoicepdf?: string | null,
    partygstcategory?: string | null,
    partyemail?: string | null,
    partygstin?: string | null,
    partytypecd?: string | null,
    ewaybillno?: number | null,
    validupto?: number | null,
    ewaybill_is_cancelled?: number | null,
    ewaybill_cancel_remarks?: string | null,
    cancel_rsn_code?: string | null,
    einvoiceenteredtimestamp?: number | null,
    ewaybillenteredtimestamp?: number | null,
    ewaybillid?: number | null,
    accountname?: string | null,
    duedatetimestamp?: number | null,
    partyisactive?: number | null,
    consigneename?: string | null,
    consigneegstin?: string | null,
    ewaybillpdf?: string | null,
    ewaybillstatus?: string | null,
    isvouchereditable?: number | null,
    goods_exist?: number | null,
    itcflag?: number | null,
    linkedamount?: number | null,
    cessexist?: number | null,
    partyamount?: number | null,
    totalgstamount?: number | null,
    tdsamount?: number | null,
    tcsamount?: number | null,
    taxableamount?: number | null,
    igstamount?: number | null,
    cgstamount?: number | null,
    sgstamount?: number | null,
    cessamount?: number | null,
    sourceofsupply?: string | null,
    taxabilitylabel?: string | null,
    additionaldiscount?: number | null,
    netinvoiceamount?: number | null,
  } | null > | null,
};

export type GetMinMaxInvoiceDateQueryVariables = {
  invoicetypecd: string,
  invoiceid: number,
  serialnumber?: string | null,
};

export type GetMinMaxInvoiceDateQuery = {
  getMinMaxInvoiceDate?:  {
    __typename: "MinMaxInvoiceDate",
    previnvoicedate?: string | null,
    nextinvoicedate?: string | null,
    latestinvoicedate?: string | null,
    openingbalancedate?: string | null,
  } | null,
};

export type ListPartyMasterSearchQueryVariables = {
  word: string,
  type: string,
  rowfrom: number,
  limitno: number,
};

export type ListPartyMasterSearchQuery = {
  listPartyMasterSearch?:  Array< {
    __typename: "partymasterv2",
    partyid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    partytypecd?: string | null,
    partydisplayname?: string | null,
    partylegalname?: string | null,
    groupaccountid?: number | null,
    gstcategory?: string | null,
    placeofsupply?: string | null,
    entity?: string | null,
    email?: string | null,
    contactnumber?: string | null,
    whatsappnumber?: string | null,
    accountsid?: number | null,
    is_active?: number | null,
    msmetype?: string | null,
    deliveryconsigneename?: string | null,
    deliveryconsigneegstin?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    lastupdatedby?: string | null,
    tdspercentage?: number | null,
    udhyamregno?: string | null,
    partygstenteredtimestamp?: number | null,
    partygstexpiredtimestamp?: number | null,
    pannumber?: string | null,
    gstin?: string | null,
    partyaddressid?: number | null,
    contacttypename?: string | null,
    contactdesignationname?: string | null,
    contactorder?: number | null,
    partycontactemail?: string | null,
    phonenumber?: string | null,
    partycontactwhatsappnumber?: string | null,
    creditperiodduration?: number | null,
    billingcurrency?: number | null,
    creditlimitcd?: number | null,
    creditlimitamount?: number | null,
    billwiseflag?: number | null,
    notes?: string | null,
    sameaddressflag?: number | null,
    comments?: string | null,
    accountbalance?: number | null,
    tdssection?: string | null,
    accounttypeflag?: number | null,
    accountgroup?: string | null,
    contactcountry?: string | null,
    whatsappcountry?: string | null,
  } | null > | null,
};

export type ListItemMasterSearchQueryVariables = {
  word: string,
  type: string,
  rowfrom: number,
  limitno: number,
};

export type ListItemMasterSearchQuery = {
  listItemMasterSearch?:  Array< {
    __typename: "itemmaster",
    itemid?: number | null,
    itemcode?: string | null,
    companyid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    itemname?: string | null,
    salesinvoiceflag?: number | null,
    purchaseinvoiceflag?: number | null,
    itemcategorycd?: string | null,
    measurementcd?: string | null,
    currencycd?: string | null,
    salesaccountid?: number | null,
    purchaseaccountid?: number | null,
    taxabilitycd?: string | null,
    reversechargeflag?: number | null,
    itemtype?: string | null,
    hsnid?: string | null,
    is_active?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    relateditemamountdetails?:  Array< {
      __typename: "ItemAmountDetails",
      id?: number | null,
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      amount?: number | null,
      effectivedate?: number | null,
      expireddate?: number | null,
      hsnid?: string | null,
      gstcompensationtype?: string | null,
      gstcompensationvalue?: number | null,
      gstrate?: number | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      lastupdatedby?: string | null,
      discounttype?: number | null,
      discountvalue?: number | null,
      invoicetype?: number | null,
      pricetype?: string | null,
      isactive?: number | null,
      isdefault?: number | null,
      pricetypeid?: number | null,
      tabletype?: number | null,
    } | null > | null,
    relateditemgstdetails?:  Array< {
      __typename: "ItemGstDetails",
      itemid: number,
      companyid: number,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      hsnid: string,
      gstcesstype: string,
      gstcompensationvalue: number,
      effectivedate?: number | null,
      expireddate?: number | null,
      gstcessvalue?: number | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    relateditemimages?:  Array< {
      __typename: "ItemImages",
      attachmentid?: number | null,
      itemid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      imagename?: string | null,
      imageurl?: string | null,
      documentname?: string | null,
      type?: string | null,
      lastupdatedby?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
    } | null > | null,
    lastupdatedby?: string | null,
    serialnumber?: string | null,
    financialyearid?: number | null,
    description?: string | null,
    hsnsacid?: number | null,
    hsncodetype?: string | null,
    hsncodevalue?: string | null,
    hsndescription?: string | null,
    cessexist?: number | null,
    barcode?: string | null,
  } | null > | null,
};

export type ListaccounttransactiondetailstotalsQueryVariables = {
  accountid: number,
  startdate: number,
  enddate: number,
  searchmode?: number | null,
  searcharray?: string | null,
  openingbalance?: number | null,
};

export type ListaccounttransactiondetailstotalsQuery = {
  listaccounttransactiondetailstotals?:  Array< {
    __typename: "TransactionDetailsModalTotals",
    totalcredit: number,
    totaldebit: number,
    balancesign: number,
    closingbalance: number,
    transactioncount: number,
  } | null > | null,
};

export type LambdatestQueryVariables = {
  input?: string | null,
};

export type LambdatestQuery = {
  lambdatest?:  {
    __typename: "LambdaAIResponse",
    statusCode?: number | null,
    body?: string | null,
  } | null,
};

export type GetpospartydetailsQueryVariables = {
  phonenumber: string,
};

export type GetpospartydetailsQuery = {
  getpospartydetails?:  Array< {
    __typename: "PosPartyDetails",
    pospartyid: number,
    companyid: number,
    partyname?: string | null,
    partycontactnumberid: number,
    financialyearid?: number | null,
    id: number,
    objecttype: string,
    objectid: number,
    countrycode: string,
    phonenumber: string,
    verifieddatetime?: number | null,
    promotionssignup?: string | null,
    smsallowed?: string | null,
    callallowed?: string | null,
    whatsappallowed?: string | null,
  } | null > | null,
};

export type GettdstcsreportQueryVariables = {
  type: string,
  startdate: number,
  enddate: number,
  word: string,
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searcharray?: string | null,
};

export type GettdstcsreportQuery = {
  gettdstcsreport?:  Array< {
    __typename: "TDSTCSReport",
    id: number,
    invoicedate: number,
    vouchernumber?: string | null,
    vouchertype?: string | null,
    suppliername?: string | null,
    legalentity?: string | null,
    pan_number?: string | null,
    deductedamount?: number | null,
    tdsamount?: number | null,
    amountaftertds?: number | null,
    tdspercentage?: number | null,
    tdssection?: string | null,
    tdsdetails?: string | null,
    totalcount?: number | null,
    transactiontype?: string | null,
  } | null > | null,
};

export type GetjournaldetailsQueryVariables = {
  transactionid: number,
};

export type GetjournaldetailsQuery = {
  getjournaldetails?:  Array< {
    __typename: "JournalDetails",
    transactionid: number,
    accountsid: number,
    accountname: string,
    creditamount: number,
    debitamount: number,
    transactiontypecd: string,
  } | null > | null,
};

export type GetewaybillQueryVariables = {
  invoiceid: number,
};

export type GetewaybillQuery = {
  getewaybill?:  Array< {
    __typename: "EwayBill",
    id: number,
    invoiceid?: number | null,
    invoicetype?: string | null,
    companyid?: number | null,
    enteredtimestamp: number,
    expiredtimestamp: number,
    ewaybillno?: number | null,
    expirydate?: number | null,
    is_cancelled?: number | null,
    cancel_remarks?: string | null,
    lastupdatedby?: string | null,
    cancel_rsn_code?: string | null,
    ewaybilldate?: number | null,
    supplytype?: string | null,
    subtype?: string | null,
    partyid?: number | null,
    transporterid?: number | null,
    modeoftransport?: string | null,
    vehicleno?: string | null,
    distance?: number | null,
    invoiceno?: string | null,
    invoicedate?: number | null,
    fromgstin?: string | null,
    togstin?: string | null,
    fromstate?: string | null,
    tostate?: string | null,
    frompincode?: number | null,
    topincode?: number | null,
    billingstate?: string | null,
    billingpincode?: string | null,
    transportername?: string | null,
    transportergstin?: string | null,
    validupto?: number | null,
    total_items_count?: number | null,
    gstrate?: number | null,
    gstamount?: number | null,
    cessamount?: number | null,
    ewbrejecteddate?: number | null,
    totalitemamount?: number | null,
    totalinvoiceamount?: number | null,
    fromtradename?: string | null,
    totradename?: string | null,
    transactiontype?: string | null,
    doctype?: string | null,
    status?: string | null,
    transdocno?: string | null,
    transdocdate?: number | null,
    vehicletype?: string | null,
    ewaybillpdf?: string | null,
    addresses?:  Array< {
      __typename: "EwayBillAddress",
      objectid?: number | null,
      objecttype?: string | null,
      statecode?: number | null,
      statename?: string | null,
      pincode?: string | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      countrycode?: string | null,
      district?: string | null,
    } | null > | null,
  } | null > | null,
};

export type ListtransportersQueryVariables = {
};

export type ListtransportersQuery = {
  listtransporters?:  Array< {
    __typename: "TransporterMaster",
    transporterid: number,
    transportername: string,
    companyid: number,
    enteredtimestamp: number,
    lastupdatedby: string,
    expiredtimestamp: number,
    transportergstin: string,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type GetLatestAppVersionQueryVariables = {
};

export type GetLatestAppVersionQuery = {
  getLatestAppVersion?:  {
    __typename: "AppVersion",
    id: number,
    version_number: string,
    release_notes?: string | null,
    release_date?: string | null,
    is_mandatory: boolean,
  } | null,
};

export type GetFirstTransactionDateQueryVariables = {
};

export type GetFirstTransactionDateQuery = {
  getFirstTransactionDate?:  {
    __typename: "FirstTransaction",
    transactiontimestamp: number,
    transactioncount: number,
  } | null,
};

export type ListewaybillQueryVariables = {
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListewaybillQuery = {
  listewaybill?:  Array< {
    __typename: "EwayBill",
    id: number,
    invoiceid?: number | null,
    invoicetype?: string | null,
    companyid?: number | null,
    enteredtimestamp: number,
    expiredtimestamp: number,
    ewaybillno?: number | null,
    expirydate?: number | null,
    is_cancelled?: number | null,
    cancel_remarks?: string | null,
    lastupdatedby?: string | null,
    cancel_rsn_code?: string | null,
    ewaybilldate?: number | null,
    supplytype?: string | null,
    subtype?: string | null,
    partyid?: number | null,
    transporterid?: number | null,
    modeoftransport?: string | null,
    vehicleno?: string | null,
    distance?: number | null,
    invoiceno?: string | null,
    invoicedate?: number | null,
    fromgstin?: string | null,
    togstin?: string | null,
    fromstate?: string | null,
    tostate?: string | null,
    frompincode?: number | null,
    topincode?: number | null,
    billingstate?: string | null,
    billingpincode?: string | null,
    transportername?: string | null,
    transportergstin?: string | null,
    validupto?: number | null,
    total_items_count?: number | null,
    gstrate?: number | null,
    gstamount?: number | null,
    cessamount?: number | null,
    ewbrejecteddate?: number | null,
    totalitemamount?: number | null,
    totalinvoiceamount?: number | null,
    fromtradename?: string | null,
    totradename?: string | null,
    transactiontype?: string | null,
    doctype?: string | null,
    status?: string | null,
    transdocno?: string | null,
    transdocdate?: number | null,
    vehicletype?: string | null,
    ewaybillpdf?: string | null,
    addresses?:  Array< {
      __typename: "EwayBillAddress",
      objectid?: number | null,
      objecttype?: string | null,
      statecode?: number | null,
      statename?: string | null,
      pincode?: string | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      countrycode?: string | null,
      district?: string | null,
    } | null > | null,
  } | null > | null,
};

export type Listewaybillv2QueryVariables = {
  startdate: number,
  enddate: number,
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type Listewaybillv2Query = {
  listewaybillv2?:  Array< {
    __typename: "EwayBill",
    id: number,
    invoiceid?: number | null,
    invoicetype?: string | null,
    companyid?: number | null,
    enteredtimestamp: number,
    expiredtimestamp: number,
    ewaybillno?: number | null,
    expirydate?: number | null,
    is_cancelled?: number | null,
    cancel_remarks?: string | null,
    lastupdatedby?: string | null,
    cancel_rsn_code?: string | null,
    ewaybilldate?: number | null,
    supplytype?: string | null,
    subtype?: string | null,
    partyid?: number | null,
    transporterid?: number | null,
    modeoftransport?: string | null,
    vehicleno?: string | null,
    distance?: number | null,
    invoiceno?: string | null,
    invoicedate?: number | null,
    fromgstin?: string | null,
    togstin?: string | null,
    fromstate?: string | null,
    tostate?: string | null,
    frompincode?: number | null,
    topincode?: number | null,
    billingstate?: string | null,
    billingpincode?: string | null,
    transportername?: string | null,
    transportergstin?: string | null,
    validupto?: number | null,
    total_items_count?: number | null,
    gstrate?: number | null,
    gstamount?: number | null,
    cessamount?: number | null,
    ewbrejecteddate?: number | null,
    totalitemamount?: number | null,
    totalinvoiceamount?: number | null,
    fromtradename?: string | null,
    totradename?: string | null,
    transactiontype?: string | null,
    doctype?: string | null,
    status?: string | null,
    transdocno?: string | null,
    transdocdate?: number | null,
    vehicletype?: string | null,
    ewaybillpdf?: string | null,
    addresses?:  Array< {
      __typename: "EwayBillAddress",
      objectid?: number | null,
      objecttype?: string | null,
      statecode?: number | null,
      statename?: string | null,
      pincode?: string | null,
      line1?: string | null,
      line2?: string | null,
      line3?: string | null,
      city?: string | null,
      countrycode?: string | null,
      district?: string | null,
    } | null > | null,
  } | null > | null,
};

export type Listewaybillv2CountQueryVariables = {
  startdate: number,
  enddate: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type Listewaybillv2CountQuery = {
  listewaybillv2Count?:  Array< {
    __typename: "EwayBillListCount",
    ewaybillcount?: number | null,
    mintotalinvoiceamount?: number | null,
    maxtotalinvoiceamount?: number | null,
    maxtotalitemamount?: number | null,
    maxtotalitemscount?: number | null,
    maxgstcess?: number | null,
    maxdistance?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
  } | null > | null,
};

export type CheckitempartyaddedQueryVariables = {
};

export type CheckitempartyaddedQuery = {
  checkitempartyadded?:  {
    __typename: "CheckItemPartyAdded",
    count: number,
  } | null,
};

export type ListStockSummaryQueryVariables = {
  input: ListStockSummaryInput,
};

export type ListStockSummaryQuery = {
  listStockSummary?:  Array< {
    __typename: "StockSummary",
    slno: number,
    itemid?: number | null,
    itemcode: string,
    itemname: string,
    unit: string,
    hsn: string,
    taxability?: string | null,
    gstrate: number,
    openingamt: number,
    openingqty: number,
    purchaseamt: number,
    purchaseqty: number,
    salesamt: number,
    salesqty: number,
    closingamt: number,
    closingqty: number,
    total_count: number,
  } | null > | null,
};

export type ListStockSummaryv2QueryVariables = {
  input: ListStockSummaryInput,
};

export type ListStockSummaryv2Query = {
  listStockSummaryv2?:  Array< {
    __typename: "StockSummary",
    slno: number,
    itemid?: number | null,
    itemcode: string,
    itemname: string,
    unit: string,
    hsn: string,
    taxability?: string | null,
    gstrate: number,
    openingamt: number,
    openingqty: number,
    purchaseamt: number,
    purchaseqty: number,
    salesamt: number,
    salesqty: number,
    closingamt: number,
    closingqty: number,
    total_count: number,
  } | null > | null,
};

export type ListUserInvitationsQueryVariables = {
  rowfrom: number,
  limitno: number,
  columnname?: string | null,
  ordertype?: string | null,
  searchmode?: number | null,
  searcharray?: string | null,
};

export type ListUserInvitationsQuery = {
  listUserInvitations?:  Array< {
    __typename: "UserInvitation",
    id: number,
    email: string,
    companyid: number,
    invitedby: string,
    status: string,
    invitationtoken: string,
    invitationsource: string,
    acceptedtimestamp?: number | null,
    enteredtimestamp: number,
    expiredtimestamp?: number | null,
  } | null > | null,
};

export type ListItemwiseStockSummaryQueryVariables = {
  input: ListItemwiseStockSummaryInput,
};

export type ListItemwiseStockSummaryQuery = {
  listItemwiseStockSummary:  Array< {
    __typename: "ItemWiseStockSummary",
    itemid?: number | null,
    date?: number | null,
    particular?: string | null,
    voucher_no?: string | null,
    qty?: number | null,
    cost_item?: number | null,
    total_cost?: number | null,
    closing_stock?: number | null,
    closing_stock_amount?: number | null,
    invoiceid?: number | null,
    next_cursor_timestamp?: number | null,
    next_cursor_transactionid?: number | null,
    total_count?: number | null,
    remark?: string | null,
  } >,
};

export type ListItemwiseStockSummaryv2QueryVariables = {
  input: ListItemwiseStockSummaryInput,
};

export type ListItemwiseStockSummaryv2Query = {
  listItemwiseStockSummaryv2:  Array< {
    __typename: "ItemWiseStockSummary",
    itemid?: number | null,
    date?: number | null,
    particular?: string | null,
    voucher_no?: string | null,
    qty?: number | null,
    cost_item?: number | null,
    total_cost?: number | null,
    closing_stock?: number | null,
    closing_stock_amount?: number | null,
    invoiceid?: number | null,
    next_cursor_timestamp?: number | null,
    next_cursor_transactionid?: number | null,
    total_count?: number | null,
    remark?: string | null,
  } >,
};

export type GetItemFinancialYearSummaryQueryVariables = {
  input: ItemFinancialYearSummaryInput,
};

export type GetItemFinancialYearSummaryQuery = {
  getItemFinancialYearSummary:  Array< {
    __typename: "ItemFinancialYearSummary",
    itemid: number,
    financialyearid: number,
    openingqty: number,
    openingamt: number,
    purchaseqty: number,
    purchaseamt: number,
    closingqty: number,
    closingamt: number,
  } >,
};

export type ListAllItemOpeningStockQueryVariables = {
};

export type ListAllItemOpeningStockQuery = {
  listAllItemOpeningStock?:  Array< {
    __typename: "ItemOpeningStockDetails",
    itemid: number,
    itemcode: string,
    itemname: string,
    units?: string | null,
    stockquantity?: number | null,
    rate_unit?: number | null,
    openingbalance?: number | null,
  } | null > | null,
};

export type ListItemDashboardDataQueryVariables = {
  starttimestamp: number,
  endtimestamp: number,
};

export type ListItemDashboardDataQuery = {
  listItemDashboardData?:  Array< {
    __typename: "ItemDashboardData",
    itemid: number,
    itemcode: string,
    itemname: string,
    itemtype?: string | null,
    itemcategoryid?: number | null,
    is_active?: boolean | null,
    closing_amount?: number | null,
    closing_quantity?: number | null,
    unit?: string | null,
  } | null > | null,
};

export type ListTotalClosingStockQueryVariables = {
  endtimestamp: number,
  financialyearid: number,
};

export type ListTotalClosingStockQuery = {
  listTotalClosingStock?:  Array< {
    __typename: "TotalClosingStock",
    total_closing_quantity?: number | null,
    total_closing_amount?: number | null,
  } | null > | null,
};

export type GetEmailsByPartyIdsQueryVariables = {
  partyIds: Array< number >,
};

export type GetEmailsByPartyIdsQuery = {
  getEmailsByPartyIds?:  Array< {
    __typename: "PartyEmailAddress",
    partyid: number,
    email: string,
    is_active: number,
    partydisplayname?: string | null,
    partylegalname?: string | null,
  } | null > | null,
};

export type ListTotalOpeningStockQueryVariables = {
  starttimestamp: number,
};

export type ListTotalOpeningStockQuery = {
  listTotalOpeningStock?:  Array< {
    __typename: "TotalOpeningStock",
    total_opening_quantity?: number | null,
    total_opening_amount?: number | null,
  } | null > | null,
};

export type GetLastUsedBankOrCashAccountQueryVariables = {
  transactiontypecd: TransactionType,
};

export type GetLastUsedBankOrCashAccountQuery = {
  getLastUsedBankOrCashAccount?:  {
    __typename: "LastUsedAccount",
    bankpaidtoaccountid?: string | null,
    cashpaidtoaccountid?: string | null,
    bankpaidtoaccountname?: string | null,
    cashpaidtoaccountname?: string | null,
    paymentmethodlastused?: string | null,
  } | null,
};

export type GettdstcsreporttotalsQueryVariables = {
  type: string,
  startdate: number,
  enddate: number,
  word: string,
  searcharray?: string | null,
};

export type GettdstcsreporttotalsQuery = {
  gettdstcsreporttotals?:  Array< {
    __typename: "TDSTCSReportTotals",
    totaltaxableamount?: number | null,
    totaltdsamount?: number | null,
    totalamountaftertds?: number | null,
    totalrecords?: number | null,
    transactiontype?: string | null,
  } | null > | null,
};

export type ListUserCompaniesv2QueryVariables = {
};

export type ListUserCompaniesv2Query = {
  listUserCompaniesv2?:  Array< {
    __typename: "CompanyDetails",
    companyid: number,
    enteredtimestamp: number,
    expiredtimestamp?: number | null,
    websiteurl?: string | null,
    currencycd?: number | null,
    accountinventoryflag?: number | null,
    pannumber?: string | null,
    tdstcsnumber?: string | null,
    cinregistrationnumber?: string | null,
    registrationtype?: number | null,
    comppercentage?: number | null,
    gstrperiod?: string | null,
    lut?: string | null,
    lutbondvalidfrom?: number | null,
    ewaybillflag?: number | null,
    gstapplicablefrom?: number | null,
    thresholdlimitcd?: number | null,
    thresholdlimitamount?: number | null,
    companylegalname?: string | null,
    companyshort?: string | null,
    lutbondtodate?: number | null,
    invoicedetailapplicablefromdate?: number | null,
    tdsapplicable?: number | null,
    gstcategory?: string | null,
    financialyearstartandendmonth?: number | null,
    companylogourl?: string | null,
    msmetype?: string | null,
    udhyamregno?: string | null,
    udhyamdocs?: string | null,
    ewaybillstartdate?: number | null,
    minamountewayinter?: number | null,
    minamountewayintra?: number | null,
    einvoiceflag?: number | null,
    einvoicestartingdate?: number | null,
    gstcompensationcessflag?: number | null,
    tradelicensenumber?: string | null,
    tradelicensestartdate?: number | null,
    tradelicenseenddate?: number | null,
    lastupdatedby?: string | null,
    cinregistrationdate?: number | null,
    einvoiceconnect?: number | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    activeflag?: number | null,
    relatedfinancialyeardata?:  Array< {
      __typename: "FinancialYear",
      financialyearid?: number | null,
      companyid?: number | null,
      companybranchid?: number | null,
      enteredtimestamp?: number | null,
      expiredtimestamp?: number | null,
      startdate?: number | null,
      enddate?: number | null,
      startyear?: string | null,
      endyear?: string | null,
      comments?: string | null,
      userid?: string | null,
      aliasname?: string | null,
      statuscode?: string | null,
      statusmessage?: string | null,
      freezestatus?: number | null,
      transferdate?: number | null,
      freezedate?: number | null,
      stepscompleted?: Array< string | null > | null,
    } | null > | null,
    financialyearid?: number | null,
    lastupdatedtimestamp?: number | null,
    companydeletiontime?: number | null,
    ewaybillconnect?: number | null,
    stepscompleted?: Array< string | null > | null,
    disablegstcompensation?: number | null,
    businesstypeid?: Array< number | null > | null,
    industrytypeid?: Array< number | null > | null,
  } | null > | null,
};

export type OnlogoutCognitoUserSubscriptionVariables = {
  cognitousername: string,
};

export type OnlogoutCognitoUserSubscription = {
  onlogoutCognitoUser?:  {
    __typename: "CognitoUserSession",
    sessionid?: number | null,
    cognitousername?: string | null,
    logintimestamp?: string | null,
    logouttimestamp?: string | null,
    linkedsessionid?: string | null,
    deviceinfo?: string | null,
    ipaddress?: string | null,
  } | null,
};

export type OnfreezeFinancialYearSubscriptionVariables = {
  companyid: number,
};

export type OnfreezeFinancialYearSubscription = {
  onfreezeFinancialYear?:  {
    __typename: "FinancialYear",
    financialyearid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    startdate?: number | null,
    enddate?: number | null,
    startyear?: string | null,
    endyear?: string | null,
    comments?: string | null,
    userid?: string | null,
    aliasname?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    freezestatus?: number | null,
    transferdate?: number | null,
    freezedate?: number | null,
    stepscompleted?: Array< string | null > | null,
  } | null,
};

export type OnunFreezeFinancialYearSubscriptionVariables = {
  companyid: number,
};

export type OnunFreezeFinancialYearSubscription = {
  onunFreezeFinancialYear?:  {
    __typename: "FinancialYear",
    financialyearid?: number | null,
    companyid?: number | null,
    companybranchid?: number | null,
    enteredtimestamp?: number | null,
    expiredtimestamp?: number | null,
    startdate?: number | null,
    enddate?: number | null,
    startyear?: string | null,
    endyear?: string | null,
    comments?: string | null,
    userid?: string | null,
    aliasname?: string | null,
    statuscode?: string | null,
    statusmessage?: string | null,
    freezestatus?: number | null,
    transferdate?: number | null,
    freezedate?: number | null,
    stepscompleted?: Array< string | null > | null,
  } | null,
};

export type OnNewAppVersionSubscriptionVariables = {
};

export type OnNewAppVersionSubscription = {
  onNewAppVersion?:  {
    __typename: "AppVersion",
    id: number,
    version_number: string,
    release_notes?: string | null,
    release_date?: string | null,
    is_mandatory: boolean,
  } | null,
};
